export const FLASHCARDS = [
  {
    "id": 1000,
    "topic_id": 5,
    "title": "What are some examples of detection access controls?",
    "description": "Security guards, supervising users, incident investigations, and intrusion detection systems."
  },
  {
    "id": 1001,
    "topic_id": 5,
    "title": "What are some examples of physical access controls?",
    "description": "Guards, fences, motion detectors, locked doors, sealed windows, lights, backups, cable protection, laptop locks, swipe cards, dogs, CCTV, mantraps, alarms."
  },
  {
    "id": 1002,
    "topic_id": 5,
    "title": "What are the three commonly recognized authentication factors?",
    "description": "Something you know, something you have, and something you are."
  },
  {
    "id": 1003,
    "topic_id": 5,
    "title": "What is a cognitive password?",
    "description": "A series of questions about facts or predefined responses that only the subject should know (for example, what is your birth date? What is your mother's maiden name?)."
  },
  {
    "id": 1004,
    "topic_id": 5,
    "title": "Name at least eight biometric factors.",
    "description": "Fingerprints, face scans, iris scans, retina scans, palm topography, palm geography, heart/pulse pattern, voice pattern, signature dynamics, keystroke patterns."
  },
  {
    "id": 1005,
    "topic_id": 5,
    "title": "What are the issues related to user acceptance of biometric enrollment and throughput rate?",
    "description": "Enrollment times longer than 2 minutes are unacceptable; subjects will typically accept a throughput rate of about 6 seconds or faster."
  },
  {
    "id": 1006,
    "topic_id": 5,
    "title": "What access control technique employs security labels?",
    "description": "Mandatory access controls. Subjects are labeled as to their level of clearance. Objects are labeled as to their level of classification or sensitivity."
  },
  {
    "id": 1007,
    "topic_id": 3,
    "title": "The Bell\u2013LaPadula, Biba, and Clark\u2013Wilson access control models were all designed to protect a single aspect of security. Name the corresponding aspect for each model.",
    "description": "Bell\u2013LaPadula protects confidentiality; Biba and Clark\u2013Wilson protect integrity."
  },
  {
    "id": 1008,
    "topic_id": 1,
    "title": "Name the three types of subjects and their roles in a security environment.",
    "description": "The user accesses objects on a system to perform a work task; the owner is liable for protection of data; the data custodian is assigned to classify and protect data."
  },
  {
    "id": 1009,
    "topic_id": 1,
    "title": "Explain why the separation of duties and responsibilities is a common security practice.",
    "description": "It prevents any single subject from being able to circumvent or disable security mechanisms."
  },
  {
    "id": 1010,
    "topic_id": 1,
    "title": "What is the principle of least privilege?",
    "description": "Subjects should be granted only the amount of access to objects that is required to accomplish their assigned work tasks."
  },
  {
    "id": 1011,
    "topic_id": 1,
    "title": "Name the four key principles upon which access control relies.",
    "description": "Identification, authentication, authorization, accountability."
  },
  {
    "id": 1012,
    "topic_id": 5,
    "title": "How are domains related to decentralized access control?",
    "description": "A domain is a realm of trust that shares a common security policy. This is a form of decentralized access control."
  },
  {
    "id": 1013,
    "topic_id": 5,
    "title": "Why is monitoring an important part of a security policy?",
    "description": "Monitoring is used to watch for security policy violations and to detect unauthorized or abnormal activities."
  },
  {
    "id": 1014,
    "topic_id": 7,
    "title": "What are the functions of an intrusion detection system (IDS)?",
    "description": "An IDS automates the inspection of audit logs and real-time system events, detects intrusion attempts, and watches for violations of confidentiality, integrity, and availability."
  },
  {
    "id": 1015,
    "topic_id": 7,
    "title": "What are the pros and cons of a host-based IDS?",
    "description": "It can pinpoint resources compromised by a malicious user. It can't detect network-only attacks or attacks on other systems, has difficulty detecting DoS attacks, and can be detected by intruders."
  },
  {
    "id": 1016,
    "topic_id": 7,
    "title": "What are the pros and cons of a network-based IDS?",
    "description": "It can monitor a large network and can be hardened against attack. It requires a central view of traffic and can't pinpoint compromised resources. High levels of traffic flow require sufficiently capable IDS systems in order for them not to be overloaded."
  },
  {
    "id": 1017,
    "topic_id": 7,
    "title": "What are the differences between knowledge-based and behavior-based detection methods used by IDS?",
    "description": "Knowledge-based uses a signature database and tries to match monitored events to that database. Behavior-based learns about the normal activities on your system through watching and learning."
  },
  {
    "id": 1018,
    "topic_id": 7,
    "title": "What is a honeynet, and what is it used for?",
    "description": "Honeynets are fake networks used to lure intruders in order to create sufficient audit trails for tracking them down and prosecuting. Honeynets contain no real or sensitive data."
  },
  {
    "id": 1019,
    "topic_id": 6,
    "title": "How does penetration testing improve your system's security?",
    "description": "Penetration testing allows you to more accurately judge the security mechanisms deployed by an organization by using the tools and techniques an attacker might use."
  },
  {
    "id": 1020,
    "topic_id": 4,
    "title": "What is a denial-of-service attack?",
    "description": "An attack that prevents the system from receiving, processing, or responding to legitimate traffic or requests for resources and objects."
  },
  {
    "id": 1021,
    "topic_id": 4,
    "title": "What is a spoofing attack?",
    "description": "The attacker pretends to be someone or something other than whom or what they are. They can spoof identities, IP addresses, email addresses, and phone numbers. They often replace the valid source and/or destination IP address and node numbers with false ones."
  },
  {
    "id": 1022,
    "topic_id": 4,
    "title": "What are countermeasures to spoofing attacks?",
    "description": "Countermeasures to spoofing attacks include patching the OS and software, enabling source/destination verification on routers, and employing an IDS to detect and block attacks."
  },
  {
    "id": 1023,
    "topic_id": 4,
    "title": "What is an adversary-in-the-middle (AitM) or on-path attack (previously known as man-in-the-middle [MitM])?",
    "description": "An attack in which a malicious user is positioned between the two endpoints of a communication's link."
  },
  {
    "id": 1024,
    "topic_id": 4,
    "title": "What is a replay or playback attack?",
    "description": "A malicious user records the traffic between a client and a server and then retransmits them to the server with slight variations of the timestamp and source IP address. It is similar to hijacking."
  },
  {
    "id": 1025,
    "topic_id": 4,
    "title": "What is a sniffer attack?",
    "description": "Any activity that results in a malicious user obtaining information about a network or the traffic over that network. Data is captured using a sniffer or protocol analyzer."
  },
  {
    "id": 1026,
    "topic_id": 4,
    "title": "What is a spamming attack?",
    "description": "Directing floods of messages to a victim's email inbox or other messaging system. Such attacks cause DoS issues by filling up storage space and preventing legitimate messages from being delivered."
  },
  {
    "id": 1027,
    "topic_id": 4,
    "title": "What are some countermeasures to common attack methods?",
    "description": "Patching software, reconfiguring security, employing firewalls, updating filters, using IDSs/IPSs, improving security policy, using traffic filters, improving physical access control, using system monitoring/auditing."
  },
  {
    "id": 1028,
    "topic_id": 4,
    "title": "Name the seven layers of the OSI model by their layer name and layer number.",
    "description": "Application (7), Presentation (6), Session (5), Transport (4), Network (3), Data Link (2), and Physical (1)."
  },
  {
    "id": 1029,
    "topic_id": 4,
    "title": "List the security features offered by the Network layer of the OSI model.",
    "description": "The Network layer (layer 3) offers confidentiality, authentication, and integrity."
  },
  {
    "id": 1031,
    "topic_id": 4,
    "title": "Name the common network topologies.",
    "description": "Ring, bus, star, and mesh."
  },
  {
    "id": 1034,
    "topic_id": 4,
    "title": "Name at least five networking device types other than firewalls.",
    "description": "Routers, switches, hubs, repeaters, bridges, gateways, proxies."
  },
  {
    "id": 1035,
    "topic_id": 4,
    "title": "What is a proxy, and what is it used for?",
    "description": "Any system that performs a function or requests a service on behalf of another system. Proxies are most often used to provide clients with Internet access while protecting their identity."
  },
  {
    "id": 1038,
    "topic_id": 4,
    "title": "How are PVC, SVC, DTE, and DCE used in a WAN network link?",
    "description": "WAN network links require the use of a DTE and a DCE at each connection point. PVC is always available; SVC is established using the best paths currently available."
  },
  {
    "id": 1039,
    "topic_id": 4,
    "title": "What are three remote access authentication mechanisms or AAA services?",
    "description": "RADIUS, DIAMETER, and TACACS+."
  },
  {
    "id": 1040,
    "topic_id": 4,
    "title": "What is tunneling, and why is it used?",
    "description": "A process that protects the contents of packets by encapsulating them in another protocol. This creates the logical illusion of a communications tunnel through an untrusted intermediary network."
  },
  {
    "id": 1041,
    "topic_id": 4,
    "title": "What is a VPN?",
    "description": "A virtual private network (VPN) is a communication tunnel that provides point-to-point transmission of both authentication and data traffic over an intermediary network."
  },
  {
    "id": 1042,
    "topic_id": 4,
    "title": "What are some common VPN protocols?",
    "description": "PPTP, L2TP, SSH, and IPsec (Note: SSL/TLS is a valid VPN protocol as well, but it's not necessarily recognized on the exam as such.)."
  },
  {
    "id": 1043,
    "topic_id": 4,
    "title": "What are the two modes available through IPsec, and what do they do?",
    "description": "In transport mode, the IP packet data is encrypted, but the header is not. In tunnel mode, the entire IP packet is encrypted, and a new header is added to govern transmission through the tunnel."
  },
  {
    "id": 1044,
    "topic_id": 4,
    "title": "What is NAT?",
    "description": "Network Address Translation (NAT) allows the private IP addresses defined in RFC 1918 to be used in a private network while still being able to communicate with the internet."
  },
  {
    "id": 1045,
    "topic_id": 4,
    "title": "What is transparency?",
    "description": "A characteristic of a service, security control, or access mechanism that ensures it is unseen by users."
  },
  {
    "id": 1046,
    "topic_id": 4,
    "title": "What are some important aspects to consider when designing email security?",
    "description": "Nonrepudiation, access control, message integrity, source authentication, verified delivery, acceptable use policies, privacy, management, and backup and retention policies."
  },
  {
    "id": 1047,
    "topic_id": 4,
    "title": "What are some common threats that may occur through email?",
    "description": "Email is a common delivery mechanism for viruses, worms, Trojan horses, documents with destructive macros, and phishing attacks."
  },
  {
    "id": 1048,
    "topic_id": 4,
    "title": "What are possible mechanisms for adding security to email?",
    "description": "S/MIME, MOSS, PEM, and PGP."
  },
  {
    "id": 1049,
    "topic_id": 4,
    "title": "What are elements of effective user training against social-engineering attacks?",
    "description": "Always err on the side of caution whenever communications are odd or unexpected. Always request proof of identity. Identify what information can be conveyed via voice communications by classifying the information. Never change passwords over the phone."
  },
  {
    "id": 1050,
    "topic_id": 4,
    "title": "What are the most common threats against communication systems?",
    "description": "Denial of service, eavesdropping, impersonation, replay, and modification."
  },
  {
    "id": 1051,
    "topic_id": 3,
    "title": "What are some countermeasures to eavesdropping?",
    "description": "Maintaining physical access security, using encryption, employing one-time authentication methods."
  },
  {
    "id": 1052,
    "topic_id": 3,
    "title": "What is an ARP attack?",
    "description": "The modification of ARP mappings. When ARP mappings are falsified, packets are not sent to their proper destination. ARP mappings can be attacked through spoofing. Spoofing provides false MAC addresses for requested IP addressed systems to redirect traffic to alternate destinations."
  },
  {
    "id": 1053,
    "topic_id": 1,
    "title": "What is privacy?",
    "description": "Prevention of unauthorized intrusion, knowledge that information deemed personal or confidential won't be shared with unauthorized entities, freedom from being observed without consent."
  },
  {
    "id": 1054,
    "topic_id": 1,
    "title": "What are the requirements for accountability?",
    "description": "Identification, authentication, authorization, and auditing."
  },
  {
    "id": 1055,
    "topic_id": 1,
    "title": "What is nonrepudiation?",
    "description": "Nonrepudiation prevents a subject from claiming not to have sent a message, not to have performed an action, or not to have been the cause of an event."
  },
  {
    "id": 1056,
    "topic_id": 1,
    "title": "What is layering?",
    "description": "Layering is the use of multiple controls in a series. The use of a multilayered solution allows for numerous controls to be brought to bear against whatever threats occur."
  },
  {
    "id": 1057,
    "topic_id": 1,
    "title": "How is abstraction used?",
    "description": "Abstraction is used to collect similar elements into groups, classes, or roles that are assigned security controls, restrictions, or permissions."
  },
  {
    "id": 1058,
    "topic_id": 1,
    "title": "What is data hiding?",
    "description": "Data hiding is preventing data from being known by a subject. Keeping a database from being accessed by unauthorized visitors is a form of data hiding."
  },
  {
    "id": 1059,
    "topic_id": 1,
    "title": "What is change control or change management?",
    "description": "A mechanism used to systematically manage change. Typically, it involves extensive logging, auditing, and monitoring of activities related to security controls and security solutions."
  },
  {
    "id": 1060,
    "topic_id": 1,
    "title": "What are the goals of change management?",
    "description": "Implementation of changes in an orderly manner, formalized testing, ability to reverse changes, ability to inform users of changes, systematical analysis of changes, minimization of negative impact of changes."
  },
  {
    "id": 1061,
    "topic_id": 1,
    "title": "What is data classification?",
    "description": "Data classification is the primary means by which data is protected based on categories of secrecy, sensitivity, or confidentiality."
  },
  {
    "id": 1062,
    "topic_id": 1,
    "title": "What criteria are used to classify data?",
    "description": "Usefulness, timeliness, value or cost, maturity or age, lifetime or expiration period, disclosure damage assessment, modification damage assessment, national or business security implications, storage."
  },
  {
    "id": 1063,
    "topic_id": 1,
    "title": "What is the government/military data classification scheme?",
    "description": "Top secret, secret, confidential, sensitive, and unclassified."
  },
  {
    "id": 1064,
    "topic_id": 1,
    "title": "What is the commercial business/private sector classification scheme?",
    "description": "Confidential, private, sensitive, public."
  },
  {
    "id": 1065,
    "topic_id": 1,
    "title": "Name at least seven security management concepts and principles.",
    "description": "CIA Triad, confidentiality, integrity, availability, privacy, identification, authentication, authorization, auditing, accountability, and nonrepudiation."
  },
  {
    "id": 1066,
    "topic_id": 1,
    "title": "What are the elements of a termination procedure policy?",
    "description": "Have at least one witness; escort terminated employees off the premises immediately; collect identification, access, or security devices; perform exit interview; disable network account."
  },
  {
    "id": 1067,
    "topic_id": 1,
    "title": "What is the function of the data owner security role?",
    "description": "The data owner is responsible for classifying information for protection within the security solution."
  },
  {
    "id": 1068,
    "topic_id": 1,
    "title": "What is the data custodian security role?",
    "description": "The data custodian is assigned the tasks of implementing the prescribed protection defined by the security policy and upper management."
  },
  {
    "id": 1069,
    "topic_id": 1,
    "title": "What is the function of the auditor security role?",
    "description": "The auditor is responsible for testing and verifying that the security policy is properly implemented and the derived security solutions are adequate."
  },
  {
    "id": 1070,
    "topic_id": 1,
    "title": "What should the documents that make up a formalized security structure include?",
    "description": "Policies, standards, baselines, guidelines, and procedures."
  },
  {
    "id": 1071,
    "topic_id": 1,
    "title": "What is generally involved in the processes of risk management?",
    "description": "Analyzing an environment for risks, evaluating each risk as to its likelihood and damage, assessing the cost of countermeasures, and creating a cost/benefit report to present to upper management."
  },
  {
    "id": 1072,
    "topic_id": 1,
    "title": "What should be considered when establishing the value of an asset?",
    "description": "Cost of purchase, development, maintenance, acquisition, and protection; value to owners/users/competitors; equity value; market valuation; liability of asset loss; and usefulness."
  },
  {
    "id": 1073,
    "topic_id": 1,
    "title": "Name at least five possible threats that should be evaluated when performing a risk analysis.",
    "description": "Viruses; buffer overflows; coding errors; user errors; intruders (physical and logical); natural disasters; equipment failure; misuse of data, resources, or services; loss of data; physical theft; denial of service."
  },
  {
    "id": 1074,
    "topic_id": 1,
    "title": "What is single loss expectancy, and how is it calculated?",
    "description": "The cost associated with a single realized risk against a specific asset. SLE = asset value (AV) * exposure factor (EF). The SLE is expressed in a dollar value."
  },
  {
    "id": 1075,
    "topic_id": 1,
    "title": "What is annualized loss expectancy, and how is it calculated?",
    "description": "The possible yearly cost of all instances of a specific realized threat against a specific asset. ALE = single loss expectancy (SLE) * annualized rate of occurrence (ARO)."
  },
  {
    "id": 1077,
    "topic_id": 1,
    "title": "What are the possible valid responses by upper/senior management to risk?",
    "description": "Reducing/mitigating risk, assigning/transferring a risk, risk deterrence, risk avoidance, accepting risk."
  },
  {
    "id": 1078,
    "topic_id": 1,
    "title": "What is residual risk?",
    "description": "Once countermeasures are implemented, the risk that remains is known as residual risk. Residual risk is the risk that management has chosen to accept rather than mitigate."
  },
  {
    "id": 1079,
    "topic_id": 1,
    "title": "What is total risk?",
    "description": "The amount of risk an organization would face if no safeguards were implemented. A formula for total risk is threats * vulnerabilities * asset value = total risk."
  },
  {
    "id": 1080,
    "topic_id": 1,
    "title": "What is the controls gap?",
    "description": "The difference between total risk and residual risk. The controls gap is the amount of risk that is reduced by implementing safeguards."
  },
  {
    "id": 1081,
    "topic_id": 1,
    "title": "What are the three learning levels of security?",
    "description": "Awareness, training, and education."
  },
  {
    "id": 1082,
    "topic_id": 1,
    "title": "What are the three types of plans employed in security management planning?",
    "description": "A strategic plan is a long-term plan that is fairly stable. The tactical plan is a midterm plan that provides more details. Operational plans are short term and highly detailed."
  },
  {
    "id": 1083,
    "topic_id": 8,
    "title": "How many primary keys may each database table have?",
    "description": "One."
  },
  {
    "id": 1084,
    "topic_id": 8,
    "title": "What type of malicious code spreads through the sharing of infected media?",
    "description": "Viruses."
  },
  {
    "id": 1085,
    "topic_id": 8,
    "title": "What term is used to describe intelligent code objects that perform actions on behalf of a user?",
    "description": "Agent."
  },
  {
    "id": 1086,
    "topic_id": 3,
    "title": "What term is used to describe code sent by a server to a client for execution on the client machine?",
    "description": "Applet."
  },
  {
    "id": 1088,
    "topic_id": 3,
    "title": "What type of database key enforces relationships between tables?",
    "description": "Foreign key."
  },
  {
    "id": 1089,
    "topic_id": 8,
    "title": "What security principle ensures that multiple records are created in a database table for viewing at different security levels?",
    "description": "Polyinstantiation."
  },
  {
    "id": 1090,
    "topic_id": 8,
    "title": "What process evaluates the technical and nontechnical security features of an IT system?",
    "description": "Certification and accreditation."
  },
  {
    "id": 1091,
    "topic_id": 3,
    "title": "What type of accreditation evaluates the systems and applications at a specific, self-contained location?",
    "description": "Site accreditation."
  },
  {
    "id": 1092,
    "topic_id": 3,
    "title": "In which phase of the Software Capability Maturity Model do you often find hardworking people charging ahead in a disorganized fashion?",
    "description": "Initial."
  },
  {
    "id": 1093,
    "topic_id": 3,
    "title": "In which layer of the ring protection scheme do user applications reside?",
    "description": "Ring 3."
  },
  {
    "id": 1095,
    "topic_id": 8,
    "title": "What is another term for the master boot record?",
    "description": "Boot sector."
  },
  {
    "id": 1096,
    "topic_id": 8,
    "title": "What type of virus embeds itself in application documents?",
    "description": "Macro virus."
  },
  {
    "id": 1097,
    "topic_id": 8,
    "title": "What can antivirus programs do when they encounter a virus infection?",
    "description": "Delete the file, disinfect the file, or quarantine the file."
  },
  {
    "id": 1098,
    "topic_id": 8,
    "title": "What type of virus modifies itself each time it infects a new system in an attempt to avoid detection?",
    "description": "Polymorphic virus."
  },
  {
    "id": 1099,
    "topic_id": 8,
    "title": "What type of malicious code launches itself when certain conditions (such as a specific date) are met?",
    "description": "Logic bomb."
  },
  {
    "id": 1101,
    "topic_id": 8,
    "title": "Where are passwords stored in a Unix or Linux system?",
    "description": "In the <code>/etc/shadow</code> file; much older systems may still use <code>/etc/passwd</code>."
  },
  {
    "id": 1102,
    "topic_id": 8,
    "title": "What term is used to describe hackers rooting through trash looking for useful information?",
    "description": "Dumpster diving."
  },
  {
    "id": 1103,
    "topic_id": 8,
    "title": "What is the cornerstone of computer security?",
    "description": "Education."
  },
  {
    "id": 1104,
    "topic_id": 4,
    "title": "What are the three phases of the three-way handshake used by TCP/IP?",
    "description": "SYN, SYN/ACK, ACK."
  },
  {
    "id": 1105,
    "topic_id": 7,
    "title": "How does the teardrop attack operate?",
    "description": "It sends overlapping packet fragments to the victim machine."
  },
  {
    "id": 1106,
    "topic_id": 8,
    "title": "What is the term used to describe a secret method used by a programmer to gain access to the system?",
    "description": "Trap door (or backdoor)."
  },
  {
    "id": 1107,
    "topic_id": 3,
    "title": "When is the XOR function true?",
    "description": "When only one of the input bits is true."
  },
  {
    "id": 1108,
    "topic_id": 3,
    "title": "What term describes a mathematical function that easily produces output values for each possible combination of inputs but makes it impossible to retrieve the input values?",
    "description": "One-way function."
  },
  {
    "id": 1109,
    "topic_id": 3,
    "title": "True or false? All ciphers are meant to obscure the meaning of a message.",
    "description": "TRUE."
  },
  {
    "id": 1110,
    "topic_id": 3,
    "title": "True or false? All codes are meant to obscure the meaning of a message.",
    "description": "FALSE."
  },
  {
    "id": 1111,
    "topic_id": 3,
    "title": "What occurs when a change in the plaintext results in multiple changes spread throughout the cipher text?",
    "description": "Diffusion."
  },
  {
    "id": 1112,
    "topic_id": 3,
    "title": "What type of cipher is the Caesar cipher?",
    "description": "Simple substitution."
  },
  {
    "id": 1113,
    "topic_id": 3,
    "title": "True or false? Modern cryptosystems rely on the secrecy of the encryption algorithm.",
    "description": "FALSE."
  },
  {
    "id": 1114,
    "topic_id": 3,
    "title": "What is the length of the key used by the standard DES algorithm?",
    "description": "56 bits."
  },
  {
    "id": 1115,
    "topic_id": 3,
    "title": "How many rounds of encryption does DES utilize?",
    "description": "16."
  },
  {
    "id": 1116,
    "topic_id": 3,
    "title": "True or false? The IDEA algorithm is available free for noncommercial use.",
    "description": "TRUE."
  },
  {
    "id": 1117,
    "topic_id": 3,
    "title": "What encryption algorithm was selected for the Advanced Encryption Standard (AES)?",
    "description": "Rijndael."
  },
  {
    "id": 1118,
    "topic_id": 3,
    "title": "What is the Diffie\u2013Hellman algorithm most commonly used for?",
    "description": "Key exchange."
  },
  {
    "id": 1119,
    "topic_id": 3,
    "title": "True or false? The Hashed Message Authentication Code (HMAC) provides nonrepudiation.",
    "description": "FALSE."
  },
  {
    "id": 1120,
    "topic_id": 3,
    "title": "What are the three encryption algorithms supported by the Digital Signature Standard?",
    "description": "DSA, RSA, and ECDSA."
  },
  {
    "id": 1121,
    "topic_id": 3,
    "title": "What ITU standard describes the contents of a digital certificate?",
    "description": "X.509."
  },
  {
    "id": 1122,
    "topic_id": 3,
    "title": "What is the process by which you are issued a digital certificate?",
    "description": "Enrollment."
  },
  {
    "id": 1123,
    "topic_id": 3,
    "title": "Who issues digital certificates?",
    "description": "Certificate authorities (CAs)."
  },
  {
    "id": 1124,
    "topic_id": 3,
    "title": "True or false? PEM provides protection against replay attacks.",
    "description": "FALSE."
  },
  {
    "id": 1125,
    "topic_id": 3,
    "title": "What protocol uses the RSA encryption algorithm to provide encrypted mail support for a number of common commercial email packages?",
    "description": "S/MIME."
  },
  {
    "id": 1126,
    "topic_id": 3,
    "title": "True or false? S-HTTP secures individual messages between a client and a server.",
    "description": "TRUE."
  },
  {
    "id": 1128,
    "topic_id": 3,
    "title": "What are the four components of IPsec?",
    "description": "Authentication Header (AH), Encapsulating Security Payload (ESP), IP Payload Compression protocol (IPComp), and Internet Key Exchange (IKE)."
  },
  {
    "id": 1129,
    "topic_id": 3,
    "title": "What type of cryptographic attack is used against algorithms that don't incorporate temporal protections?",
    "description": "Replay attack."
  },
  {
    "id": 1130,
    "topic_id": 3,
    "title": "What are some common reasons a certificate might need to be revoked?",
    "description": "The certificate was compromised, the certificate was erroneously issued, the certificate details changed, the private key was exposed, or there was a change of security association."
  },
  {
    "id": 1131,
    "topic_id": 3,
    "title": "What type of cryptography relies on the use of public and private keys?",
    "description": "Asymmetric."
  },
  {
    "id": 1132,
    "topic_id": 3,
    "title": "What technology allows multiple users to make use of the same process without interfering with each other?",
    "description": "Multithreading."
  },
  {
    "id": 1133,
    "topic_id": 3,
    "title": "What are some of the terms used to describe the CPU mode that gives access to the full range of supported instructions?",
    "description": "System mode, privileged mode, supervisory mode, and kernel mode."
  },
  {
    "id": 1134,
    "topic_id": 3,
    "title": "What is the greatest security risk to RAM modules?",
    "description": "Theft."
  },
  {
    "id": 1135,
    "topic_id": 3,
    "title": "What addressing scheme supplies the CPU with the actual address of the memory location to be accessed?",
    "description": "Direct addressing."
  },
  {
    "id": 1136,
    "topic_id": 8,
    "title": "Magnetic/optical media devices are classified as what type of memory?",
    "description": "Secondary."
  },
  {
    "id": 1137,
    "topic_id": 8,
    "title": "Memory devices designed to retain their data when power is removed are known as ___________________.",
    "description": "nonvolatile."
  },
  {
    "id": 1138,
    "topic_id": 8,
    "title": "What two ways can storage devices be accessed?",
    "description": "Randomly and sequentially."
  },
  {
    "id": 1140,
    "topic_id": 3,
    "title": "What is another term often used for firmware?",
    "description": "Microcode."
  },
  {
    "id": 1141,
    "topic_id": 3,
    "title": "Where are the operating system\u2013independent primitive instructions that a computer needs to start and load the operating system stored?",
    "description": "BIOS or UEFI."
  },
  {
    "id": 1142,
    "topic_id": 3,
    "title": "What concept ensures that data existing at one level of security is not visible to processes running at different security levels?",
    "description": "Data hiding."
  },
  {
    "id": 1143,
    "topic_id": 1,
    "title": "What are the important factors in personnel management?",
    "description": "Hiring practices, ongoing job performance reviews, and termination procedures."
  },
  {
    "id": 1144,
    "topic_id": 1,
    "title": "What security mechanisms are countermeasures to collusion?",
    "description": "Job rotation, separation of duties, mandatory vacations, workstation change."
  },
  {
    "id": 1145,
    "topic_id": 1,
    "title": "Why is antivirus protection important?",
    "description": "Malware is the most common form of security breach in the IT world. Any communications pathway can be and is being exploited as a delivery mechanism for a virus or other malicious code."
  },
  {
    "id": 1146,
    "topic_id": 1,
    "title": "What is need to know?",
    "description": "Need to know is the requirement to have access to, knowledge of, or possession of data or a resource in order to perform specific work tasks."
  },
  {
    "id": 1148,
    "topic_id": 1,
    "title": "What are due care and due diligence?",
    "description": "Due diligence is establishing a plan, policy, and process to protect the interests of an organization. Due care is practicing the individual activities that maintain the due diligence effort. Due diligence is knowing what should be done and planning for it; due care is doing the right action at the right time."
  },
  {
    "id": 1149,
    "topic_id": 1,
    "title": "How are security and illegal activities related?",
    "description": "A secure environment should provide mechanisms to prevent illegal activities, which are actions that violate a legal restriction, regulation, or requirement."
  },
  {
    "id": 1150,
    "topic_id": 2,
    "title": "With what level of security precautions should backup media be treated?",
    "description": "Backup media should be handled with the same security precautions as any other asset with the same data classification."
  },
  {
    "id": 1151,
    "topic_id": 2,
    "title": "What are the goals of managing backup media?",
    "description": "Preventing disclosure, destruction, or alteration of data."
  },
  {
    "id": 1152,
    "topic_id": 2,
    "title": "What are the processes that can be applied to used media in order to prepare the media for reuse in various environments?",
    "description": "Erasing, clearing, and overwriting media that will be used in the same classification environments; purging, sanitizing, and degaussing if media is used in different classification environments."
  },
  {
    "id": 1153,
    "topic_id": 1,
    "title": "What are the classifications of security control types?",
    "description": "Preventive, deterrent, detective, corrective, recovery, compensation, directive."
  },
  {
    "id": 1154,
    "topic_id": 7,
    "title": "What is the purpose of auditing?",
    "description": "To ensure compliance with security policy and to detect abnormalities, unauthorized occurrences, or outright crimes."
  },
  {
    "id": 1155,
    "topic_id": 7,
    "title": "What types of activities are labeled as auditing?",
    "description": "Recording of event/occurrence data, examination of data, data reduction, use of event/occurrence alarm triggers, log analysis, logging, monitoring, using alerts, intrusion detection."
  },
  {
    "id": 1156,
    "topic_id": 1,
    "title": "What is the purpose of compliance testing?",
    "description": "To ensure that all of the necessary and required elements of a security solution are properly deployed and functioning as expected."
  },
  {
    "id": 1157,
    "topic_id": 7,
    "title": "How are audit trails used?",
    "description": "To reconstruct an event, to extract information about an incident, to prove or disprove culpability."
  },
  {
    "id": 1158,
    "topic_id": 6,
    "title": "What types of activities can be used as penetration tests?",
    "description": "Information/intelligence gathering, war driving, sniffing, eavesdropping, radiation monitoring, dumpster diving, social engineering, port scanning, ping scanning, vulnerability scanning, war dialing, and actual compromise activities."
  },
  {
    "id": 1159,
    "topic_id": 1,
    "title": "What are some ways to keep inappropriate content to a minimum?",
    "description": "Address the issue in the security policy, perform awareness training, use content filtering tools to filter source or word content."
  },
  {
    "id": 1160,
    "topic_id": 4,
    "title": "Why is it important to protect against resource waste?",
    "description": "If the storage space, computing power, or networking bandwidth capacity, is consumed by inappropriate or non-work-related (non-profit-producing) data, the organization loses money."
  },
  {
    "id": 1161,
    "topic_id": 4,
    "title": "Why is it important to protect against privilege abuse?",
    "description": "It can cause the disclosure of sensitive information, violating the principle of confidentiality."
  },
  {
    "id": 1162,
    "topic_id": 1,
    "title": "What countermeasures are moderately effective against errors and omissions?",
    "description": "Input validators and user training."
  },
  {
    "id": 1163,
    "topic_id": 1,
    "title": "How can you protect data against fraud and theft?",
    "description": "By using access controls (auditing and monitoring, for example)."
  },
  {
    "id": 1164,
    "topic_id": 1,
    "title": "What are some safeguards against sabotage?",
    "description": "Intensive auditing, monitoring for abnormal or unauthorized activity, keeping lines of communication open between employees and managers, compensating and recognizing employees for excellence."
  },
  {
    "id": 1165,
    "topic_id": 1,
    "title": "Why isn't there an effective direct countermeasure against the threat of malicious hackers?",
    "description": "Most safeguards and countermeasures protect against one specific threat or another, but it is not possible to protect against all possible threats that malicious hackers represent."
  },
  {
    "id": 1166,
    "topic_id": 8,
    "title": "What is malicious code?",
    "description": "Any script or program that performs an unwanted, unauthorized, or unknown activity on a computer system."
  },
  {
    "id": 1167,
    "topic_id": 1,
    "title": "True or false? Senior management should be included in the BCP process from the beginning.",
    "description": "TRUE."
  },
  {
    "id": 1168,
    "topic_id": 1,
    "title": "What resource is in greatest demand during the BCP testing, training, and maintenance process?",
    "description": "Personnel time and attention."
  },
  {
    "id": 1169,
    "topic_id": 1,
    "title": "What type of decision making is mainly concerned with metrics such as dollar values and downtime?",
    "description": "Quantitative."
  },
  {
    "id": 1170,
    "topic_id": 1,
    "title": "What business impact analysis/assessment variable is used to describe the longest period of time a resource can be unavailable without causing irreparable harm to the business?",
    "description": "Maximum tolerable downtime (MTD)."
  },
  {
    "id": 1171,
    "topic_id": 1,
    "title": "What is the formula for computing single loss expectancy?",
    "description": "SLE = AV * EF [Single Loss Expectancy = Asset Value * Exposure Factor]."
  },
  {
    "id": 1172,
    "topic_id": 1,
    "title": "What is the formula for computing annualized loss expectancy?",
    "description": "ALE = SLE * ARO [Annualized Loss Expectancy = Single Loss Expectancy * Annual Rate of Occurrence]."
  },
  {
    "id": 1173,
    "topic_id": 1,
    "title": "What are some of the qualitative factors that must be taken into account when assessing the cost of a disaster?",
    "description": "Loss of goodwill among client base, loss of employees after prolonged downtime, social/ethical responsibilities to the community, negative publicity."
  },
  {
    "id": 1174,
    "topic_id": 1,
    "title": "What is the first thing you should do when a disaster strikes?",
    "description": "Ensure that people are safe."
  },
  {
    "id": 1175,
    "topic_id": 1,
    "title": "What are the two possible responses to a risk?",
    "description": "Acceptance and mitigation."
  },
  {
    "id": 1176,
    "topic_id": 1,
    "title": "Provide two examples of devices that might be used to harden a system.",
    "description": "Computer-safe fire suppression systems and uninterruptible power supplies."
  },
  {
    "id": 1177,
    "topic_id": 1,
    "title": "What is the goal of business continuity planning (BCP)?",
    "description": "To ensure the continuous operation of a business in the face of an emergency situation."
  },
  {
    "id": 1178,
    "topic_id": 1,
    "title": "What are some of the elements that should be included in emergency response guidelines?",
    "description": "Immediate response procedures, notification procedures, secondary response procedures."
  },
  {
    "id": 1179,
    "topic_id": 1,
    "title": "What are the five steps of the business impact assessment process?",
    "description": "Identification of priorities, risk identification, likelihood assessment, impact assessment, resource prioritization."
  },
  {
    "id": 1180,
    "topic_id": 1,
    "title": "What process brings order to the chaotic events surrounding the interruption of an organization's normal activities by an emergency?",
    "description": "Disaster recovery planning (DRP)."
  },
  {
    "id": 1181,
    "topic_id": 7,
    "title": "Name some common natural disasters.",
    "description": "Possible answers include: earthquakes, floods, storms, tornadoes, tsunamis, pandemics, and fires, among others."
  },
  {
    "id": 1182,
    "topic_id": 7,
    "title": "What organization sponsors the National Flood Insurance Program and is a good source of historical flood information?",
    "description": "Federal Emergency Management Agency (FEMA)."
  },
  {
    "id": 1183,
    "topic_id": 7,
    "title": "What disaster recovery system is often highly dependent on the public water supply?",
    "description": "Fire suppression system."
  },
  {
    "id": 1184,
    "topic_id": 7,
    "title": "What type of disaster recovery separates recovery sites by business teams?",
    "description": "Workgroup recovery."
  },
  {
    "id": 1185,
    "topic_id": 7,
    "title": "What are the three major options for alternative processing sites?",
    "description": "Hot sites, warm sites, and cold sites."
  },
  {
    "id": 1186,
    "topic_id": 7,
    "title": "What type of recovery site is particularly suited to workgroup recovery options?",
    "description": "Mobile site."
  },
  {
    "id": 1187,
    "topic_id": 7,
    "title": "True or false? Organizations participating in a mutual assistance agreement are typically located in the same geographic region.",
    "description": "TRUE."
  },
  {
    "id": 1188,
    "topic_id": 7,
    "title": "True or false? There is an accepted standards document defining the requirements for an electronic vaulting solution.",
    "description": "FALSE."
  },
  {
    "id": 1189,
    "topic_id": 7,
    "title": "What is the most common document type used for emergency response plans?",
    "description": "Checklists."
  },
  {
    "id": 1190,
    "topic_id": 7,
    "title": "What are the three major types of filesystem backups?",
    "description": "Full backups, incremental backups, and differential backups."
  },
  {
    "id": 1191,
    "topic_id": 7,
    "title": "What can be used to protect a company against the failure of a developer to provide adequate support?",
    "description": "Software escrow agreements."
  },
  {
    "id": 1192,
    "topic_id": 7,
    "title": "It is sometimes useful to separate disaster ___________________ tasks from disaster ___________________ tasks.",
    "description": "recovery, restoration (in either order)."
  },
  {
    "id": 1193,
    "topic_id": 7,
    "title": "True or false? In most circumstances, it is illegal for an employer to monitor an employee's email.",
    "description": "FALSE."
  },
  {
    "id": 1194,
    "topic_id": 7,
    "title": "If a witness is not able to uniquely identify an object, how else may it be authenticated in court?",
    "description": "By establishing a chain of evidence."
  },
  {
    "id": 1195,
    "topic_id": 7,
    "title": "What type of evidence is an authenticated computer log?",
    "description": "Documentary evidence."
  },
  {
    "id": 1196,
    "topic_id": 7,
    "title": "What are the three major evidence admissibility requirements?",
    "description": "Evidence must be relevant, material, and competent."
  },
  {
    "id": 1197,
    "topic_id": 7,
    "title": "What law created the category of mission-critical computer systems?",
    "description": "Government Information Security Reform Act."
  },
  {
    "id": 1198,
    "topic_id": 1,
    "title": "What are the two requirements for acceptance of a trademark application?",
    "description": "The trademark must not be confusingly similar to another trademark, and it must not be descriptive."
  },
  {
    "id": 1199,
    "topic_id": 1,
    "title": "What are the three requirements for acceptance of a patent application?",
    "description": "The invention must be new, useful, and nonobvious."
  },
  {
    "id": 1200,
    "topic_id": 1,
    "title": "How long does trade secret protection last?",
    "description": "Indefinitely."
  },
  {
    "id": 1202,
    "topic_id": 1,
    "title": "What amendment to the U.S. Constitution forms the basis for privacy rights?",
    "description": "Fourth Amendment."
  },
  {
    "id": 1203,
    "topic_id": 1,
    "title": "What law requires that websites provide parents with the opportunity to review any information collected from their children?",
    "description": "Children's Online Privacy Protection Act."
  },
  {
    "id": 1204,
    "topic_id": 1,
    "title": "What law grants privacy rights to students enrolled in educational institutions that accept government funding?",
    "description": "Family Educational Rights and Privacy Act."
  },
  {
    "id": 1206,
    "topic_id": 7,
    "title": "Which type of computer crime would likely be timed to occur simultaneously with a physical attack to reduce the ability to effectively respond to the physical attack?",
    "description": "Terrorist attack."
  },
  {
    "id": 1207,
    "topic_id": 7,
    "title": "What term refers to any hardware, software, or data that can be used to prove the identity and actions of an attacker?",
    "description": "Evidence."
  },
  {
    "id": 1208,
    "topic_id": 8,
    "title": "What term describes any violation or threatened violation of a security policy?",
    "description": "Incident."
  },
  {
    "id": 1209,
    "topic_id": 8,
    "title": "Which type of incident generally does not cause direct damage to the victim?",
    "description": "Scanning. The purpose of a scanning attack is to collect information. The real damage to the system occurs in later attacks."
  },
  {
    "id": 1210,
    "topic_id": 8,
    "title": "How do you protect your system from a malicious code incident?",
    "description": "Make sure your security policy restricts the introduction of untested files to your computer system. Have a good scanner with an up-to-date signature database. Frequently scan all files. Implement whitelisting or allow listing of applications."
  },
  {
    "id": 1211,
    "topic_id": 8,
    "title": "Which two types of incidents are the easiest to stop by dynamically altering filtering rules?",
    "description": "Scanning and denial of service. They can both potentially be stopped by filtering out the offending packets."
  },
  {
    "id": 1212,
    "topic_id": 8,
    "title": "What must you do to make sure evidence is kept viable for use in a trial?",
    "description": "You must ensure that the evidence has not changed, and you must be able to validate its integrity."
  },
  {
    "id": 1213,
    "topic_id": 7,
    "title": "Where should you begin looking to find information about an incident that occurred in the recent past?",
    "description": "The first place to look is in the system and network log files."
  },
  {
    "id": 1214,
    "topic_id": 7,
    "title": "If an incident has occurred that has violated no laws or regulations, how do you determine whether to report it?",
    "description": "The incident reporting guidelines should be in your security policy."
  },
  {
    "id": 1215,
    "topic_id": 7,
    "title": "Is adherence to the ISC2 Code of Ethics recommended, mandatory, or optional for CISSPs?",
    "description": "Adherence to the ISC2 Code of Ethics is mandatory, and acceptance of the Code of Ethics is a condition of certification."
  },
  {
    "id": 1216,
    "topic_id": 7,
    "title": "What is the leading reason many incidents are not reported?",
    "description": "Because they are not recognized as incidents."
  },
  {
    "id": 1217,
    "topic_id": 3,
    "title": "What are the three main types of physical security controls?",
    "description": "Administrative physical security controls, technical physical security controls, physical controls for physical security."
  },
  {
    "id": 1218,
    "topic_id": 3,
    "title": "What is the primary purpose of lighting as a physical security device?",
    "description": "To discourage casual intruders, trespassers, prowlers, and would-be thieves."
  },
  {
    "id": 1219,
    "topic_id": 3,
    "title": "What are the benefits of security guards?",
    "description": "They are able to adapt and react to any condition or situation, are able to learn and recognize attack patterns, can adjust to a changing environment, and are able to make decisions and judgment calls."
  },
  {
    "id": 1220,
    "topic_id": 3,
    "title": "What are the disadvantages of security guards?",
    "description": "Not all environments support them; prescreening, bonding, and training is not always effective; they are expensive, subject to illness, take vacations, and are vulnerable to social engineering."
  },
  {
    "id": 1221,
    "topic_id": 3,
    "title": "What are the benefits and disadvantages of guard dogs?",
    "description": "They can be deployed as a perimeter security control and as detection and deterrent agents, they are costly and require high maintenance, and their use involves insurance and liability issues."
  },
  {
    "id": 1222,
    "topic_id": 3,
    "title": "What are the electrical terms and definitions you should be aware of?",
    "description": "Fault, blackout, sag, brownout, spike, surge, inrush, noise, clean, ground."
  },
  {
    "id": 1223,
    "topic_id": 3,
    "title": "What are the types of noise or interference and their sources?",
    "description": "Common mode noise is generated by the difference in power between the hot and ground wires. Traverse mode noise is generated by the difference in power between the hot and neutral wires."
  },
  {
    "id": 1224,
    "topic_id": 3,
    "title": "What are the typical HVAC requirements for a computer room?",
    "description": "A computer room should be kept at 60 to 75 degrees Fahrenheit (15 to 23 degrees Celsius). Humidity in a computer room should be maintained at between 40 and 60 percent."
  },
  {
    "id": 1225,
    "topic_id": 3,
    "title": "What type of damage occurs when static electricity discharges exceed 40 volts?",
    "description": "Destruction of sensitive circuits."
  },
  {
    "id": 1226,
    "topic_id": 3,
    "title": "What is a Type C fire extinguisher used for, and what is it made of?",
    "description": "A Type C fire extinguisher is for use on electrical devices, thus the extinguishing agent is nonconductive, so the devices might use CO2, halon, or various alternatives."
  },
  {
    "id": 1227,
    "topic_id": 3,
    "title": "What are the four types of water-based fire suppression systems?",
    "description": "Wet pipe system, dry pipe system, deluge system, preaction system."
  },
  {
    "id": 1229,
    "topic_id": 3,
    "title": "Which security vulnerability conveys information by altering the performance of a system component or modifying a resource's timing in a predictable manner?",
    "description": "Covert timing channel."
  },
  {
    "id": 1230,
    "topic_id": 3,
    "title": "What is a separate object that is associated with a resource and describes its security attributes?",
    "description": "Security token."
  },
  {
    "id": 1231,
    "topic_id": 3,
    "title": "In the Clark\u2013Wilson security model, what is a procedure that scans data items and confirms their integrity?",
    "description": "Integrity verification procedure (IVP)."
  },
  {
    "id": 1232,
    "topic_id": 3,
    "title": "In the Biba integrity model, what is the Simple Integrity Axiom, which states that a subject cannot read an object of a lower integrity, also called?",
    "description": "No read down."
  },
  {
    "id": 1233,
    "topic_id": 3,
    "title": "Which organization developed the Bell\u2013LaPadula security model?",
    "description": "The U.S. Department of Defense."
  },
  {
    "id": 1234,
    "topic_id": 3,
    "title": "What is the collection of TCB components that work together to implement the reference monitor functions?",
    "description": "Security kernel."
  },
  {
    "id": 1235,
    "topic_id": 3,
    "title": "What does ITSEC call the system that is being evaluated?",
    "description": "The target of evaluation (TOE)."
  },
  {
    "id": 1236,
    "topic_id": 3,
    "title": "What TCSEC category is reserved for systems that have been evaluated but do not meet the requirements of any other category?",
    "description": "Category D (minimal protection)."
  },
  {
    "id": 1237,
    "topic_id": 3,
    "title": "Which IPsec protocol component provides integrity, authentication, and nonrepudiation to the secure message exchange?",
    "description": "Authentication Header (AH)."
  },
  {
    "id": 1238,
    "topic_id": 3,
    "title": "Which type of controls considers static attributes of the subject and the object to determine the permissibility of an access?",
    "description": "Mandatory access controls."
  },
  {
    "id": 1239,
    "topic_id": 3,
    "title": "What term is used to refer to the user or process that makes a request to access a resource?",
    "description": "Subject."
  },
  {
    "id": 1240,
    "topic_id": 3,
    "title": "What is the imaginary boundary that separates the TCB from the rest of the system?",
    "description": "Security perimeter."
  },
  {
    "id": 1241,
    "topic_id": 3,
    "title": "What term describes the technical evaluation of each part of a computer system to assess its concordance with security standards?",
    "description": "Certification."
  },
  {
    "id": 1242,
    "topic_id": 4,
    "title": "What is the difference between analog and digital signals?",
    "description": "Analog communications occur with a continuous signal that varies in frequency, amplitude, and so on. Digital communications occur through the use of a state change of on-off pulses."
  },
  {
    "id": 1243,
    "topic_id": 4,
    "title": "What is the difference between synchronous and asynchronous communications?",
    "description": "Synchronous communications rely on a timing or clocking mechanism. Asynchronous communications rely on a stop and start delimiter bit to manage transmission of data."
  },
  {
    "id": 1244,
    "topic_id": 4,
    "title": "What is the difference between baseband and broadband communications?",
    "description": "Baseband technology uses a direct current to support a single communication channel. Broadband technology uses frequency modulation to support multiple simultaneous signals."
  },
  {
    "id": 1245,
    "topic_id": 4,
    "title": "Describe broadcast, multicast, and unicast communications.",
    "description": "A broadcast supports communications to all possible recipients. A multicast supports communications to multiple specific recipients. A unicast supports only a single communication to one recipient."
  },
  {
    "id": 1246,
    "topic_id": 4,
    "title": "What is the difference between packet switching and circuit switching?",
    "description": "In circuit switching, a dedicated physical pathway is created between the two parties. Packet switching occurs when the message is broken up into segments and sent across the intermediary network."
  },
  {
    "id": 1247,
    "topic_id": 4,
    "title": "What are the characteristics of PPP?",
    "description": "The Point-to-Point Protocol (PPP) is an encapsulation protocol designed to support the transmission of IP traffic over dial-up or point-to-point links. PPP supports CHAP and PAP for authentication."
  },
  {
    "id": 1249,
    "topic_id": 5,
    "title": "What is CORBA?",
    "description": "Common Object Request Broker Architecture (CORBA) is an international standard (sanctioned by the International Organization for Standardization) for distributed computing."
  },
  {
    "id": 1250,
    "topic_id": 5,
    "title": "What's the most desirable default setting for access control?",
    "description": "Denial. When access is not specifically granted, it should be denied by default. This is also known as implicit deny."
  },
  {
    "id": 1251,
    "topic_id": 5,
    "title": "What type of approach to security is considered better than a fortress mentality approach?",
    "description": "Defense in depth, multiple layers of security, concentric circles of security."
  },
  {
    "id": 1252,
    "topic_id": 5,
    "title": "What form of password attack consists first of a dictionary attack and then a brute-force attack based on the dictionary list?",
    "description": "A hybrid attack. Sometimes called a one-upped password attack."
  },
  {
    "id": 1254,
    "topic_id": 5,
    "title": "What is the most unacceptable form of biometric control to end users?",
    "description": "Retina scans."
  },
  {
    "id": 1255,
    "topic_id": 5,
    "title": "What is the stored sample of a biometric factor called?",
    "description": "A reference profile or a reference template."
  },
  {
    "id": 1256,
    "topic_id": 5,
    "title": "With what other forms of single sign-on can Kerberos be combined?",
    "description": "Any or all of them, including SESAME, KryptoKnight, NetSP, thin clients, directory services, and scripted access."
  },
  {
    "id": 1257,
    "topic_id": 5,
    "title": "How is the ticket-granting ticket used by Kerberos generated?",
    "description": "The user's password is hashed, and a timestamp is added."
  },
  {
    "id": 1258,
    "topic_id": 5,
    "title": "What is a centralized database of resources available to the network?",
    "description": "A directory service."
  },
  {
    "id": 1259,
    "topic_id": 5,
    "title": "What are examples of rule-based access control?",
    "description": "Attribute-based access control, rule-based access control, firewall rules."
  },
  {
    "id": 1260,
    "topic_id": 5,
    "title": "What form of access control can combine levels of security domains with compartments of additional control and isolation?",
    "description": "MAC (specifically, a hybrid MAC environment)."
  },
  {
    "id": 1261,
    "topic_id": 5,
    "title": "What form of access control is best suited to those organizations with a high rate of employee turnover?",
    "description": "RBAC."
  },
  {
    "id": 1262,
    "topic_id": 7,
    "title": "When an intrusion is detected, what should be the first response?",
    "description": "Contain or constrain the intrusion."
  },
  {
    "id": 1263,
    "topic_id": 7,
    "title": "Once an intrusion has occurred, what is the most secure process for restoring the environment?",
    "description": "Format and reinstall from scratch."
  },
  {
    "id": 1264,
    "topic_id": 7,
    "title": "What form of IDS is easier for an intruder to discover and disable?",
    "description": "Host-based IDS."
  },
  {
    "id": 1265,
    "topic_id": 4,
    "title": "What network device works primarily at the Application layer?",
    "description": "An Application layer Gateway."
  },
  {
    "id": 1266,
    "topic_id": 4,
    "title": "What are the most common causes of network failure?",
    "description": "Cable failures and misconfigurations."
  },
  {
    "id": 1267,
    "topic_id": 4,
    "title": "What type of cabling must be used to comply with building code safety requirements?",
    "description": "Plenum-rated cable."
  },
  {
    "id": 1268,
    "topic_id": 4,
    "title": "How many sockets does TCP have?",
    "description": "65, 536 (2^16) sockets (aka ports), numbered from 0 to 65,535."
  },
  {
    "id": 1269,
    "topic_id": 4,
    "title": "What is the IP header protocol field value for TCP? UDP? ICMP? IGMP?",
    "description": "6, 17, 1, 2."
  },
  {
    "id": 1270,
    "topic_id": 4,
    "title": "What protocol is used by <code>ping, pathping</code>, and <code>traceroute</code>?",
    "description": "ICMP."
  },
  {
    "id": 1271,
    "topic_id": 4,
    "title": "What is the APIPA range?",
    "description": "169.254.0.1 to 169.254.255.254 along with the default Class B subnet mask of 255.255.0.0."
  },
  {
    "id": 1272,
    "topic_id": 4,
    "title": "What port is used by IMAP?",
    "description": "143."
  },
  {
    "id": 1273,
    "topic_id": 4,
    "title": "What port is used by DHCP?",
    "description": "Port 68 for client request broadcast and port 67 for server point-to-point response."
  },
  {
    "id": 1274,
    "topic_id": 4,
    "title": "Network devices at what layer and above separate collision domains?",
    "description": "Layer 2."
  },
  {
    "id": 1275,
    "topic_id": 4,
    "title": "Network devices at what layer and above separate broadcast domains?",
    "description": "Layer 3."
  },
  {
    "id": 1276,
    "topic_id": 4,
    "title": "Which VPN protocol supports multiple simultaneous connections?",
    "description": "IPsec."
  },
  {
    "id": 1277,
    "topic_id": 4,
    "title": "What is the primary weakness of satellite communications?",
    "description": "Large terrestrial footprint."
  },
  {
    "id": 1278,
    "topic_id": 4,
    "title": "What makes the usable throughput of ISDN less than the stated bandwidth?",
    "description": "The D channel is used only for call management, not data."
  },
  {
    "id": 1279,
    "topic_id": 4,
    "title": "What type of system is a common target of attackers who want to disseminate email spam?",
    "description": "Open relay SMTP servers."
  },
  {
    "id": 1280,
    "topic_id": 4,
    "title": "What is the primary method to improve fax security?",
    "description": "Deactivate automatic printing of received faxes."
  },
  {
    "id": 1281,
    "topic_id": 1,
    "title": "What is the form of new system deployment testing called when the new system and the old system are run simultaneously?",
    "description": "Parallel run."
  },
  {
    "id": 1282,
    "topic_id": 1,
    "title": "When an asset no longer needs or warrants a high security sensitivity label, what should occur?",
    "description": "Declassification."
  },
  {
    "id": 1283,
    "topic_id": 1,
    "title": "What is the name of the security management approach in which senior management calls the shots?",
    "description": "Top-down approach."
  },
  {
    "id": 1284,
    "topic_id": 1,
    "title": "What is the cost/benefit analysis equation for countermeasures?",
    "description": "(ALE before safeguard \u2013 ALE after implementing the safeguard) \u2013 annual cost of safeguard = value of the safeguard to the company."
  },
  {
    "id": 1285,
    "topic_id": 8,
    "title": "What type of relationships can be established with relational databases? With hierarchical databases? With distributed databases?",
    "description": "One-to-one, one-to-many, and many-to-many."
  },
  {
    "id": 1286,
    "topic_id": 8,
    "title": "What are the six basic SQL commands?",
    "description": "<code>SELECT, UPDATE, DELETE, INSERT, GRANT, AND REVOKE.</code>"
  },
  {
    "id": 1287,
    "topic_id": 8,
    "title": "What is a placeholder for SQL literal values such as numbers or character strings?",
    "description": "Bind variable."
  },
  {
    "id": 1288,
    "topic_id": 8,
    "title": "What database security feature uses locking to prevent simultaneous write access to cells?",
    "description": "Concurrency."
  },
  {
    "id": 1289,
    "topic_id": 8,
    "title": "What database security feature can be used to subvert aggregation, inferencing, and contamination vulnerabilities?",
    "description": "Database partitioning."
  },
  {
    "id": 1290,
    "topic_id": 8,
    "title": "What feature of databases allows two or more rows in the same table to appear to have identical primary key elements but contain different data for use at differing classification levels?",
    "description": "Polyinstantiation."
  },
  {
    "id": 1291,
    "topic_id": 8,
    "title": "What acts as an interface between back-end database systems and user applications?",
    "description": "ODBC."
  },
  {
    "id": 1292,
    "topic_id": 8,
    "title": "What attack collects numerous low-level security items or low-value items and combines them to create something of a higher security level or value?",
    "description": "Aggregation."
  },
  {
    "id": 1293,
    "topic_id": 8,
    "title": "What is more secure than a data warehouse and designed to store metadata?",
    "description": "Data mart."
  },
  {
    "id": 1294,
    "topic_id": 8,
    "title": "What type of application analyzes business data and presents it in such a way as to make business decisions easier for users?",
    "description": "Decision support system."
  },
  {
    "id": 1295,
    "topic_id": 8,
    "title": "What security problem cannot be prevented or compensated for by environmental controls or hardware devices?",
    "description": "Bad coding."
  },
  {
    "id": 1296,
    "topic_id": 8,
    "title": "What is a valid security response when an application violates OS-imposed security, such as interfering with other processes or accessing hardware directly?",
    "description": "Stopping the environment, a STOP error, a BSOD."
  },
  {
    "id": 1297,
    "topic_id": 8,
    "title": "What is it called when programmers decompile vendor code in order to understand the intricate details of its functionality?",
    "description": "Reverse engineering."
  },
  {
    "id": 1298,
    "topic_id": 8,
    "title": "What is the communication to or input of an object?",
    "description": "Message."
  },
  {
    "id": 1299,
    "topic_id": 8,
    "title": "What is the internal code that defines the actions an object performs in response to a message?",
    "description": "Method."
  },
  {
    "id": 1300,
    "topic_id": 8,
    "title": "What are the results or output exhibited by an object based on processing a message through a method?",
    "description": "Behavior."
  },
  {
    "id": 1301,
    "topic_id": 8,
    "title": "What is the collection of the common methods from a set of objects that is used to define the behavior of those objects?",
    "description": "Class."
  },
  {
    "id": 1302,
    "topic_id": 8,
    "title": "What is it called when an object is an example of a class because the object contains a method from that class?",
    "description": "Instance."
  },
  {
    "id": 1303,
    "topic_id": 8,
    "title": "What characteristic describes an object that exhibits different behaviors based on the same message and methods because of variances in external conditions?",
    "description": "Polymorphism."
  },
  {
    "id": 1304,
    "topic_id": 8,
    "title": "Highly __________ objects are not as dependent on other objects.",
    "description": "cohesive."
  },
  {
    "id": 1305,
    "topic_id": 8,
    "title": "Lower ___________ provides better software design because objects are more independent.",
    "description": "coupling."
  },
  {
    "id": 1306,
    "topic_id": 8,
    "title": "What is a type of bar chart that shows the interrelationships over time between projects and schedules?",
    "description": "Gantt chart."
  },
  {
    "id": 1307,
    "topic_id": 8,
    "title": "What is a project-scheduling tool that is used to judge the size of a software product in development and calculate the standard deviation for risk assessment?",
    "description": "Program Evaluation Review Technique (PERT)."
  },
  {
    "id": 1308,
    "topic_id": 8,
    "title": "What form of testing examines the internal logical structures of a program?",
    "description": "White-box testing or known environment testing."
  },
  {
    "id": 1309,
    "topic_id": 8,
    "title": "What form of testing examines the input and output of a program without focusing on the internal logical structures?",
    "description": "Black-box testing or unknown environment testing."
  },
  {
    "id": 1310,
    "topic_id": 8,
    "title": "What form of testing examines the extent of the system testing in order to locate untested program logic?",
    "description": "Test data method."
  },
  {
    "id": 1311,
    "topic_id": 8,
    "title": "Which form of antivirus response not only removes the virus from the system but also repairs any related damage?",
    "description": "Cleaning."
  },
  {
    "id": 1312,
    "topic_id": 3,
    "title": "What is the name of the assumption that all algorithms should be public but all keys should remain private?",
    "description": "Kerckhoffs's principle."
  },
  {
    "id": 1313,
    "topic_id": 3,
    "title": "What is the range of valid values of keys for an algorithm called?",
    "description": "Key space."
  },
  {
    "id": 1314,
    "topic_id": 3,
    "title": "What defines the hardware and software requirements of cryptographic modules in use by the federal government?",
    "description": "Federal Information Processing Standards (FIPS-140-2)."
  },
  {
    "id": 1315,
    "topic_id": 3,
    "title": "What acts as a placeholder variable in mathematical functions and is used in random number generation?",
    "description": "Nonce."
  },
  {
    "id": 1316,
    "topic_id": 3,
    "title": "What is a random bit string (a nonce) that is the same length as the block size that is XORed with the message and adds strength to cryptography systems?",
    "description": "Initialization vector (IV)."
  },
  {
    "id": 1317,
    "topic_id": 3,
    "title": "What is the most significant bit in a string?",
    "description": "The leftmost bit."
  },
  {
    "id": 1318,
    "topic_id": 3,
    "title": "What is it called when a plaintext message generates identical cipher-text messages using the same algorithm but different keys?",
    "description": "Clustering or key clustering."
  },
  {
    "id": 1319,
    "topic_id": 3,
    "title": "What is a concept of communication whereby a specific type of information is exchanged but no real data is exchanged?",
    "description": "Zero-knowledge proof."
  },
  {
    "id": 1320,
    "topic_id": 3,
    "title": "What is the basic idea that the information or privilege required to perform an operation is divided among multiple users (it is an application of separation of duties)?",
    "description": "Split knowledge."
  },
  {
    "id": 1321,
    "topic_id": 3,
    "title": "What is an example of split knowledge employed to protect key escrow?",
    "description": "M of N control."
  },
  {
    "id": 1322,
    "topic_id": 3,
    "title": "What is a way of measuring the strength of a cryptography system by measuring the effort in terms of cost and/or time?",
    "description": "Work function or work factor."
  },
  {
    "id": 1323,
    "topic_id": 3,
    "title": "What is an example of a polyalphabetic substitution cipher?",
    "description": "Vigen\u00e8re cipher."
  },
  {
    "id": 1324,
    "topic_id": 3,
    "title": "What attack is often successful against substitution ciphers?",
    "description": "Frequency analysis."
  },
  {
    "id": 1325,
    "topic_id": 3,
    "title": "What attack is often successful against polyalphabetic substitution ciphers?",
    "description": "Period analysis."
  },
  {
    "id": 1326,
    "topic_id": 3,
    "title": "What form of encryption is used to protect communications that occur in real time?",
    "description": "Stream ciphers."
  },
  {
    "id": 1327,
    "topic_id": 3,
    "title": "What form of encryption can provide secure communications between two parties when they have no prior method of communicating securely?",
    "description": "Asymmetric cryptography."
  },
  {
    "id": 1329,
    "topic_id": 3,
    "title": "What are the valid key sizes for RC5?",
    "description": "0 to 2,048 bits."
  },
  {
    "id": 1330,
    "topic_id": 2,
    "title": "If a message is signed and encrypted, what security services are you providing?",
    "description": "Confidentiality, integrity, authenticity/access control, and nonrepudiation."
  },
  {
    "id": 1331,
    "topic_id": 2,
    "title": "Who has the responsibility to ensure that communications are secured?",
    "description": "The sender."
  },
  {
    "id": 1333,
    "topic_id": 4,
    "title": "What is the standard that wireless networking technology is based on?",
    "description": "802.11."
  },
  {
    "id": 1334,
    "topic_id": 3,
    "title": "What cryptographic attack attempts to find a weakness in the algorithm?",
    "description": "Analytic attack."
  },
  {
    "id": 1335,
    "topic_id": 3,
    "title": "What cryptographic attack attempts to find a weakness in the software code?",
    "description": "Implementation attack."
  },
  {
    "id": 1336,
    "topic_id": 3,
    "title": "What cryptographic attack attempts to exploit weaknesses in the computer hardware or operating system?",
    "description": "Statistical attack."
  },
  {
    "id": 1339,
    "topic_id": 3,
    "title": "What are the security requests of a client called under Common Criteria?",
    "description": "Protection profile."
  },
  {
    "id": 1340,
    "topic_id": 3,
    "title": "What are the security features of a designed system called under Common Criteria?",
    "description": "Security target."
  },
  {
    "id": 1342,
    "topic_id": 3,
    "title": "What is the name of the accreditation process of the Department of Defense?",
    "description": "Defense Information Technology Security Certification and Accreditation Process (DITSCAP)."
  },
  {
    "id": 1343,
    "topic_id": 3,
    "title": "What are the three forms of accreditation offered by National Information Assurance Certification and Accreditation Process (NIACAP)?",
    "description": "Site, type, system."
  },
  {
    "id": 1344,
    "topic_id": 3,
    "title": "What are often added to passwords under Linux to make their resultant hash even more secure?",
    "description": "Salts."
  },
  {
    "id": 1345,
    "topic_id": 7,
    "title": "When a disaster strikes but your ability to perform work tasks is only threatened, not actually interrupted, what response should be used?",
    "description": "BCP."
  },
  {
    "id": 1346,
    "topic_id": 7,
    "title": "What is always your top priority when dealing with a disaster of any type or significance?",
    "description": "Safety of personnel."
  },
  {
    "id": 1347,
    "topic_id": 7,
    "title": "What feature of insurance can improve your ability to replace lost or damaged assets?",
    "description": "Actual Cost Value (ACV)."
  },
  {
    "id": 1348,
    "topic_id": 7,
    "title": "What is the most common cause of unplanned downtime?",
    "description": "Hardware failures."
  },
  {
    "id": 1349,
    "topic_id": 7,
    "title": "What are some examples of alternate processing facilities that should be considered when designing a DRP?",
    "description": "Hot, warm, and cold sites; mobile sites; service bureaus; multiple sites; and reciprocal agreements/mutual assistance agreements (MAA)."
  },
  {
    "id": 1350,
    "topic_id": 7,
    "title": "What forms of backup always set the archive bit to 0?",
    "description": "Full and incremental."
  },
  {
    "id": 1351,
    "topic_id": 7,
    "title": "What backup media may be appropriate for personal backups but not for network backups?",
    "description": "Writable CDs, DVDs, and Blu-ray discs as well as flash drives. These and similar types of smaller capacity storage mechanisms are useful for holding smaller amounts of data than when compared to enterprise options such as multiterabyte hard drives and tapes."
  },
  {
    "id": 1352,
    "topic_id": 7,
    "title": "What form of backup, when used to restore data, will always result in some amount of data loss?",
    "description": "Periodic backups."
  },
  {
    "id": 1353,
    "topic_id": 1,
    "title": "What law requires all communications carriers to make wiretaps possible for law enforcement with an appropriate court order regardless of the technology in use?",
    "description": "Communications Assistance for Law Enforcement Act (CALEA) of 1994."
  },
  {
    "id": 1354,
    "topic_id": 1,
    "title": "What law extends the definition of property to include proprietary economic information so that the theft of this information can be considered industrial or corporate espionage?",
    "description": "Economic and Protection of Proprietary Information Act of 1996."
  },
  {
    "id": 1355,
    "topic_id": 3,
    "title": "__________ controls are your first line of defense, whereas ________ are your last line of defense.",
    "description": "Physical, people."
  },
  {
    "id": 1356,
    "topic_id": 3,
    "title": "What is the functional order of controls when deployed for physical security?",
    "description": "The functional order of controls when deployed for physical security is deter, deny, detect, delay, determine, and decide."
  },
  {
    "id": 1357,
    "topic_id": 3,
    "title": "What type of lock consists of three elements: an electromagnet, a credential reader, and a door-closed sensor?",
    "description": "Electronic access control (EAC)."
  },
  {
    "id": 1358,
    "topic_id": 3,
    "title": "Reviewing the recorded images from CCTV is what type of security control?",
    "description": "Detection."
  },
  {
    "id": 1359,
    "topic_id": 2,
    "title": "What is the primary difference between memory cards and smartcards?",
    "description": "Processing capability."
  },
  {
    "id": 1360,
    "topic_id": 3,
    "title": "At what stage of a fire is a flame visible?",
    "description": "Stage 3: Flame."
  },
  {
    "id": 1361,
    "topic_id": 3,
    "title": "What is the most common cause of fires in a data center?",
    "description": "Overloaded electrical distribution outlets."
  },
  {
    "id": 1362,
    "topic_id": 3,
    "title": "Where should fire detectors be placed?",
    "description": "In dropped ceilings, raised floors, server rooms, private offices and public areas, HVAC vents, elevator shafts, the basement, and so on."
  },
  {
    "id": 1363,
    "topic_id": 3,
    "title": "What is the most common cause of failure of a water-based suppression system?",
    "description": "Human error."
  },
  {
    "id": 1364,
    "topic_id": 4,
    "title": "Name one or more examples of vector routing protocol.",
    "description": "RIP, IGRP, BGP."
  },
  {
    "id": 1365,
    "topic_id": 4,
    "title": "Name an example of a link state routing protocol.",
    "description": "Open Shortest Path First (OSPF), ISO's Intermediate System to Intermediate System (IS-IS)."
  },
  {
    "id": 1366,
    "topic_id": 4,
    "title": "At what layer does SSL and TLS function?",
    "description": "Transport layer (OSI layer 4)."
  },
  {
    "id": 1367,
    "topic_id": 4,
    "title": "Name at least four technologies commonly called wireless.",
    "description": "802.11 networking, Bluetooth (802.15), mobile phones, and cordless phones."
  },
  {
    "id": 1369,
    "topic_id": 4,
    "title": "Name three wireless frequency access technologies.",
    "description": "FHSS, DSSS, and OFDM."
  },
  {
    "id": 1372,
    "topic_id": 4,
    "title": "What is the IEEE standard for WiMax?",
    "description": "802.16."
  },
  {
    "id": 1373,
    "topic_id": 4,
    "title": "What is another name for the area of Bluetooth connectivity?",
    "description": "Personal area network (PAN)."
  },
  {
    "id": 1374,
    "topic_id": 4,
    "title": "What is the primary security feature of Bluetooth pairing?",
    "description": "A four-digit PIN."
  },
  {
    "id": 1375,
    "topic_id": 4,
    "title": "What two items are required for infrastructure mode wireless networking?",
    "description": "Wireless access points and wireless clients."
  },
  {
    "id": 1376,
    "topic_id": 4,
    "title": "What mode is used when a wireless network link is established without the use of an access point?",
    "description": "Ad hoc or peer-to-peer."
  },
  {
    "id": 1377,
    "topic_id": 4,
    "title": "What is the minimum amount of information needed by a wireless client to connect to a network hosted by a wireless access point?",
    "description": "SSID."
  },
  {
    "id": 1378,
    "topic_id": 4,
    "title": "Name four examples of infrastructure mode wireless networking.",
    "description": "Standalone, wired extension, enterprise extended, and bridge."
  },
  {
    "id": 1382,
    "topic_id": 4,
    "title": "What two forms of authentication are supported by 802.11?",
    "description": "Open System Authentication (OSA) and Shared Key Authentication (SKA)."
  },
  {
    "id": 1383,
    "topic_id": 4,
    "title": "What is the minimum length of a TCP header?",
    "description": "20 bytes."
  },
  {
    "id": 1384,
    "topic_id": 4,
    "title": "How long is a UDP header?",
    "description": "8 bytes."
  },
  {
    "id": 1385,
    "topic_id": 4,
    "title": "What are the four TCP header flags that are used in virtual circuit setup and teardown?",
    "description": "SYN, ACK, FIN, and RES (or RST)."
  },
  {
    "id": 1386,
    "topic_id": 4,
    "title": "What two ICMP type field values are employed in a successful ping activity?",
    "description": "8: echo request, 0: echo reply."
  },
  {
    "id": 1387,
    "topic_id": 1,
    "title": "What is Control Objectives for Information and Related Technology (COBIT)?",
    "description": "COBIT a documented set of best IT security practices crafted by the Information Systems Audit and Control Association (ISACA). It prescribes goals and requirements for security controls and encourages the mapping of IT security ideals to business objectives. COBIT is based on six key principles."
  },
  {
    "id": 1390,
    "topic_id": 7,
    "title": "What form of testing examines the input and output of a program with access to the internal logical structures?",
    "description": "Gray-box testing or semi-known environment testing."
  },
  {
    "id": 1391,
    "topic_id": 1,
    "title": "What kinds of items qualify as access controls?",
    "description": "Any hardware, software, or organizational administrative policy or procedure that maintains confidentiality, integrity, and/or accountability also counts as an access control."
  },
  {
    "id": 1392,
    "topic_id": 1,
    "title": "What is the proper term for ensuring that information is accessible only to authorized parties?",
    "description": "Confidentiality."
  },
  {
    "id": 1393,
    "topic_id": 1,
    "title": "What is the proper term for the assurance that information and security controls used to protect information are accessible and usable when needed?",
    "description": "Availability."
  },
  {
    "id": 1394,
    "topic_id": 1,
    "title": "What is it called when an authorized party indicates its intention to fulfill some contractual obligation and forgoes its right to dispute that fulfillment after the fact?",
    "description": "Nonrepudiation."
  },
  {
    "id": 1395,
    "topic_id": 1,
    "title": "Items of information used to establish or prove authorized identities are known as what kind of factors?",
    "description": "Authentication."
  },
  {
    "id": 1396,
    "topic_id": 1,
    "title": "What kind of access control enforces access policy determined by the owner of the object to which the control applies?",
    "description": "Discretionary access control (DAC)."
  },
  {
    "id": 1397,
    "topic_id": 1,
    "title": "What kind of access control is determined by the system in which the object resides rather than its owner?",
    "description": "Mandatory access control (MAC)."
  },
  {
    "id": 1398,
    "topic_id": 1,
    "title": "Which access control scheme requires organizational roles to be defined along with various task requirements and applicable object permissions?",
    "description": "Role-based access control (RBAC)."
  },
  {
    "id": 1399,
    "topic_id": 5,
    "title": "Which access control scheme requires administrative rules to be defined along with the various conditions under which they apply as well as applicable object permissions?",
    "description": "Rule-based access control."
  },
  {
    "id": 1400,
    "topic_id": 5,
    "title": "What is the practice of defense in depth called when it involves a multilayered security infrastructure that includes multiple combined individual applications and processes?",
    "description": "Concentric circle strategy."
  },
  {
    "id": 1401,
    "topic_id": 2,
    "title": "What is the term for exercising reasonable care in protecting organizational assets and interests, including development of a formalized security structure consisting of policies, procedures, and protocols?",
    "description": "Due care."
  },
  {
    "id": 1402,
    "topic_id": 2,
    "title": "When users are granted only the minimum access necessary to complete some task or process, what principle is involved?",
    "description": "The principle of least privilege."
  },
  {
    "id": 1403,
    "topic_id": 2,
    "title": "What kinds of processes must be applied when confidential storage media is prepared for reuse in questionably secure environments?",
    "description": "Declassification."
  },
  {
    "id": 1404,
    "topic_id": 2,
    "title": "What is the name for the demagnetization process used to erase disk drives or tapes to wipe out all previously stored data?",
    "description": "Degaussing."
  },
  {
    "id": 1405,
    "topic_id": 1,
    "title": "What kind of control does any security tool provide when it's used to guide the security implementation within an organization?",
    "description": "Directive control."
  },
  {
    "id": 1406,
    "topic_id": 1,
    "title": "What kind of control does any mechanism, tool, or practice provide if it deters or mitigates undesirable actions or events?",
    "description": "Preventive control."
  },
  {
    "id": 1407,
    "topic_id": 1,
    "title": "What kind of control should be used to verify the effectiveness of other security controls?",
    "description": "Detective control."
  },
  {
    "id": 1408,
    "topic_id": 1,
    "title": "What kind of check should be applied to ensure that all necessary elements of a security solution are properly deployed and functioning as expected?",
    "description": "Compliance checking."
  },
  {
    "id": 1409,
    "topic_id": 7,
    "title": "What do you call a person who is trained in responsible network security methods, who employs a philosophy of nondestructive and nonintrusive penetration testing, but who may also use underground or \"black-hat\" or unauthorized entity tools?",
    "description": "Ethical hacker."
  },
  {
    "id": 1410,
    "topic_id": 7,
    "title": "What is the proper name for a criminal act committed against an organization by a current or former employee who exploits knowledge gained on the job in its perpetration?",
    "description": "Sabotage."
  },
  {
    "id": 1411,
    "topic_id": 7,
    "title": "What is the proper name for the illegal intent behind obtaining and profiting from sensitive information that belongs to some third party (government, corporation, individual, and so on)?",
    "description": "Espionage."
  },
  {
    "id": 1412,
    "topic_id": 5,
    "title": "When a person attempts to deceive an insider within an organization to divulge sensitive information or to perform sensitive actions on their behalf, what might this be called?",
    "description": "Social engineering."
  },
  {
    "id": 1413,
    "topic_id": 6,
    "title": "When a penetration test team is privy to detailed information about organizational assets, including hardware and software inventory, but not to other information (accounts, users, naming conventions, and so on), how might this team be described?",
    "description": "Partial-knowledge team."
  },
  {
    "id": 1414,
    "topic_id": 6,
    "title": "When a penetration test team is privy only to what it itself can learn about the target organizations for the test, how might this team be described?",
    "description": "Zero-knowledge team (performs black-box testing or unknown environment testing)."
  },
  {
    "id": 1415,
    "topic_id": 6,
    "title": "What term identifies the data extraction technique whereby elements of data are extracted from a much larger body of data to construct a meaningful representation of its overall contents?",
    "description": "Sampling."
  },
  {
    "id": 1416,
    "topic_id": 2,
    "title": "What governs how long records are kept to substantiate system security assessments and support system analysis?",
    "description": "Record retention."
  },
  {
    "id": 1417,
    "topic_id": 1,
    "title": "What does BCP stand for, and what does it mean?",
    "description": "Business continuity planning (BCP) is the preventive practice of establishing and planning for threats to business flow, including natural and unnatural risk and threats to daily operations."
  },
  {
    "id": 1418,
    "topic_id": 7,
    "title": "What does DRP stand for, and what does it mean?",
    "description": "Disaster recovery planning (DRP) is the practice of establishing and executing recovery actions as part of an emergency response following a disaster."
  },
  {
    "id": 1419,
    "topic_id": 7,
    "title": "What term describes damage from disruptive and irresistible forces of nature (such as earthquakes, floods, storms, and so on)?",
    "description": "Natural disaster."
  },
  {
    "id": 1420,
    "topic_id": 7,
    "title": "What term describes damage resulting from arson, human error, acts of terrorism, or power outages and other utility failures?",
    "description": "Human-made or person-made disaster."
  },
  {
    "id": 1421,
    "topic_id": 7,
    "title": "What kind of strategy drives defining practices, policies, and procedures to restore a business to normal operation in the wake of some kind of outage or disaster?",
    "description": "Recovery strategy."
  },
  {
    "id": 1422,
    "topic_id": 7,
    "title": "What label applies to a partial standby facility for which power and other infrastructure elements are available, but for which no operational computing facilities are supplied in advance of a disaster?",
    "description": "Cold site."
  },
  {
    "id": 1423,
    "topic_id": 7,
    "title": "What label applies to a standby facility that is ready to take over for a primary facility as soon as notice is received that the primary facility has gone down?",
    "description": "Hot site."
  },
  {
    "id": 1424,
    "topic_id": 7,
    "title": "What label applies to a site that is already provisioned with hardware and software to take over for a primary facility but that needs to obtain and install a backup or image of client-specific data before going online?",
    "description": "Warm site."
  },
  {
    "id": 1425,
    "topic_id": 7,
    "title": "How might you describe a site housed in self-contained transportable units with all the control, hardware, and software elements necessary to establish an operational, safe computing environment?",
    "description": "Mobile site."
  },
  {
    "id": 1426,
    "topic_id": 7,
    "title": "What roles can a service bureau play in disaster recovery?",
    "description": "Service bureaus lease computer time via contractual agreements and can meet an organization's entire IT needs in the event of disaster or catastrophic failure."
  },
  {
    "id": 1427,
    "topic_id": 3,
    "title": "What is critical path analysis?",
    "description": "A systematic effort to identify relationships between mission-critical applications, processes, and operations and all of the necessary supporting elements."
  },
  {
    "id": 1428,
    "topic_id": 3,
    "title": "Name three examples of administrative physical security controls.",
    "description": "Examples of administrative physical security controls are facility construction and selection, site management, building design, personnel controls, awareness training, and emergency response and procedures."
  },
  {
    "id": 1429,
    "topic_id": 3,
    "title": "Name three examples of technical physical security controls.",
    "description": "Technical physical security controls can be building access controls; intrusion detection; alarms; security cameras; monitoring; heating, ventilation, and air-conditioning (HVAC) power supplies; and fire detection and suppression."
  },
  {
    "id": 1430,
    "topic_id": 3,
    "title": "Name three physical controls for physical security.",
    "description": "Physical controls for physical security are fencing, lighting, locks, construction materials, access control vestibules (formerly known as mantraps), guard dogs, and security guards."
  },
  {
    "id": 1431,
    "topic_id": 3,
    "title": "What term describes the act of gathering information about a system by observing the display or watching an operator at the keyboard?",
    "description": "Shoulder surfing."
  },
  {
    "id": 1432,
    "topic_id": 4,
    "title": "What term describes the act of using another person's security ID to gain unauthorized entry into a facility?",
    "description": "Masquerading."
  },
  {
    "id": 1433,
    "topic_id": 3,
    "title": "When one person follows another through a secured gate or doorway without presenting identification or otherwise being authenticated, what is this entry technique called?",
    "description": "Piggybacking."
  },
  {
    "id": 1434,
    "topic_id": 4,
    "title": "What kind of system is designed to detect intrusions, breaches, or attack attempts as they are underway or after the fact?",
    "description": "Intrusion detection system (IDS)."
  },
  {
    "id": 1435,
    "topic_id": 3,
    "title": "What does UPS stand for, and what does it mean?",
    "description": "An uninterruptible power supply (UPS) is a type of self-charging battery that can be used to supply consistent clean power to sensitive equipment."
  },
  {
    "id": 1436,
    "topic_id": 4,
    "title": "What does EMI stand for, and what does it mean?",
    "description": "Electromagnetic interference (EMI) refers to any noise generated by electric current and can affect any means of data transmission or storage that relies on electromagnetic transport mechanisms."
  },
  {
    "id": 1437,
    "topic_id": 8,
    "title": "Describe the models of systems development.",
    "description": "The waterfall model is a sequential development process.  The spiral model uses several iterations of the waterfall model to produce a number of fully specified and tested prototypes. Agile development models place an emphasis on customer needs and quickly developing new functionality in an iterative fashion."
  },
  {
    "id": 1438,
    "topic_id": 8,
    "title": "Describe the purpose of software development maturity models.",
    "description": "Maturity models help software organizations improve the maturity and quality of their software processes by implementing an evolutionary path from ad hoc, chaotic processes to mature, disciplined software processes."
  },
  {
    "id": 1439,
    "topic_id": 8,
    "title": "What are the important elements of change and configuration management?",
    "description": "The three basic components of change control are request control, change control, and release control."
  },
  {
    "id": 1440,
    "topic_id": 3,
    "title": "What is TEMPEST?",
    "description": "TEMPEST is a standard for the study and control of electronic signals produced by various types of electronic hardware, such as computers, televisions, phones, and so on. Its primary goal is to prevent EMI and RFI radiation from leaving a strictly defined area to eliminate the possibility of external radiation monitoring, eavesdropping, and signal sniffing. The term TEMPEST has become less common, and the corresponding security discipline is now emission security (EMSEC)."
  },
  {
    "id": 1441,
    "topic_id": 8,
    "title": "What is static software testing?",
    "description": "Static testing evaluates the security of software without running it by analyzing either the source code or the compiled application. Static analysis usually involves the use of automated tools designed to detect common software flaws, such as buffer overflows."
  },
  {
    "id": 1442,
    "topic_id": 8,
    "title": "What type of software testing is most appropriate when the tester does not have access to the underlying source code?",
    "description": "Dynamic testing."
  },
  {
    "id": 1443,
    "topic_id": 8,
    "title": "What does malicious code often create on an infected system to allow the developers of the malicious code to remotely access the system at a later time?",
    "description": "Backdoor."
  },
  {
    "id": 1444,
    "topic_id": 3,
    "title": "What name is given to the cryptographic concept of making the relationship between the plaintext and the key so complex that an attacker can't use known plaintext attacks to determine the key?",
    "description": "Confusion."
  },
  {
    "id": 1445,
    "topic_id": 1,
    "title": "What types of organizations need to comply with PCI DSS?",
    "description": "Those that store, process, or transmit credit card account information."
  },
  {
    "id": 1446,
    "topic_id": 1,
    "title": "What trend makes it especially important to incorporate an assessment of security controls in contracting and procurement reviews?",
    "description": "The increased use of third-party and cloud services."
  },
  {
    "id": 1447,
    "topic_id": 7,
    "title": "What are the branches of forensic analysis?",
    "description": "Media analysis, network analysis, software analysis, and hardware/embedded device analysis."
  },
  {
    "id": 1448,
    "topic_id": 5,
    "title": "What is it called when a user has more access, privilege, or permission than their assigned work tasks dictate?",
    "description": "Excessive privileges (also known as the violation of least privilege)."
  },
  {
    "id": 1449,
    "topic_id": 5,
    "title": "What is it called when a user accumulates privileges over time as their job roles and assigned tasks change but unneeded privileges are not revoked?",
    "description": "Creeping privileges or privilege creep."
  },
  {
    "id": 1450,
    "topic_id": 5,
    "title": "Which access control scheme requires administrative rules to be defined along with the various conditions under which they apply as well as applicable object permissions?",
    "description": "Rule-based access control."
  },
  {
    "id": 1451,
    "topic_id": 3,
    "title": "Name some physical controls for physical security.",
    "description": "Fencing, lighting, locks, construction materials, mantraps, watchdogs, guards."
  },
  {
    "id": 1452,
    "topic_id": 5,
    "title": "What term is used to refer to the user or process that makes a request to access a resource?",
    "description": "Subject."
  },
  {
    "id": 1453,
    "topic_id": 5,
    "title": "What kind of control does any mechanism, tool, or practice provide if it deters or mitigates undesirable actions or events?",
    "description": "Preventive control."
  },
  {
    "id": 1454,
    "topic_id": 5,
    "title": "What process identifies the actual value of assets so that assets can be prioritized?",
    "description": "Asset valuation."
  },
  {
    "id": 1455,
    "topic_id": 1,
    "title": "What process identifies and categorizes potential threats?",
    "description": "Threat modeling."
  },
  {
    "id": 1456,
    "topic_id": 1,
    "title": "What process is used to identify weaknesses?",
    "description": "Vulnerability analysis."
  },
  {
    "id": 1457,
    "topic_id": 1,
    "title": "When evaluating access control attacks, what are three primary elements that must be identified?",
    "description": "Assets, threats, and vulnerabilities."
  },
  {
    "id": 1458,
    "topic_id": 1,
    "title": "A group of attackers is sponsored by a government. They are highly motivated, skilled, and patient and focused on a single target to gain and retain access over long periods of time. What is this group called?",
    "description": "Advanced persistent threat (APT)."
  },
  {
    "id": 1459,
    "topic_id": 3,
    "title": "What are often added to passwords to make their resultant hash secure and resistant to rainbow attacks?",
    "description": "Salts."
  },
  {
    "id": 1460,
    "topic_id": 7,
    "title": "What is a nonstatistical sampling method that only records or alerts on events that exceed a threshold?",
    "description": "Clipping levels."
  },
  {
    "id": 1461,
    "topic_id": 7,
    "title": "What is a group of records from one or more databases or logs that can be used to reconstruct events after an incident?",
    "description": "Audit trail."
  },
  {
    "id": 1462,
    "topic_id": 7,
    "title": "What is the purpose of an access review and audit?",
    "description": "Check to ensure that users do not have excessive privileges and that accounts are managed appropriately."
  },
  {
    "id": 1463,
    "topic_id": 5,
    "title": "What can a user entitlement review detect?",
    "description": "Violation of the principle of least privilege policy, as incidents of excessive privileges or creeping privileges."
  },
  {
    "id": 1464,
    "topic_id": 5,
    "title": "What types of accounts are focused on during a user entitlement review?",
    "description": "Privileged accounts such as administrator or root user accounts."
  },
  {
    "id": 1465,
    "topic_id": 5,
    "title": "Who should have access to audit reports?",
    "description": "Only people who have a need to know."
  },
  {
    "id": 1466,
    "topic_id": 7,
    "title": "What determines how often an audit should be performed?",
    "description": "Risk."
  },
  {
    "id": 1467,
    "topic_id": 7,
    "title": "What policy requires users to spend at least a week away from their jobs on an annual basis to help prevent fraud?",
    "description": "Mandatory vacations."
  },
  {
    "id": 1468,
    "topic_id": 2,
    "title": "What method will remove all data with assurances that it cannot be removed using any known methods?",
    "description": "Purging, sanitization, or destruction."
  },
  {
    "id": 1469,
    "topic_id": 2,
    "title": "What methods can be used to protect mobile devices such as a smartphone?",
    "description": "Encryption, GPS, password-protected screen locks, and remote wipe."
  },
  {
    "id": 1470,
    "topic_id": 2,
    "title": "What can be used to remove data on a lost smartphone?",
    "description": "Remote wipe."
  },
  {
    "id": 1471,
    "topic_id": 2,
    "title": "What should be done before disposing of a desktop computer at the end of its life cycle?",
    "description": "Sanitization."
  },
  {
    "id": 1472,
    "topic_id": 2,
    "title": "What is the term that identifies data on a disk after the data has supposedly been erased?",
    "description": "Data remanence."
  },
  {
    "id": 1473,
    "topic_id": 7,
    "title": "What are the steps of a patch management program?",
    "description": "Evaluate, test, apply, and audit patches."
  },
  {
    "id": 1474,
    "topic_id": 7,
    "title": "What can be used to verify patches have been applied?",
    "description": "Vulnerability scanner or a patch management system."
  },
  {
    "id": 1475,
    "topic_id": 7,
    "title": "What should be done to verify patches have been applied?",
    "description": "Audit patches, or use a vulnerability scanner to verify patches have been applied."
  },
  {
    "id": 1476,
    "topic_id": 7,
    "title": "What tool can check for weaknesses in systems?",
    "description": "Vulnerability scanner."
  },
  {
    "id": 1477,
    "topic_id": 7,
    "title": "What would be completed to check an entire organization for weaknesses?",
    "description": "Vulnerability assessment."
  },
  {
    "id": 1478,
    "topic_id": 2,
    "title": "What does imaging provide in relation to configuration management?",
    "description": "Baseline."
  },
  {
    "id": 1479,
    "topic_id": 8,
    "title": "What helps prevent outages that can occur from unauthorized modifications?",
    "description": "Change management."
  },
  {
    "id": 1480,
    "topic_id": 8,
    "title": "What helps prevent inadvertent weakening of security from unauthorized outages?",
    "description": "Change management."
  },
  {
    "id": 1481,
    "topic_id": 7,
    "title": "What are the typical steps in incident response?",
    "description": "The CISSP Security Operations domain lists incident management steps as detection, response, mitigation, reporting, recovery, remediation, and lessons learned."
  },
  {
    "id": 1482,
    "topic_id": 7,
    "title": "In which stage of incident response should a root cause analysis be conducted?",
    "description": "Remediation and Review."
  },
  {
    "id": 1483,
    "topic_id": 7,
    "title": "While containing an incident, what is the next important consideration?",
    "description": "Protection of evidence."
  },
  {
    "id": 1484,
    "topic_id": 7,
    "title": "An attack has a negative effect on the confidentiality, integrity, or availability of an organization's assets. What is this called?",
    "description": "Computer security incident."
  },
  {
    "id": 1485,
    "topic_id": 7,
    "title": "What is it called when malware is installed on a user's system after visiting a website?",
    "description": "Drive-by download."
  },
  {
    "id": 1486,
    "topic_id": 7,
    "title": "What three generic elements can help prevent malware infections?",
    "description": "Education, policies, and tools."
  },
  {
    "id": 1487,
    "topic_id": 7,
    "title": "An attacker has launched an attack using a vulnerability known only to them. What is this called?",
    "description": "Zero-day exploit."
  },
  {
    "id": 1488,
    "topic_id": 7,
    "title": "What type of attack leverages part of the TCP three-way handshake?",
    "description": "SYN flood attack."
  },
  {
    "id": 1489,
    "topic_id": 7,
    "title": "What are computers in a botnet commonly called?",
    "description": "Zombies."
  },
  {
    "id": 1490,
    "topic_id": 7,
    "title": "What is the best protection against a computer joining a botnet?",
    "description": "Up-to-date antivirus software."
  },
  {
    "id": 1491,
    "topic_id": 7,
    "title": "What type of IDS detects attacks based on known methods?",
    "description": "Knowledge-based (also called signature-based or pattern-matching)."
  },
  {
    "id": 1492,
    "topic_id": 7,
    "title": "What type of IDS detects attacks based by comparing it to a baseline?",
    "description": "Behavior-based (also called statistical-intrusion detection or anomaly detection)."
  },
  {
    "id": 1493,
    "topic_id": 7,
    "title": "After a network is upgraded, what must be done with a behavior-based IDS?",
    "description": "Upgrade the baseline."
  },
  {
    "id": 1494,
    "topic_id": 6,
    "title": "What is required before starting a penetration test?",
    "description": "Knowledge and consent of management."
  },
  {
    "id": 1496,
    "topic_id": 6,
    "title": "A penetration testing team has full knowledge about a target. What is this team called?",
    "description": "Full-knowledge team (performs white-box testing or known environment testing)."
  },
  {
    "id": 1497,
    "topic_id": 3,
    "title": "What is used to provide fault tolerance for a disk subsystem?",
    "description": "Redundant array of independent disks (RAID)."
  },
  {
    "id": 1498,
    "topic_id": 3,
    "title": "What is used to provide fault tolerance for a server?",
    "description": "Failover cluster."
  },
  {
    "id": 1499,
    "topic_id": 3,
    "title": "What is used to provide short-term fault tolerance for a power failure?",
    "description": "Uninterruptible power supply (UPS)."
  },
  {
    "id": 1500,
    "topic_id": 3,
    "title": "What is used to provide long-term fault tolerance for a power failure?",
    "description": "Generator."
  },
  {
    "id": 1502,
    "topic_id": 4,
    "title": "What are the six flags from the TCP header that we still commonly use and what is their order in the header?",
    "description": "XXUAPRSF. The X represents two flags no longer used, followed by Urgent, Acknowledgment, Push, Reset, Synchronization, and Finish. You can memorize this flag order using the phrase \"Unskilled Attackers Pester Real Security Folk.\"."
  },
  {
    "id": 1503,
    "topic_id": 4,
    "title": "What is VLAN hopping?",
    "description": "An attack using double-encapsulated IEEE 802.1Q VLAN tags to fool a switch into allowing traffic to jump to a different VLAN from which the traffic originated."
  },
  {
    "id": 1504,
    "topic_id": 4,
    "title": "What is NAC?",
    "description": "Network access control (NAC) is a concept of controlling access to an environment through strict adherence to and implementation of security policy. The goals of NAC are to prevent/reduce zero-day attacks, enforce security policy throughout the network, and use identities to perform access control."
  },
  {
    "id": 1505,
    "topic_id": 4,
    "title": "What is endpoint security?",
    "description": "The concept that each individual device must maintain local security whether or not its network or telecommunications channels provide security. Sometimes this is expressed as the end device is responsible for its own security."
  },
  {
    "id": 1506,
    "topic_id": 4,
    "title": "On an 802.11 wireless network, what contains the regular announcement of the network name by default?",
    "description": "The beacon frame contains the SSID (i.e., network name) by default. This can be stopped using the Disable SSID Broadcast feature of a wireless access point."
  },
  {
    "id": 1507,
    "topic_id": 4,
    "title": "What are the standards-based form(s) of encryption of 802.11 wireless networks and the cryptography protocols related to WPA2?",
    "description": "WPA2 (AES/CCMP)."
  },
  {
    "id": 1508,
    "topic_id": 4,
    "title": "What is 802.1X?",
    "description": "IEEE 802.1X defines the use of encapsulated EAP to support a wide range of authentication options for LAN connections. The IEEE 802.1X standard is formally named \"Port-Based Network Access Control.\" 802.1X is basically a mechanism to proxy authentication from the local device to another dedicated authentication service within the network."
  },
  {
    "id": 1509,
    "topic_id": 4,
    "title": "What is war driving?",
    "description": "A collection of techniques to discover that a wireless network is present at a given location."
  },
  {
    "id": 1510,
    "topic_id": 4,
    "title": "What is a VLAN?",
    "description": "A hardware-imposed network segmentation created by switches used to manage traffic."
  },
  {
    "id": 1514,
    "topic_id": 4,
    "title": "What is virtualization?",
    "description": "Technology used to host one or more operating systems within the memory of a single host computer. This mechanism allows virtually any OS to operate on any hardware. It also allows multiple operating systems to work simultaneously on the same hardware."
  },
  {
    "id": 1515,
    "topic_id": 4,
    "title": "What are the two main forms of DoS?",
    "description": "The first form exploits a vulnerability in hardware or software. This exploitation of a weakness, error, or standard feature of software to cause a system to hang, freeze, consume all system resources, and so on. The end result is that the victimized computer is unable to process any legitimate tasks. The second form floods the victim's communication pipeline with garbage network traffic. Sometimes called a traffic generation or flooding attack."
  },
  {
    "id": 1516,
    "topic_id": 1,
    "title": "What is security management planning?",
    "description": "Security management planning ensures proper creation, implementation, and enforcement of a security policy. Security management is a responsibility of upper management, not of the IT staff, and is considered a business operations issue rather than an IT administration issue."
  },
  {
    "id": 1517,
    "topic_id": 1,
    "title": "What is security governance?",
    "description": "Security governance is the collection of practices related to supporting, defining, and directing the security efforts of an organization. A common goal of organizational governance is to ensure that the organization will continue to exist and will grow or expand over time."
  },
  {
    "id": 1518,
    "topic_id": 1,
    "title": "What is third-party governance?",
    "description": "Third-party governance is the system of oversight that may be mandated by law, regulation, industry standards, or licensing requirements. The actual method of governance may vary but generally involves an outside investigator or auditor."
  },
  {
    "id": 1519,
    "topic_id": 1,
    "title": "What is documentation review?",
    "description": "Documentation review is the process of not just reading the exchange materials but verifying it against standards and expectations. The documentation review is typically performed before any onsite inspection is performed."
  },
  {
    "id": 1523,
    "topic_id": 3,
    "title": "What are some benefits of virtualization?",
    "description": "Being able to launch individual instances of servers or services as needed, real-time scalability, and being able to run the exact needed OS version for the needed application."
  },
  {
    "id": 1524,
    "topic_id": 3,
    "title": "What is TPM?",
    "description": "Trusted Platform Module (TPM) is a cryptoprocessor chip on a mainboard used to store and process cryptographic keys for the purposes of a hardware-supported or -implemented hard drive encryption system."
  },
  {
    "id": 1525,
    "topic_id": 3,
    "title": "What is an HSM?",
    "description": "A hardware security module (HSM) is a cryptoprocessor used to manage/store digital encryption keys, accelerate crypto operations, support faster digital signatures, and improve authentication."
  },
  {
    "id": 1526,
    "topic_id": 3,
    "title": "What is cloud computing?",
    "description": "A concept of computing where processing and storage are performed elsewhere over a network connection rather than locally."
  },
  {
    "id": 1527,
    "topic_id": 3,
    "title": "What are some issues or concerns regarding cloud computing?",
    "description": "Privacy concerns, regulation compliance difficulties, use of open/closed source solutions, adoption of open standards, and whether or not cloud-based data is actually secured (or even securable)."
  },
  {
    "id": 1528,
    "topic_id": 3,
    "title": "What is PaaS?",
    "description": "Platform as a service (PaaS) is the concept of providing a computing platform and software solution stack as a virtual or cloud-based service."
  },
  {
    "id": 1529,
    "topic_id": 3,
    "title": "What is SaaS?",
    "description": "Software as a service (SaaS) is a derivative of platform as a service (PaaS). Software as a service provides on-demand online access to specific software applications or suites without the need for local installation (or even local hardware and OS requirements in many cases)."
  },
  {
    "id": 1530,
    "topic_id": 3,
    "title": "What is IaaS?",
    "description": "Infrastructure as a service (IaaS) takes the platform as a service (PaaS) model another step forward. It provides not just on-demand operating solutions but complete outsourcing options as well. This can include utility or metered computing services, administrative task automation, dynamic scaling, virtualization services, policy implementation and management services, and managed/filtered internet connectivity."
  },
  {
    "id": 1531,
    "topic_id": 3,
    "title": "What is grid computing?",
    "description": "Grid computing is a form of parallel distributed processing that loosely groups a significant number of processing nodes toward the completion of a specific processing goal."
  },
  {
    "id": 1532,
    "topic_id": 3,
    "title": "What is technology convergence?",
    "description": "The tendency for various technologies, solutions, utilities, and systems to evolve and merge over time. Often this results in multiple systems performing similar or redundant tasks or one system taking over the features and abilities of another. While in some instances this can result in improved efficiency and cost savings, it can also be an increased single point of failure and can become a more valuable target for hackers and intruders."
  },
  {
    "id": 1533,
    "topic_id": 1,
    "title": "Define the aspect of confidentiality known as sensitivity.",
    "description": "Sensitivity refers to the quality of information that could cause harm or damage if disclosed. Maintaining confidentiality of sensitive information helps to prevent harm or damage."
  },
  {
    "id": 1534,
    "topic_id": 1,
    "title": "Define the aspect of confidentiality known as discretion.",
    "description": "Discretion is an act of decision whereby an operator can influence or control disclosure in order to minimize harm or damage."
  },
  {
    "id": 1535,
    "topic_id": 1,
    "title": "Define the aspect of confidentiality known as criticality.",
    "description": "The level to which information is mission critical is its measure of criticality. The higher the level of criticality, the more likely the need to maintain the confidentiality of the information. High levels of criticality are essential to the operation or function of an organization."
  },
  {
    "id": 1536,
    "topic_id": 1,
    "title": "Define the aspect of confidentiality known as concealment.",
    "description": "Concealment is the act of hiding or preventing disclosure. Often concealment is viewed as a means of cover, obfuscation, or distraction."
  },
  {
    "id": 1537,
    "topic_id": 1,
    "title": "Define the aspect of confidentiality known as secrecy.",
    "description": "Secrecy is the activity of keeping something a secret or preventing the disclosure of information."
  },
  {
    "id": 1538,
    "topic_id": 1,
    "title": "Define the aspect of confidentiality known as privacy.",
    "description": "Privacy refers to keeping information confidential that is personally identifiable or that might cause harm, embarrassment, or disgrace to someone if revealed."
  },
  {
    "id": 1539,
    "topic_id": 1,
    "title": "Define the aspect of confidentiality known as seclusion.",
    "description": "Seclusion refers to storing something in an out-of-the-way location. This location can also provide strict access controls. Seclusion can help enforce confidentiality protections."
  },
  {
    "id": 1540,
    "topic_id": 1,
    "title": "Define the aspect of confidentiality known as isolation.",
    "description": "Isolation is the act of keeping something separated from others. Isolation can be used to prevent co-mingling of information or disclosure of information."
  },
  {
    "id": 1541,
    "topic_id": 1,
    "title": "What is a business case?",
    "description": "A business case is usually a documented argument or stated position in order to define a need to make a decision or take some form of action. To make a business case is to demonstrate a business-specific need to alter an existing process or choose an approach to a business task. A business case is often made to justify the start of a new project, especially a project related to security. It is also important to consider the budget that can be allocated to a business-need-based security project."
  },
  {
    "id": 1542,
    "topic_id": 1,
    "title": "What is threat modeling?",
    "description": "Threat modeling is the security process whereby potential threats are identified, categorized, and analyzed. Threat modeling can be performed as a proactive measure during design and development or as a reactive measure once a product has been deployed."
  },
  {
    "id": 1544,
    "topic_id": 1,
    "title": "What are the two goals of SD3+C?",
    "description": "To reduce the number of security-related design and coding defects. To reduce the severity of any remaining defects."
  },
  {
    "id": 1545,
    "topic_id": 1,
    "title": "Define proactive and reactive threat modeling?",
    "description": "A proactive approach (aka defensive approach) is based on predicting threats and designing in specific defenses during the coding and crafting process.<br> A reactive approach (aka adversarial approach) is a reaction to issues/problems and is the core concept behind ethical hacking, penetration testing, source code review, and fuzz testing."
  },
  {
    "id": 1546,
    "topic_id": 1,
    "title": "Name the three common approaches to identifying threats.",
    "description": "Focused on assets, focused on attackers, and focused on software."
  },
  {
    "id": 1547,
    "topic_id": 1,
    "title": "What is STRIDE?",
    "description": "Microsoft developed a threat categorization scheme known as STRIDE. STRIDE is often used in relation to assessing threats against applications or operating systems. However, it can also be used in other contexts as well. STRIDE is an acronym standing for Spoofing, Tampering, Repudiation, Information disclosure, Denial of service, and Elevation of privilege."
  },
  {
    "id": 1548,
    "topic_id": 1,
    "title": "What is reduction analysis?",
    "description": "Reduction analysis is also known as decomposing the application, system, or environment. The purpose of this task it to gain a greater understanding of the logic of the product as well as its interactions with external elements. Whether an application, a system, or an entire environment, it needs to be divided into smaller containers or compartments."
  },
  {
    "id": 1549,
    "topic_id": 1,
    "title": "Name three methods to rank and prioritize threats.",
    "description": "Probability * Damage Potential, high/medium/low, or DREAD."
  },
  {
    "id": 1550,
    "topic_id": 1,
    "title": "What is DREAD?",
    "description": "DREAD is a threat rating system. Its elements are: Damage potential, Reproducibility, Exploitability, Affected users, and Discoverability."
  },
  {
    "id": 1551,
    "topic_id": 1,
    "title": "What is cross-training?",
    "description": "Cross-training is often discussed as an alternative to job rotation. In both cases, workers learn the responsibilities and tasks of multiple job positions. However, in cross-training the workers are just prepared to perform the other job positions; they are not rotated through them on a regular basis. Cross-training enables existing personnel to fill the work gap when the proper employee is unavailable as a type of emergency response procedure."
  },
  {
    "id": 1552,
    "topic_id": 1,
    "title": "What is compliance?",
    "description": "Compliance is the act of conforming to or adhering to rules, policies, regulations, standards, or requirements. Compliance is an important concern to security governance. On a personnel level, compliance is related to whether individual employees follow company policy and perform their job tasks in accordance to defined procedures."
  },
  {
    "id": 1553,
    "topic_id": 1,
    "title": "What is a risk framework?",
    "description": "A risk framework is a guideline or recipe for how risk is to be assessed, resolved, and monitored.r how risk is to be assessed, resolved, and monitored."
  },
  {
    "id": 1554,
    "topic_id": 1,
    "title": "What is FISMA?",
    "description": "The Federal Information Security Management Act (FISMA), passed in 2002, requires that federal agencies implement an information security program that covers the agency's operations. FISMA also requires that government agencies include the activities of contractors in their security management programs."
  },
  {
    "id": 1555,
    "topic_id": 1,
    "title": "What is HITECH?",
    "description": "In 2009, Congress amended HIPAA by passing the Health Information Technology for Economic and Clinical Health (HITECH) Act. This law updated many of HIPAA's privacy and security requirements and was implemented through the HIPAA Omnibus Rule in 2013."
  },
  {
    "id": 1556,
    "topic_id": 1,
    "title": "What are the parameters of the HITECH data breach notification requirements?",
    "description": "Under the HITECH Breach Notification Rule, HIPAA-covered entities that experience a data breach must notify affected individuals of the breach and must also notify both the Secretary of Health and Human Services and the media when the breach affects more than 500 individuals."
  },
  {
    "id": 1557,
    "topic_id": 2,
    "title": "What is an early step in asset security?",
    "description": "Classifying and labeling assets."
  },
  {
    "id": 1558,
    "topic_id": 2,
    "title": "What is sensitive data?",
    "description": "Sensitive data is any information that isn't public or unclassified. It can include confidential, proprietary, protected, or any other type of data that an organization needs to protect due to its value to the organization or to comply with existing laws and regulations."
  },
  {
    "id": 1559,
    "topic_id": 2,
    "title": "What is PII?",
    "description": "Personally identifiable information (PII) is any information that can identify an individual."
  },
  {
    "id": 1560,
    "topic_id": 2,
    "title": "What is PHI?",
    "description": "Protected health information (PHI) is any health-related information that can be related to a specific person. In the United States, the Health Insurance Portability and Accountability Act (HIPAA) mandates the protection of PHI."
  },
  {
    "id": 1561,
    "topic_id": 2,
    "title": "What is proprietary data?",
    "description": "Proprietary data refers to any data that helps an organization maintain a competitive edge. It could be software code it developed, technical plans for products, internal processes, intellectual property, or trade secrets. If competitors are able to access the proprietary data, it can seriously affect the primary mission of an organization."
  },
  {
    "id": 1562,
    "topic_id": 2,
    "title": "What legal protections exist for proprietary data?",
    "description": "Copyrights, patents, and trade secret laws provide protection for proprietary data."
  },
  {
    "id": 1563,
    "topic_id": 2,
    "title": "What are the three data states and their definitions?",
    "description": "Data at rest is any data stored on media such as system hard drives, external USB drives, storage area networks (SANs), and backup tapes. Data in transit (sometimes called data in motion) is any data transmitted over a network. This includes data transmitted over an internal network using wired or wireless methods and data transmitted over public networks such as the internet. Data in use refers to data in temporary storage buffers while an application is using it."
  },
  {
    "id": 1564,
    "topic_id": 2,
    "title": "When sensitive data is no longer needed by an organization, what should be done with it?",
    "description": "When an organization no longer needs sensitive data, personnel should destroy it. Proper destruction ensures that it cannot fall into the wrong hands and result in unauthorized disclosure."
  },
  {
    "id": 1565,
    "topic_id": 2,
    "title": "What is data remanence?",
    "description": "Data remanence is the data that remains on a storage device as residual and potentially recoverable data. Using system tools to delete data generally leaves much of the data remaining on the media, and widely available tools can easily undelete it. Even when you use sophisticated tools to overwrite the media, traces of the original data may remain."
  },
  {
    "id": 1566,
    "topic_id": 2,
    "title": "In relation to storage media, what is erasing?",
    "description": "Erasing media is simply performing a delete operation against a file, a selection of files, or the entire media. In most cases, the deletion or removal process removes only the directory or catalog link to the data. The actual data remains on the drive."
  },
  {
    "id": 1567,
    "topic_id": 2,
    "title": "In relation to storage media, what is clearing?",
    "description": "Clearing, or overwriting, is a process of preparing media for reuse and assuring that the cleared data cannot be recovered using traditional recovery tools. When media is cleared, unclassified data is written over all addressable locations on the media."
  },
  {
    "id": 1568,
    "topic_id": 2,
    "title": "In relation to storage media, what is purging?",
    "description": "Purging is a more intense form of clearing that prepares media for reuse in less secure environments. It provides a level of assurance that the original data is not recoverable using any known methods. A purging process will repeat the clearing process multiple times and may combine it with another method such as degaussing to completely remove the data. Even though purging is intended to remove all data remnants, it isn't always trusted."
  },
  {
    "id": 1569,
    "topic_id": 2,
    "title": "In relation to storage media, what is declassification?",
    "description": "Declassification involves any process that purges media or a system in preparation for reuse in an unclassified environment. Purging can be used to prepare media for declassification, but often the efforts required to securely declassify media are significantly greater than the cost of new media for a less secure environment."
  },
  {
    "id": 1570,
    "topic_id": 2,
    "title": "In relation to storage media, what is sanitization?",
    "description": "Sanitization is a combination of processes that removes data from a system or from media. It ensures that data cannot be recovered by any means."
  },
  {
    "id": 1571,
    "topic_id": 2,
    "title": "What is degaussing?",
    "description": "A degausser creates a strong magnetic field that erases data on some media in a process called degaussing. Technicians commonly use degaussing methods to remove data from magnetic tapes with the goal of returning the tape to its original state. Although it is possible to degauss hard disks, it is not recommended. Degaussing a hard disk will normally destroy the electronics used to access the data."
  },
  {
    "id": 1572,
    "topic_id": 2,
    "title": "What are some methods of storage media destruction?",
    "description": "Destruction is the final stage in the life cycle of media and is the most secure method of sanitizing media. When destroying media it's important to ensure that the media cannot be reused or repaired and that data cannot be extracted from the destroyed media. Methods of destruction include incineration, crushing, shredding, disintegration, and dissolving using caustic or acidic chemicals. Some organizations remove the platters in highly classified disk drives and destroy them separately."
  },
  {
    "id": 1573,
    "topic_id": 2,
    "title": "What are scoping and tailoring?",
    "description": "Scoping refers to reviewing baseline security controls and selecting only those controls that apply to the IT system you're trying to protect. Tailoring refers to modifying the list of security controls within a baseline so that they align with the mission of the organization."
  },
  {
    "id": 1574,
    "topic_id": 3,
    "title": "In 2012, the committee overseeing the development of SHA-3 made what announcement?",
    "description": "In 2012, the federal government design committee announced the selection of the Keccak algorithm as the SHA-3 standard. However as of mid-2015, the SHA-3 standard remains in draft form and some technical details still require finalization."
  },
  {
    "id": 1576,
    "topic_id": 3,
    "title": "What is DRM?",
    "description": "Digital rights management (DRM) software uses encryption to enforce copyright restrictions on digital media. The purpose is to prevent the unauthorized use, modification, and distribution of copyrighted works."
  },
  {
    "id": 1577,
    "topic_id": 3,
    "title": "What is a cryptographic salt and what is it used for?",
    "description": "The cryptographic salt is a random value that is added to the end of the password before the operating system hashes the password. The salt is then stored in the password file along with the hash. It is used to help combat the use of brute-force attacks, including those aided by dictionaries and rainbow tables."
  },
  {
    "id": 1578,
    "topic_id": 3,
    "title": "What is transitive trust?",
    "description": "Transitive trust is the concept that if A trusts B and B trusts C, then A inherits trust of C through the transitive property, which works like it would in a mathematical equation: if A = B, and B = C, then A = C. In this example, when A requests data from B, then B requests data from C, the data that A receives is essentially from C. Transitive trust is a serious security concern because it may enable bypassing of restrictions or limitations between A and C."
  },
  {
    "id": 1579,
    "topic_id": 3,
    "title": "What is the purpose of memory protection?",
    "description": "Memory protection is used to prevent an active process from interacting with an area of memory that was not specifically assigned or allocated to it. Memory protection is a core security component that must be designed and implemented into an operating system. It must be enforced regardless of the programs executing in the system. Otherwise instability, violation of integrity, denial of service, and disclosure are likely results."
  },
  {
    "id": 1580,
    "topic_id": 3,
    "title": "What is flash memory?",
    "description": "Flash memory is a derivative concept from EEPROM. It is a nonvolatile form of storage media that can be electronically erased and rewritten. The primary difference between EEPROM and flash memory is that EEPROM must be fully erased to be rewritten, while flash memory can be erased and written in blocks or pages."
  },
  {
    "id": 1581,
    "topic_id": 3,
    "title": "What is UEFI?",
    "description": "UEFI (Unified Extensible Firmware Interface) is a more advanced interface (than BIOS) between hardware and the operating system, which maintains support for legacy BIOS services."
  },
  {
    "id": 1582,
    "topic_id": 3,
    "title": "What is a local cache?",
    "description": "A local cache is anything that is temporarily stored on the client for future reuse. There are many local caches on a typical client, including ARP cache, DNS cache, and Internet files cache."
  },
  {
    "id": 1583,
    "topic_id": 3,
    "title": "What are two forms of ARP poisoning?",
    "description": "ARP cache poisoning is caused by an attack responding to ARP broadcast queries in order to send back falsified replies. A second form of ARP cache poisoning is to create static ARP entries."
  },
  {
    "id": 1584,
    "topic_id": 3,
    "title": "What are five examples of DNS poisoning?",
    "description": "HOSTS poisoning, authorized DNS server attack, caching DNS server attack, changing a DNS server address, and DNS query spoofing."
  },
  {
    "id": 1585,
    "topic_id": 3,
    "title": "What is data analytics?",
    "description": "Data analytics is the science of raw data examination with the focus of extracting useful information out of the bulk information set. The results of data analytics could focus on important outliers or exceptions to normal or standard items, a summary of all data items, or some focused extraction and organization of interesting information."
  },
  {
    "id": 1586,
    "topic_id": 3,
    "title": "What is big data?",
    "description": "Big data refers to collections of data that have become so large that traditional means of analysis or processing are ineffective, inefficient, and insufficient. Big data involves numerous difficult challenges, including collection, storage, analysis, mining, transfer, distribution, and results presentation."
  },
  {
    "id": 1587,
    "topic_id": 3,
    "title": "What are parallel data systems?",
    "description": "Parallel data systems or parallel computing is a computation system design to perform numerous calculations simultaneously. But parallel data systems often go far beyond basic multiprocessing capabilities. They often include the concept of dividing up a large task into smaller elements, then distributing each subelement to a different processing subsystem for parallel computation. This implementation is based on the idea that some problems can be solved efficiently if they are broken into smaller tasks that can be worked on concurrently."
  },
  {
    "id": 1589,
    "topic_id": 3,
    "title": "What are three forms of ICS?",
    "description": "There are several forms of ICS, including distributed control systems (DCSs), programmable logic controllers (PLCs), and supervisory control and data acquisition (SCADA)."
  },
  {
    "id": 1590,
    "topic_id": 3,
    "title": "Where are DCS systems used and why?",
    "description": "DCS units are typically found in industrial process plans where the need to gather data and implement control over a large-scale environment from a single location is essential. An important aspect of DCS is the controlling elements are distributed across the monitored environment, such as a manufacturing floor or a production line, while the centralized monitoring location sends commands out of those localized controllers while gathering status and performance data."
  },
  {
    "id": 1591,
    "topic_id": 3,
    "title": "What is a PLC?",
    "description": "Programmable logic controller (PLC) units are effectively single-purpose or focused-purpose digital computers. They are typically deployed for the management and automation of various industrial electromechanical operations, such as controlling systems on an assembly line or a large-scale digital light display."
  },
  {
    "id": 1592,
    "topic_id": 3,
    "title": "What is SCADA?",
    "description": "Supervisory control and data acquisition (SCADA) systems can operate as a standalone device, be networked together with other SCADA systems, or be networked with traditional IT systems. Most SCADA systems are designed with minimal human interfaces. Often, they use mechanical buttons and knobs or simple LCD screen interfaces."
  },
  {
    "id": 1593,
    "topic_id": 3,
    "title": "Name five generic terms that refer to mobile phones, tablets, and other similar devices.",
    "description": "A device owned by an individual can be referenced using any of these terms: portable device, mobile device, personal mobile device (PMD), personal electronic device or portable electronic device (PED), and personally owned device (POD)."
  },
  {
    "id": 1594,
    "topic_id": 3,
    "title": "What is Android (the OS)?",
    "description": "Android is a mobile device OS based on Linux, which was acquired by Google in 2005. The Android source code is made open source through the Apache license, but most devices also include proprietary software. Although it's mostly intended for use on phones and tablets, Android is being used on a wide range of devices, including televisions, game consoles, digital cameras, microwaves, watches, e-readers, cordless phones, and ski goggles."
  },
  {
    "id": 1595,
    "topic_id": 3,
    "title": "What is iOS?",
    "description": "iOS is the mobile device OS from Apple that is available on the iPhone, iPad, iPod, and Apple TV. iOS isn't licensed for use on any non-Apple hardware. Thus, Apple is in full control of the features and capabilities of iOS."
  },
  {
    "id": 1596,
    "topic_id": 3,
    "title": "What is remote wiping?",
    "description": "Remote wipe lets you delete all data and possibly even configuration settings from a device remotely. The wipe process can be triggered over mobile phone service or sometimes over any internet connection."
  },
  {
    "id": 1597,
    "topic_id": 3,
    "title": "What is storage segmentation on a mobile device?",
    "description": "Storage segmentation is used to artificially compartmentalize various types or values of data on a storage medium. On a mobile device, the device manufacturer and/or the service provider may use storage segmentation to isolate the device's OS and preinstalled apps from user-installed apps and user data."
  },
  {
    "id": 1598,
    "topic_id": 3,
    "title": "What is MDM?",
    "description": "Mobile device management (MDM) is used to manage the myriad mobile devices that employees use to access company resources. The goals of MDM are to improve security, provide monitoring, enable remote management, and support troubleshooting. You can use MDM to push or remove apps, manage data, and enforce configuration settings both over the air (across a carrier network) and over Wi-Fi connections."
  },
  {
    "id": 1599,
    "topic_id": 3,
    "title": "What is credential management?",
    "description": "The storage of credentials in a central location is referred to as credential management. Given the wide range of internet sites and services, each with its own particular logon requirements, it can be a burden to use unique names and passwords. Credential management solutions offer a means to securely store a plethora of credential sets."
  },
  {
    "id": 1600,
    "topic_id": 3,
    "title": "What is geo-tagging?",
    "description": "Mobile devices with GPS support enable the embedding of geographical location (geo-tagging) in the form of latitude and longitude as well as date/time information on photos taken with these devices."
  },
  {
    "id": 1601,
    "topic_id": 3,
    "title": "What is application whitelisting or allow listing?",
    "description": "Application whitelisting or allow listing is a security option that prohibits unauthorized software from being able to execute. Whitelisting or allow listing is also known as deny by default or implicit deny. In application security, whitelisting prevents any and all software, including malware, from executing unless it's on the preapproved exception list: the whitelist or allow list."
  },
  {
    "id": 1602,
    "topic_id": 3,
    "title": "What is BYOD?",
    "description": "Bring-your-own-device (BYOD) is a policy that allows employees to bring their own personal mobile devices to work and use those devices to connect to (or through) the company network to business resources and/or the Internet. Although BYOD may improve employee morale and job satisfaction, it increases security risk to the organization."
  },
  {
    "id": 1603,
    "topic_id": 3,
    "title": "What is an embedded system?",
    "description": "An embedded system is a computer implemented as part of a larger system, which is typically designed around a limited set of specific functions. It may consist of the typical computer components or it may be a microcontroller (an integrated chip with on-board memory and peripheral ports). Examples include network-attached printers, smart TVs, HVAC controls, smart appliances, smart thermostats, Ford SYNC (a Microsoft embedded system in vehicles), and medical devices."
  },
  {
    "id": 1604,
    "topic_id": 3,
    "title": "What is a static system?",
    "description": "A static system or static environment is a set of conditions, events, and surroundings that don't change. In theory, once understood, a static environment doesn't offer new or surprising elements. A static IT environment is any system that is intended to remain unchanged by users and administrators. The goal is to prevent or at least reduce the possibility of a user implementing change that could result in reduced security or functional operation."
  },
  {
    "id": 1605,
    "topic_id": 3,
    "title": "What is a cyber-physical system?",
    "description": "Cyber-physical system is a term used to refer to devices that offer a computational means to control something in the physical world. In the past these might have been referred to as embedded systems, but the category of cyber-physical seems to focus more on the physical world results rather than the computational aspects."
  },
  {
    "id": 1607,
    "topic_id": 3,
    "title": "What is DNP3?",
    "description": "DNP3 (Distributed Network Protocol) is a multilayer protocol primarily used in the electric and water utility and management industries. It is used to support communications between data acquisition systems and the system control equipment. DNP3 is an open and public standard. DNP3 is a multilayer protocol that functions similarly to TCP/IP, in that it has link, transport, and transportation layers."
  },
  {
    "id": 1608,
    "topic_id": 3,
    "title": "What are converged protocols?",
    "description": "Converged protocols are the merging of specialty or proprietary protocols with standard protocols. The primary benefit of converged protocols is the ability to use an existing network infrastructure to host special or proprietary services without the need for unique deployments of alternate networking hardware. Common examples of converged protocols include FCoE, MPLS, iSCSI, VPN, SDN, cloud, virtualization, SOA, microservices, infrastructure as code (IaC), and serverless architecture."
  },
  {
    "id": 1609,
    "topic_id": 3,
    "title": "What is FCoE?",
    "description": "Fibre Channel over Ethernet (FCoE) can be used to support Fibre Channel communications over the existing network infrastructure. FCoE is used to encapsulate Fibre Channel communications over Ethernet networks. It typically requires 10 Gbps Ethernet in order to support the Fibre Channel protocol."
  },
  {
    "id": 1610,
    "topic_id": 3,
    "title": "What is MPLS?",
    "description": "MPLS (multiprotocol label switching) is a high-throughput, high-performance network technology that directs data across a network based on short path labels rather than longer network addresses."
  },
  {
    "id": 1611,
    "topic_id": 3,
    "title": "What is iSCSI?",
    "description": "Internet Small Computer System Interface (iSCSI) is a networking storage standard based on IP. This technology can be used to enable location-independent file storage, transmission, and retrieval over LAN, WAN, or public internet connections. iSCSI is often viewed as a low-cost alternative to Fibre Channel."
  },
  {
    "id": 1612,
    "topic_id": 3,
    "title": "What is VoIP?",
    "description": "Voice over IP (VoIP) is a tunneling mechanism used to transport voice and/or data over a TCP/IP network. VoIP has the potential to replace or supplant PSTN because it's often less expensive and offers a wider variety of options and features."
  },
  {
    "id": 1613,
    "topic_id": 3,
    "title": "What is SDN?",
    "description": "Software-defined network (SDN) is a unique approach to network operation, design, and management. SDN aims at separating the infrastructure layer (i.e., hardware and hardware-based settings) from the control layer (i.e., network services of data transmission management). Furthermore, this also removes the traditional networking concepts of IP addressing, subnets, routing, and so on from needing to be programmed into or be deciphered by hosted applications."
  },
  {
    "id": 1614,
    "topic_id": 4,
    "title": "What is a captive portal?",
    "description": "A captive portal is an authentication technique that redirects a newly connected wireless web client to a portal access control page. The portal page may require the user to input payment information, provide logon credentials, or input an access code."
  },
  {
    "id": 1615,
    "topic_id": 4,
    "title": "What is a site survey?",
    "description": "A site survey is a formal assessment of wireless signal strength, quality, and interference using a RF signal detector. A site survey is performed by placing a wireless base station in a desired location and then collecting signal measurements from the area. The signal measurements are overlaid onto a blueprint of the building to determine whether sufficient signal is present where needed, while minimizing signals outside the desired location."
  },
  {
    "id": 1616,
    "topic_id": 4,
    "title": "What is a CDN?",
    "description": "A content-distribution network (CDN) or content delivery network is a collection of resource services deployed in numerous data centers across the internet in order to provide low-latency, high-performance, high-availability of the hosted content."
  },
  {
    "id": 1617,
    "topic_id": 4,
    "title": "What is port isolation or private ports in relation to VLANs?",
    "description": "These are private VLANs that are configured to use a dedicated or reserved uplink port. The members of a private VLAN or a port isolated VLAN can only interact with each other and over the predetermined exit port or uplink port. A common implementation of port isolation occurs in hotels."
  },
  {
    "id": 1618,
    "topic_id": 4,
    "title": "What is guest OS?",
    "description": "Virtualization technology is used to host one or more operating systems within the memory of a single host computer. This mechanism allows virtually any OS to operate on any hardware. Such an OS is also known as a guest operating system. From the perspective that there is an original or host OS installed directly on the computer hardware, the additional OSs hosted by the hypervisor system are guests."
  },
  {
    "id": 1619,
    "topic_id": 5,
    "title": "What is OAuth?",
    "description": "OAuth is an open SSO standard designed to work with HTTP, and it allows users to log on with one account. For example, users can log onto their Google account and use the same account to access Facebook and Twitter pages."
  },
  {
    "id": 1620,
    "topic_id": 5,
    "title": "What is OpenID Connect (OIDC)?",
    "description": "OpenID Connect (OIDC) is an authentication layer using the OAuth 2.0 authorization framework. A key point is that it provides both authentication and authorization. OIDC is maintained by the OpenID Foundation. OIDC uses a JavaScript Object Notation (JSON) Web Token (JWT), also called an ID token."
  },
  {
    "id": 1621,
    "topic_id": 5,
    "title": "What is IDaaS?",
    "description": "Identity as a service, or identity and access as a service (IDaaS), is a third-party service that provides identity and access management. IDaaS effectively provides SSO for the cloud and is especially useful when internal clients access cloud-based software-as-a-service (SaaS) applications."
  },
  {
    "id": 1622,
    "topic_id": 5,
    "title": "What is ABAC?",
    "description": "An advanced implementation of a rule-BAC is an <italic>attribute-based access control</italic> (ABAC) model. ABAC models use policies that include multiple attributes for rules. Many software-defined networking applications use ABAC models."
  },
  {
    "id": 1623,
    "topic_id": 6,
    "title": "What is a security test for?",
    "description": "Security tests verify that a control is functioning properly. These tests include automated scans, tool-assisted penetration tests, and manual attempts to undermine security."
  },
  {
    "id": 1624,
    "topic_id": 6,
    "title": "What is a security assessment?",
    "description": "Security assessments are comprehensive reviews of the security of a system, application, or other tested environment. During a security assessment, a trained information security professional performs a risk assessment that identifies vulnerabilities in the tested environment that may allow a compromise and makes recommendations for remediation as needed."
  },
  {
    "id": 1625,
    "topic_id": 6,
    "title": "What is a security audit?",
    "description": "Security audits use many of the same techniques followed during security assessments but must be performed by independent auditors."
  },
  {
    "id": 1626,
    "topic_id": 6,
    "title": "What are vulnerability scans?",
    "description": "Vulnerability scans automatically probe systems, applications, and networks looking for weaknesses that may be exploited by an attacker. The scanning tools used in these tests provide quick, point-and-click tests that perform otherwise tedious tasks without requiring manual intervention."
  },
  {
    "id": 1627,
    "topic_id": 6,
    "title": "What is nmap?",
    "description": "The most common tool used for network discovery scanning. Originally released in 1997, nmap is remarkably still maintained and in general use today. It remains one of the most popular network security tools, and almost every security professional either uses nmap regularly or used it at some point in their career."
  },
  {
    "id": 1628,
    "topic_id": 6,
    "title": "What are network vulnerability scans?",
    "description": "Network vulnerability scans go deeper than discovery scans. They don't stop with detecting open ports but continue on to actually probe a targeted system or network for the presence of known vulnerabilities. These tools contain databases of thousands of known vulnerabilities along with tests they can perform to identify whether a system is susceptible to each vulnerability in the system's database."
  },
  {
    "id": 1629,
    "topic_id": 6,
    "title": "What is a false positive?",
    "description": "When the scanner tests a system for vulnerabilities, it uses the tests in its database to determine whether a system may contain the vulnerability. In some cases, the scanner may not have enough information to conclusively determine that a vulnerability exists and it reports a vulnerability when there really is no problem. This situation is known as a false positive report and is sometimes seen as a nuisance to system administrators."
  },
  {
    "id": 1630,
    "topic_id": 6,
    "title": "What is a false negative?",
    "description": "Far more dangerous than a false positive is when the vulnerability scanner misses a vulnerability and fails to alert the administrator to the presence of a dangerous situation. This error is known as a false negative report."
  },
  {
    "id": 1631,
    "topic_id": 6,
    "title": "What are web vulnerability scanners?",
    "description": "Web vulnerability scanners are special-purpose tools that scour web applications for known vulnerabilities. They play an important role in any security testing program because they may discover flaws not visible to network vulnerability scanners. When an administrator runs a web application scan, the tool probes the web application using automated techniques that manipulate inputs and other parameters to identify web vulnerabilities."
  },
  {
    "id": 1632,
    "topic_id": 6,
    "title": "What is a penetration test?",
    "description": "The penetration test goes beyond vulnerability testing techniques because it actually attempts to exploit systems. Security professionals performing penetration tests actually try to defeat security controls and break into a targeted system or application to demonstrate the flaw."
  },
  {
    "id": 1633,
    "topic_id": 6,
    "title": "What is Nessus?",
    "description": "An example of a vulnerability scanner."
  },
  {
    "id": 1634,
    "topic_id": 6,
    "title": "What is Metasploit?",
    "description": "A penetration testing tool used to automatically execute exploits against targeted systems. Metasploit uses a scripting language to allow the automatic execution of common attacks, saving testers (and hackers!) quite a bit of time by eliminating many of the tedious, routine steps involved in executing an attack."
  },
  {
    "id": 1635,
    "topic_id": 6,
    "title": "What is code review?",
    "description": "Code review is the foundation of software assessment programs. During a code review, also known as a peer review, developers (other than the one who wrote the code) review it for defects. Code reviews may result in approval of an application's move into a production environment or they may send the code back to the original developer with recommendations for rework of issues detected during the review."
  },
  {
    "id": 1636,
    "topic_id": 6,
    "title": "The Fagan code review process has six steps. Name them.",
    "description": "Planning <br> Overview <br> Preparation <br> Inspection <br> Rework <br> Follow-up."
  },
  {
    "id": 1637,
    "topic_id": 6,
    "title": "What is static testing?",
    "description": "Static testing evaluates the security of software without running it by analyzing either the source code or the compiled application. Static analysis usually involves the use of automated tools designed to detect common software flaws, such as buffer overflows."
  },
  {
    "id": 1638,
    "topic_id": 6,
    "title": "What is dynamic testing?",
    "description": "Dynamic testing evaluates the security of software in a runtime environment and is often the only option for organizations deploying applications written by someone else. In those cases, testers often do not have access to the underlying source code."
  },
  {
    "id": 1639,
    "topic_id": 6,
    "title": "What are synthetic transactions?",
    "description": "Dynamic testing may include the use of synthetic transactions to verify system performance. These are scripted transactions with known expected results. The testers run the synthetic transactions against the tested code and then compare the output of the transactions to the expected state."
  },
  {
    "id": 1640,
    "topic_id": 6,
    "title": "What is fuzz testing?",
    "description": "Fuzz testing is a specialized dynamic testing technique that provides many different types of input to software to stress its limits and find previously undetected flaws. Fuzz testing software supplies invalid input to the software, either randomly generated or specially crafted to trigger known software vulnerabilities."
  },
  {
    "id": 1641,
    "topic_id": 6,
    "title": "Name two types of fuzz testing.",
    "description": "Mutation (dumb) fuzzing takes previous input values from actual operation of the software and manipulates (or mutates) it to create fuzzed input. It might alter the characters of the content, append strings to the end of the content, or perform other data manipulation techniques.<br> Generational (intelligent) fuzzing develops data models and creates new fuzzed input based on an understanding of the types of data used by the program."
  },
  {
    "id": 1642,
    "topic_id": 6,
    "title": "What is the zzuf tool used for?",
    "description": "The zzuf tool automates the process of mutation fuzzing by manipulating input according to user specifications."
  },
  {
    "id": 1643,
    "topic_id": 6,
    "title": "What is interface testing?",
    "description": "Interface testing assesses the performance of modules against the interface specifications to ensure that they will work together properly when all of the development efforts are complete."
  },
  {
    "id": 1644,
    "topic_id": 6,
    "title": "What is misuse case testing?",
    "description": "In some applications, there are clear examples of ways that software users might attempt to misuse the application. Software testers use a process known as misuse case testing or abuse case testing to evaluate the vulnerability of their software to these known risks."
  },
  {
    "id": 1645,
    "topic_id": 6,
    "title": "What is test coverage analysis?",
    "description": "While Testing is an important part of any software development process, but it is unfortunately impossible to completely test any piece of software. There are simply too many ways that software might malfunction or undergo attack. Software testing professionals often conduct a test coverage analysis to estimate the degree of testing conducted against the new software."
  },
  {
    "id": 1646,
    "topic_id": 6,
    "title": "Security managers should monitor key performance and risk indicators on an ongoing basis. Name some potential examples of metrics that should be monitored.",
    "description": "Number of open vulnerabilities <br> Time to resolve vulnerabilities <br> Number of compromised accounts <br> Number of software flaws detected in preproduction scanning <br> Repeat audit findings <br> User attempts to visit known malicious sites."
  },
  {
    "id": 1647,
    "topic_id": 7,
    "title": "What is entitlement?",
    "description": "Entitlement refers to the amount of privileges granted to users, typically when first provisioning an account."
  },
  {
    "id": 1648,
    "topic_id": 7,
    "title": "What is segregation of duties?",
    "description": "Segregation of duties is similar to a separation of duties and responsibilities policy, but it also combines the principle of least privilege. The goal is to ensure that individuals do not have excessive system access that may result in a conflict of interest."
  },
  {
    "id": 1649,
    "topic_id": 7,
    "title": "What is two-person control?",
    "description": "Two-person control is similar to segregation of duties. It requires the approval of two individuals for critical tasks."
  },
  {
    "id": 1650,
    "topic_id": 7,
    "title": "What is versioning?",
    "description": "Versioning typically refers to version control used in software configuration management. A labeling or numbering system differentiates between different software sets and configurations across multiple machines or at different points in time on a single machine."
  },
  {
    "id": 1651,
    "topic_id": 7,
    "title": "What is CVE?",
    "description": "Vulnerabilities are commonly referred to using the Common Vulnerability and Exposures (CVE) dictionary. The CVE dictionary provides a standard convention used to identify vulnerabilities. MITRE maintains the CVE database, and you can view it at <code>cve.mitre.org</code>."
  },
  {
    "id": 1652,
    "topic_id": 7,
    "title": "What is DDoS?",
    "description": "A distributed denial-of-service (DDoS) attack occurs when multiple systems attack a single system at the same time."
  },
  {
    "id": 1653,
    "topic_id": 7,
    "title": "What is DRDoS?",
    "description": "A distributed reflective denial-of-service (DRDoS) attack is a variant of a DoS. It uses a reflected approach to an attack. In other words, it doesn't attack the victim directly but instead manipulates traffic or a network service so that the attacks are reflected back to the victim from other sources."
  },
  {
    "id": 1654,
    "topic_id": 7,
    "title": "What is a ping flood?",
    "description": "A ping flood attack floods a victim with ping requests. This can be very effective when launched by zombies within a botnet as a DDoS attack. If tens of thousands of systems simultaneously send ping requests to a system, the system can be overwhelmed trying to answer the ping requests."
  },
  {
    "id": 1655,
    "topic_id": 7,
    "title": "What is a drive-by download?",
    "description": "A drive-by download is code downloaded and installed on a user's system without the user's knowledge. Attackers modify the code on a web page, and when the user visits, the code downloads and installs malware on the user's system without the user's knowledge or consent."
  },
  {
    "id": 1656,
    "topic_id": 7,
    "title": "What is war dialing?",
    "description": "War dialing means using a modem to search for a system that accepts inbound connection attempts."
  },
  {
    "id": 1657,
    "topic_id": 7,
    "title": "What is a honeypot or a honeynet?",
    "description": "A honeypot is an individual computer created as a trap for intruders. A honeynet is two or more networked honeypots used together to simulate a network. They look and act like legitimate systems, but they do not host data of any real value for an attacker."
  },
  {
    "id": 1658,
    "topic_id": 7,
    "title": "What is a pseudo flaw?",
    "description": "A pseudo flaw is a false vulnerability or apparent loophole intentionally implanted in a system in an attempt to tempt attackers. They are often used on honeypot systems to emulate well-known operating system vulnerabilities."
  },
  {
    "id": 1659,
    "topic_id": 7,
    "title": "What is a padded cell?",
    "description": "A padded cell system is similar to a honeypot, but it performs intrusion isolation using a different approach. When an IDS detects an intruder, that intruder is automatically transferred to a padded cell."
  },
  {
    "id": 1660,
    "topic_id": 7,
    "title": "What is sandboxing?",
    "description": "Sandboxing provides a security boundary for applications and prevents the application from interacting with other applications. Antimalware applications use sandboxing techniques to test unknown applications. If the application displays suspicious characteristics, the sandboxing technique prevents the application from infecting other applications or the operating system."
  },
  {
    "id": 1661,
    "topic_id": 7,
    "title": "Many organizations use a centralized application to automate monitoring of systems on a network. Name three terms that refer to these types of systems.",
    "description": "Security Information and Event Management (SIEM), Security Event Management (SEM), and Security Information Management (SIM)."
  },
  {
    "id": 1662,
    "topic_id": 7,
    "title": "In relation to auditing and monitoring, what is sampling?",
    "description": "Sampling, or data extraction, is the process of extracting specific elements from a large collection of data to construct a meaningful representation or summary of the whole. In other words, sampling is a form of data reduction that allows someone to glean valuable information by looking at only a small sample of data in an audit trail."
  },
  {
    "id": 1663,
    "topic_id": 7,
    "title": "What is egress monitoring?",
    "description": "Egress monitoring refers to monitoring outgoing traffic to prevent data exfiltration, which is the unauthorized transfer of data. Some common methods used to prevent data exfiltration are data loss prevention techniques, looking for steganography attempts, and watermarking."
  },
  {
    "id": 1664,
    "topic_id": 7,
    "title": "What is DLP?",
    "description": "Data loss prevention (DLP) systems attempt to detect and block data exfiltration attempts. These systems have the capability of scanning data looking for keywords and data patterns."
  },
  {
    "id": 1665,
    "topic_id": 7,
    "title": "Name two common types of DLP.",
    "description": "A network-based DLP scans all outgoing data looking for specific data. An endpoint-based DLP can scan files stored on a system and files sent to external devices."
  },
  {
    "id": 1666,
    "topic_id": 7,
    "title": "What is steganography?",
    "description": "Steganography is the practice of embedding a message within a file."
  },
  {
    "id": 1667,
    "topic_id": 7,
    "title": "What is watermarking?",
    "description": "Watermarking is the practice of embedding an image or pattern in paper that isn't readily perceivable. It is often used with currency to thwart counterfeiting attempts. Similarly, organizations often use watermarking in digital documents and other types of files."
  },
  {
    "id": 1668,
    "topic_id": 7,
    "title": "What is system resilience?",
    "description": "System resilience refers to the ability of a system to maintain an acceptable level of service during an adverse event. This could be a hardware fault managed by fault-tolerant components, or it could be an attack managed by other controls such as effective intrusion detection and prevention systems."
  },
  {
    "id": 1669,
    "topic_id": 7,
    "title": "What is a failover cluster?",
    "description": "A failover cluster includes two or more servers, and if one of the servers fails, another server in the cluster can take over its load in an automatic process called failover. Failover clusters can include multiple servers (not just two), and they can also provide fault tolerance for multiple services or applications."
  },
  {
    "id": 1670,
    "topic_id": 7,
    "title": "Define a fail-secure system.",
    "description": "A fail-secure system will default to a secure state in the event of a failure, blocking all access."
  },
  {
    "id": 1671,
    "topic_id": 7,
    "title": "Define a fail-open system.",
    "description": "A fail-open system will fail in an open state, granting all access."
  },
  {
    "id": 1672,
    "topic_id": 7,
    "title": "What use is QoS?",
    "description": "Quality of service (QoS) controls protect the integrity of data networks under load. Many different factors contribute to the quality of the end user experience, and QoS attempts to manage all of those factors to create an experience that meets business requirements."
  },
  {
    "id": 1673,
    "topic_id": 7,
    "title": "What does an operational investigation focus on?",
    "description": "An operational investigation examines issues related to the organization's computing infrastructure and has the primary goal of resolving operational issues."
  },
  {
    "id": 1674,
    "topic_id": 7,
    "title": "What does a criminal investigation focus on?",
    "description": "A criminal investigation, typically conducted by law enforcement personnel, investigates the alleged violation of criminal law. A criminal investigation may result in charging suspects with a crime and the prosecution of those charges in criminal court."
  },
  {
    "id": 1675,
    "topic_id": 7,
    "title": "What does a civil investigation focus on?",
    "description": "A civil investigation typically does not involve law enforcement but rather involves internal employees and outside consultants working on behalf of a legal team. It prepares the evidence necessary to present a case in civil court resolving a dispute between two parties."
  },
  {
    "id": 1676,
    "topic_id": 7,
    "title": "What is electronic discovery?",
    "description": "In legal proceedings, each side has a duty to preserve evidence related to the case and, through the discovery process, share information with their adversary in the proceedings. This discovery process applies to both paper records and electronic records, and the electronic discovery (or eDiscovery) process facilitates the processing of electronic information for disclosure."
  },
  {
    "id": 1677,
    "topic_id": 7,
    "title": "What is an APT?",
    "description": "Recent years marked the rise of sophisticated attackers known as advanced persistent threats (APTs). These attackers are well funded and have advanced technical skills and resources. They act on behalf of a nation-state, organized crime, terrorist group, or other sponsor and wage highly effective attacks against a very focused target in order to maintain persistent unauthorized access or effect."
  },
  {
    "id": 1678,
    "topic_id": 7,
    "title": "What does a business attack focus on?",
    "description": "A business attack focuses on illegally obtaining an organization's confidential information. This could be information that is critical to the operation of the organization, such as a secret recipe, or information that could damage the organization's reputation if disclosed, such as personal information about its employees."
  },
  {
    "id": 1679,
    "topic_id": 7,
    "title": "What is industrial espionage?",
    "description": "The gathering of a competitor's confidential information, also called industrial espionage, is not a new phenomenon. Businesses have used illegal means to acquire competitive information for many years. The temptation to steal a competitor's trade secrets and the ease with which a savvy attacker can compromise some computer systems makes this type of attack attractive."
  },
  {
    "id": 1680,
    "topic_id": 7,
    "title": "What are financial attacks?",
    "description": "Financial attacks are carried out to unlawfully obtain money or services. They are the type of computer crime you most commonly hear about in the news. The goal of a financial attack could be to steal credit card numbers, increase the balance in a bank account, or place \"free\" long-distance telephone calls."
  },
  {
    "id": 1681,
    "topic_id": 7,
    "title": "What are terrorist attacks?",
    "description": "Terrorist attacks are a reality in modern society. Our increasing reliance on information systems makes them more and more attractive to terrorists. Such attacks differ from military and intelligence attacks. The purpose of a terrorist attack is to disrupt normal life and instill fear, whereas a military or intelligence attack is designed to extract secret information."
  },
  {
    "id": 1682,
    "topic_id": 7,
    "title": "What are grudge attacks?",
    "description": "Grudge attacks are attacks that are carried out to damage an organization or a person. The damage could be in the loss of information or information processing capabilities or harm to the organization or a person's reputation."
  },
  {
    "id": 1683,
    "topic_id": 7,
    "title": "What are thrill attacks?",
    "description": "Thrill attacks are the attacks launched only for the fun of it."
  },
  {
    "id": 1684,
    "topic_id": 7,
    "title": "What are scanning attacks?",
    "description": "Scanning attacks are reconnaissance attacks that usually precede another, more serious attack."
  },
  {
    "id": 1685,
    "topic_id": 8,
    "title": "What is the purpose of assurance procedures?",
    "description": "To ensure that the security control mechanisms built into a new application properly implement the security policy throughout the life cycle of the system."
  },
  {
    "id": 1686,
    "topic_id": 8,
    "title": "What is DevOps?",
    "description": "The word DevOps is a combination of Development and Operations, symbolizing that these functions must merge and cooperate to meet business requirements. The DevOps approach seeks to resolve these issues by bringing the three functions (software development, quality assurance, and technology operations) together in a single operational model."
  },
  {
    "id": 1687,
    "topic_id": 8,
    "title": "What is an API?",
    "description": "An application programming interface (API) allows application developers to bypass traditional web pages and interact directly with the underlying service through function calls."
  },
  {
    "id": 1688,
    "topic_id": 8,
    "title": "What is a code repository?",
    "description": "It acts as a central storage point for developers to place their source code. It may also provide version control, bug tracking, web hosting, release management, and communications functions that support software development."
  },
  {
    "id": 1689,
    "topic_id": 6,
    "title": "What type of website monitoring technique is only able to detect issues <italic>after</italic> they occur?",
    "description": "Passive monitoring."
  },
  {
    "id": 1690,
    "topic_id": 6,
    "title": "What type of website monitoring technique executes artificial transactions against the site?",
    "description": "Synthetic monitoring (or active monitoring)."
  },
  {
    "id": 1691,
    "topic_id": 8,
    "title": "What is the most common open source database vulnerability scanner?",
    "description": "sqlmap."
  },
  {
    "id": 1692,
    "topic_id": 6,
    "title": "What are the four components covered by assessments under NIST 800-53A?",
    "description": "Specifications, mechanisms, activities, and individuals."
  },
  {
    "id": 1693,
    "topic_id": 6,
    "title": "What is the minimum timeframe covered by an SSAE 16 or SSAE 18 Type II report?",
    "description": "Six months."
  },
  {
    "id": 1694,
    "topic_id": 6,
    "title": "What SCAP component provides a standardized scoring system for describing the severity of security vulnerabilities?",
    "description": "Common Vulnerability Scoring System (CVSS)."
  },
  {
    "id": 1695,
    "topic_id": 8,
    "title": "What are the three major characteristics of a functional requirement?",
    "description": "Inputs, behaviors, and outputs."
  },
  {
    "id": 1696,
    "topic_id": 2,
    "title": "Administrators are removing all data from data records that can be used to identify an individual. What is this process called?",
    "description": "Anonymization."
  },
  {
    "id": 1697,
    "topic_id": 2,
    "title": "Administrators are replacing all data in data records that can be used to identify an individual with pseudonyms. What is this process called?",
    "description": "Pseudonymization."
  },
  {
    "id": 1698,
    "topic_id": 1,
    "title": "What is the GDPR?",
    "description": "The European Union (EU) General Data Protection Regulation (GDPR) replaced the EU Data Protection Directive, and it regulates the transfer of personal data in and out of the EU."
  },
  {
    "id": 1699,
    "topic_id": 3,
    "title": "What is context-aware authentication?",
    "description": "An authentication method often used by mobile device management (MDM) systems to identify mobile device users. It includes multiple elements such as the location of the user, the time of day, and the mobile device."
  },
  {
    "id": 1700,
    "topic_id": 4,
    "title": "Where are you most likely to see an ABAC model?",
    "description": "An attribute-based access control (ABAC) model is typically implemented in software-defined networks (SDNs)."
  },
  {
    "id": 1701,
    "topic_id": 3,
    "title": "What type of attack is thwarted with the use of bcrypt?",
    "description": "Rainbow table attacks. Bcrypt salts passwords."
  },
  {
    "id": 1702,
    "topic_id": 3,
    "title": "What is the purpose of a cryptographic pepper?",
    "description": "A pepper can be added to a salt to add additional protection for passwords."
  },
  {
    "id": 1703,
    "topic_id": 3,
    "title": "What is the purpose of a cryptographic salt?",
    "description": "A salt adds extra bits to a password before hashing it to protect against rainbow table attacks."
  },
  {
    "id": 1704,
    "topic_id": 3,
    "title": "What type of VDI maintains a user's desktop changes?",
    "description": "A persistent virtual desktop infrastructure (VDI) maintains user desktop changes."
  },
  {
    "id": 1705,
    "topic_id": 3,
    "title": "What is a hybrid cloud?",
    "description": "A combination of two or more private, public, and/or community clouds."
  },
  {
    "id": 1706,
    "topic_id": 1,
    "title": "What are the five elements of an AAA service?",
    "description": "Identification, authentication, authorization, auditing, and accounting."
  },
  {
    "id": 1707,
    "topic_id": 2,
    "title": "Define Sensitive But Unclassified (SBU)?",
    "description": "Sensitive But Unclassified (SBU) is used for data that is for internal use or office use only. Often SBU is used to protect information that could violate the privacy rights of individuals."
  },
  {
    "id": 1708,
    "topic_id": 1,
    "title": "What are the seven elements of PASTA (Process for Attack Simulation and Threat Analysis)?",
    "description": "Stage I is Definition the Objectives (DO) for the Analysis of Risks, Stage II is Definition of the Technical Scope (DTS), Stage III is Application Decomposition and Analysis (ADA), Stage IV is Threat Analysis (TA), Stage V is Weakness and Vulnerability Analysis (WVA), Stage VI is Attack Modeling & Simulation (AMS), and Stage VII is Risk Analysis & Management (RAM)."
  },
  {
    "id": 1709,
    "topic_id": 3,
    "title": "What is Trike?",
    "description": "Trike is a threat modeling methodology that focuses on a risk-based approach instead of depending on the aggregated threat model used in STRIDE and DREAD. Trike provides a method of performing a security audit in a reliable and repeatable procedure. It also provides a consistent framework for communication and collaboration among security workers."
  },
  {
    "id": 1710,
    "topic_id": 1,
    "title": "What is VAST?",
    "description": "VAST (Visual, Agile, and Simple Threat) is a threat modeling concept based on Agile project management and programming principles. The goal of VAST is to integrate threat and risk management into an Agile programming environment on a scalable basis."
  },
  {
    "id": 1711,
    "topic_id": 1,
    "title": "What is onboarding?",
    "description": "Onboarding is the process of adding new employees to the identity and access management (IAM) system of an organization. The onboarding process is also used when an employee's role or position changes or when that person is awarded additional levels of privilege or access."
  },
  {
    "id": 1712,
    "topic_id": 1,
    "title": "What is offboarding?",
    "description": "Offboarding is the reverse of this process. It is the removal of an employee's identity from the identity and access management (IAM) system once that person has left the organization."
  },
  {
    "id": 1713,
    "topic_id": 1,
    "title": "What is risk deterrence?",
    "description": "Risk deterrence is the process of implementing deterrents to would-be violators of security and policy. Examples include implementation of auditing, security cameras, security guards, instructional signage, warning banners, motion detectors, strong authentication, and making it known that the organization is willing to cooperate with authorities and prosecute those who participate in cybercrime."
  },
  {
    "id": 1714,
    "topic_id": 1,
    "title": "What is risk avoidance?",
    "description": "Risk avoidance is the process of selecting alternate options or activities that have less associated risk than the default, common, expedient, or cheap option. For example, choosing to fly to a destination instead of drive is a form of risk avoidance. Another example is to locate a business in Arizona instead of Florida to avoid hurricanes."
  },
  {
    "id": 1715,
    "topic_id": 1,
    "title": "Define Security Control Assessment (SCA).",
    "description": "A Security Control Assessment (SCA) is the formal evaluation of a security infrastructure's individual mechanisms against a baseline or reliability expectation. The SCA can be performed in addition to or independently of a full security evaluation, such as a penetration test or vulnerability assessment."
  },
  {
    "id": 1716,
    "topic_id": 4,
    "title": "What is split-DNS?",
    "description": "A split-DNS is deploying a DNS server for public use and a separate DNS server for internal use. All data in the zone file on the public DNS server is accessible by the public via queries or probing. However, the internal DNS is for internal use only. Only internal systems are granted access to interact with the internal DNS server."
  },
  {
    "id": 1717,
    "topic_id": 4,
    "title": "What ports are used by DNS and for what purposes?",
    "description": "TCP 53 is used for zone transfers (which includes most DNS server to DNS server communications), and UDP 53 is used for queries (which is any non-DNS system sending a query to a DNS server)."
  },
  {
    "id": 1718,
    "topic_id": 3,
    "title": "What the two types of hypervisors?",
    "description": "A Type I hypervisor is a native or bare-metal hypervisor. In this configuration, there is no host OS; instead, the hypervisor installs directly onto the hardware where the host OS would normally reside. A Type II hypervisor is a hosted hypervisor. In this configuration, a standard regular OS is present on the hardware, and then the hypervisor is installed as another software application."
  },
  {
    "id": 1719,
    "topic_id": 2,
    "title": "What is cloud storage?",
    "description": "Cloud storage is the idea of using storage capacity provided by a cloud vendor as a means to host data files for an organization. Cloud storage can be used as form of backup or support for online data services. Cloud storage may be cost effective, but it is not always high speed or low latency."
  },
  {
    "id": 1720,
    "topic_id": 2,
    "title": "Define an on-premises solution.",
    "description": "An on-premises solution is the traditional deployment concept in which an organization owns the hardware, licenses the software, and operates and maintains the systems on its own usually within their own building."
  },
  {
    "id": 1721,
    "topic_id": 2,
    "title": "Define a hosted solution.",
    "description": "A hosted solution is a deployment concept where the organization must license software and then operates and maintains the software. The hosting provider owns, operates, and maintains the hardware that supports the organization's software."
  },
  {
    "id": 1722,
    "topic_id": 2,
    "title": "Define a cloud solution.",
    "description": "A cloud solution is a deployment concept where an organization contracts with a third-party cloud provider. The cloud provider owns, operates, and maintains the hardware and software. The organization pays a monthly fee (often based on a per-user multiplier) to use the cloud solution."
  },
  {
    "id": 1723,
    "topic_id": 3,
    "title": "What is a private cloud?",
    "description": "A private cloud is a cloud service within a corporate network and isolated from the Internet."
  },
  {
    "id": 1724,
    "topic_id": 3,
    "title": "What is a public cloud?",
    "description": "A public cloud is a cloud service that is accessible to the general public, typically over an internet connection. Public cloud services may require some form of subscription or pay per use or may be offered for free."
  },
  {
    "id": 1725,
    "topic_id": 3,
    "title": "What is a hybrid cloud?",
    "description": "A hybrid cloud is a mixture of private and public cloud components."
  },
  {
    "id": 1726,
    "topic_id": 3,
    "title": "What is a community cloud?",
    "description": "A community cloud is a cloud environment maintained, used, and paid for by a group of users or organizations for their shared benefit, such as collaboration and data exchange. This may allow for some cost savings compared to accessing private or public clouds independently."
  },
  {
    "id": 1727,
    "topic_id": 3,
    "title": "What are snapshots?",
    "description": "Snapshots are backups of virtual machines. They offer a quick means to recover from errors or poor updates. It's often easier and faster to make backups of entire virtual systems rather than the equivalent native hardware installed system."
  },
  {
    "id": 1728,
    "topic_id": 2,
    "title": "What is a cloud access security broker (CASB)?",
    "description": "A cloud access security broker (CASB) is a security policy enforcement solution that may be installed on-premises, or it may be cloud-based. The goal of a CASB is to enforce and ensure that proper security measures are implemented between a cloud solution and a customer organization."
  },
  {
    "id": 1729,
    "topic_id": 3,
    "title": "What is security as a service (SECaaS)?",
    "description": "A cloud provider concept in which security is provided to an organization through or by an online entity. The purpose of an SECaaS solution is to reduce the cost and overhead of implementing and managing security locally."
  },
  {
    "id": 1730,
    "topic_id": 3,
    "title": "What is the cloud shared responsibility model?",
    "description": "The concept that when an organization uses a cloud solution, there is a division of security and stability responsibility between the provider and the customer. The different forms of cloud service (such as SaaS, PaaS, and IaaS) may each have different levels or division points of shared responsibility."
  },
  {
    "id": 1731,
    "topic_id": 3,
    "title": "What is a smart device?",
    "description": "Smart devices are a range of mobile devices that offer the user a plethora of customization options, typically through installing apps, and may take advantage of on-device or in-the-cloud artificial intelligence (AI) processing."
  },
  {
    "id": 1732,
    "topic_id": 3,
    "title": "Define COPE.",
    "description": "The concept of COPE (company-owned, personally enabled) is for the organization to purchase devices and provide them to employees. Each user is then able to customize the device and use it for both work activities and personal activities."
  },
  {
    "id": 1733,
    "topic_id": 3,
    "title": "Define CYOD.",
    "description": "The concept of CYOD (choose your own device) provides users with a list of approved devices from which to select the device to implement. A CYOD can be implemented so that employees purchase their own devices from the approved list (a BYOD variant) or the company can purchase the devices for the employees (a COPE variant)."
  },
  {
    "id": 1734,
    "topic_id": 3,
    "title": "Describe the concept of a corporate-owned mobile strategy.",
    "description": "A corporate-owned mobile strategy is when the company purchases the mobile devices that can support security compliance with the security policy. These devices are to be used exclusively for company purposes, and users should not perform any personal tasks on the devices. This often requires workers to carry a second device for personal use."
  },
  {
    "id": 1735,
    "topic_id": 3,
    "title": "What is VDI?",
    "description": "Virtual desktop infrastructure (VDI) is a means to reduce the security risk and performance requirements of end devices by hosting virtual machines on central servers that are remotely accessed by users. It is a means to retain storage control on central servers, gain access to higher levels of system processing and other resources, and allow lower-end devices access to software and services behind their hardware's capacity."
  },
  {
    "id": 1736,
    "topic_id": 3,
    "title": "What is VMI?",
    "description": "Virtual mobile infrastructure (VMI) is a technology where the operating system of a mobile device is virtualized on a central server. Thus most of the actions and activities of the traditional mobile device are no longer occurring on the mobile device itself. This remote virtualization allows an organization greater control and security than when using a standard mobile device platform."
  },
  {
    "id": 1737,
    "topic_id": 3,
    "title": "What does a cable plant management policy address?",
    "description": "A cable plant is the collection of interconnected cables and intermediary devices (such as cross-connects, patch panels, and switches) that establish the physical network. Elements of a cable plant include entrance facility, equipment room, backbone distribution system, telecommunications room, and horizontal distribution system."
  },
  {
    "id": 1738,
    "topic_id": 3,
    "title": "What is a Faraday cage?",
    "description": "A Faraday cage is EM blocking enclosure, often a wire mesh that fully surrounds an area on all sides. This metal skin acts as an EMI absorbing capacitor (which is why it's named after Michael Faraday, a pioneer in the field of electromagnetism) that prevents electromagnetic signals (emanations) from exiting or entering the area that the cage encloses."
  },
  {
    "id": 1739,
    "topic_id": 3,
    "title": "What is white noise (as related to EMI)?",
    "description": "White noise simply means broadcasting false traffic at all times to mask and hide the presence of real emanations."
  },
  {
    "id": 1740,
    "topic_id": 4,
    "title": "What components make up a FQDN?",
    "description": "A fully qualified domain names (FQDN) consists of three main parts: top-level domain (TLD), like the <code>com</code> in <code>www.google.com</code>; registered domain name, like the <code>google</code> in <code>www.google.com</code>; and subdomain(s) or hostname, like the <code>www</code> in <code>www.google.com.</code>"
  },
  {
    "id": 1741,
    "topic_id": 4,
    "title": "When a domain name is registered, where and how is it stored?",
    "description": "Every registered domain name has an assigned authoritative name server. The primary authoritative name server hosts the original zone file for the domain. Secondary authoritative name servers can be used to host read-only copies of the zone file. A zone file is the collection of resource records or details about the specific domain. There are dozens of possible resource records."
  },
  {
    "id": 1742,
    "topic_id": 4,
    "title": "What is DNSSEC?",
    "description": "DNSSEC (Domain Name System Security Extensions) is a security improvement to the existing DNS infrastructure. The primary function of DNSSEC is to provide reliable authentication between devices during DNS operations. DNSSEC has been implemented across a significant portion of the DNS system. Each DNS server is issued a digital certificate, which is then used to perform mutual certificate authentication."
  },
  {
    "id": 1743,
    "topic_id": 4,
    "title": "What is DNS poisoning?",
    "description": "DNS poisoning is the act of falsifying the DNS information used by a client to reach a desired system. It can take place in many ways."
  },
  {
    "id": 1744,
    "topic_id": 4,
    "title": "What are some of the means for a DNS poisoning or attack to occur?",
    "description": "Rogue DNS server, planting false data in zone file, altering the HOSTS file, and corrupting IP configuration to change DNS lookup server address."
  },
  {
    "id": 1745,
    "topic_id": 4,
    "title": "What is DNS pharming?",
    "description": "DNS pharming is the malicious redirection of a valid website's URL or IP address to a fake website that hosts a false version of the original valid site. This is often part of a phishing attack where the attacker is attempting to trick victims into giving up their logon credentials."
  },
  {
    "id": 1746,
    "topic_id": 4,
    "title": "What is domain hijacking?",
    "description": "Domain hijacking, or domain theft, is the malicious action of changing the registration of a domain name without the authorization of the valid owner. This may be accomplished by stealing the owner's logon credentials; using XSRF, session hijacking, or MitM/on-path attack; or exploiting a flaw in the domain registrar's systems."
  },
  {
    "id": 1747,
    "topic_id": 4,
    "title": "What is the Wi-Fi attack known as KRACK?",
    "description": "In late 2017, a concept of attack known as KRACK (Key Reinstallation AttaCKs) was disclosed that is able to corrupt the initial four-way handshake between client and WAP into reusing a previously used key and in some cases use a key composed of only zeros."
  },
  {
    "id": 1748,
    "topic_id": 4,
    "title": "What is WPS?",
    "description": "Wi-Fi Protected Setup (WPS) is a security standard for wireless networks. It is intended to simplify the effort involved in adding new clients to a well-secured wireless network. It operates by autoconnecting the first new wireless client to seek the network once the administrator triggered the feature by pressing the WPS button on the base station."
  },
  {
    "id": 1749,
    "topic_id": 4,
    "title": "What is war chalking?",
    "description": "War chalking is a type of geek graffiti that some wireless hackers used during the early years of wireless (1997\u20132002). It's a way to physically mark an area with information about the presence of a wireless network."
  },
  {
    "id": 1750,
    "topic_id": 4,
    "title": "What is the evil twin attack?",
    "description": "Evil twin is an attack in which a hacker operates a false access point that will automatically clone, or twin, the identity of an access point based on a client device's request to connect."
  },
  {
    "id": 1751,
    "topic_id": 4,
    "title": "What is RFID?",
    "description": "RFID (Radio Frequency Identification) is a tracking technology based on the ability to power a radio transmitter using current generated in an antenna when placed in a magnetic field. RFID can be triggered/powered and read from a considerable distance away (often hundreds of meters)."
  },
  {
    "id": 1752,
    "topic_id": 4,
    "title": "What is NFC?",
    "description": "Near field communication (NFC) is a standard that establishes radio communications between devices in close proximity. It lets you perform a type of automatic synchronization and association between devices by touching them together or bringing them within inches of each other."
  },
  {
    "id": 1753,
    "topic_id": 4,
    "title": "What is SRTP?",
    "description": "SRTP (Secure Real-Time Transport Protocol, or Secure RTP) is a security improvement over RTP (Real-Time Transport Protocol) that is used in many VoIP (Voice over IP) communications. SRTP aims to minimize the risk of VoIP DoS through robust encryption and reliable authentication."
  },
  {
    "id": 1754,
    "topic_id": 4,
    "title": "What is Opportunistic TLS?",
    "description": "Opportunistic TLS for SMTP will attempt to set up an encrypted connection with every other email server in the event that it is supported; otherwise, it will downgrade to plaintext. Using opportunistic TLS for SMTP gateways reduces the opportunities for casual sniffing of email."
  },
  {
    "id": 1755,
    "topic_id": 4,
    "title": "What is SPF?",
    "description": "Sender Policy Framework (SPF) is used to protect against spam and email spoofing. SPF operates by checking that inbound messages originate from a host authorized to send messages by the owners of the SMTP origin domain."
  },
  {
    "id": 1756,
    "topic_id": 4,
    "title": "What is a broadcast storm?",
    "description": "A broadcast storm is a flood of unwanted Ethernet broadcast network traffic."
  },
  {
    "id": 1757,
    "topic_id": 3,
    "title": "What is VM escaping?",
    "description": "VM escaping occurs when software within a guest OS is able to breach the isolation protection provided by the hypervisor in order to violate the container of other guest OSs or to infiltrate a host OS."
  },
  {
    "id": 1758,
    "topic_id": 1,
    "title": "How does identification work?",
    "description": "Identification is the process by which a subject professes an identity and accountability is initiated. A subject must provide an identity to a system to start the process of authentication, authorization, and accountability."
  },
  {
    "id": 1759,
    "topic_id": 1,
    "title": "What is the process of authentication?",
    "description": "Authentication is the process of verifying or testing that a claimed identity is valid. Authentication requires information (i.e., authentication factors) from the subject that must exactly correspond to the identity indicated."
  },
  {
    "id": 1760,
    "topic_id": 1,
    "title": "What is the function of authorization?",
    "description": "Once a subject is authenticated, its access must be authorized. The process of authorization ensures that the requested activity or object access is possible given the rights and privileges assigned to the authenticated identity."
  },
  {
    "id": 1761,
    "topic_id": 1,
    "title": "What is auditing (related to AAA services)?",
    "description": "Auditing is the programmatic means by which subjects are held accountable for their actions while authenticated on a system through the documentation or recording of subject activities."
  },
  {
    "id": 1762,
    "topic_id": 1,
    "title": "What is the importance of accountability?",
    "description": "Security can be maintained only if subjects are held accountable for their actions. Effective accountability relies on the capability to prove a subject's identity and track their activities."
  },
  {
    "id": 1763,
    "topic_id": 1,
    "title": "What is the concept of abstraction?",
    "description": "Abstraction is used to collect similar elements into groups, classes, or roles that are assigned security controls, restrictions, or permissions as a collective. It adds efficiency to carrying out a security plan."
  },
  {
    "id": 1764,
    "topic_id": 1,
    "title": "What is a security boundary?",
    "description": "A security boundary is the line of intersection between any two areas, subnets, or environments that have different security requirements or needs."
  },
  {
    "id": 1765,
    "topic_id": 1,
    "title": "What is the purpose of alignment of security function to business strategy, goals, mission, and objectives?",
    "description": "Security management planning ensures proper creation, implementation, and enforcement of a <italic>security policy</italic>. Security management planning aligns the security functions to the strategy, goals, mission, and objectives of the organization. This includes designing and implementing security based on business cases, budget restrictions, or scarcity of resources."
  },
  {
    "id": 1766,
    "topic_id": 1,
    "title": "What are the six key principles for governance and management of enterprise IT according to COBIT?",
    "description": "COBIT is based on six key principles for governance and management of enterprise IT: Provide Stakeholder Value, Holistic Approach, Dynamic Governance System, Governance Distinct from Management, Tailored to Enterprise Needs, and End-to-End Governance System."
  },
  {
    "id": 1767,
    "topic_id": 1,
    "title": "What is supply chain risk management (SCRM)?",
    "description": "SCRM is means to ensure that all the vendors or links in the supply chain are reliable, trustworthy, reputable organizations that disclose their practices and security requirements to their business partners. SCRM includes evaluating risks associated with hardware, software, and services; performing third-party assessment and monitoring; establishing minimum security requirements; and enforcing service-level requirements."
  },
  {
    "id": 1768,
    "topic_id": 1,
    "title": "What role do humans play as a key element in security?",
    "description": "Humans are often considered the weakest element in any security solution. No matter what physical or logical controls are deployed, humans can discover ways to avoid them, circumvent or subvert them, or disable them. However, people can also become a key security asset when they are properly trained and are motivated to protect not only themselves but the security of the organization as well."
  },
  {
    "id": 1769,
    "topic_id": 1,
    "title": "What is the importance of job descriptions?",
    "description": "Without a job description, there is no consensus on what type of individual should be hired. Thus, crafting job descriptions is the first step in defining security needs related to personnel and being able to seek out new hires."
  },
  {
    "id": 1770,
    "topic_id": 1,
    "title": "What are the security implications of hiring new employees?",
    "description": "To properly plan for security, you must have standards in place for job descriptions, job classification, work tasks, job responsibilities, prevention of collusion, candidate screening, background checks, security clearances, employment agreements, and nondisclosure agreements. By deploying such mechanisms, you ensure that new hires are aware of the required security standards, thus protecting your organization's assets."
  },
  {
    "id": 1771,
    "topic_id": 1,
    "title": "What is the need for a nondisclosure agreement (NDA)?",
    "description": "An NDA is used to protect the confidential information within an organization from being disclosed by a former employee. When a person signs an NDA, they agree not to disclose any information that is defined as confidential to anyone outside the organization."
  },
  {
    "id": 1772,
    "topic_id": 1,
    "title": "What are the common elements of employee oversight?",
    "description": "Throughout the employment lifetime of personnel, managers should regularly review or audit the job descriptions, work tasks, privileges, and responsibilities for every staff member."
  },
  {
    "id": 1773,
    "topic_id": 1,
    "title": "What are user behavior analytics (UBA) and user and entity behavior analytics (UEBA)?",
    "description": "User behavior analytics (UBA) and user and entity behavior analytics (UEBA) are the concepts of analyzing the behavior of users, subjects, visitors, customers, etc. for some specific goal or purpose. Information collected from UBA/UEBA monitoring can be used to improve personnel security policies, procedures, training, and related security oversight programs."
  },
  {
    "id": 1774,
    "topic_id": 1,
    "title": "How should an organization handle employee transfers?",
    "description": "Personnel transfers may be treated as a fire/rehire rather than a personnel move. Some of the elements that go into making the decision as to which procedure to use include whether the same user account will be retained, if their clearance will be adjusted, if their new work responsibilities are similar to the previous position, and if a \"clean slate\" account is required for auditing purposes in the new job position."
  },
  {
    "id": 1775,
    "topic_id": 1,
    "title": "What is the purpose of vendor, consultant, and contractor controls?",
    "description": "Vendor, consultant, and contractor controls are used to define the levels of performance, expectation, compensation, and consequences for entities, persons, or organizations that are external to the primary organization. Often these controls are defined in a document or policy known as a service-level agreement (SLA)."
  },
  {
    "id": 1776,
    "topic_id": 1,
    "title": "Define the concept of risk management?",
    "description": "Risk management is the process of identifying factors that could damage or disclose data, evaluating those factors in light of data value and countermeasure cost, and implementing cost-effective solutions for mitigating or reducing risk is known as risk management. By performing risk management, you lay the foundation for reducing risk overall."
  },
  {
    "id": 1777,
    "topic_id": 1,
    "title": "What are the key elements of risk analysis?",
    "description": "Risk analysis is the process by which upper management is provided with details to make decisions about which risks are to be mitigated, which should be transferred, and which should be accepted. To fully evaluate risks and subsequently take the proper precautions, you must analyze the following: assets, asset valuation, threats, vulnerability, exposure, risk, realized risk, safeguards, countermeasures, attacks, and breaches."
  },
  {
    "id": 1778,
    "topic_id": 1,
    "title": "What are key concerns related to threat evaluation?",
    "description": "Threats can originate from numerous sources, including IT, humans, and nature. Threat assessment should be performed as a team effort to provide the widest range of perspectives. By fully evaluating risks from all angles, you reduce your system's vulnerability."
  },
  {
    "id": 1779,
    "topic_id": 1,
    "title": "What is the Delphi technique?",
    "description": "The Delphi technique is simply an anonymous feedback-and-response process used to arrive at a consensus. Such a consensus gives the responsible parties the opportunity to properly evaluate risks and implement solutions."
  },
  {
    "id": 1780,
    "topic_id": 1,
    "title": "What is exposure factor (EF)?",
    "description": "An EF is an element of quantitative risk analysis that represents the percentage of loss that an organization would experience if a specific asset were violated by a realized risk. By calculating exposure factors, you are able to implement a sound risk management policy."
  },
  {
    "id": 1781,
    "topic_id": 1,
    "title": "What is annualized rate of occurrence (ARO)?",
    "description": "ARO is an element of quantitative risk analysis that represents the expected frequency with which a specific threat or risk will occur (in other words, become realized) within a single year. Understanding AROs further enables you to calculate the risk and take proper precautions."
  },
  {
    "id": 1782,
    "topic_id": 1,
    "title": "What is the purpose of security monitoring and measurement?",
    "description": "Security controls should provide benefits that can be monitored and measured. If a security control's benefits cannot be quantified, evaluated, or compared, then it does not actually provide any security."
  },
  {
    "id": 1783,
    "topic_id": 1,
    "title": "What is risk reporting?",
    "description": "Risk reporting involves the production of a risk report and a presentation of that report to the interested/relevant parties. A risk report should be accurate, timely, comprehensive of the entire organization, clear and precise to support decision making, and updated on a regular basis."
  },
  {
    "id": 1784,
    "topic_id": 1,
    "title": "Why is continuous improvement necessary?",
    "description": "Security is always changing. Thus, any implemented security solution requires updates and changes over time. If a continuous improvement path is not provided by a selected countermeasure, then it should be replaced with one that offers scalable improvements to security."
  },
  {
    "id": 1785,
    "topic_id": 1,
    "title": "What is the Risk Maturity Model (RMM)?",
    "description": "The Risk Maturity Model (RMM) is a means to assess the key indicators and activities of a mature, sustainable, and repeatable risk management process. The RMM levels are ad hoc, preliminary, defined, integrated, and optimized."
  },
  {
    "id": 1786,
    "topic_id": 1,
    "title": "What should be known about legacy system security risk?",
    "description": "Legacy systems are often a threat because they may not be receiving security updates from their vendors. End-of-life (EOL) is the point at which a manufacturer no longer produces a product. End-of-service-life (EOSL) or end-of-support (EOS) are those that are no longer receiving updates and support from the vendor."
  },
  {
    "id": 1787,
    "topic_id": 1,
    "title": "Name several risk frameworks?",
    "description": "Risk Management Framework (RMF) defined by NIST, NIST Cybersecurity Framework (CSF), Control Objectives for Information and Related Technology (COBIT), Sherwood Applied Business Security Architecture (SABSA), Federal Risk and Authorization Management Program (FedRAMP), Information Technology Infrastructure Library (ITIL), and Payment Card Industry (PCI)."
  },
  {
    "id": 1788,
    "topic_id": 1,
    "title": "Define social engineering and name several examples of types of social engineering attacks?",
    "description": "Social engineering is a form of attack that exploits human nature and human behavior. The attack principles are authority, intimidation, consensus, scarcity, familiarity, trust, and urgency. Social engineering attacks include eliciting information, pretexting, prepending, phishing, spear phishing, business email compromise (BEC), whaling, smishing, vishing, spam, shoulder surfing, invoice scams, hoaxes, impersonation, masquerading, tailgating, piggybacking, dumpster diving, identity fraud, and influence campaigns."
  },
  {
    "id": 1789,
    "topic_id": 1,
    "title": "Why should an organization implement security awareness training and education?",
    "description": "Awareness establishes a baseline of general security understanding. Training teaches employees to perform their work tasks in compliance with the security policy,  standards, guidelines, and procedures mandated by the organization. Education is a more detailed endeavor in which students/users learn much more than they actually need to know to perform their work tasks."
  },
  {
    "id": 1790,
    "topic_id": 1,
    "title": "What is a security champion?",
    "description": "Often a security champion is a member of a group who decides (or is assigned) to take charge of leading the adoption and integration of security concepts into the group's work activities. Security champions are often non-security employees who take up the mantle to encourage others to support and adopt more security practices and behaviors."
  },
  {
    "id": 1791,
    "topic_id": 1,
    "title": "What is gamification as it applies to personnel security management?",
    "description": "Gamification is a means to encourage compliance and engagement by integrating common elements of game play into other activities, such as security compliance and behavior change."
  },
  {
    "id": 1792,
    "topic_id": 1,
    "title": "What is the need for periodic content reviews and effectiveness evaluations?",
    "description": "It is important to perform periodic content reviews of all training materials. This is to ensure that the training materials and presentation stays in line with business goals, organizational mission, and security objectives. Some means of verification should be used to measure whether the training is beneficial or a waste of time and resources."
  },
  {
    "id": 1793,
    "topic_id": 1,
    "title": "What are the four steps of the business continuity planning process?",
    "description": "Business continuity planning involves four distinct phases: project scope and planning, business impact analysis, continuity planning, and approval and implementation. Each task contributes to the overall goal of ensuring that business operations continue uninterrupted in the face of an emergency."
  },
  {
    "id": 1794,
    "topic_id": 1,
    "title": "What is business organization analysis?",
    "description": "In the business organization analysis, the individuals responsible for leading the BCP process determine which departments and individuals have a stake in the business continuity plan. This analysis serves as the foundation for BCP team selection and, after validation by the BCP team, is used to guide the next stages of BCP development."
  },
  {
    "id": 1795,
    "topic_id": 1,
    "title": "Who are the necessary members of the business continuity planning team?",
    "description": "The BCP team should contain, at a minimum, representatives from each of the operational and support departments; technical experts from the IT department; physical and IT security personnel with BCP skills; legal representatives familiar with corporate legal, regulatory, and contractual responsibilities; and representatives from senior management. Additional team members depend on the structure and nature of the organization."
  },
  {
    "id": 1796,
    "topic_id": 1,
    "title": "What are the legal and regulatory requirements that face business continuity planners?",
    "description": "Business leaders must exercise due diligence to ensure that shareholders' interests are protected in the event disaster strikes. Some industries are also subject to federal, state, and local regulations that mandate specific BCP procedures. Many businesses also have contractual obligations to their clients that they must meet before, during, and after a disaster."
  },
  {
    "id": 1797,
    "topic_id": 1,
    "title": "What are the steps of the business impact analysis process?",
    "description": "The five stages of the business impact analysis process are the identification of priorities, risk identification, likelihood assessment, impact analysis, and resource prioritization."
  },
  {
    "id": 1798,
    "topic_id": 1,
    "title": "What is the process used to develop a continuity strategy in relation to BCP?",
    "description": "During the strategy development phase, the BCP team determines which risks they will mitigate. In the provisions and processes phase, the team designs mechanisms and procedures that will mitigate identified risks. The plan must then be approved by senior management and implemented. Personnel must also receive training on their roles in the BCP process."
  },
  {
    "id": 1799,
    "topic_id": 1,
    "title": "What is the importance of comprehensively documenting an organization's business continuity plan?",
    "description": "Committing the plan to writing provides the organization with a written record of the procedures to follow when disaster strikes. It prevents the \"it's in my head\" syndrome and ensures the orderly progress of events in an emergency."
  },
  {
    "id": 1800,
    "topic_id": 1,
    "title": "What are the differences between criminal law, civil law, and administrative law?",
    "description": "Criminal law protects society against acts that violate the basic principles we believe in. Violations of criminal law are prosecuted by federal and state governments. Civil law provides the framework for the transaction of business between people and organizations. Violations of civil law are brought to the court and argued by the two affected parties. Administrative law is used by government agencies to effectively carry out their day-to-day business."
  },
  {
    "id": 1801,
    "topic_id": 1,
    "title": "Name the two primary laws that are designed to protect society against computer crime and their basic provisions?",
    "description": "The Computer Fraud and Abuse Act (as amended) protects computers used by the government or in interstate commerce from a variety of abuses. The Electronic Communications Privacy Act (ECPA) makes it a crime to invade the electronic privacy of an individual."
  },
  {
    "id": 1802,
    "topic_id": 1,
    "title": "What are the differences among copyrights, trademarks, patents, and trade secrets?",
    "description": "Copyrights protect original works of authorship, such as books, articles, poems, and songs. Trademarks are names, slogans, and logos that identify a company, product, or service. Patents provide protection to the creators of new inventions. Trade secret law protects the operating secrets of a firm."
  },
  {
    "id": 1803,
    "topic_id": 1,
    "title": "What are the basic provisions of the Digital Millennium Copyright Act of 1998?",
    "description": "The Digital Millennium Copyright Act prohibits the circumvention of copy protection mechanisms placed in digital media and limits the liability of internet service providers for the activities of their users."
  },
  {
    "id": 1804,
    "topic_id": 1,
    "title": "What are the basic provisions of the Economic Espionage Act of 1996?",
    "description": "The Economic Espionage Act provides penalties for individuals found guilty of the theft of trade secrets. Harsher penalties apply when the individual knows that the information will benefit a foreign government."
  },
  {
    "id": 1805,
    "topic_id": 1,
    "title": "Define the various types of software license agreements.",
    "description": "Perpetual licenses, subscription licenses, open source licenses, freeware, enterprise license agreements (ELAs), end-user license agreements (EULAs), concurrent use licenses, named user licenses, and cloud services license agreements."
  },
  {
    "id": 1806,
    "topic_id": 1,
    "title": "What are the terms of the notification requirements placed on organizations that experience a data breach within the US?",
    "description": "California's SB 1386 implemented the first statewide requirement to notify individuals of a breach of their personal information. All other states eventually followed suit with similar laws. Currently, federal law only requires the notification of individuals when a HIPAA-covered entity breaches their protected health information."
  },
  {
    "id": 1807,
    "topic_id": 1,
    "title": "What are the major laws that govern privacy of personal information in the United States, the European Union, and Canada?",
    "description": "The United States has a number of privacy laws that affect the government's use of information as well as the use of information by specific industries, such as financial services companies and healthcare organizations that handle sensitive information. The EU has a more comprehensive General Data Protection Regulation that governs the use and exchange of personal information. In Canada, the Personal Information Protection and Electronic Documents Act (PIPEDA) governs the use of personal information."
  },
  {
    "id": 1808,
    "topic_id": 1,
    "title": "What is the importance of a well-rounded compliance program?",
    "description": "Most organizations are subject to a wide variety of legal and regulatory requirements related to information security. Building a compliance program ensures that you become and remain compliant with these often overlapping requirements."
  },
  {
    "id": 1809,
    "topic_id": 1,
    "title": "How should an organization incorporate security into the procurement and vendor governance process?",
    "description": "The expanded use of cloud services by many organizations requires added attention to conducting reviews of information security controls during the vendor selection process and as part of ongoing vendor governance."
  },
  {
    "id": 1810,
    "topic_id": 1,
    "title": "What are the legal responsibilities of a cybersecurity professional?",
    "description": "Cybersecurity professionals must be able to analyze a situation and determine what jurisdictions and laws apply. They must be able to identify relevant contractual, legal, regulatory, and industry standards and interpret them for their given situation."
  },
  {
    "id": 1811,
    "topic_id": 2,
    "title": "What is the importance of data and asset classifications?",
    "description": "Data owners are responsible for defining data and asset classifications and ensuring that data and systems are properly marked. Additionally, data owners define requirements to protect data at different classifications, such as encrypting sensitive data at rest and in transit. Data classifications are typically defined within security policies or data policies."
  },
  {
    "id": 1812,
    "topic_id": 2,
    "title": "How should an organization approach the management of sensitive information?",
    "description": "Sensitive information is any type of classified information, and proper management helps prevent unauthorized disclosure resulting in a loss of confidentiality. Proper management includes marking, handling, storing, and destroying sensitive information. The two areas where organizations often miss the mark are adequately protecting backup media holding sensitive information and sanitizing media or equipment when it is at the end of its lifecycle."
  },
  {
    "id": 1813,
    "topic_id": 2,
    "title": "Compare the various data destruction methods.",
    "description": "Erasing a file doesn't delete it. Clearing media overwrites it with characters or bits. Purging repeats the clearing process multiple times and removes data so that the media can be reused. Degaussing removes data from tapes and magnetic hard disk drives, but it does not affect optical media or SSDs. Destruction methods include incineration, crushing, shredding, and disintegration."
  },
  {
    "id": 1814,
    "topic_id": 2,
    "title": "Describe record retention policies.",
    "description": "Record retention policies ensure that data is kept in a usable state while it is needed and destroyed when it is no longer needed. Many laws and regulations mandate keeping data for a specific amount of time, but in the absence of formal regulations, organizations specify the retention period within a policy. Audit trail data needs to be kept long enough to reconstruct recent past incidents. A current trend in many organizations is to reduce legal liabilities by implementing shorter retention policies."
  },
  {
    "id": 1815,
    "topic_id": 2,
    "title": "What is the difference between EOL and EOS?",
    "description": "End-of-life (EOL) is the date announced by a vendor when sales of a product stop. However, the vendor still supports the product after EOL. End-of-support (EOS) identifies the date when a vendor will no longer support a product."
  },
  {
    "id": 1816,
    "topic_id": 2,
    "title": "What is tokenization?",
    "description": "Tokenization replaces data elements with a string of characters or a token. Credit card processors replace credit card data with a token, and a third party holds the mapping to the original data and the token."
  },
  {
    "id": 1818,
    "topic_id": 2,
    "title": "What are security control baselines?",
    "description": "Security control baselines provide a listing of controls that an organization can apply as a baseline. Not all baselines apply to all organizations. Organizations apply scoping and tailoring techniques to adapt a baseline to their needs."
  },
  {
    "id": 1819,
    "topic_id": 3,
    "title": "What is the role that confidentiality, integrity, and nonrepudiation play in cryptosystems?",
    "description": "Confidentiality is one of the major goals of cryptography. It protects the secrecy of data while it is both at rest and in transit. Integrity provides the recipient of a message with the assurance that data was not altered (intentionally or unintentionally) between the time it was created and the time it was accessed. Nonrepudiation provides undeniable proof that the sender of a message actually authored it. It prevents the sender from subsequently denying that they sent the original message."
  },
  {
    "id": 1820,
    "topic_id": 3,
    "title": "How can cryptosystems be used to achieve authentication goals?",
    "description": "Authentication provides assurances as to the identity of a user. One possible scheme that uses authentication is the challenge-response protocol, in which the remote user is asked to encrypt a message using a key known only to the communicating parties. Authentication can be achieved with both symmetric and asymmetric cryptosystems."
  },
  {
    "id": 1821,
    "topic_id": 3,
    "title": "What is the difference between a code and a cipher and explain the basic types of ciphers?",
    "description": "Codes are cryptographic systems of symbols that operate on words or phrases and are sometimes secret but don't always provide confidentiality. Ciphers, however, are always meant to hide the true meaning of a message. Know how the following types of ciphers work: transposition ciphers, substitution ciphers (including one-time pads), stream ciphers, and block ciphers."
  },
  {
    "id": 1822,
    "topic_id": 3,
    "title": "What are the requirements for successful use of a one-time pad?",
    "description": "For a one-time pad to be successful, the key must be generated randomly without any known pattern. The key must be at least as long as the message to be encrypted. The pads must be protected against physical disclosure, and each pad must be used only one time and then discarded."
  },
  {
    "id": 1823,
    "topic_id": 3,
    "title": "What is the importance of key security?",
    "description": "Cryptographic keys provide the necessary element of secrecy to a cryptosystem. Modern symmetric cryptosystems utilize keys that are at least 128 bits long to provide adequate security. Modern asymmetric cryptosystems utilize keys that are at least 2048 bits long to provide adequate security."
  },
  {
    "id": 1824,
    "topic_id": 3,
    "title": "What are the differences between symmetric and asymmetric cryptosystems?",
    "description": "Symmetric key cryptosystems (or secret key cryptosystems) rely on the use of a shared secret key. They are much faster than asymmetric algorithms, but they lack support for scalability, easy key distribution, and nonrepudiation. Asymmetric cryptosystems use public-private key pairs for communication between parties but operate much more slowly than symmetric algorithms."
  },
  {
    "id": 1825,
    "topic_id": 3,
    "title": "What are the basic operational modes of symmetric cryptosystems?",
    "description": "Symmetric cryptosystems operate in several discrete modes: Electronic Code Book (ECB) mode, Cipher Block Chaining (CBC) mode, Cipher Feedback (CFB) mode, Output Feedback (OFB) mode, Counter (CTR) mode, Galois/Counter mode (GCM), and Counter with Cipher Block Chaining Message Authentication Code mode (CCM). ECB mode is considered the least secure and is used only for short messages."
  },
  {
    "id": 1826,
    "topic_id": 3,
    "title": "What are the characteristics of the Advanced Encryption Standard (AES)?",
    "description": "The Advanced Encryption Standard (AES) uses the Rijndael algorithm and is the U.S. government standard for the secure exchange of sensitive but unclassified data. AES uses key lengths of 128, 192, and 256 bits and a fixed block size of 128 bits to achieve a much higher level of security than that provided by the older DES algorithm."
  },
  {
    "id": 1827,
    "topic_id": 3,
    "title": "What are the key types used in asymmetric cryptography?",
    "description": "Public keys are freely shared among communicating parties, whereas private keys are kept secret. To encrypt a message, use the recipient's public key. To decrypt a message, use your own private key. To sign a message, use your own private key. To validate a signature, use the sender's public key."
  },
  {
    "id": 1828,
    "topic_id": 3,
    "title": "What are the three major public key cryptosystems?",
    "description": "RSA is the most famous public key cryptosystem; it was developed by Rivest, Shamir, and Adleman in 1977. It depends on the difficulty of factoring the product of prime numbers. ElGamal is an extension of the Diffie\u2013Hellman key exchange algorithm that depends on modular arithmetic. The elliptic curve algorithm depends on the elliptic curve discrete logarithm problem and provides more security than other algorithms when both are used with keys of the same length."
  },
  {
    "id": 1829,
    "topic_id": 3,
    "title": "What are the fundamental requirements of a hash function?",
    "description": "Good hash functions have five requirements. They must allow input of any length, provide fixed-length output, make it relatively easy to compute the hash function for any input, provide one-way functionality, and be collision-resistant."
  },
  {
    "id": 1830,
    "topic_id": 3,
    "title": "What are the hashing algorithms in primary use today?",
    "description": "The successors to the Secure Hash Algorithm (SHA), SHA-2 and SHA-3, make up the government standard message digest function. SHA-2 supports variable-length message digests, ranging up to 512 bits. SHA-3 improves upon the security of SHA-2 and supports the same hash lengths."
  },
  {
    "id": 1831,
    "topic_id": 3,
    "title": "How do salts improve the security of password hashing?",
    "description": "When straightforward hashing is used to store passwords in a password file, attackers may use rainbow tables of precomputed values to identify commonly used passwords. Adding salts to the passwords before hashing them reduces the effectiveness of rainbow table attacks. Common password hashing algorithms that use key stretching to further increase the difficulty of attack include PBKDF2, bcrypt, and scrypt."
  },
  {
    "id": 1832,
    "topic_id": 3,
    "title": "How are digital signatures generated and verified?",
    "description": "To digitally sign a message, first use a hashing function to generate a message digest; then encrypt the digest with your private key. To verify the digital signature on a message, decrypt the signature with the sender's public key and then compare the message digest to one you generate yourself. If they match, the message is authentic."
  },
  {
    "id": 1833,
    "topic_id": 3,
    "title": "What is public key infrastructure (PKI)?",
    "description": "In the public key infrastructure, certificate authorities (CAs) generate digital certificates containing the public keys of system users. Users then distribute these certificates to people with whom they want to communicate. Certificate recipients verify a certificate using the CA's public key."
  },
  {
    "id": 1834,
    "topic_id": 3,
    "title": "What are the common applications of cryptography to secure email?",
    "description": "The emerging standard for encrypted messages is the S/MIME protocol. Another popular email security tool is Phil Zimmerman's Pretty Good Privacy (PGP). Most users of email encryption rely on having this technology built into their email client or their web-based email service."
  },
  {
    "id": 1835,
    "topic_id": 3,
    "title": "What are the common applications of cryptography to secure web activity?",
    "description": "The de facto standard for secure web traffic is the use of HTTP over Transport Layer Security (TLS). This approach relies on hybrid cryptography using asymmetric cryptography to exchange an ephemeral session key, which is then used to carry on symmetric cryptography for the remainder of the session."
  },
  {
    "id": 1836,
    "topic_id": 3,
    "title": "What are the common applications of cryptography to secure networking?",
    "description": "The IPsec protocol standard provides a common framework for encrypting network traffic and is built into a number of common operating systems. In IPsec transport mode, packet contents are encrypted for peer-to-peer communication. In tunnel mode, the entire packet, including header information, is encrypted for gateway-to-gateway communications."
  },
  {
    "id": 1837,
    "topic_id": 3,
    "title": "Explain the cryptographic attacks.",
    "description": "Ciphertext-only attacks only need access to a message's ciphertext: examples are brute-force attack (tries to randomly find correct cryptographic key) and frequency analysis (counts characters to reverse substitution ciphers). Known plaintext, chosen ciphertext, & chosen plaintext attacks must have info beyond ciphertext. Man-in-the-middle or on-path attacks fool two parties into communicating w/attacker instead of each other. Birthday attacks seek hash-function collisions; replay attacks reuse authentication requests."
  },
  {
    "id": 1838,
    "topic_id": 3,
    "title": "Describe open and closed systems.",
    "description": "Open systems are designed using industry standards and are usually easy to integrate with other open systems. Closed systems are generally proprietary hardware and/or software. Their specifications are not normally published, and they are usually harder to integrate with other systems."
  },
  {
    "id": 1839,
    "topic_id": 3,
    "title": "Describe open and closed source.",
    "description": "An open source solution is one where the source code, and other internal logic, is exposed to the public. A closed source solution is one where the source code and other internal logic is hidden from the public."
  },
  {
    "id": 1840,
    "topic_id": 3,
    "title": "What are some concerns about defaults?",
    "description": "Never assume the default settings of any product are secure. It is always up to the system's administrator and/or company security staff to alter a product's settings to comply with the organization's security policies."
  },
  {
    "id": 1841,
    "topic_id": 3,
    "title": "What is the concept of fail securely?",
    "description": "Failure management includes programmatic error handling (aka exception handling) and input sanitization; secure failure is integrated into the system (fail-safe vs. fail-secure)."
  },
  {
    "id": 1842,
    "topic_id": 3,
    "title": "What is the principle of \"keep it simple\"?",
    "description": "\"Keep it simple\" is the encouragement to avoid overcomplicating the environment, organization, or product design. The more complex a system, the more difficult it is to secure."
  },
  {
    "id": 1843,
    "topic_id": 3,
    "title": "What is zero trust?",
    "description": "Zero trust is a security concept where nothing inside the organization is automatically trusted. Each request for activity or access is assumed to be from an unknown and untrusted location until otherwise verified. The concept is \"never trust, always verify.\" The zero trust model is based around \"assume breach\" and microsegmentation."
  },
  {
    "id": 1844,
    "topic_id": 3,
    "title": "What is Privacy by Design?",
    "description": "Privacy by Design (PbD) is a guideline to integrate privacy protections into products during the early design phase rather than attempting to tack it on at the end of development. The PbD framework is based on seven foundational principles."
  },
  {
    "id": 1845,
    "topic_id": 3,
    "title": "Define \"trust but verify.\"",
    "description": "\"Trust but verify\" is a traditional security approach of trusting subjects and devices within the company's security perimeter automatically. This type of security approach leaves an organization vulnerable to insider attacks and grants intruders the ability to easily perform lateral movement among internal systems."
  },
  {
    "id": 1846,
    "topic_id": 3,
    "title": "Define confinement, bounds, and isolation.",
    "description": "Confinement restricts a process to reading from and writing to certain memory locations. Bounds are the limits of memory a process cannot exceed when reading or writing. Isolation is the mode a process runs in when it is confined through the use of memory bounds."
  },
  {
    "id": 1847,
    "topic_id": 3,
    "title": "What is the purpose of security controls?",
    "description": "Security controls use access rules to limit the access by a subject to an object."
  },
  {
    "id": 1848,
    "topic_id": 3,
    "title": "Define trust and assurance?",
    "description": "A trusted system is one in which all protection mechanisms work together to process sensitive data for many types of users while maintaining a stable and secure computing environment. In other words, trust is the presence of a security mechanism or capability. Assurance is the degree of confidence in satisfaction of security needs. In other words, assurance is how reliable the security mechanisms are at providing security."
  },
  {
    "id": 1849,
    "topic_id": 3,
    "title": "What is a trusted computing base (TCB)?",
    "description": "The combination of hardware, software, and controls that form a trusted base enforcing the security policy."
  },
  {
    "id": 1850,
    "topic_id": 3,
    "title": "Define the state machine model.",
    "description": "The state machine model ensures that all instances of subjects accessing objects are secure."
  },
  {
    "id": 1851,
    "topic_id": 3,
    "title": "Define the information flow model.",
    "description": "The information flow model is designed to prevent unauthorized, insecure, or restricted information flow."
  },
  {
    "id": 1852,
    "topic_id": 3,
    "title": "Define the noninterference model.",
    "description": "The noninterference model prevents the actions of one subject from affecting the system state or actions of another subject."
  },
  {
    "id": 1853,
    "topic_id": 3,
    "title": "Define the take-grant model.",
    "description": "The take-grant model dictates how rights can be passed from one subject to another or from a subject to an object."
  },
  {
    "id": 1854,
    "topic_id": 3,
    "title": "Define the concept of access control matrix.",
    "description": "An access control matrix is a table of subjects and objects that indicates the actions or functions that each subject can perform on each object."
  },
  {
    "id": 1855,
    "topic_id": 3,
    "title": "Define the Bell\u2013LaPadula model.",
    "description": "Bell\u2013LaPadula subjects have a clearance level that allows them to access only those objects with the corresponding classification levels, which protects confidentiality."
  },
  {
    "id": 1856,
    "topic_id": 3,
    "title": "Define the Biba model.",
    "description": "Biba prevents subjects with lower security levels from writing to objects at higher security levels."
  },
  {
    "id": 1857,
    "topic_id": 3,
    "title": "Define the Clark\u2013Wilson model.",
    "description": "Clark\u2013Wilson is an integrity model that relies on the access control triplet (i.e., subject/program/object)."
  },
  {
    "id": 1858,
    "topic_id": 3,
    "title": "What does the Goguen\u2013Meseguer model focus on?",
    "description": "Goguen\u2013Meseguer model focuses on integrity."
  },
  {
    "id": 1859,
    "topic_id": 3,
    "title": "What does the Sutherland model focus on?",
    "description": "Sutherland model focuses on integrity."
  },
  {
    "id": 1860,
    "topic_id": 3,
    "title": "Define the Graham\u2013Denning model.",
    "description": "Graham\u2013Denning focuses on the secure creation and deletion of both subjects and objects."
  },
  {
    "id": 1862,
    "topic_id": 3,
    "title": "Define the Common Criteria.",
    "description": "The Common Criteria (ISO/IEC 15408) is a subjective security function evaluation tool that uses protection profiles (PPs) and security targets (STs) and assigns an Evaluation Assurance Level (EAL)."
  },
  {
    "id": 1863,
    "topic_id": 3,
    "title": "What is Authorization to Operate (ATO)?",
    "description": "Authorization to Operate (ATO) (from the RMF) is a formal approval to operate IT/IS based on an acceptable risk level based on the implementation of an agreed-on set of security and privacy controls."
  },
  {
    "id": 1864,
    "topic_id": 3,
    "title": "What are the typical security capabilities of information systems?",
    "description": "Common security capabilities include memory protection, virtualization, Trusted Platform Module (TPM), encryption/decryption, interfaces, and fault tolerance."
  },
  {
    "id": 1865,
    "topic_id": 3,
    "title": "What is shared responsibility?",
    "description": "The security design principle that indicates that organizations do not operate in isolation. It is because we participate in shared responsibility that we must research, implement and manage engineering processes using secure design principles."
  },
  {
    "id": 1866,
    "topic_id": 3,
    "title": "Explain the differences between multitasking, multicore, multiprocessing, multiprogramming, and multithreading.",
    "description": "Multitasking is the simultaneous execution of more than one application on a computer. Multicore is the presence of multiple execution cores in a single CPU. Multiprocessing is the use of more than one processor to increase computing power. Multiprogramming is similar to multitasking and involves the pseudo-simultaneous execution of two tasks on a single processor. Multithreading permits multiple concurrent tasks to be performed within a single process."
  },
  {
    "id": 1867,
    "topic_id": 3,
    "title": "What are protection rings?",
    "description": "From a security standpoint, protection rings organize code and components in an OS into concentric rings. The deeper inside the circle you go, the higher the privilege level associated with the code that occupies a specific ring."
  },
  {
    "id": 1868,
    "topic_id": 3,
    "title": "What are the common process states?",
    "description": "The process states are ready, running, waiting, supervisory, and stopped."
  },
  {
    "id": 1870,
    "topic_id": 3,
    "title": "Describe the different types of memory used by a computer.",
    "description": "ROM is nonvolatile and can't be written to by the end user. Data can be written to PROM chips only once. EPROM/UVEPROM chips may be erased with ultraviolet light. EEPROM chips may be erased with electrical current. RAM chips are volatile and lose their contents when the computer is powered off."
  },
  {
    "id": 1871,
    "topic_id": 3,
    "title": "Name some security issues surrounding memory components.",
    "description": "Some security issues surround memory components: the fact that data may remain on the chip after power is removed and the control of access to memory in a multiuser system."
  },
  {
    "id": 1872,
    "topic_id": 3,
    "title": "What are the concepts of memory addressing?",
    "description": "Means of memory addressing include register addressing, immediate addressing, direct addressing, indirect addressing, and base+offset addressing."
  },
  {
    "id": 1873,
    "topic_id": 3,
    "title": "Describe the different characteristics of storage devices used by computers.",
    "description": "Primary storage is the same as memory. Secondary storage consists of magnetic, flash, and optical media that must be first read into primary memory before the CPU can use the data. Random access storage devices can be read at any point, whereas sequential access devices require scanning through all the data physically stored before the desired location."
  },
  {
    "id": 1874,
    "topic_id": 3,
    "title": "What are the variations of storage types?",
    "description": "The variations include primary versus secondary, volatile versus nonvolatile, and random versus sequential."
  },
  {
    "id": 1875,
    "topic_id": 3,
    "title": "Name the security issues surrounding secondary storage devices.",
    "description": "Three main security issues surround secondary storage devices: removable media can be used to steal data, access controls and encryption must be applied to protect data, and data can remain on the media even after file deletion or media formatting."
  },
  {
    "id": 1876,
    "topic_id": 3,
    "title": "Define emanation security.",
    "description": "Many electrical devices emanate electrical signals or radiation that can be intercepted by unauthorized individuals. These signals may contain confidential, sensitive, or private data. TEMPEST countermeasures to Van Eck phreaking (i.e., eavesdropping), include Faraday cages, white noise, control zones, and shielding."
  },
  {
    "id": 1877,
    "topic_id": 3,
    "title": "What are security risks that input and output devices can pose?",
    "description": "Input/output devices can be subject to eavesdropping and tapping, are subject to shoulder surfing, are used to smuggle data out of an organization, or are used to create unauthorized, insecure points of entry into an organization's systems and networks. Be prepared to recognize and mitigate such vulnerabilities."
  },
  {
    "id": 1878,
    "topic_id": 3,
    "title": "What is the purpose of firmware?",
    "description": "Firmware is software stored on a ROM chip. At the computer level, it contains the basic instructions needed to start a computer. Firmware is also used to provide operating instructions in peripheral devices such as printers. Examples include BIOS and UEFI."
  },
  {
    "id": 1879,
    "topic_id": 3,
    "title": "Describe some JavaScript security concerns.",
    "description": "JavaScript is the most widely used scripting language in the world and is embedded into HTML documents. Whenever you allow code from an unknown and thus untrusted source to execute on your system, you are putting your system at risk of compromise."
  },
  {
    "id": 1880,
    "topic_id": 3,
    "title": "Describe large-scale parallel data systems.",
    "description": "Systems designed to perform numerous calculations simultaneously include SMP, AMP, and MPP. Grid computing is a form of parallel distributed processing that loosely groups a significant number of processing nodes to work toward a specific processing goal. Peer-to-peer (P2P) technologies are networking and distributed application solutions that share tasks and workloads among peers."
  },
  {
    "id": 1881,
    "topic_id": 3,
    "title": "What is ICS?",
    "description": "An industrial control system (ICS) is a form of computer-management device that controls industrial processes and machines (aka operational technology). ICS examples include distributed control systems (DCSs), programmable logic controllers (PLCs), and supervisory control and data acquisition (SCADA)."
  },
  {
    "id": 1882,
    "topic_id": 3,
    "title": "What are distributed systems?",
    "description": "A distributed system or a distributed computing environment (DCE) is a collection of individual systems that work together to support a resource or provide a service. The primary security concern is the interconnectedness of the components."
  },
  {
    "id": 1883,
    "topic_id": 3,
    "title": "Define blockchain.",
    "description": "A blockchain is a collection or ledger of records, transactions, operations, or other events that are verified using hashing, timestamps, and transaction data."
  },
  {
    "id": 1884,
    "topic_id": 3,
    "title": "What is data sovereignty?",
    "description": "Data sovereignty is the concept that, once information has been converted into a binary form and stored as digital files, it is subject to the laws of the country within which the storage device resides."
  },
  {
    "id": 1885,
    "topic_id": 3,
    "title": "What are smart devices?",
    "description": "Smart devices are a range of devices that offer the user a plethora of customization options, typically through installing apps, and may take advantage of on-device or in-the-cloud machine learning (ML) processing."
  },
  {
    "id": 1886,
    "topic_id": 3,
    "title": "What is IoT?",
    "description": "The Internet of Things (IoT) is a class of devices that are internet-connected in order to provide automation, remote control, or AI processing to appliances or devices. The security issues related to IoT often relate to access and encryption."
  },
  {
    "id": 1887,
    "topic_id": 3,
    "title": "What is IIoT?",
    "description": "Industrial Internet of Things (IIoT) is a derivative of IoT that focuses on industrial, engineering, manufacturing, or infrastructure level oversight, automation, management, and sensing. IIoT is an evolution of ICS and DCS that integrates cloud services to perform data collection, analysis, optimization, and automation."
  },
  {
    "id": 1889,
    "topic_id": 3,
    "title": "What is SOA?",
    "description": "Service-oriented architecture (SOA) constructs new applications or functions out of existing but separate and distinct software services. The resulting application is often new; thus, its security issues are unknown, untested, and unprotected. A derivative of SOA is microservices."
  },
  {
    "id": 1890,
    "topic_id": 3,
    "title": "What are microservices?",
    "description": "A microservice is simply one element, feature, capability, business logic, or function of a web application that can be called upon or used by other web applications. It is the conversion or transformation of a capability of one web application into a microservice that can be called upon by numerous other web applications. It allows large complex solutions to be broken into smaller self-contained functions."
  },
  {
    "id": 1891,
    "topic_id": 3,
    "title": "What is IaC?",
    "description": "Infrastructure as code (IaC) is a change in how hardware management is perceived and handled. Instead of seeing hardware configuration as a manual, direct hands-on, one-on-one administration hassle, it is viewed as just another collection of elements to be managed in the same way that software and code are managed under DevSecOps (development, security, and operations)."
  },
  {
    "id": 1892,
    "topic_id": 3,
    "title": "What is virtual software?",
    "description": "A virtual application or virtual software is a software product deployed in such a way that it is fooled into believing it is interacting with a full host OS. A virtual (or virtualized) application has been packaged or encapsulated so that it can execute but operate without full access to the host OS. A virtual application is isolated from the host OS so that it cannot make any direct or permanent changes to the host OS."
  },
  {
    "id": 1893,
    "topic_id": 3,
    "title": "What is virtual networking?",
    "description": "A virtualized network or network virtualization is the combination of hardware and software networking components into a single integrated entity. The resulting solution allows for software control over all network functions: management, traffic shaping, address assignment, and so on."
  },
  {
    "id": 1894,
    "topic_id": 3,
    "title": "What is SDx?",
    "description": "Software-defined everything (SDx) refers to a trend of replacing hardware with software using virtualization. SDx includes virtualization, virtualized software, virtual networking, containerization, serverless architecture, infrastructure as code, SDN, VSAN, software-defined storage (SDS), VDI, VMI, SDV, and software-defined data center (SDDC)."
  },
  {
    "id": 1895,
    "topic_id": 3,
    "title": "What are VDI and VMI?",
    "description": "Virtual desktop infrastructure (VDI) is a means to reduce the security risk and performance requirements of end devices by hosting desktop/workstation OS virtual machines on central servers that are remotely accessed by users. Virtual mobile infrastructure (VMI) is where the OS of a mobile device is virtualized on a central server."
  },
  {
    "id": 1896,
    "topic_id": 3,
    "title": "What is SDV?",
    "description": "Software-defined visibility (SDV) is a framework to automate the processes of network monitoring and response. The goal is to enable the analysis of every packet and make deep intelligence-based decisions on forwarding, dropping, or otherwise responding to threats."
  },
  {
    "id": 1897,
    "topic_id": 3,
    "title": "What is SDDC?",
    "description": "Software-defined data center (SDDC) or virtual data center (VDC) is the concept of replacing physical IT elements with solutions provided virtually, and often by an external third party, such as a cloud service provider (CSP)."
  },
  {
    "id": 1898,
    "topic_id": 3,
    "title": "What is XaaS?",
    "description": "Anything as a service (XaaS) is the catchall term to refer to any type of computing service or capability that can be provided to customers through or over a cloud solution. Examples are SECaaS, IPaaS, FaaS, ITaaS, and MaaS."
  },
  {
    "id": 1899,
    "topic_id": 3,
    "title": "What are some security issues of virtualization?",
    "description": "Virtualization doesn't lessen the security management requirements of an OS. Thus, patch management is still essential. It's important to protect the stability of the host. Organizations should maintain backups of their virtual assets. Virtualized systems should be security tested. VM sprawl occurs when an organization deploys numerous virtual machines without an overarching IT management or security plan in place."
  },
  {
    "id": 1900,
    "topic_id": 3,
    "title": "What is containerization?",
    "description": "Containerization or OS virtualization is based on the concept of eliminating the duplication of OS elements in a virtual machine. Each application is placed into a container that includes only the actual resources needed to support the enclosed application, and the common or shared OS elements are then part of the hypervisor."
  },
  {
    "id": 1901,
    "topic_id": 3,
    "title": "What is serverless architecture?",
    "description": "Serverless architecture is a cloud computing concept where code is managed by the customer and the platform (i.e., supporting hardware and software) or server is managed by the cloud service provider (CSP). There is always a physical server running the code, but this execution model allows the software designer/architect/programmer/developer to focus on the logic of their code and not have to be concerned about the parameters or limitations of a specific server. This is also known as function as a service (FaaS)."
  },
  {
    "id": 1902,
    "topic_id": 3,
    "title": "What is a microcontroller?",
    "description": "A microcontroller is similar to but less complex than a system on a chip (SoC). A microcontroller may be a component of an SoC. A microcontroller is a small computer consisting of a CPU (with one or more cores), memory, various input/output capabilities, RAM, and often nonvolatile storage in the form of flash or ROM/PROM/EEPROM. Examples include Raspberry Pi, Arduino, and FPGA."
  },
  {
    "id": 1903,
    "topic_id": 3,
    "title": "What are embedded systems and static environment security concerns?",
    "description": "Static environments, embedded systems, network-enabled devices, cyber-physical systems, HPC systems, edge computing devices, and fog computing devices, mobile devices, and other limited or single-purpose computing environments need security management. These techniques may include network segmentation, security layers, application firewalls, manual updates, firmware version control, wrappers, and control redundancy and diversity."
  },
  {
    "id": 1904,
    "topic_id": 3,
    "title": "What are HPC systems?",
    "description": "High-performance computing (HPC) systems are Computing platforms designed to perform complex calculations or data manipulations at extremely high speeds. Super computers and MPP solutions are common examples of HPC systems."
  },
  {
    "id": 1905,
    "topic_id": 3,
    "title": "What is an RTOS?",
    "description": "A real-time operating system (RTOS) is designed to process or handle data as it arrives on the system with minimal latency or delay. An RTOS is usually stored on read-only memory (ROM) and is designed to operate in hard real-time or soft real-time conditions."
  },
  {
    "id": 1906,
    "topic_id": 3,
    "title": "What is edge computing?",
    "description": "Edge computing is a philosophy of network design where data and the compute resources are located as close as possible in order to optimize bandwidth use while minimizing latency. In edge computing, the intelligence and processing are contained within each device. Thus, rather than having to send data off to a master processing entity, each device can process its own data locally."
  },
  {
    "id": 1907,
    "topic_id": 3,
    "title": "What is fog computing?",
    "description": "Fog computing is another example of advanced computation architectures, which is also often used as an element in an IIoT deployment. Fog computing relies on sensors, IoT devices, or even edge computing devices to collect data, and then transfer it back to a central location for processing. Thus, intelligence and processing is centralized."
  },
  {
    "id": 1908,
    "topic_id": 3,
    "title": "What are elements of mobile device security?",
    "description": "Can include: device authentication, full-device encryption, communication protection, remote wiping, device lockout, screen locks, GPS/location services mgmt, content mgmt, application control, push notification mgmt, third-party app store control, storage segmentation, asset tracking/inventory control, removable storage, connection method mgmt, disabling unused features, rooting/jailbreaking, sideloading, custom firmware, carrier unlocking, firmware over-the-air updates, key mgmt, credential mgmt, and text messaging security."
  },
  {
    "id": 1909,
    "topic_id": 3,
    "title": "What is COMS?",
    "description": "A corporate-owned mobile strategy (COMS) or corporate-owned, business-only (COBO) strategy is when the company purchases the mobile devices that can support security compliance with the security policy. These devices are to be used exclusively for company purposes, and users should not perform any personal tasks on the devices. This often requires workers to carry a second device for personal use."
  },
  {
    "id": 1910,
    "topic_id": 3,
    "title": "What are common elements of a mobile device deployment policy?",
    "description": "A mobile device deployment policy should address data ownership, support ownership, patch and update management, security product management, forensics, privacy, onboarding/offboarding, adherence to corporate policies, user acceptance, architecture/infrastructure considerations, legal concerns, acceptable use policies, onboard cameras/video, recording microphone, Wi-Fi Direct, tethering and hotspots, and contactless payment methods."
  },
  {
    "id": 1911,
    "topic_id": 3,
    "title": "What is process isolation?",
    "description": "Process isolation requires that the OS provide separate memory spaces for each process's instructions and data. It also requires that the OS enforce those boundaries, preventing one process from reading or writing data that belongs to another process."
  },
  {
    "id": 1912,
    "topic_id": 3,
    "title": "What is the purpose of hardware segmentation?",
    "description": "Hardware segmentation is similar to process isolation in purpose\u2014it prevents the access of information that belongs to a different process/security level. The main difference is that hardware segmentation enforces these requirements through the use of physical hardware controls rather than the logical process isolation controls imposed by an OS."
  },
  {
    "id": 1913,
    "topic_id": 3,
    "title": "What is the need for a system security policy?",
    "description": "The role of a system security policy is to inform and guide the design, development, implementation, testing, and maintenance of a particular system. Thus, this kind of security policy tightly targets a single implementation effort."
  },
  {
    "id": 1914,
    "topic_id": 3,
    "title": "What are covert channels?",
    "description": "A covert channel is a method used to pass information over a path that is not normally used for communication. Using a covert channel provides a means to violate, bypass, or circumvent a security policy undetected. Basic types are timing and storage."
  },
  {
    "id": 1915,
    "topic_id": 3,
    "title": "What are some security concerns due to design and coding flaws?",
    "description": "Certain attacks may result from poor design techniques, questionable implementation practices and procedures, or poor or inadequate testing. Some attacks may result from deliberate design decisions, such as backdoors or debugging hooks which are not removed when that code is put into production. Poor coding practices and lack of security consideration are common sources or causes of vulnerabilities that can be attributed to failures in design, implementation, prerelease code cleanup, or out-and-out coding mistakes."
  },
  {
    "id": 1916,
    "topic_id": 3,
    "title": "What is a rootkit?",
    "description": "Malware that embeds itself deep within an OS. The term is a derivative of the concept of rooting and a utility kit of hacking tools. Rooting is gaining total or full control over a system."
  },
  {
    "id": 1917,
    "topic_id": 3,
    "title": "What are incremental attacks?",
    "description": "Some forms of attack occur in slow, gradual increments rather than through obvious or recognizable attempts to compromise system security or integrity. Two such forms of attack are data diddling and the salami attack."
  },
  {
    "id": 1918,
    "topic_id": 3,
    "title": "Why is there no security without physical security?",
    "description": "Without control over the physical environment, no amount of administrative or technical/logical access controls can provide adequate security. If a malicious person can gain physical access to your facility or equipment, they can do just about anything they want, from destruction to disclosure and alteration."
  },
  {
    "id": 1919,
    "topic_id": 3,
    "title": "What is a security facility plan?",
    "description": "A secure facility plan outlines the security needs of your organization and emphasizes methods or mechanisms to provide security. Such a plan is developed through risk assessment and critical path analysis."
  },
  {
    "id": 1920,
    "topic_id": 3,
    "title": "What is important to know about site selection?",
    "description": "Site selection should be based on the security needs of the organization. Cost, location, and size are important, but addressing the requirements of security should always take precedence. The key elements in making a site selection are visibility, composition of the surrounding area, and area accessibility."
  },
  {
    "id": 1921,
    "topic_id": 3,
    "title": "What is CPTED?",
    "description": "Crime Prevention Through Environmental Design (CPTED) is based on the idea to structure the physical environment and surroundings to influence individual decisions that potential offenders make before committing any criminal acts."
  },
  {
    "id": 1922,
    "topic_id": 3,
    "title": "What is the importance of prepping for equipment failure?",
    "description": "No matter the quality of the equipment your organization chooses to purchase and install, eventually it will fail. Preparing for equipment failure may include purchasing replacement parts, storing equipment, or having an SLA with a vendor."
  },
  {
    "id": 1923,
    "topic_id": 3,
    "title": "What are MTTF, MTTR, and MTBF?",
    "description": "Mean time to failure (MTTF) is the expected typical functional lifetime of the device given a specific operating environment. Mean time to repair (MTTR) is the average length of time required to perform a repair on the device. Mean time between failures (MTBF) is an estimation of the time between the first and any subsequent failures."
  },
  {
    "id": 1924,
    "topic_id": 3,
    "title": "What are features of secure work areas?",
    "description": "There should not be equal access to all locations within a facility. Areas that contain assets of higher value or importance should have restricted access. Valuable and confidential assets should be located in the heart or center of protection provided by a facility."
  },
  {
    "id": 1925,
    "topic_id": 3,
    "title": "What are the security concerns of a wiring closet?",
    "description": "A wiring closet is where the networking cables for a whole building or just a floor are connected to other essential equipment, such as patch panels, switches, routers, LAN extenders, and backbone channels. Most of the security for a wiring closet focuses on preventing physical unauthorized access. If an unauthorized intruder gains access to the area, they may be able to steal equipment, pull or cut cables, or even plant a listening device."
  },
  {
    "id": 1926,
    "topic_id": 3,
    "title": "What are smartcards?",
    "description": "Smartcards are credit card\u2013sized IDs, badges, or security passes with an embedded magnetic stripe, bar code, or integrated circuit chip. They contain information about the authorized bearer that can be used for identification and/or authentication purposes."
  },
  {
    "id": 1927,
    "topic_id": 3,
    "title": "What are examples of proximity devices?",
    "description": "Proximity devices can be a passive device, a field-powered device, or a transponder."
  },
  {
    "id": 1928,
    "topic_id": 3,
    "title": "What are security concepts related to cameras?",
    "description": "Video surveillance, video monitoring, closed-circuit television (CCTV), and security cameras deter unwanted activity and create a digital record of events. Cameras can be overt or hidden; can record locally or to the cloud; may offer pan, tilt, and zoom; may operate in visible or infrared light; may be triggered by movement; may support time-lapse recording, tracking, facial recognition, object detection, or infrared or color-filtered recording; and may offer face recognition, gait analysis, and/or object detection."
  },
  {
    "id": 1929,
    "topic_id": 3,
    "title": "What are security needs for media storage?",
    "description": "Media storage facilities should be designed to securely store blank media, reusable media, and installation media. The concerns include theft, corruption, and data remnant recovery. Media storage facility protections include using locked cabinets or safes, using a media librarian/custodian, implementing a check-in/check-out process, and using media sanitization."
  },
  {
    "id": 1930,
    "topic_id": 3,
    "title": "What are security concerns of evidence storage?",
    "description": "Evidence storage is used to retain logs, drive images, virtual machine snapshots, and other datasets for recovery, internal investigations, and forensic investigations. Protections include dedicated/isolated storage facilities, offline storage, activity tracking, hash management, access restrictions, and encryption."
  },
  {
    "id": 1931,
    "topic_id": 3,
    "title": "What are some common threats to physical access controls?",
    "description": "No matter what form of physical access control is used, a security guard or other monitoring system must be deployed to prevent abuse, impersonation, masquerading, tailgating, and piggybacking."
  },
  {
    "id": 1932,
    "topic_id": 3,
    "title": "What are the optimal environmental levels for rooms containing electronic equipment?",
    "description": "In addition to power considerations, maintaining the environment involves control over the HVAC mechanisms. Rooms containing primarily computers should be kept at 59 to 89.6 degrees Fahrenheit (15 to 32 degrees Celsius). Humidity in a computer room should be maintained between 20 and 80 percent. Too much humidity can cause corrosion. Too little humidity causes static electricity."
  },
  {
    "id": 1933,
    "topic_id": 3,
    "title": "How should an organization prepare for managing water leakage and flooding?",
    "description": "Water leakage and flooding should be addressed in your environmental safety policy and procedures. Plumbing leaks are not an everyday occurrence, but when they occur, they often cause significant damage. Water and electricity don't mix. If your computer systems come in contact with water, especially while they are operating, damage is sure to occur. Whenever possible, locate server rooms and critical computer equipment away from any water source or transport pipes."
  },
  {
    "id": 1934,
    "topic_id": 3,
    "title": "What is the importance of fire detection and suppression?",
    "description": "Fire detection and suppression must not be overlooked. Protecting personnel from harm should always be the most important goal of any security or protection system. In addition to protecting people, fire detection and suppression is designed to keep damage caused by fire, smoke, heat, and suppression materials to a minimum, especially in regard to the IT infrastructure."
  },
  {
    "id": 1935,
    "topic_id": 3,
    "title": "What are common elements of physical perimeter security controls?",
    "description": "Control access to a facility can be accomplished using fences, gates, turnstiles, access control vestibules, bollards, and barricades."
  },
  {
    "id": 1936,
    "topic_id": 3,
    "title": "How visitors be handled at a secure facility?",
    "description": "If a facility employs restricted areas to control physical security, then a mechanism to handle visitors is required. Often an escort is assigned to visitors, and their access and activities are monitored closely. Failing to track the actions of outsiders when they are granted access to a protected area can result in malicious activity against the most protected assets."
  },
  {
    "id": 1937,
    "topic_id": 3,
    "title": "What are some examples of internal physical security controls?",
    "description": "Locks, badges, protective distribution systems (PDSs), motion detectors, intrusion alarms, secondary verification mechanisms."
  },
  {
    "id": 1938,
    "topic_id": 3,
    "title": "What is the most important goal for all security solutions?",
    "description": "In all circumstances and under all conditions, the most important aspect of security is protecting people. Thus, preventing harm to people is the most important goal for all security solutions."
  },
  {
    "id": 1939,
    "topic_id": 3,
    "title": "What are KPIs of physical security?",
    "description": "Key performance indicators (KPIs) of physical security should be determined, monitored, recorded, and evaluated. KPIs are metrics or measurements of the operation of or the failure of various aspects of physical security, such as intrusions, crimes, incidents, disruptions, restoration time, response time, and impact level."
  },
  {
    "id": 1940,
    "topic_id": 3,
    "title": "What is encapsulation?",
    "description": "The addition of a header, and possibly a footer, to the data received by each layer from the layer above before it's handed off to the layer below. The inverse action is deencapsulation."
  },
  {
    "id": 1941,
    "topic_id": 3,
    "title": "What are the network container names at each OSI model layer?",
    "description": "OSI layers 7\u20135 protocol data unit (PDU), layer 4 segment (TCP) or a datagram (UDP), layer 3 packet, layer 2 frame, and layer 1 bits."
  },
  {
    "id": 1942,
    "topic_id": 3,
    "title": "What is a protocol analyzer?",
    "description": "A protocol analyzer is a tool used to examine the contents of network traffic."
  },
  {
    "id": 1943,
    "topic_id": 3,
    "title": "What is a MAC address?",
    "description": "Media Access Control (MAC) address is a 6-byte (48-bit) binary address written in hexadecimal notation, aka hardware address, physical address, the NIC address, and the Ethernet address. The first 3 bytes (24 bits) of the address is the organizationally unique identifier (OUI), which denotes the vendor or manufacturer."
  },
  {
    "id": 1944,
    "topic_id": 4,
    "title": "What are the basic labels, groupings, and examples of routing protocols?",
    "description": "Interior routing protocols are distance vector (Routing Information Protocol ([RIP] and Interior Gateway Routing Protocol [IGRP]) and link state (Open Shortest Path First [OSPF] and Intermediate System to Intermediate System [IS-IS]); exterior routing protocols are path vector (Border Gateway Protocol [BGP])."
  },
  {
    "id": 1945,
    "topic_id": 4,
    "title": "What is the TCP/IP model?",
    "description": "Also known as DARPA or the DOD model, the TCP/IP model is a protocol model derived from TCP/IP and has four layers: Application (also known as Process), Transport (also known as Host-to-Host), Internet (sometimes known as Internetworking), and Link (although Network Interface and sometimes Network Access are used)."
  },
  {
    "id": 1946,
    "topic_id": 4,
    "title": "What is DNS?",
    "description": "The Domain Name System (DNS) is the hierarchical naming scheme used in both public and private networks. DNS links human-friendly fully qualified domain names (FQDNs) and IP addresses together. DNSSEC and DoH are DNS security features."
  },
  {
    "id": 1947,
    "topic_id": 4,
    "title": "What is typosquatting?",
    "description": "Typosquatting is a practice employed to capture and redirect traffic when a user mistypes the domain name or IP address of an intended resource."
  },
  {
    "id": 1948,
    "topic_id": 4,
    "title": "What is a homograph attack?",
    "description": "A homograph attack leverages similarities in character sets to register phony international domain names (IDNs) that to the naked eye appear legitimate."
  },
  {
    "id": 1949,
    "topic_id": 4,
    "title": "What is URL hijacking?",
    "description": "URL hijacking refers to the practice of displaying a link or advertisement that looks like that of a well-known product, service, or site, but when clicked redirects the user to an alternate location, service, or product. This may be accomplished by posting sites and pages and exploiting search engine optimization (SEO), or through the use of adware that replaces legitimate ads and links with those leading to alternate or malicious locations."
  },
  {
    "id": 1950,
    "topic_id": 4,
    "title": "What is clickjacking?",
    "description": "Clickjacking is a means to redirect a user's click or selection on a web page to an alternate often malicious target instead of the intended and desired location. One means of clickjacking is to add an invisible or hidden overlay, frame, or image map over the displayed page. The user sees the original page, but any mouse click or selection will be captured by the floating frame and redirected to the malicious target."
  },
  {
    "id": 1951,
    "topic_id": 4,
    "title": "What is ARP?",
    "description": "Address Resolution Protocol (ARP) is essential to the interoperability of logical and physical addressing schemes. ARP is used to resolve IP addresses into MAC addresses."
  },
  {
    "id": 1952,
    "topic_id": 4,
    "title": "What are the benefits and drawbacks of multilayer protocols?",
    "description": "Benefits of multilayer protocols include the fact that they can be used at higher OSI levels and that they offer encryption, flexibility, and resiliency. Drawbacks include covert channels, filter bypass, and violation of network segment boundaries."
  },
  {
    "id": 1953,
    "topic_id": 4,
    "title": "What are the various types and purposes of network segmentation?",
    "description": "Network segmentation can be used to manage traffic, improve performance, and enforce security. Examples of network segments or subnetworks include intranet, extranet, and screened subnet."
  },
  {
    "id": 1954,
    "topic_id": 4,
    "title": "What is microsegmentation?",
    "description": "Microsegmentation is dividing up an internal network in numerous subzones, potentially as small as a single device, such as a high-value server or even a client or endpoint device. Each zone is separated from the others by internal segmentation firewalls (ISFWs), subnets, or VLANs."
  },
  {
    "id": 1955,
    "topic_id": 4,
    "title": "What is an SSID?",
    "description": "A service set identifier (SSID) is a network name. Technically there are two types of SSIDs used on infrastructure mode networks: extended service set identifier (ESSID) and basic service set identifier (BSSID). An ESSID is the name of a wireless network when a WAP is used (i.e., infrastructure mode). The BSSID is the MAC address of the base station, which is used to differentiate multiple base stations supporting an ESSID. Independent service set identifier (ISSID) is used by Wi-Fi Direct or ad hoc mode."
  },
  {
    "id": 1956,
    "topic_id": 4,
    "title": "Define WPA2.",
    "description": "IEEE 802.11i defined Wi-Fi Protected Access 2 (WPA2). WPA2 supports two authentication options: preshared key (PSK) or personal (PER) and IEEE 802.1X or enterprise (ENT). WPA2 uses AES-CCMP."
  },
  {
    "id": 1957,
    "topic_id": 4,
    "title": "Define WPA3.",
    "description": "Wi-Fi Protected Access 3 (WPA3) uses 192-bit AES CCMP encryption, whereas WPA3-PER remains at 128-bit AES CCMP. WPA3-PER uses Simultaneous Authentication of Equals (SAE)."
  },
  {
    "id": 1958,
    "topic_id": 4,
    "title": "What is SAE?",
    "description": "Simultaneous Authentication of Equals (SAE) performs a zero-knowledge proof process known as Dragonfly Key Exchange, which is itself a derivative of Diffie\u2013Hellman. The process uses a preset password and the MAC addresses of the client and AP to perform authentication and session key exchange."
  },
  {
    "id": 1959,
    "topic_id": 4,
    "title": "What is MAC filtering?",
    "description": "A MAC filter is a list of authorized wireless client interface MAC addresses that is used by a WAP to block access to all nonauthorized devices. MAC filters may also be used on switches or other wired network management devices."
  },
  {
    "id": 1960,
    "topic_id": 4,
    "title": "What are the types of wireless antenna?",
    "description": "Omnidirectional pole antennas as well as many directional antennas, such as Yagi, cantenna, panel, and parabolic."
  },
  {
    "id": 1961,
    "topic_id": 4,
    "title": "What is spread spectrum?",
    "description": "Spectrum-use techniques manage the simultaneous use of the limited radio frequencies, including FHSS, DSSS, and OFDM."
  },
  {
    "id": 1962,
    "topic_id": 4,
    "title": "What are examples of Bluetooth attacks?",
    "description": "Bluesniffing, bluesmacking, bluejacking, bluesnarfing, and bluebugging."
  },
  {
    "id": 1963,
    "topic_id": 4,
    "title": "What are examples of Wi-Fi attacks?",
    "description": "War driving, wireless scanners/crackers, rogue access points, evil twin, disassociation, jamming, IV abuse, and replay."
  },
  {
    "id": 1964,
    "topic_id": 4,
    "title": "What are common network devices?",
    "description": "Repeater, hub, modem, bridge, switch, router, LAN extender, jumpbox, sensor, collector, aggregator."
  },
  {
    "id": 1965,
    "topic_id": 4,
    "title": "What are some examples of the various types of firewalls?",
    "description": "Static packet filtering, application-level, circuit-level, stateful inspection, NGFW, and ISFW. Also, virtual firewall, filters/rules/ACLs/tuples, bastion host, ingress, egress, RTBH, stateless vs. stateful, WAF, SWG, TCP wrapper, DPI, and content and URL filtering."
  },
  {
    "id": 1966,
    "topic_id": 4,
    "title": "What is EDR?",
    "description": "Endpoint detection and response (EDR) is a security mechanism that is an evolution of traditional antimalware products, IDS, and firewall solutions. EDR seeks to detect, record, evaluate, and respond to suspicious activities and events."
  },
  {
    "id": 1967,
    "topic_id": 4,
    "title": "What is MDR?",
    "description": "Managed detection and response (MDR) focuses on threat detection and mediation, but is not limited to the scope of endpoints. MDR is a service that attempts to monitor an IT environment in real time in order to quickly detect and resolve threats. Often an MDR solution is a combination and integration of numerous technologies, including SIEM, network traffic analysis (NTA), EDR, and IDS."
  },
  {
    "id": 1968,
    "topic_id": 4,
    "title": "What is EPP?",
    "description": "Endpoint protection platform (EPP) is a variation of EDR much like IPS is a variation of IDS. The focus on EPP is on four main security functions: predict, prevent, detect, and respond. Thus, EPP is the more active prevent and predict variation of the more passive EDR concept."
  },
  {
    "id": 1969,
    "topic_id": 4,
    "title": "What is XDR?",
    "description": "Extended detection and response (XDR) components often include EDR, MDR, and EPP elements. Also, XDR is not solely focused on endpoints but often includes NTA, NIDS, and NIPS functions as well."
  },
  {
    "id": 1970,
    "topic_id": 4,
    "title": "What is MSSP?",
    "description": "Managed security service providers (MSSPs) can provide centrally controlled and managed XDR solutions deployed fully on-premise, fully in the cloud, or in a hybrid structure. MSSP solutions can be overseen through a local or remote SOC. Typically, working with an MSSP to provide EDR, MDR, EPP, or XDR services can allow an organization to gain the benefits of these advanced security products and leverage the experience and expertise of the MSSP's staff of security management and response professionals."
  },
  {
    "id": 1971,
    "topic_id": 4,
    "title": "Define PAP, CHAP, and EAP.",
    "description": "Password Authentication Protocol (PAP) transmits usernames and passwords in cleartext. Challenge Handshake Authentication Protocol (CHAP) performs authentication using a challenge-response dialogue that cannot be replayed. Extensible Authentication Protocol (EAP) allows customized authentication security solutions."
  },
  {
    "id": 1972,
    "topic_id": 4,
    "title": "What are examples of EAP methods?",
    "description": "Over 40 EAP methods are defined, including LEAP, PEAP, EAP-SIM, EAP-FAST, EAP-MD5, EAP-POTP, EAP-TLS, and EAP-TTLS."
  },
  {
    "id": 1973,
    "topic_id": 4,
    "title": "What is a split tunnel and a full tunnel?",
    "description": "A split tunnel is a VPN configuration that allows a VPN-connected client system (i.e., remote node) to access both the organizational network over the VPN and the internet directly at the same time. A full tunnel is a VPN configuration in which all of the client's traffic is sent to the organizational network over the VPN link, and then any internet-destined traffic is routed out of the organizational network's proxy or firewall interface to the internet."
  },
  {
    "id": 1974,
    "topic_id": 4,
    "title": "What is port security?",
    "description": "Port security can mean the physical control of all connection points, such as RJ-45 wall jacks or device ports. Port security is the management of TCP and User Datagram Protocol (UDP) ports. Port security can also refer to the need to authenticate to a port before being allowed to communicate through or across the port (i.e., IEEE 802.1X)."
  },
  {
    "id": 1975,
    "topic_id": 4,
    "title": "What are some security issues related to VoIP?",
    "description": "VoIP is at risk for caller ID spoofing, vishing, call manager software/firmware attacks, phone hardware attacks, DoS, MitM/on-path attacks, spoofing, and switch hopping."
  },
  {
    "id": 1976,
    "topic_id": 4,
    "title": "What is phreaking?",
    "description": "Phreaking is a specific type of attack in which various types of technology are used to circumvent the telephone system to make free long-distance calls, to alter the function of telephone service, to steal specialized services, or to cause service disruptions."
  },
  {
    "id": 1977,
    "topic_id": 4,
    "title": "What is a load balancer?",
    "description": "The purpose of load balancing is to obtain more optimal infrastructure utilization, minimize response time, maximize throughput, reduce overloading, and eliminate bottlenecks. A load balancer is used to spread or distribute network traffic load across several network links or network devices."
  },
  {
    "id": 1978,
    "topic_id": 4,
    "title": "What is the difference between active/active and active/passive?",
    "description": "An active-active system is a form of load balancing that uses all available pathways or systems during normal operations. But has reduced capacity in adverse conditions. An active-passive system is a form of load balancing that keeps some pathways or system in an unused dormant state during normal operations. And is able to maintain consistent capacity during abnormal conditions."
  },
  {
    "id": 1979,
    "topic_id": 4,
    "title": "What are examples of email security solutions?",
    "description": "Secure Multipurpose Internet Mail Extensions (S/MIME), Pretty Good Privacy (PGP), DomainKeys Identified Mail (DKIM), Sender Policy Framework (SPF), Domain Message Authentication Reporting and Conformance (DMARC), STARTTLS, Implicit SMTPS."
  },
  {
    "id": 1980,
    "topic_id": 4,
    "title": "What is a virtualized network?",
    "description": "A virtualized network or network virtualization is the combination of hardware and software networking components into a single integrated entity. Examples include software-defined networks (SANs), VLANs, VPNs, virtual switches, virtual SANs, guest operating systems, port isolation, and NAT."
  },
  {
    "id": 1981,
    "topic_id": 5,
    "title": "How do physical access controls protect assets?",
    "description": "Physical access controls are those you can touch, and they directly protect systems, devices, and facilities by controlling access and controlling the environment. Indirectly, they also protect information and applications by limiting physical access."
  },
  {
    "id": 1982,
    "topic_id": 5,
    "title": "How do logical access controls protect assets?",
    "description": "Logical access controls include authentication, authorization, and permissions. They limit who can access information stored on systems and devices. They also limit access to configuration settings on systems and devices."
  },
  {
    "id": 1983,
    "topic_id": 5,
    "title": "What is the typical process for a new employee to establish their identity?",
    "description": "New employees establish their identity with official documentation such as a passport, driver's license, or birth certificate. HR personnel then begin the registration process, which includes creating an account for new employees. When biometric authentication is used, the registration process also collects biometric data. Identity proofing includes knowledge-based authentication and cognitive passwords. These ask users a series of questions that only the user would know."
  },
  {
    "id": 1984,
    "topic_id": 5,
    "title": "What is single sign-on?",
    "description": "Single sign-on (SSO) is a mechanism that allows subjects to authenticate once and access multiple objects without authenticating again."
  },
  {
    "id": 1985,
    "topic_id": 5,
    "title": "What is JIT provisioning in relation to IAM?",
    "description": "Just-in-time (JIT) provisioning creates user accounts on third-party sites the first time a user logs onto the site. JIT reduces the administrative workload compared to a manual identity and access management solution."
  },
  {
    "id": 1986,
    "topic_id": 5,
    "title": "What is session management?",
    "description": "Session management processes help prevent unauthorized access by closing unattended sessions. Developers commonly use web frameworks to implement session management. These frameworks allow developers to ensure sessions are closed after a specific amount of inactivity, such as after 2 minutes."
  },
  {
    "id": 1987,
    "topic_id": 5,
    "title": "What is the identity and access provisioning lifecycle?",
    "description": "The identity and access provisioning lifecycle refers to the creation, management, and deletion of accounts. Provisioning ensures that accounts have appropriate privileges based on task requirements and employees receive any needed hardware. Onboarding processes inform employees of organizational processes. Deprovisioning processes disable or delete an account when employees leave, and offboarding processes ensure that employees return all the hardware an organization issued to them."
  },
  {
    "id": 1988,
    "topic_id": 5,
    "title": "What is the purpose of account access reviews?",
    "description": "Account access reviews are performed on user accounts, system accounts, and service accounts. These reviews ensure that accounts don't have excessive privileges. They can often detect when accounts have excessive privileges and when unused accounts have not been disabled or deleted."
  },
  {
    "id": 1989,
    "topic_id": 5,
    "title": "What are common authorization mechanisms?",
    "description": "Authorization ensures that the requested activity or object access is possible, given an entity's privileges. 2Common authorization mechanisms include implicit deny, access control lists, access control matrixes, capability tables, constrained interfaces, content-dependent controls, and context-dependent controls. These mechanisms enforce security principles such as need to know, the principle of least privilege, and separation of duties."
  },
  {
    "id": 1990,
    "topic_id": 5,
    "title": "What are the key concepts of the Discretionary Access Control (DAC) model?",
    "description": "With the DAC model, all objects have owners, and the owners can modify permissions. Each object has an access control list defining permissions, such as read and modify for files. All other models are nondiscretionary models, and administrators centrally manage nondiscretionary controls."
  },
  {
    "id": 1991,
    "topic_id": 5,
    "title": "What are the key concepts of the role-based access control (RBAC) model?",
    "description": "RBAC models use task-based roles, and users gain privileges when administrators place their accounts into a role or group. Taking a user out of a role removes the permissions granted through the role membership."
  },
  {
    "id": 1992,
    "topic_id": 5,
    "title": "What are the key concepts of the rule-based access control model?",
    "description": "Rule-based access control models use a set of rules, restrictions, or filters to determine access. A firewall's access control list includes a list of rules that define what access is allowed and what access is blocked."
  },
  {
    "id": 1993,
    "topic_id": 5,
    "title": "What are the key concepts of the attribute-based access control (ABAC) model?",
    "description": "An ABAC model is an advanced implementation of a rule-based access control model, applying rules based on attributes. Software-defined networks (SDNs) often use an ABAC model."
  },
  {
    "id": 1994,
    "topic_id": 5,
    "title": "What are key concepts of the Mandatory Access Control (MAC) model?",
    "description": "The MAC model uses labels to identify security domains. Subjects need matching labels to access objects. The MAC model enforces the need to know principle and supports a hierarchical environment, a compartmentalized environment, or a combination of both in a hybrid environment. It is frequently referred to as a lattice-based model."
  },
  {
    "id": 1995,
    "topic_id": 5,
    "title": "What are the key concepts of the risk-based access control model?",
    "description": "A risk-based access control model evaluates the environment and the situation, and makes decisions based on software-based security policies. It can control access based on multiple factors such as a user's location, determined by IP addresses; whether the user has logged on with multifactor authentication; and the user's device. Advanced implementations can use machine learning to evaluate risk."
  },
  {
    "id": 1996,
    "topic_id": 5,
    "title": "What are examples of single sign-on methods used on the internet?",
    "description": "SinglSecurity Assertion Markup Language (SAML) is an open XML-based standard used to exchange authentication and authorization information. OAuth 2.0 is an authorization framework supported by many online sites. OASIS maintains OpenID and OpenID Connect (OIDC). OpenID provides authentication. OIDC provides both authentication and authorization by using the OAuth framework and building on the OpenID standard."
  },
  {
    "id": 1997,
    "topic_id": 5,
    "title": "What is Kerberos?",
    "description": "Kerberos is the most common SSO method used within organizations. The primary purpose of Kerberos is authentication. It uses symmetric cryptography and tickets to prove identification and provide authentication. One server synchronizes its time with a Network Time Protocol (NTP) server, and all clients within a network synchronize with the same time."
  },
  {
    "id": 1998,
    "topic_id": 5,
    "title": "What is the purpose of AAA protocols?",
    "description": "Several protocols provide centralized authentication, authorization, and accounting services. Network access (or remote access) systems use AAA protocols."
  },
  {
    "id": 1999,
    "topic_id": 5,
    "title": "What is privilege escalation?",
    "description": "Attackers use privilege escalation techniques to gain additional privileges after exploiting a single system. They typically try to gain additional privileges on the exploited systems first. They can also reach other systems in a network and attempt to gain elevated privileges on them. Limiting privileges given to service accounts reduces the success of some privilege escalation attacks."
  },
  {
    "id": 2000,
    "topic_id": 5,
    "title": "What is the pass-the-hash attack?",
    "description": "Pass-the-hash attacks allow an attacker to impersonate a user with the captured hash of a user's password instead of the user's password. Pass-the-hash attacks typically exploit NTLM vulnerabilities, but attackers also use similar attacks against other protocols, including Kerberos."
  },
  {
    "id": 2001,
    "topic_id": 5,
    "title": "What are examples of Kerberos exploitation attacks?",
    "description": "Kerberos attacks attempt to exploit weaknesses in Kerberos tickets. In some attacks, they capture tickets held in the <code>lsass.exe</code> process and use them in pass-the-ticket attacks. A silver ticket grants the attacker all the privileges granted to a service account. Attackers can create golden tickets after obtaining the hash of the Kerberos service account (KRBTGT), giving them the ability to create tickets at will within Active Directory."
  },
  {
    "id": 2002,
    "topic_id": 5,
    "title": "How do salt and pepper thwart password attacks?",
    "description": "Salting adds additional bits to a password before hashing it and helps thwart rainbow table attacks. Some algorithms, such as Argon2, bcrypt, and Password-Based Key Derivation Function 2 (PBKDF2), add the salt and repeat the hashing functions many times. Salts are stored in the same database as the hashed password. A pepper is a large constant number used to increase the security of the hashed password further, and it is stored somewhere outside the database holding the hashed passwords."
  },
  {
    "id": 2003,
    "topic_id": 5,
    "title": "What is the importance of security assessment and testing programs?",
    "description": "Security assessment and testing programs provide an important mechanism for validating the ongoing effectiveness of security controls. They include a variety of tools, including vulnerability assessments, penetration tests, software testing, audits, and security management tasks designed to validate controls. Every organization should have a security assessment and testing program defined and operational."
  },
  {
    "id": 2004,
    "topic_id": 5,
    "title": "What is the purpose of vulnerability assessments and penetration tests?",
    "description": "Vulnerability assessments use automated tools to search for known vulnerabilities in systems, applications, and networks. These flaws may include missing patches, misconfigurations, or faulty code that expose the organization to security risks. Penetration tests also use these same tools but supplement them with attack techniques where an assessor attempts to exploit vulnerabilities and gain access to the system."
  },
  {
    "id": 2005,
    "topic_id": 5,
    "title": "Why is it important to perform software testing to validate code before moving it into production?",
    "description": "Software testing techniques verify that code functions as designed and does not contain security flaws. Code review uses a peer review process to formally or informally validate code before deploying it in production. Interface testing assesses the interactions between components and users with API testing, user interface testing, and physical interface testing."
  },
  {
    "id": 2006,
    "topic_id": 5,
    "title": "What are examples of security management tasks used to provide oversight to the information security program?",
    "description": "Security managers must perform a variety of activities to retain proper oversight of the information security program. Log reviews, particularly for administrator activities, ensure that systems are not misused. Account management reviews ensure that only authorized users retain access to information systems. Backup verification ensures that the organization's data protection process is functioning properly. Key performance and risk indicators provide a high-level view of security program effectiveness."
  },
  {
    "id": 2007,
    "topic_id": 5,
    "title": "What is security process data and where can it come from?",
    "description": "Many components of the information security program generate data that is crucial to security assessment processes. These include the account management process, management review and approval, key performance and risk indicators, backup verification data, training and awareness metrics, and the data generated by disaster recovery and business continuity programs."
  },
  {
    "id": 2008,
    "topic_id": 5,
    "title": "What is job rotation and why consider implementing it?",
    "description": "Job rotation is when employees are rotated into different jobs, or tasks are assigned to different employees. It may be implemented as a defense against collusion. Collusion is an agreement among multiple persons to perform some unauthorized or illegal actions."
  },
  {
    "id": 2009,
    "topic_id": 5,
    "title": "Why monitor privileged operations?",
    "description": "Privileged entities are trusted, but they can abuse their privileges. Because of this, it's essential to monitor all assignment of privileges and the use of privileged operations. The goal is to ensure that trusted employees do not abuse the special privileges they are granted. Monitoring these operations can also detect many attacks because attackers commonly use special privileges during an attack. Advanced privileged account management practices can limit the time users have advanced privileges."
  },
  {
    "id": 2010,
    "topic_id": 5,
    "title": "What is an SLA?",
    "description": "Organizations use service-level agreements (SLAs) with outside entities such as vendors. They stipulate performance expectations such as maximum downtimes and often include penalties if the vendor doesn't meet expectations."
  },
  {
    "id": 2011,
    "topic_id": 7,
    "title": "What are security issues with managed services in the cloud?",
    "description": "Managed services in the cloud include any resources stored in or accessed via the cloud. Storing data in the cloud increases the risk, so additional steps may be necessary to protect the data, depending on its value. When leasing cloud-based services, you must understand who is responsible for maintenance and security. The cloud service provider provides the least amount of maintenance and security in the IaaS model."
  },
  {
    "id": 2012,
    "topic_id": 7,
    "title": "Why implement basic preventive measures?",
    "description": "Basic preventive measures can prevent many incidents from occurring. These include keeping systems up-to-date, removing or disabling unneeded protocols and services, using intrusion detection and prevention systems, using antimalware software with up-to-date signatures, and enabling both host-based and network-based firewalls."
  },
  {
    "id": 2013,
    "topic_id": 7,
    "title": "What are botnets, botnet controllers, and bot herders?",
    "description": "Botnets represent significant threats due to the massive number of computers that can launch attacks. A botnet is a collection of compromised computing devices (often called bots or zombies) organized in a network controlled by a criminal known as a bot herder. Bot herders use a command and control server to remotely control the zombies and often use the botnet to launch attacks on other systems or send spam or phishing emails. Bot herders also rent botnet access out to other criminals."
  },
  {
    "id": 2014,
    "topic_id": 7,
    "title": "What are the differences between HIDSs and NIDSs?",
    "description": "Host-based IDSs (HIDSs) can monitor activity on a single system only. A drawback is that attackers can discover and disable them. A network-based IDS (NIDS) can monitor activity on a network, and an NIDS isn't as visible to attackers."
  },
  {
    "id": 2015,
    "topic_id": 7,
    "title": "What are methods used to block malicious code?",
    "description": "Malicious code is thwarted with a combination of tools. The obvious tool is antimalware software with up-to-date definitions installed on each system, at the boundary of the network, and on email servers. However, policies that enforce basic security principles, such as the least privilege principle, prevent regular users from installing potentially malicious software. Additionally, educating users about the risks and the methods attackers commonly use to spread viruses helps users understand and avoid dangerous behaviors."
  },
  {
    "id": 2016,
    "topic_id": 7,
    "title": "What are examples of types of log files?",
    "description": "Log data is recorded in databases and different types of log files. Common log files include security logs, system logs, application logs, firewall logs, proxy logs, and change management logs. Log files should be protected by centrally storing them and using permissions to restrict access, and archived logs should be set to read-only to prevent modifications."
  },
  {
    "id": 2017,
    "topic_id": 7,
    "title": "What is the purpose of monitoring and uses of monitoring tools?",
    "description": "Monitoring is a form of auditing that focuses on active review of the log file data. It is used to hold subjects accountable for their actions, to detect abnormal or malicious activities, and to monitor system performance. Monitoring tools such as IDSs or SIEMs automate continuous monitoring and provide real-time analysis of network events, including internal-only, inbound (i.e., ingress), and outboard (i.e., egress) traffic. Log management includes analyzing logs and archiving logs."
  },
  {
    "id": 2018,
    "topic_id": 7,
    "title": "What are audit trails?",
    "description": "Audit trails are the records created by recording information about events and occurrences into one or more databases or log files. They are used to reconstruct an event, extract information about an incident, and prove or disprove culpability. Using audit trails is a passive form of detective security control, and audit trails are essential evidence in criminals' prosecution."
  },
  {
    "id": 2019,
    "topic_id": 7,
    "title": "How is accountability maintained?",
    "description": "Accountability is maintained for individual subjects through the use of auditing. Logs record user activities and users can be held accountable for their logged actions. This directly promotes good user behavior and compliance with the organization's security policy."
  },
  {
    "id": 2020,
    "topic_id": 7,
    "title": "What are threat feeds and why use them?",
    "description": "Threat feeds provide organizations with a steady stream of raw data. By analyzing threat feeds, security administrators can learn of current threats. They can then use this knowledge to search through the network, looking for signs of these threats. This is known as threat hunting."
  },
  {
    "id": 2021,
    "topic_id": 8,
    "title": "What is SOAR?",
    "description": "Security Orchestration, Automation, and Response (SOAR) technologies automate responses to incidents. One of the primary benefits is that this reduces the workload of administrators. It also removes the possibility of human error by having computer systems respond."
  },
  {
    "id": 2022,
    "topic_id": 7,
    "title": "What are the technologies that may assist with database backup?",
    "description": "Databases benefit from three backup technologies. Electronic vaulting is used to transfer database backups to a remote site as part of a bulk transfer. In remote journaling, data transfers occur on a more frequent basis. With remote mirroring technology, database transactions are mirrored at the backup site in real time."
  },
  {
    "id": 2023,
    "topic_id": 7,
    "title": "What are the major elements in a disaster recovery program?",
    "description": "Disaster recovery programs should take a comprehensive approach to planning and include considerations related to the initial response effort, personnel involved, communication among the team and with internal and external entities, assessment of response efforts and restoration of services. DR programs should also include training and awareness efforts to ensure personnel understand their responsibilities and lessons learned sessions to continuously improve the program."
  },
  {
    "id": 2024,
    "topic_id": 7,
    "title": "What are the five types of disaster recovery plan tests and the impact each has on normal business operations?",
    "description": "The five types of DRP tests are read-through/checklist tests, structured walk-throughs, simulation tests, parallel tests, and full-interruption tests. Checklist tests are purely paperwork exercises. Structured walk-throughs involve a project team meeting. Simulation tests may shut down noncritical business units. Parallel tests involve relocating personnel but do not affect day-to-day operations. Full-interruption tests involve shutting down primary systems and shifting responsibility to the recovery facility."
  },
  {
    "id": 2025,
    "topic_id": 7,
    "title": "What are the basic alternatives for confiscating evidence and when is each one appropriate?",
    "description": "The person who owns the evidence could voluntarily surrender it. Second, a subpoena could be used to compel the subject to surrender the evidence. Third, an officer may seize visible evidence that the officer has probable cause to believe is associated with criminal activity. Fourth, a search warrant is most useful when you need to confiscate evidence without giving the subject an opportunity to alter it. Fifth, a law enforcement officer may collect evidence when exigent circumstances exist."
  },
  {
    "id": 2026,
    "topic_id": 7,
    "title": "What is the definition of computer crime?",
    "description": "Computer crime is a crime (or violation of a law or regulation) that is directed against, or directly involves, a computer."
  },
  {
    "id": 2027,
    "topic_id": 7,
    "title": "What are the six categories of computer crimes?",
    "description": "Computer crimes are grouped into six categories: military and intelligence attack, business attack, financial attack, terrorist attack, grudge attack, and thrill attack. For the exam, be able to explain the motive of each type of attack."
  },
  {
    "id": 2028,
    "topic_id": 7,
    "title": "What is the importance of retaining investigatory data?",
    "description": "Because you will discover some incidents after they have occurred, you will lose valuable evidence unless you ensure that critical log files are retained for a reasonable period of time. You can retain log files and system status information either in place or in archives."
  },
  {
    "id": 2029,
    "topic_id": 7,
    "title": "What are the various types of evidence that may be used in a criminal or civil trial?",
    "description": "Real evidence consists of actual objects that can be brought into the courtroom. Documentary evidence consists of written documents that provide insight into the facts. Testimonial evidence consists of verbal or written statements made by witnesses."
  },
  {
    "id": 2030,
    "topic_id": 1,
    "title": "What is the importance of ethics to security personnel?",
    "description": "Security practitioners are granted a very high level of authority and responsibility to execute their job functions. The potential for abuse exists, and without a strict code of personal behavior, security practitioners could be regarded as having unchecked power. Adherence to a code of ethics helps ensure that such power is not abused. Security professionals must subscribe to both their own organization's code of ethics as well as the ISC2 Code of Ethics."
  },
  {
    "id": 2031,
    "topic_id": 7,
    "title": "What are expert systems, machine learning, and neural networks and how do they function?",
    "description": "Expert systems consist of two main components: a knowledge base of \"if/then\" rules and an inference engine. Machine learning techniques attempt to algorithmically discover knowledge from datasets. Neural networks simulate the functioning of the human mind to a limited extent by arranging a series of layered calculations to solve problems. Neural networks require extensive training on a particular problem before they are able to offer solutions."
  },
  {
    "id": 2032,
    "topic_id": 8,
    "title": "What are the models of systems development?",
    "description": "The waterfall model describes a sequential development process that results in the development of a finished product. Developers may step back only one phase in the process if errors are discovered. The spiral model uses several iterations of the waterfall model to produce a number of fully specified and tested prototypes. Agile development models place an emphasis on the needs of the customer and quickly developing new functionality that meets those needs in an iterative fashion."
  },
  {
    "id": 2033,
    "topic_id": 8,
    "title": "What is Scrum?",
    "description": "Scrum IS an organized approach to implementing the Agile philosophy, Scrum relies on daily meetings to organize and review work. Development focuses on short sprints of activity that deliver finished products. Integrated product teams (IPTs) are an early effort at this approach that was used by the U.S. Department of Defense."
  },
  {
    "id": 2034,
    "topic_id": 8,
    "title": "What is the purpose of software development maturity models?",
    "description": "To help software organizations improve the maturity and quality of their software processes by implementing an evolutionary path from ad hoc, chaotic processes to mature, disciplined software processes."
  },
  {
    "id": 2035,
    "topic_id": 8,
    "title": "What are the stages of the SW-CMM?",
    "description": "The stages of the Software Capability Maturity Model (SW-CMM) are Initial, Repeatable, Defined, Managed, and Optimizing."
  },
  {
    "id": 2036,
    "topic_id": 8,
    "title": "What are the functions of SAMM?",
    "description": "The Software Assurance Maturity Model (SAMM) is an open source project with five business functions: Governance, Design, Implementation, Verification, and Operations."
  },
  {
    "id": 2037,
    "topic_id": 8,
    "title": "What are the phase of the IDEAL model?",
    "description": "The phases of the IDEAL model are Initiating, Diagnosing, Establishing, Acting, and Learning."
  },
  {
    "id": 2038,
    "topic_id": 8,
    "title": "What is DevSecOps?",
    "description": "DevSecOps approaches expand on the DevOps model by introducing security operations activities into the integrated model. Continuous integration and delivery (CI/CD) techniques automate the DevOps and DevSecOps pipelines."
  },
  {
    "id": 2039,
    "topic_id": 8,
    "title": "What are the roles of different coding tools in software development ecosystems?",
    "description": "Developers write code in different programming languages which is then either compiled into machine language or executed through an interpreter. Developers may make use of software development toolsets and integrated development environments to facilitate the code writing process. Software libraries create shared and reusable code, and code repositories provide a management platform for the software development process."
  },
  {
    "id": 2040,
    "topic_id": 8,
    "title": "What is the impact of acquired software on organizations?",
    "description": "Organizations may purchase commercial off-the-shelf (COTS) software to meet their requirements, and they may also rely on free open source software (OSS). All of this software expands the potential attack surface and requires security review and testing."
  },
  {
    "id": 2041,
    "topic_id": 8,
    "title": "What are the various types of application attacks attackers use to exploit poorly written software?",
    "description": "Application attacks are one of the greatest threats to modern computing. Attackers exploit buffer overflows, backdoors, time-of-check-to-time-of-use vulnerabilities, and rootkits to gain illegitimate access to a system. Security professionals must have a clear understanding of each of these attacks and associated countermeasures."
  },
  {
    "id": 2042,
    "topic_id": 7,
    "title": "What are the propagation techniques used by viruses?",
    "description": "Viruses use four main propagation techniques\u2014file infection, service injection, boot sector infection, and macro infection\u2014to penetrate systems and spread their malicious payloads. You need to understand these techniques to effectively protect systems on your network from malicious code."
  },
  {
    "id": 2043,
    "topic_id": 7,
    "title": "What is the threat posed by ransomware?",
    "description": "Ransomware uses traditional malware techniques to infect a system and then encrypts data on that system using a key known only to the attacker. The attacker then demands payment of a ransom from the victim in exchange for providing the decryption key."
  },
  {
    "id": 2044,
    "topic_id": 7,
    "title": "How do antivirus software packages detect known viruses?",
    "description": "Most antivirus programs use signature-based detection algorithms to look for telltale patterns of known viruses. This makes it essential to periodically update virus definition files in order to maintain protection against newly authored viruses as they emerge. Behavior-based detection monitors target users and systems for unusual activity and either block it or flag it for investigation."
  },
  {
    "id": 2045,
    "topic_id": 200,
    "title": "Understand the\u00a0CIA Triad elements of\u00a0confidentiality, integrity, and\u00a0availability.",
    "description": "Confidentiality is the principle that objects are not disclosed to unauthorized subjects. Integrity is the principle that objects retain their veracity and are intentionally modified only by authorized subjects. Availability is the principle that authorized subjects are granted timely and uninterrupted access to objects."
  },
  {
    "id": 2046,
    "topic_id": 200,
    "title": "Know the\u00a0elements of\u00a0AAA services.",
    "description": "AAA is composed of identification, authentication, authorization, auditing, and accountability."
  },
  {
    "id": 2048,
    "topic_id": 200,
    "title": "Understand the\u00a0process of\u00a0authentication.",
    "description": "Authentication is the process of verifying or testing that a claimed identity is valid. Authentication requires information from the subject that must exactly correspond to the identity indicated."
  },
  {
    "id": 2052,
    "topic_id": 200,
    "title": "Be able to\u00a0explain nonrepudiation.",
    "description": "Nonrepudiation ensures that the subject of an activity or event cannot deny that the event occurred. It prevents a subject from claiming not to have sent a message, not to have performed an action, or not to have been the cause of an event."
  },
  {
    "id": 2053,
    "topic_id": 200,
    "title": "Know about defense in\u00a0depth.",
    "description": "Defense in depth, also known as layering, is simply the use of multiple controls in a series. Using a multilayered solution allows for numerous different controls to guard against whatever threats come to pass."
  },
  {
    "id": 2055,
    "topic_id": 200,
    "title": "Understand data hiding.",
    "description": "Data hiding is exactly what it sounds like: preventing data from being discovered or accessed by a subject. It is often a key element in security controls as well as in programming."
  },
  {
    "id": 2057,
    "topic_id": 200,
    "title": "Understand security governance.",
    "description": "Security governance is the collection of practices related to supporting, defining, and directing the security efforts of an organization."
  },
  {
    "id": 2058,
    "topic_id": 200,
    "title": "Know about third-party governance.",
    "description": "Third-party governance is the system of external entity oversight that may be mandated by law, regulation, industry standards, contractual obligation, or licensing requirements. The actual method of governance may vary, but it generally involves an outside investigator or auditor."
  },
  {
    "id": 2059,
    "topic_id": 200,
    "title": "Understand documentation review.",
    "description": "Documentation review is the process of reading the exchanged materials and verifying them against standards and expectations. In many situations, especially related to government or military agencies or contractors, failing to provide sufficient documentation to meet requirements of third-party governance can result in a loss of or a voiding of authorization to operate (ATO)."
  },
  {
    "id": 2060,
    "topic_id": 200,
    "title": "Understand alignment of\u00a0security function to\u00a0business strategy, goals, mission, and\u00a0objectives.",
    "description": "Security management planning ensures proper creation, implementation, and enforcement of a security policy. Security management planning aligns the security functions to the strategy, goals, mission, and objectives of the organization. This includes designing and implementing security based on business cases, budget restrictions, or scarcity of resources."
  },
  {
    "id": 2061,
    "topic_id": 200,
    "title": "Know what a\u00a0business case is.",
    "description": "A business case is usually a documented argument or stated position in order to define a need to make a decision or take some form of action. To make a business case is to demonstrate a business-specific need to alter an existing process or choose an approach to a business task. A business case is often made to justify the start of a new project, especially a project related to security."
  },
  {
    "id": 2062,
    "topic_id": 200,
    "title": "Understand security management planning.",
    "description": "Security management is based on three types of plans: strategic, tactical, and operational. A strategic plan is a long-term plan that is fairly stable. It defines the organization's goals, mission, and objectives. The tactical plan is a midterm plan developed to provide more details on accomplishing the goals set forth in the strategic plan. Operational plans are short-term and highly detailed plans based on the strategic and tactical plans."
  },
  {
    "id": 2063,
    "topic_id": 200,
    "title": "Know the\u00a0elements of\u00a0a formalized security policy structure.",
    "description": "To create a comprehensive security plan, you need the following items in place: security policy, standards, baselines, guidelines, and procedures."
  },
  {
    "id": 2064,
    "topic_id": 200,
    "title": "Understand organizational process.",
    "description": "Security governance needs to address every aspect of an organization. This includes the organizational processes of acquisitions, divestitures, and governance committees."
  },
  {
    "id": 2065,
    "topic_id": 200,
    "title": "Understand key security roles.",
    "description": "The primary security roles are senior manager, security professional, asset owner, custodian, user, and auditor."
  },
  {
    "id": 2066,
    "topic_id": 200,
    "title": "Know the\u00a0basics of\u00a0COBIT.",
    "description": "Control Objectives for Information and Related Technology (COBIT) is a security concept infrastructure used to organize the complex security solutions of companies."
  },
  {
    "id": 2067,
    "topic_id": 200,
    "title": "Understand due\u00a0diligence and\u00a0due care.",
    "description": "Due diligence is establishing a plan, policy, and process to protect the interests of an organization. Due care is practicing the individual activities that maintain the due diligence effort. Due diligence is knowing what should be done and planning for it; due care is doing the right action at the right time."
  },
  {
    "id": 2068,
    "topic_id": 200,
    "title": "Know the\u00a0basics of\u00a0threat modeling.",
    "description": "Threat modeling is the security process where potential threats are identified, categorized, and analyzed. Threat modeling can be performed as a proactive measure during design and development or as a reactive measure once a product has been deployed. Key concepts include assets/attackers/software, STRIDE, PASTA, VAST, diagramming, reduction/decomposing, and DREAD."
  },
  {
    "id": 2069,
    "topic_id": 200,
    "title": "Understand supply chain risk management (SCRM) concepts.",
    "description": "SCRM is a means to ensure that all the vendors or links in the supply chain are reliable, trustworthy, reputable organizations that disclose their practices and security requirements to their business partners. SCRM includes evaluating risks associated with hardware, software, and services; performing third-party assessment and monitoring; establishing minimum security requirements; and enforcing service-level requirements."
  },
  {
    "id": 2070,
    "topic_id": 200,
    "title": "Understand that humans are a\u00a0key element in\u00a0security.",
    "description": "Humans are often considered the weakest element in any security solution. No matter what physical or logical controls are deployed, humans can discover ways to avoid them, circumvent or subvert them, or disable them. However, people can also become a key security asset when they are properly trained and are motivated to protect not only themselves but the security of the organization as well."
  },
  {
    "id": 2072,
    "topic_id": 200,
    "title": "Understand the\u00a0security implications of\u00a0hiring new employees.",
    "description": "To properly plan for security, you must have standards in place for job descriptions, job classification, work tasks, job responsibilities, prevention of collusion, candidate screening, background checks, security clearances, employment agreements, and nondisclosure agreements. By deploying such mechanisms, you ensure that new hires are aware of the required security standards, thus protecting your organization's assets."
  },
  {
    "id": 2073,
    "topic_id": 200,
    "title": "Understand onboarding and\u00a0offboarding.",
    "description": "Onboarding is the process of adding new employees to the organization using socialization and orientation. Offboarding is the removal of an employee's identity from the IAM system once that person has left the organization."
  },
  {
    "id": 2074,
    "topic_id": 200,
    "title": "Know the\u00a0principle of\u00a0least privilege.",
    "description": "The principle of least privilege states that users should be granted the minimum amount of access necessary for them to complete their required work tasks or job responsibilities."
  },
  {
    "id": 2075,
    "topic_id": 200,
    "title": "Understand the\u00a0need for\u00a0a nondisclosure agreement (NDA).",
    "description": "An NDA is used to protect the confidential information within an organization from being disclosed by a former employee. When a person signs an NDA, they agree not to disclose any information that is defined as confidential to anyone outside the organization."
  },
  {
    "id": 2077,
    "topic_id": 200,
    "title": "Know why mandatory vacations are necessary.",
    "description": "Mandatory vacations of one to two weeks are used to audit and verify the work tasks and privileges of employees. This often results in easy detection of abuse, fraud, or negligence."
  },
  {
    "id": 2078,
    "topic_id": 200,
    "title": "Know about UBA and\u00a0UEBA.",
    "description": "User behavior analytics (UBA) and user and entity behavior analytics (UEBA) are the concepts of analyzing the behavior of users, subjects, visitors, customers, etc. for some specific goal or purpose."
  },
  {
    "id": 2079,
    "topic_id": 200,
    "title": "Understand employee transfers.",
    "description": "Personnel transfers may be treated as a fire/rehire rather than a personnel move. This depends on the organization's policies and the means they have determined to best manage this change. Some of the elements that go into making the decision as to which procedure to use include whether the same user account will be retained, if their clearance will be adjusted, if their new work responsibilities are similar to the previous position, and if a \"clean slate\" account is required for auditing purposes in the new job position."
  },
  {
    "id": 2080,
    "topic_id": 200,
    "title": "Be able to\u00a0explain proper termination policies.",
    "description": "A termination policy defines the procedure for terminating employees. It should include items such as always having a witness, disabling the employee's network access, and performing an exit interview. A termination policy should also include escorting the terminated employee off the premises and requiring the return of security tokens and badges and company property."
  },
  {
    "id": 2081,
    "topic_id": 200,
    "title": "Understand vendor, consultant, and\u00a0contractor controls.",
    "description": "Vendor, consultant, and contractor controls are used to define the levels of performance, expectation, compensation, and consequences for entities, persons, or organizations that are external to the primary organization. Often these controls are defined in a document or policy known as a service-level agreement (SLA)."
  },
  {
    "id": 2082,
    "topic_id": 200,
    "title": "Understand policy compliance.",
    "description": "Compliance is the act of conforming to or adhering to rules, policies, regulations, standards, or requirements. Compliance is an important concern to security governance. On a personnel level, compliance is related to whether individual employees follow company policy and perform their job tasks in accordance with defined procedures."
  },
  {
    "id": 2083,
    "topic_id": 200,
    "title": "Know how privacy fits into the\u00a0realm of\u00a0IT security.",
    "description": "Know the multiple meanings/definitions of privacy, why it is important to protect, and the issues surrounding it, especially in a work environment."
  },
  {
    "id": 2084,
    "topic_id": 200,
    "title": "Be able to\u00a0define overall risk management.",
    "description": "The process of identifying factors that could damage or disclose data, evaluating those factors in light of data value and countermeasure cost, and implementing cost-effective solutions for mitigating or reducing risk is known as risk management. By performing risk management, you lay the foundation for reducing risk overall."
  },
  {
    "id": 2085,
    "topic_id": 200,
    "title": "Understand risk analysis and\u00a0the key elements involved.",
    "description": "Risk analysis is the process by which upper management is provided with details to make decisions about which risks are to be mitigated, which should be transferred, and which should be accepted. To fully evaluate risks and subsequently take the proper precautions, you must analyze the following: assets, asset valuation, threats, vulnerability, exposure, risk, realized risk, safeguards, countermeasures, attacks, and breaches."
  },
  {
    "id": 2086,
    "topic_id": 200,
    "title": "Know how to\u00a0evaluate threats.",
    "description": "Threats can originate from numerous sources, including IT, humans, and nature. Threat assessment should be performed as a team effort to provide the widest range of perspectives. By fully evaluating risks from all angles, you reduce your system's vulnerability."
  },
  {
    "id": 2087,
    "topic_id": 200,
    "title": "Understand qualitative risk analysis.",
    "description": "Qualitative risk analysis is based more on scenarios than calculations. Exact dollar figures are not assigned to possible losses; instead, threats are ranked on a scale to evaluate their risks, costs, and effects. Such an analysis assists those responsible for creating proper risk management policies."
  },
  {
    "id": 2088,
    "topic_id": 200,
    "title": "Understand the\u00a0Delphi technique.",
    "description": "The Delphi technique is simply an anonymous feedbackand-response process used to arrive at a consensus. Such a consensus gives the responsible parties the opportunity to properly evaluate risks and implement solutions."
  },
  {
    "id": 2089,
    "topic_id": 200,
    "title": "Understand quantitative risk analysis.",
    "description": "Quantitative risk analysis focuses on hard values and percentages. A complete quantitative analysis is not possible because of intangible aspects of risk. The process involves valuing assets and identifying threats and then determining a threat's potential frequency and the resulting damage, which leads to the risk response tasks of the cost/benefit analysis of safeguards."
  },
  {
    "id": 2090,
    "topic_id": 200,
    "title": "Be able to\u00a0explain the\u00a0concept of\u00a0an exposure factor (EF).",
    "description": "An EF is an element of quantitative risk analysis that represents the percentage of loss that an organization would experience if a specific asset were violated by a realized risk. By calculating exposure factors, you are able to implement a sound risk management policy."
  },
  {
    "id": 2091,
    "topic_id": 200,
    "title": "Know what single loss expectancy (SLE) is and\u00a0how to\u00a0calculate it.",
    "description": "SLE is an element of quantitative risk analysis that represents the cost associated with a single realized risk against a specific asset. The formula is SLE = asset value (AV) * exposure factor (EF)."
  },
  {
    "id": 2092,
    "topic_id": 200,
    "title": "Understand annualized rate of\u00a0occurrence (ARO).",
    "description": "ARO is an element of quantitative risk analysis that represents the expected frequency with which a specific threat or risk will occur (in other words, become realized) within a single year. Understanding AROs further enables you to calculate the risk and take proper precautions."
  },
  {
    "id": 2093,
    "topic_id": 200,
    "title": "Know what annualized loss expectancy (ALE) is and\u00a0how to\u00a0calculate it.",
    "description": "ALE is an element of quantitative risk analysis that represents the possible yearly cost of all instances of a specific realized threat against a specific asset. The formula is ALE = single loss expectancy (SLE) * annualized rate of occurrence (ARO)."
  },
  {
    "id": 2094,
    "topic_id": 200,
    "title": "Know the\u00a0formula for\u00a0safeguard evaluation.",
    "description": "In addition to determining the annual cost of a safeguard, you must calculate the ALE for the asset if the safeguard is implemented. Use this formula: ALE before safeguard\u00a0\u2013 ALE after implementing the safeguard\u00a0\u2013 annual cost of safeguard = value of the safeguard to the company, or (ALE1\u00a0\u2013 ALE2)\u00a0\u2013 ACS."
  },
  {
    "id": 2095,
    "topic_id": 200,
    "title": "Know the\u00a0options for\u00a0handling risk.",
    "description": "Reducing risk, or risk mitigation, is the implementation of safeguards and countermeasures. Assigning risk or transferring a risk places the cost of loss a risk represents onto another entity or organization. Purchasing insurance is one form of assigning or transferring risk. Risk deterrence is the process of implementing deterrents to would-be violators of security and policy. Risk avoidance is the process of selecting alternate options or activities that have less associated risk than the default, common, expedient, or cheap option. Accepting risk means management has evaluated the cost/benefit analysis of possible safeguards and has determined that the cost of the countermeasure greatly outweighs the possible cost of loss due to a risk. It also means that management has agreed to accept the consequences and the loss if the risk is realized."
  },
  {
    "id": 2096,
    "topic_id": 200,
    "title": "Be able to\u00a0explain total risk, residual risk, and\u00a0the controls gap.",
    "description": "Total risk is the amount of risk an organization would face if no safeguards were implemented. To calculate total risk, use this formula: threats * vulnerabilities * asset value = total risk. Residual risk is the risk that management has chosen to accept rather than mitigate. The difference between total risk and residual risk is the controls gap, which is the amount of risk that is reduced by implementing safeguards. To calculate residual risk, use the following formula: total risk\u00a0\u2013 controls gap = residual risk."
  },
  {
    "id": 2097,
    "topic_id": 200,
    "title": "Understand control types.",
    "description": "The term <italic>control</italic> refers to a broad range of controls that perform such tasks as ensuring that only authorized users can log on and preventing unauthorized users from gaining access to resources. Control types include preventive, deterrent, detective, compensation, corrective, recovery, and directive. Controls can also be categorized by how they are implemented: administrative, logical, or physical."
  },
  {
    "id": 2098,
    "topic_id": 200,
    "title": "Understand security control assessment (SCA).",
    "description": "An SCA is the formal evaluation of a security infrastructure's individual mechanisms against a baseline or reliability expectation."
  },
  {
    "id": 2100,
    "topic_id": 200,
    "title": "Understand risk reporting.",
    "description": "Risk reporting involves the production of a risk report and a presentation of that report to the interested/relevant parties. A risk report should be accurate, timely, comprehensive of the entire organization, clear and precise to support decision making, and updated on a regular basis."
  },
  {
    "id": 2101,
    "topic_id": 200,
    "title": "Know the\u00a0need for\u00a0continuous improvement.",
    "description": "Security is always changing. Thus, any implemented security solution requires updates and changes over time. If a continuous improvement path is not provided by a selected countermeasure, then it should be replaced with one that offers scalable improvements to security."
  },
  {
    "id": 2103,
    "topic_id": 200,
    "title": "Know about legacy system security risk.",
    "description": "Legacy systems are often a threat because they may not be receiving security updates from their vendors. End-of-life (EOL) is the point at which a manufacturer no longer produces a product. End-of-service-life (EOSL) or end-ofsupport (EOS) are those that are no longer receiving updates and support from the vendor."
  },
  {
    "id": 2104,
    "topic_id": 200,
    "title": "Know about risk frameworks.",
    "description": "A risk framework is a guideline or recipe for how risk is to be assessed, resolved, and monitored. The primary example of a risk framework referenced by the CISSP exam is the Risk Management Framework (RMF) defined by NIST in SP\u00a080037 Rev. 2. Others include ISO/IEC 31000, ISO/IEC 31004, COSO, Risk IT, OCTAVE, FAIR, and TARA."
  },
  {
    "id": 2105,
    "topic_id": 200,
    "title": "Understand social engineering.",
    "description": "Social engineering is a form of attack that exploits human nature and human behavior. The common social engineering principles are authority, intimidation, consensus, scarcity, familiarity, trust, and urgency. Such attacks may be used to elicit information or gain access through the use of pretexting and/or prepending. Social engineering attacks include phishing, spear phishing, business email compromise (BEC), whaling, smishing, vishing, spam, shoulder surfing, invoice scams, hoaxes, impersonation, masquerading, tailgating, piggybacking, dumpster diving, identity fraud, typo squatting, and influence campaigns."
  },
  {
    "id": 2106,
    "topic_id": 200,
    "title": "Know how to\u00a0implement security awareness training and\u00a0education.",
    "description": "Before actual training can take place, awareness of security as a recognized entity must be created for users. Once this is accomplished, training, or teaching employees to perform their work tasks and to comply with the security policy, can begin. All new employees require some level of training so that they will be able to comply with all standards, guidelines, and procedures mandated by the security policy. Education is a more detailed endeavor in which students/users learn much more than they actually need to know to perform their work tasks. Education is most often associated with users pursuing certification or seeking job promotion."
  },
  {
    "id": 2107,
    "topic_id": 200,
    "title": "Know about security champions.",
    "description": "Often a security champion is a member of a group who decides (or is assigned) to take charge of leading the adoption and integration of security concepts into the group's work activities. Security champions are often non-security employees who take up the mantle to encourage others to support and adopt more security practices and behaviors."
  },
  {
    "id": 2109,
    "topic_id": 200,
    "title": "Know about the\u00a0need for\u00a0periodic content reviews and\u00a0effectiveness evaluations.",
    "description": "It is important to perform periodic content reviews of all training materials. This is to ensure that the training materials and presentation stays in line with business goals, organizational mission, and security objectives. Some means of verification should be used to measure whether the training is beneficial or a waste of time and resources."
  },
  {
    "id": 2110,
    "topic_id": 200,
    "title": "Understand the\u00a0four steps of\u00a0the business continuity planning process.",
    "description": "Business continuity planning involves four distinct phases: project scope and planning, business impact analysis, continuity planning, and approval and implementation. Each task contributes to the overall goal of ensuring that business operations continue uninterrupted in the face of an emergency."
  },
  {
    "id": 2111,
    "topic_id": 200,
    "title": "Describe how to\u00a0perform the\u00a0business organization analysis.",
    "description": "In the business organization analysis, the individuals responsible for leading the BCP process determine which departments and individuals have a stake in the business continuity plan. This analysis serves as the foundation for BCP team selection and, after validation by the BCP team, is used to guide the next stages of BCP development."
  },
  {
    "id": 2112,
    "topic_id": 200,
    "title": "List the\u00a0necessary members of\u00a0the business continuity planning team.",
    "description": "The BCP team should contain, at a minimum, representatives from each of the operational and support departments; technical experts from the IT department; physical and IT security personnel with BCP skills; legal representatives familiar with corporate legal, regulatory, and contractual responsibilities; and representatives from senior management. Additional team members depend on the structure and nature of the organization."
  },
  {
    "id": 2113,
    "topic_id": 200,
    "title": "Know the\u00a0legal and\u00a0regulatory requirements that face business continuity planners.",
    "description": "Business leaders must exercise due diligence to ensure that shareholders' interests are protected in the event disaster strikes. Some industries are also subject to federal, state, and local regulations that mandate specific BCP procedures. Many businesses also have contractual obligations to their clients that they must meet before, during, and after a disaster."
  },
  {
    "id": 2115,
    "topic_id": 200,
    "title": "Describe the\u00a0process used to\u00a0develop a\u00a0continuity strategy.",
    "description": "During the strategy development phase, the BCP team determines which risks they will mitigate. In the provisions and processes phase, the team designs mechanisms and procedures that will mitigate identified risks. The plan must then be approved by senior management and implemented. Personnel must also receive training on their roles in the BCP process."
  },
  {
    "id": 2117,
    "topic_id": 200,
    "title": "Understand the\u00a0differences between criminal law, civil law, and\u00a0administrative law.",
    "description": "Criminal law protects society against acts that violate the basic principles we believe in. Violations of criminal law are prosecuted by federal and state governments. Civil law provides the framework for the transaction of business between people and organizations. Violations of civil law are brought to the court and argued by the two affected parties. Administrative law is used by government agencies to effectively carry out their day-to-day business."
  },
  {
    "id": 2118,
    "topic_id": 200,
    "title": "Be able to\u00a0explain the\u00a0basic provisions of\u00a0the major laws designed to\u00a0protect society against computer crime.",
    "description": "The Computer Fraud and Abuse Act (as amended) protects computers used by the government or in interstate commerce from a variety of abuses. The Electronic Communications Privacy Act (ECPA) makes it a crime to invade the electronic privacy of an individual."
  },
  {
    "id": 2119,
    "topic_id": 200,
    "title": "Know the\u00a0differences among copyrights, trademarks, patents, and\u00a0trade secrets.",
    "description": "Copyrights protect original works of authorship, such as books, articles, poems, and songs. Trademarks are names, slogans, and logos that identify a company, product, or service. Patents provide protection to the creators of new inventions. Trade secret law protects the operating secrets of a firm."
  },
  {
    "id": 2122,
    "topic_id": 200,
    "title": "Understand the\u00a0various types of\u00a0software license agreements.",
    "description": "Contractual license agreements are written agreements between a software vendor and user. Shrink-wrap agreements are written on software packaging and take effect when a user opens the package. Click-through agreements are included in a package but require the user to accept the terms during the software installation process."
  },
  {
    "id": 2123,
    "topic_id": 200,
    "title": "Understand the\u00a0notification requirements placed on\u00a0organizations that experience a\u00a0data breach.",
    "description": "California's SB 1386 implemented the first statewide requirement to notify individuals of a breach of their personal information. All other states eventually followed suit with similar laws. Currently, federal law only requires the notification of individuals when a HIPAA-covered entity breaches their protected health information."
  },
  {
    "id": 2124,
    "topic_id": 200,
    "title": "Understand the\u00a0major laws that govern privacy of\u00a0personal information in\u00a0the United States, the\u00a0European Union, and\u00a0Canada.",
    "description": "The United States has a number of privacy laws that affect the government's use of information as well as the use of information by specific industries, such as financial services companies and healthcare organizations that handle sensitive information. The EU has a more comprehensive General Data Protection Regulation that governs the use and exchange of personal information. In Canada, the Personal Information Protection and Electronic Documents Act (PIPEDA) governs the use of personal information."
  },
  {
    "id": 2128,
    "topic_id": 200,
    "title": "Know legal and\u00a0regulatory issues and\u00a0how they pertain to\u00a0information security.",
    "description": "Understand the concepts of cybercrime and data breaches and be able to apply them in your environment when incidents arise. Understand what licensing and intellectual property protections apply to your organization's data and your obligations when encountering data belonging to other organizations. Understand the privacy and export control issues associated with transferring information across international borders."
  },
  {
    "id": 2129,
    "topic_id": 200,
    "title": "Understand the\u00a0importance of\u00a0data and\u00a0asset classifications.",
    "description": "Data owners are responsible for defining data and asset classifications and ensuring that data and systems are properly marked. Additionally, data owners define requirements to protect data at different classifications, such as encrypting sensitive data at rest and in transit. Data classifications are typically defined within security policies or data policies."
  },
  {
    "id": 2130,
    "topic_id": 200,
    "title": "Define PII and\u00a0PHI.",
    "description": "Personally identifiable information (PII) is any information that can identify an individual. Protected health information (PHI) is any health-related information that can be related to a specific person. Many laws and regulations mandate the protection of PII and PHI."
  },
  {
    "id": 2131,
    "topic_id": 200,
    "title": "Know how to\u00a0manage sensitive information.",
    "description": "Sensitive information is any type of classified information, and proper management helps prevent unauthorized disclosure resulting in a loss of confidentiality. Proper management includes marking, handling, storing, and destroying sensitive information. The two areas where organizations often miss the mark are adequately protecting backup media holding sensitive information and sanitizing media or equipment when it is at the end of its lifecycle."
  },
  {
    "id": 2132,
    "topic_id": 200,
    "title": "Describe the\u00a0three data states.",
    "description": "The three data states are at rest, in transit, and in use. Data at rest is any data stored on media such as hard drives or external media. Data in transit is any data transmitted over a network. Encryption methods protect data at rest and in transit. Data in use refers to data in memory and used by an application. Applications should flush memory buffers to remove data after it is no longer needed."
  },
  {
    "id": 2133,
    "topic_id": 200,
    "title": "Define DLP.",
    "description": "Data loss prevention (DLP) systems detect and block data exfiltration attempts by scanning unencrypted files and looking for keywords and data patterns.  Network-based systems (including cloud-based systems) scan files before they leave the network. Endpoint-based systems prevent users from copying or printing some files."
  },
  {
    "id": 2134,
    "topic_id": 200,
    "title": "Compare data destruction methods.",
    "description": "Erasing a file doesn't delete it. Clearing media overwrites it with characters or bits. Purging repeats the clearing process multiple times and removes data so that the media can be reused. Degaussing removes data from tapes and magnetic hard disk drives, but it does not affect optical media or SSDs. Destruction methods include incineration, crushing, shredding, and disintegration."
  },
  {
    "id": 2135,
    "topic_id": 200,
    "title": "Describe data remanence.",
    "description": "Data remanence is the data that remains on media after it should have been removed. Hard disk drives sometimes retain residual magnetic flux that can be read with advanced tools. Advanced tools can read slack space on a disk, which is unused space in clusters. Erasing data on a disk leaves data remanence."
  },
  {
    "id": 2136,
    "topic_id": 200,
    "title": "Understand record retention policies.",
    "description": "Record retention policies ensure that data is kept in a usable state while it is needed and destroyed when it is no longer needed. Many laws and regulations mandate keeping data for a specific amount of time, but in the absence of formal regulations, organizations specify the retention period within a policy. Audit trail data needs to be kept long enough to reconstruct past incidents, but the organization must identify how far back they want to investigate. A current trend in many organizations is to reduce legal liabilities by implementing short retention policies with email."
  },
  {
    "id": 2138,
    "topic_id": 200,
    "title": "Explain DRM.",
    "description": "Digital rights management (DRM) methods provide copyright protection for copyrighted works. The purpose is to prevent the unauthorized use, modification, and distribution of copyrighted works."
  },
  {
    "id": 2139,
    "topic_id": 200,
    "title": "Explain CASB.",
    "description": "A cloud access security broker (CASB) is placed logically between users and cloud resources. It can apply internal security controls to cloud resources. The CASB component can be placed on-premises or in the cloud."
  },
  {
    "id": 2140,
    "topic_id": 200,
    "title": "Define pseudonymization.",
    "description": "Pseudonymization is the process of replacing some data elements with pseudonyms or aliases. It removes privacy data so that a dataset can be shared. However, the original data remains available in a separate dataset."
  },
  {
    "id": 2142,
    "topic_id": 200,
    "title": "Define anonymization.",
    "description": "Anonymization replaces privacy data with useful but inaccurate data. The dataset can be shared and used for analysis purposes, but anonymization removes individual identities. Anonymization is permanent."
  },
  {
    "id": 2143,
    "topic_id": 200,
    "title": "Know the\u00a0responsibilities of\u00a0data roles.",
    "description": "The data owner is the person responsible for classifying, labeling, and protecting data. System owners are responsible for the systems that process the data. Business and mission owners own the processes and ensure that the systems provide value to the organization. Data controllers decide what data to process and how to process it. Data processors are often the third-party entities that process data for an organization at the direction of the data controller. Administrators grant access to data based on guidelines provided by the data owners. A user, or subject, accesses data while performing work tasks. A custodian has day-to-day responsibilities for protecting and storing data."
  },
  {
    "id": 2145,
    "topic_id": 200,
    "title": "Understand the\u00a0role that confidentiality, integrity, and\u00a0nonrepudiation play in\u00a0cryptosystems.",
    "description": "Confidentiality is one of the major goals of cryptography. It protects the secrecy of data while it is both at rest and in transit. Integrity provides the recipient of a message with the assurance that data was not altered (intentionally or unintentionally) between the time it was created and the time it was accessed. Nonrepudiation provides undeniable proof that the sender of a message actually authored it. It prevents the sender from subsequently denying that they sent the original message."
  },
  {
    "id": 2146,
    "topic_id": 200,
    "title": "Know how cryptosystems can be\u00a0used to\u00a0achieve authentication goals.",
    "description": "Authentication provides assurances as to the identity of a user. One possible scheme that uses authentication is the challenge-response protocol, in which the remote user is asked to encrypt a message using a key known only to the communicating parties. Authentication can be achieved with both symmetric and asymmetric cryptosystems."
  },
  {
    "id": 2147,
    "topic_id": 200,
    "title": "Be familiar with\u00a0the basic terminology of\u00a0cryptography.",
    "description": "When a sender wants to transmit a private message to a recipient, the sender takes the plaintext (unencrypted) message and encrypts it using an algorithm and a key. This produces a ciphertext message that is transmitted to the recipient. The recipient then uses a similar algorithm and key to decrypt the ciphertext and re-create the original plaintext message for viewing."
  },
  {
    "id": 2148,
    "topic_id": 200,
    "title": "Understand the\u00a0difference between a\u00a0code and\u00a0a cipher and\u00a0explain the\u00a0basic types of\u00a0ciphers.",
    "description": "Codes are cryptographic systems of symbols that operate on words or phrases and are sometimes secret but don't always provide confidentiality. Ciphers, however, are always meant to hide the true meaning of a message. Know how the following types of ciphers work: transposition ciphers, substitution ciphers (including one-time pads), stream ciphers, and block ciphers."
  },
  {
    "id": 2149,
    "topic_id": 200,
    "title": "Know the\u00a0requirements for\u00a0successful use of\u00a0a one-time pad.",
    "description": "For a one-time pad to be  successful, the key must be generated randomly without any known pattern. The key must be at least as long as the message to be encrypted. The pads must be protected against physical disclosure, and each pad must be used only one time and then discarded."
  },
  {
    "id": 2150,
    "topic_id": 200,
    "title": "Understand split knowledge.",
    "description": "Split knowledge means that the information or privilege required to perform an operation is divided among multiple users. This ensures that no single person has sufficient privileges to compromise the security of the environment. M of N Control is an example of split knowledge used in key recovery and other sensitive tasks."
  },
  {
    "id": 2151,
    "topic_id": 200,
    "title": "Understand work function (work factor).",
    "description": "Work function, or work factor, is a way to measure the strength of a cryptography system by measuring the effort in terms of cost and/or time to decrypt messages. Usually the time and effort required to perform a complete bruteforce attack against an encryption system is what a work function rating represents. The security and protection offered by a cryptosystem is directly proportional to the value of its work function/factor."
  },
  {
    "id": 2152,
    "topic_id": 200,
    "title": "Understand the\u00a0importance of\u00a0key security.",
    "description": "Cryptographic keys provide the necessary element of secrecy to a cryptosystem. Modern cryptosystems utilize keys that are at least 128 bits long to provide adequate security."
  },
  {
    "id": 2153,
    "topic_id": 200,
    "title": "Know the\u00a0differences between symmetric and\u00a0asymmetric cryptosystems.",
    "description": "Symmetric key cryptosystems (or secret key cryptosystems) rely on the use of a shared secret key. They are much faster than asymmetric algorithms, but they lack support for scalability, easy key distribution, and nonrepudiation. Asymmetric cryptosystems use public-private key pairs for communication between parties but operate much more slowly than symmetric algorithms."
  },
  {
    "id": 2154,
    "topic_id": 200,
    "title": "Be able to\u00a0explain the\u00a0basic operational modes of\u00a0symmetric cryptosystems.",
    "description": "Symmetric cryptosystems operate in several discrete modes: Electronic Code Book (ECB) mode, Cipher Block Chaining (CBC) mode, Cipher Feedback (CFB) mode, Output Feedback (OFB) mode, Counter (CTR) mode, Galois/Counter mode (GCM), and Counter with Cipher Block Chaining Message Authentication Code mode (CCM). ECB mode is considered the least secure and is used only for short messages. 3DES uses three iterations of DES with two or three different keys to increase the effective key strength to 112 or 168 bits, respectively."
  },
  {
    "id": 2155,
    "topic_id": 200,
    "title": "Know the\u00a0Advanced Encryption Standard (AES).",
    "description": "The Advanced Encryption Standard (AES) uses the Rijndael algorithm and is the U.S. government standard for the secure exchange of sensitive but unclassified data. AES uses key lengths of 128, 192, and 256 bits and a fixed block size of 128 bits to achieve a much higher level of security than that provided by the older DES algorithm."
  },
  {
    "id": 2156,
    "topic_id": 200,
    "title": "Understand the\u00a0key types used in\u00a0asymmetric cryptography.",
    "description": "Public keys are freely shared among communicating parties, whereas private keys are kept secret. To encrypt a message, use the recipient's public key. To decrypt a message, use your own private key. To sign a message, use your own private key. To validate a signature, use the sender's public key."
  },
  {
    "id": 2157,
    "topic_id": 200,
    "title": "Be familiar with\u00a0the three major public key cryptosystems.",
    "description": "RSA is the most famous public key cryptosystem; it was developed by Rivest, Shamir, and Adleman in 1977. It depends on the difficulty of factoring the product of prime numbers. ElGamal is an extension of the  Diffie\u2013Hellman key exchange algorithm that depends on modular arithmetic. The elliptic curve algorithm depends on the elliptic curve discrete logarithm problem and provides more security than other algorithms when both are used with keys of the same length."
  },
  {
    "id": 2159,
    "topic_id": 200,
    "title": "Be familiar with\u00a0the major hashing algorithms.",
    "description": "The successors to the Secure Hash Algorithm (SHA), SHA-2 and SHA-3, make up the government standard message digest function. SHA-2 supports variable-length message digests, ranging up to 512 bits. SHA-3 improves upon the security of SHA-2 and supports the same hash lengths."
  },
  {
    "id": 2160,
    "topic_id": 200,
    "title": "Know how cryptographic salts improve the\u00a0security of\u00a0password hashing.",
    "description": "When straightforward hashing is used to store passwords in a password file, attackers may use rainbow tables of precomputed values to identify commonly used passwords. Adding salts to the passwords before hashing them reduces the effectiveness of rainbow table attacks. Common password hashing algorithms that use key stretching to further increase the difficulty of attack include PBKDF2, bcrypt, and scrypt."
  },
  {
    "id": 2161,
    "topic_id": 200,
    "title": "Understand how digital signatures are generated and\u00a0verified.",
    "description": "To digitally sign a message,  first use a hashing function to generate a message digest; then encrypt the digest with your private key. To verify the digital signature on a message, decrypt the signature with the sender's public key and then compare the message digest to one you generate yourself. If they match, the message is authentic."
  },
  {
    "id": 2162,
    "topic_id": 200,
    "title": "Understand the\u00a0public key infrastructure (PKI).",
    "description": "In the public key infrastructure, certificate authorities (CAs) generate digital certificates containing the public keys of system users. Users then distribute these certificates to people with whom they want to communicate. Certificate recipients verify a certificate using the CA's public key."
  },
  {
    "id": 2163,
    "topic_id": 200,
    "title": "Know the\u00a0common applications of\u00a0cryptography to\u00a0secure email.",
    "description": "The emerging standard for encrypted messages is the S/MIME protocol. Another popular email security tool is Phil Zimmerman's Pretty Good Privacy (PGP). Most users of email encryption rely on having this technology built into their email client or their web-based email service."
  },
  {
    "id": 2164,
    "topic_id": 200,
    "title": "Know the\u00a0common applications of\u00a0cryptography to\u00a0secure web activity.",
    "description": "The de facto standard for secure web traffic is the use of HTTP over Transport Layer Security (TLS). This approach relies on hybrid cryptography using asymmetric cryptography to exchange an ephemeral session key, which is then used to carry on symmetric cryptography for the remainder of the session."
  },
  {
    "id": 2165,
    "topic_id": 200,
    "title": "Know the\u00a0common applications of\u00a0cryptography to\u00a0secure networking.",
    "description": "The IPsec protocol standard provides a common framework for encrypting network traffic and is built into a number of common operating systems. In IPsec transport mode, packet contents are encrypted for peer-to-peer communication. In tunnel mode, the entire packet, including header information, is encrypted for gateway-to-gateway communications."
  },
  {
    "id": 2166,
    "topic_id": 200,
    "title": "Be able to\u00a0describe IPsec.",
    "description": "IPsec is a security architecture framework that supports secure communication over IP. IPsec establishes a secure channel in either transport mode or tunnel mode. It can be used to establish direct communication between computers or to set up a VPN between networks. IPsec uses two protocols: Authentication Header (AH) and Encapsulating Security Payload (ESP)."
  },
  {
    "id": 2167,
    "topic_id": 200,
    "title": "Be able to\u00a0explain common cryptographic attacks.",
    "description": "Ciphertext-only attacks require access only to the ciphertext of a message. One example of a ciphertext-only attack is the bruteforce attack, which attempts to randomly find the correct cryptographic key. Frequency analysis, another ciphertext-only attack, counts characters in the ciphertext to reverse substitution ciphers. Known plaintext, chosen ciphertext, and chosen plaintext attacks require the attacker to have some extra information in addition to the ciphertext. The man-in-the-middle attack fools both parties into communicating with the attacker instead of directly with each other. The birthday attack is an attempt to find collisions in hash functions. The replay attack is an attempt to reuse authentication requests."
  },
  {
    "id": 2168,
    "topic_id": 200,
    "title": "Be able to define object and subject in terms of access.",
    "description": "The subject is the user or process that makes a request to access a resource. The object is the resource a user or process wants to access."
  },
  {
    "id": 2169,
    "topic_id": 200,
    "title": "Be able to\u00a0describe open and\u00a0closed systems.",
    "description": "Open systems are designed using industry standards and are usually easy to integrate with other open systems. Closed systems are generally proprietary hardware and/or software. Their specifications are not normally published, and they are usually harder to integrate with other systems."
  },
  {
    "id": 2174,
    "topic_id": 200,
    "title": "Understand zero trust.",
    "description": "Zero trust is a security concept where nothing inside the organization is automatically trusted. Each request for activity or access is assumed to be from an unknown and untrusted location until otherwise verified. The concept is \"never trust, always verify.\" The zero trust model is based around \"assume breach\" and microsegmentation."
  },
  {
    "id": 2175,
    "topic_id": 200,
    "title": "Know about Privacy by Design.",
    "description": "Privacy by Design (PbD) is a guideline to integrate privacy protections into products during the early design phase rather than attempting to tack them on at the end of development. The PbD framework is based on seven foundational principles."
  },
  {
    "id": 2176,
    "topic_id": 200,
    "title": "Understand \"trust but verify.\"",
    "description": "\"Trust but verify\" is a traditional security approach of trusting subjects and devices within the company's security perimeter automatically. This type of security approach leaves an organization vulnerable to insider attacks and grants intruders the ability to easily perform lateral movement among internal systems."
  },
  {
    "id": 2177,
    "topic_id": 200,
    "title": "Know what confinement, bounds, and\u00a0isolation are.",
    "description": "Confinement restricts a process to reading from and writing to certain memory locations. Bounds are the limits of memory a process cannot exceed when reading or writing. Isolation is the mode a process runs in when it is confined through the use of memory bounds."
  },
  {
    "id": 2179,
    "topic_id": 200,
    "title": "Understand trust and\u00a0assurance.",
    "description": "A trusted system is one in which all protection mechanisms work together to process sensitive data for many types of users while maintaining a stable and secure computing environment. In other words, trust is the presence of a security mechanism or capability. Assurance is the degree of confidence in satisfaction of security needs. In other words, assurance is how reliable the security mechanisms are at providing security."
  },
  {
    "id": 2180,
    "topic_id": 200,
    "title": "Define a\u00a0trusted computing base (TCB).",
    "description": "A TCB is the combination of hardware, software, and controls that form a trusted base that enforces the security policy."
  },
  {
    "id": 2181,
    "topic_id": 200,
    "title": "Be able to\u00a0explain what a\u00a0security perimeter is.",
    "description": "A security perimeter is the imaginary boundary that separates the TCB from the rest of the system. TCB components communicate with non-TCB components using trusted paths."
  },
  {
    "id": 2182,
    "topic_id": 200,
    "title": "Know what the\u00a0reference monitor and\u00a0the security kernel are.",
    "description": "The reference monitor is the logical part of the TCB that confirms whether a subject has the right to use a resource prior to granting access. The security kernel is the collection of the TCB components that implement the functionality of the reference monitor."
  },
  {
    "id": 2183,
    "topic_id": 200,
    "title": "Know details about each of\u00a0the security models.",
    "description": "The state machine model ensures that all instances of subjects accessing objects are secure. <br>The information flow model is designed to prevent unauthorized, insecure, or restricted information flow. <br>The noninterference model prevents the actions of one subject from affecting the system state or actions of another subject. <br>The take-grant model dictates how rights can be passed from one subject to another or from a subject to an object. <br>An access control matrix is a table of subjects and objects that indicates the actions or functions that each subject can perform on each object. <br>Bell\u2013LaPadula subjects have a clearance level that allows them to access only those objects with the corresponding classification levels, which protects confidentiality. <br>Biba prevents subjects with lower security levels from writing to objects at higher security levels. <br>Clark\u2013Wilson is an integrity model that relies on the access control triplet (i.e., subject/program/object). <br>Goguen\u2013Meseguer and Sutherland models focus on integrity. <br>Graham\u2013Denning focuses on the secure creation and deletion of both subjects and objects. <br>The Harrison\u2013Ruzzo\u2013Ullman (HRU) model focuses on the assignment of object access rights to subjects as well as the integrity (or resilience) of those assigned rights. <br>The Common Criteria (ISO/IEC 15408) is a subjective security function evaluation tool that uses protection profiles (PPs) and security targets (STs) and assigns an Evaluation Assurance Level (EAL). <br>Authorization to Operate (ATO) (from the RMF) is a formal approval to operate IT/IS based on an acceptable risk level based on the implementation of an agreed-on set of security and privacy controls."
  },
  {
    "id": 2184,
    "topic_id": 200,
    "title": "Understand the\u00a0security capabilities of\u00a0information systems.",
    "description": "Common security capabilities include memory protection, virtualization, Trusted Platform Module (TPM), encryption/ decryption, interfaces, and fault tolerance."
  },
  {
    "id": 2185,
    "topic_id": 200,
    "title": "Understand shared responsibility.",
    "description": "The security design principle indicates that organizations do not operate in isolation. It is because we participate in shared responsibility that we must research, implement, and manage engineering processes using secure design principles."
  },
  {
    "id": 2186,
    "topic_id": 200,
    "title": "Be able to\u00a0explain the\u00a0differences between multitasking, multicore, multiprocessing, multiprogramming, and\u00a0multithreading.",
    "description": "Multitasking is the simultaneous execution of more than one application on a computer and is managed by the OS. Multicore is the presence of multiple execution cores in a single CPU. Multiprocessing is the use of more than one processor to increase computing power. Multiprogramming is similar to multitasking and involves the pseudo-simultaneous execution of two tasks on a single processor coordinated by the OS as a way to increase operational efficiency. Multithreading permits multiple concurrent tasks to be performed within a single process."
  },
  {
    "id": 2190,
    "topic_id": 200,
    "title": "Describe the\u00a0different types of\u00a0memory used by a\u00a0computer.",
    "description": "ROM is nonvolatile and can't be written to by the end user. Data can be written to PROM chips only once. EPROM/ UVEPROM chips may be erased with ultraviolet light. EEPROM chips may be erased with electrical current. RAM chips are volatile and lose their contents when the computer is powered off."
  },
  {
    "id": 2193,
    "topic_id": 200,
    "title": "Describe the\u00a0different characteristics of\u00a0storage devices used by computers.",
    "description": "Primary storage is the same as memory. Secondary storage consists of magnetic, flash, and optical media that must be first read into primary memory before the CPU can use the data. Random access storage devices can be read at any point, whereas sequential access devices require scanning through all the data physically stored before the desired location."
  },
  {
    "id": 2196,
    "topic_id": 200,
    "title": "Know about emanation security.",
    "description": "Many electrical devices emanate electrical signals or radiation that can be intercepted by unauthorized individuals. These signals may contain confidential, sensitive, or private data. TEMPEST countermeasures to Van Eck phreaking (i.e., eavesdropping), include Faraday cages, white noise, control zones, and shielding."
  },
  {
    "id": 2197,
    "topic_id": 200,
    "title": "Understand security risks that input and\u00a0output devices can pose.",
    "description": "Input/output devices can be subject to eavesdropping and tapping, are subject to shoulder surfing, are used to smuggle data out of an organization, or are used to create unauthorized, insecure points of entry into an organization's systems and networks. Be prepared to recognize and mitigate such vulnerabilities."
  },
  {
    "id": 2198,
    "topic_id": 200,
    "title": "Know the\u00a0purpose of\u00a0firmware.",
    "description": "Firmware is software stored on a ROM chip. At the computer level, it contains the basic instructions needed to start a computer. Firmware is also used to provide operating instructions in peripheral devices such as printers. Examples include BIOS and UEFI."
  },
  {
    "id": 2200,
    "topic_id": 200,
    "title": "Know about large-scale parallel data systems.",
    "description": "Systems designed to perform numerous calculations simultaneously include SMP, AMP, and MPP. Grid computing is a form of parallel distributed processing that loosely groups a significant number of processing nodes to work toward a specific processing goal. Peer-to-peer (P2P) technologies are networking and distributed application solutions that share tasks and workloads among peers."
  },
  {
    "id": 2201,
    "topic_id": 200,
    "title": "Be able to\u00a0define ICS.",
    "description": "An industrial control system (ICS) is a form of computer-management device that controls industrial processes and machines (aka operational technology). ICS examples include distributed control systems (DCSs), programmable logic controllers (PLCs), and supervisory control and data acquisition (SCADA)."
  },
  {
    "id": 2205,
    "topic_id": 200,
    "title": "Understand smart devices.",
    "description": "Smart devices are devices that offer the user a plethora of customization options, typically through installing apps, and may take advantage of on-device or in-the-cloud machine learning (ML) processing."
  },
  {
    "id": 2206,
    "topic_id": 200,
    "title": "Be able to\u00a0define IoT.",
    "description": "The Internet of Things (IoT) is a class of devices that are internetconnected in order to provide automation, remote control, or AI processing to appliances or devices. The security issues related to IoT often relate to access and encryption."
  },
  {
    "id": 2207,
    "topic_id": 200,
    "title": "Be able to\u00a0define IIoT.",
    "description": "Industrial Internet of Things (IIoT) is a derivative of IoT that focuses on industrial, engineering, manufacturing, or infrastructure level oversight, automation, management, and sensing. IIoT is an evolution of ICS and DCS that integrates cloud services to perform data collection, analysis, optimization, and automation."
  },
  {
    "id": 2208,
    "topic_id": 200,
    "title": "Be aware of\u00a0specialized devices.",
    "description": "Specialized equipment is anything designed for one specific purpose, to be used by a specific type of organization, or to perform a specific function. It may be considered a type of DCS, IoT, smart device, endpoint device, or edge computing system. Some common examples of specialized devices are medical equipment, smart vehicles, autonomous aircraft, and smart meters."
  },
  {
    "id": 2209,
    "topic_id": 200,
    "title": "Be able to\u00a0define SOA.",
    "description": "Service-oriented architecture (SOA) constructs new applications or functions out of existing but separate and distinct software services. The resulting application is often new; thus, its security issues are unknown, untested, and unprotected. A derivative of SOA is microservices."
  },
  {
    "id": 2210,
    "topic_id": 200,
    "title": "Understand microservices.",
    "description": "A microservice is simply one element, feature, capability, business logic, or function of a web application that can be called upon or used by other web applications. It is the conversion or transformation of a capability of one web application into a microservice that can be called upon by numerous other web applications. It allows large complex solutions to be broken into smaller self-contained functions."
  },
  {
    "id": 2211,
    "topic_id": 200,
    "title": "Be able to\u00a0define IaC.",
    "description": "Infrastructure as code (IaC) is a change in how hardware management is perceived and handled. Instead of seeing hardware configuration as a manual, direct hands-on, one-on-one administration hassle, it is viewed as just another collection of elements to be managed in the same way that software and code are managed under DevSecOps (development, security, and operations)."
  },
  {
    "id": 2212,
    "topic_id": 200,
    "title": "Understand hypervisors.",
    "description": "The hypervisor, also known as the virtual machine monitor/ manager (VMM), is the component of virtualization that creates, manages, and operates virtual machines."
  },
  {
    "id": 2213,
    "topic_id": 200,
    "title": "Know about the\u00a0type I\u00a0hypervisor.",
    "description": "A type I hypervisor is a native or bare-metal hypervisor. In this configuration, there is no host OS; instead, the hypervisor installs directly onto the hardware where the host OS would normally reside."
  },
  {
    "id": 2214,
    "topic_id": 200,
    "title": "Know about the\u00a0type II hypervisor.",
    "description": "A type II hypervisor is a hosted hypervisor. In this configuration, a standard regular OS is present on the hardware, and the hypervisor is then installed as another software application."
  },
  {
    "id": 2216,
    "topic_id": 200,
    "title": "Understand virtual software.",
    "description": "A virtual application or virtual software is a software product deployed in such a way that it is fooled into believing it is interacting with a full host OS. A virtual (or virtualized) application has been packaged or encapsulated so that it can execute but operate without full access to the host OS. A virtual application is isolated from the host OS so that it cannot make any direct or permanent changes to the host OS."
  },
  {
    "id": 2217,
    "topic_id": 200,
    "title": "Know virtual networking.",
    "description": "A virtualized network or network virtualization is the combination of hardware and software networking components into a single integrated entity. The resulting solution allows for software control over all network functions: management, traffic shaping, address assignment, and so on."
  },
  {
    "id": 2218,
    "topic_id": 200,
    "title": "Know about SDx.",
    "description": "Software-defined everything (SDx) refers to a trend of replacing hardware with software using virtualization. SDx includes virtualization, virtualized software, virtual networking, containerization, serverless architecture, infrastructure as code, SDN, VSAN, software-defined storage (SDS), VDI, VMI, SDV, and software-defined data center (SDDC)."
  },
  {
    "id": 2219,
    "topic_id": 200,
    "title": "Know about VDI and\u00a0VMI.",
    "description": "Virtual desktop infrastructure (VDI) is a means to reduce the security risk and performance requirements of end devices by hosting desktop/workstation OS virtual machines on central servers that are remotely accessed by users. Virtual mobile infrastructure (VMI) is where the OS of a mobile device is virtualized on a central server."
  },
  {
    "id": 2220,
    "topic_id": 200,
    "title": "Be aware of\u00a0SDV.",
    "description": "Software-defined visibility (SDV) is a framework to automate the processes of network monitoring and response. The goal is to enable the analysis of every packet and make deep intelligence-based decisions on forwarding, dropping, or otherwise responding to threats."
  },
  {
    "id": 2223,
    "topic_id": 200,
    "title": "Know some of\u00a0the security issues of\u00a0virtualization.",
    "description": "Virtualization doesn't lessen the security management requirements of an OS. Thus, patch management is still essential. It's important to protect the stability of the host. Organizations should maintain backups of their virtual assets. Virtualized systems should be security tested. VM sprawl occurs when an organization deploys numerous virtual machines without an overarching IT management or security plan in place."
  },
  {
    "id": 2224,
    "topic_id": 200,
    "title": "Understand containerization.",
    "description": "Containerization or OS virtualization is based on the concept of eliminating the duplication of OS elements in a virtual machine. Each application is placed into a container that includes only the actual resources needed to support the enclosed application, and the common or shared OS elements are then part of the hypervisor."
  },
  {
    "id": 2225,
    "topic_id": 200,
    "title": "Know about serverless architecture.",
    "description": "Serverless architecture is a cloud computing concept where code is managed by the customer and the platform (i.e., supporting hardware and software) or server is managed by the cloud service provider (CSP). There is always a physical server running the code, but this execution model allows the software designer/ architect/programmer/developer to focus on the logic of their code and not have to be concerned about the parameters or limitations of a specific server. This is also known as function as a service (FaaS)."
  },
  {
    "id": 2226,
    "topic_id": 200,
    "title": "Understand embedded systems.",
    "description": "An embedded system is typically designed around a limited set of specific functions in relation to the larger product to which it is attached."
  },
  {
    "id": 2227,
    "topic_id": 200,
    "title": "Be aware of\u00a0microcontrollers.",
    "description": "A microcontroller is similar to but less complex than a system on a chip (SoC). A microcontroller may be a component of an SoC. A microcontroller is a small computer consisting of a CPU (with one or more cores), memory, various input/output capabilities, RAM, and often nonvolatile storage in the form of flash or ROM/ PROM/EEPROM. Examples include Raspberry Pi, Arduino, and FPGA."
  },
  {
    "id": 2228,
    "topic_id": 200,
    "title": "Know about static systems/environments.",
    "description": "Static systems/environments are applications, OSs, hardware sets, or networks that are configured for a specific need, capability, or function, and then set to remain unaltered."
  },
  {
    "id": 2229,
    "topic_id": 200,
    "title": "Be aware of\u00a0network-enabled devices.",
    "description": "Network-enabled devices are any type of portable or nonportable device that has native network capabilities. Network-enabled devices may be embedded systems or used to create embedded systems. Network-enabled devices are also often static systems."
  },
  {
    "id": 2230,
    "topic_id": 200,
    "title": "Know about cyber-physical systems.",
    "description": "Cyber-physical systems refer to devices that offer a computational means to control something in the physical world. In the past these might have been referred to as embedded systems, but the category of cyber-physical seems to focus more on the physical world results rather than the computational aspects."
  },
  {
    "id": 2231,
    "topic_id": 200,
    "title": "Understand embedded systems and\u00a0static environment security concerns.",
    "description": "Static environments, embedded systems, network-enabled devices, cyber-physical systems, HPC systems, edge computing devices, fog computing devices, mobile devices, and other limited or singlepurpose computing environments need security management. These techniques may include network segmentation, security layers, application firewalls, manual updates, firmware version control, wrappers, and control redundancy and diversity."
  },
  {
    "id": 2232,
    "topic_id": 200,
    "title": "Know about HPC systems.",
    "description": "High-performance computing (HPC) systems are computing platforms designed to perform complex calculations or data manipulations at extremely high speeds. Supercomputers and MPP solutions are common examples of HPC systems."
  },
  {
    "id": 2233,
    "topic_id": 200,
    "title": "Be aware of\u00a0RTOS.",
    "description": "A real-time operating system (RTOS) is designed to process or handle data as it arrives on the system with minimal latency or delay. An RTOS is usually stored on read-only memory (ROM) and is designed to operate in a hard real-time or soft real-time condition."
  },
  {
    "id": 2234,
    "topic_id": 200,
    "title": "Understand edge computing.",
    "description": "Edge computing is a philosophy of network design where data and the compute resources are located as close as possible in order to optimize bandwidth use while minimizing latency. In edge computing, the intelligence and processing are contained within each device. Thus, rather than having to send data off to a master processing entity, each device can process its own data locally."
  },
  {
    "id": 2235,
    "topic_id": 200,
    "title": "Know about fog computing.",
    "description": "Fog computing is another example of advanced computation architectures, which is also often used as an element in an IIoT deployment. Fog computing relies upon sensors, IoT devices, or even edge computing devices to collect data, and then transfer it back to a central location for processing. Thus, intelligence and processing is centralized."
  },
  {
    "id": 2236,
    "topic_id": 200,
    "title": "Understand mobile device security.",
    "description": "Personal electronic device (PED) security features can often be managed using a mobile device management (MDM) or unified endpoint management (UEM) solution. These include device authentication, full-device encryption, communication protection, remote wiping, device lockout, screen locks, GPS and location services management, content management, application control, push notification management, third-party application store control, storage segmentation, asset tracking and inventory control, removable storage, management of connection methods, disabling of unused features, rooting/jailbreaking, sideloading, custom firmware, carrier unlocking, firmware OTA updates, key management, credential management, and text messaging security."
  },
  {
    "id": 2237,
    "topic_id": 200,
    "title": "Understand mobile device deployment policies.",
    "description": "A number of deployment models are available for allowing and/or providing mobile devices for employees to use while at work and to perform work tasks when away from the office. Examples include BYOD, COPE, CYOD, and COMS/COBO. You should also consider VDI and VMI options."
  },
  {
    "id": 2238,
    "topic_id": 200,
    "title": "Be aware of\u00a0mobile device deployment policy details.",
    "description": "A mobile device deployment policy should address data ownership, support ownership, patch and update management, security product management, forensics, privacy, onboarding/offboarding, adherence to corporate policies, user acceptance, architecture/infrastructure considerations, legal concerns, acceptable use policies, onboard cameras/video, recording microphone, Wi-Fi Direct, tethering and hotspots, and contactless payment methods."
  },
  {
    "id": 2239,
    "topic_id": 200,
    "title": "Understand process isolation.",
    "description": "Process isolation requires that the OS provide separate memory spaces for each process's instructions and data. It also requires that the OS enforce those boundaries, preventing one process from reading or writing data that belongs to another process."
  },
  {
    "id": 2240,
    "topic_id": 200,
    "title": "Be aware of\u00a0hardware segmentation.",
    "description": "Hardware segmentation is similar to process isolation in purpose\u2014it prevents the access of information that belongs to a different process/ security level. The main difference is that hardware segmentation enforces these requirements through the use of physical hardware controls rather than the logical process isolation controls imposed by an OS."
  },
  {
    "id": 2242,
    "topic_id": 200,
    "title": "Be able to\u00a0explain what covert channels are.",
    "description": "A covert channel is a method that is used to pass information over a path that is not normally used for communication. Using a covert channel provides a means to violate, bypass, or circumvent a security policy undetected. Basic types are timing and storage."
  },
  {
    "id": 2243,
    "topic_id": 200,
    "title": "Know about vulnerabilities due\u00a0to design and\u00a0coding flaws.",
    "description": "Certain attacks may result from poor design techniques, questionable implementation practices and procedures, or poor or inadequate testing. Some attacks may result from deliberate design decisions when special points of entry, built into code to circumvent access controls, login, or other security checks often added to code while under development, are not removed when that code is put into production. Poor coding practices and lack of security consideration are common sources or causes of vulnerabilities of system architectures that can be attributed to failures in design, implementation, prerelease code cleanup, or out-and-out coding mistakes."
  },
  {
    "id": 2244,
    "topic_id": 200,
    "title": "Be aware of\u00a0rootkits.",
    "description": "A rootkit is malware that embeds itself deep within an OS. The term is a derivative of the concept of rooting and a utility kit of hacking tools. Rooting is gaining total or full control over a system."
  },
  {
    "id": 2246,
    "topic_id": 200,
    "title": "Understand why there is no security without physical security.",
    "description": "Without control over the physical environment, no amount of administrative or technical/logical access controls can provide adequate security. If a malicious person can gain physical access to your facility or equipment, they can do just about anything they want, from destruction to disclosure and alteration."
  },
  {
    "id": 2248,
    "topic_id": 200,
    "title": "Define critical path analysis.",
    "description": "Critical path analysis is a systematic effort to identify relationships between mission-critical applications, processes, and operations and all the necessary supporting elements."
  },
  {
    "id": 2249,
    "topic_id": 200,
    "title": "Know about technology convergence.",
    "description": "Technology convergence is the tendency for various technologies, solutions, utilities, and systems to evolve and merge over time. Though in some instances this can result in improved efficiency and cost savings, it can also represent a single point of failure and become a more valuable target for malicious hackers and intruders."
  },
  {
    "id": 2250,
    "topic_id": 200,
    "title": "Understand site selection.",
    "description": "Site selection should be based on the security needs of the organization. Cost, location, and size are important, but addressing the requirements of security should always take precedence. The key elements in making a site selection are visibility, composition of the surrounding area, and area accessibility."
  },
  {
    "id": 2251,
    "topic_id": 200,
    "title": "Know the\u00a0key elements in\u00a0designing a\u00a0facility for\u00a0construction.",
    "description": "A key element in designing a facility for construction is understanding the level of security needed by your organization and planning for it before construction begins."
  },
  {
    "id": 2256,
    "topic_id": 200,
    "title": "Know the\u00a0functional order of\u00a0controls.",
    "description": "These are deter, deny, detect, delay, determine, and decide."
  },
  {
    "id": 2258,
    "topic_id": 200,
    "title": "Define MTTF, MTTR, and\u00a0MTBF.",
    "description": "Mean time to failure (MTTF) is the expected typical functional lifetime of the device given a specific operating environment. Mean time to repair (MTTR) is the average length of time required to perform a repair on the device. Mean time between failures (MTBF) is an estimation of the time between the first and any subsequent failures."
  },
  {
    "id": 2259,
    "topic_id": 200,
    "title": "Know how to\u00a0design and\u00a0configure secure work areas.",
    "description": "There should not be equal access to all locations within a facility. Areas that contain assets of higher value or importance should have restricted access. Valuable and confidential assets should be located in the heart or center of protection provided by a facility."
  },
  {
    "id": 2260,
    "topic_id": 200,
    "title": "Understand the\u00a0security concerns of\u00a0a wiring closet.",
    "description": "A wiring closet is where the networking cables for a whole building or just a floor are connected to other essential equipment, such as patch panels, switches, routers, LAN extenders, and backbone channels. Most of the security for a wiring closet focuses on preventing physical unauthorized access. If an unauthorized intruder gains access to the area, they may be able to steal equipment, pull or cut cables, or even plant a listening device."
  },
  {
    "id": 2261,
    "topic_id": 200,
    "title": "Understand smartcards.",
    "description": "Smartcards are credit card\u2013sized IDs, badges, or security passes with an embedded magnetic stripe, bar code, or integrated circuit chip. They contain information about the authorized bearer that can be used for identification and/or authentication purposes."
  },
  {
    "id": 2262,
    "topic_id": 200,
    "title": "Know about proximity devices and readers.",
    "description": "A proximity device can be a passive device, a field-powered device, or a transponder. When it passes near a proximity reader, the reader device is able to determine who the bearer is and whether they have authorized access."
  },
  {
    "id": 2263,
    "topic_id": 200,
    "title": "Understand intrusion detection systems.",
    "description": "Intrusion detection systems (IDSs) or burglar alarms are systems\u2014automated or manual\u2014designed to detect an attempted intrusion, breach, or attack; the use of an unauthorized entry point; or the occurrence of some specific event at an unauthorized or abnormal time."
  },
  {
    "id": 2264,
    "topic_id": 200,
    "title": "Know about cameras.",
    "description": "Video surveillance, video monitoring, closed-circuit television (CCTV), and security cameras are all means to deter unwanted activity and create a digital record of the occurrence of events. Cameras can be overt or hidden; can record locally or to a cloud storage service; may offer pan, tilt, and zoom; may operate in visible or infrared light; may be triggered by movement; may support time-lapse recording, tracking, facial recognition, object detection, or infrared or color-filtered recording; and may offer face recognition, gait analysis, and/or object detection."
  },
  {
    "id": 2265,
    "topic_id": 200,
    "title": "Understand security needs for\u00a0media storage.",
    "description": "Media storage facilities should be designed to securely store blank media, reusable media, and installation media. The concerns include theft, corruption, and data remnant recovery. Media storage facility protections include using locked cabinets or safes, using a media librarian/custodian, implementing a check-in/ check-out process, and using media sanitization."
  },
  {
    "id": 2266,
    "topic_id": 200,
    "title": "Understand the\u00a0concerns of\u00a0evidence storage.",
    "description": "Evidence storage is used to retain logs, drive images, virtual machine snapshots, and other datasets for recovery, internal investigations, and forensic investigations. Protections include dedicated/isolated storage facilities, offline storage, activity tracking, hash management, access restrictions, and encryption."
  },
  {
    "id": 2268,
    "topic_id": 200,
    "title": "Know the\u00a0terms commonly associated with\u00a0power issues.",
    "description": "Know the definitions of the following: fault, blackout, sag, brownout, spike, surge, inrush, ground, and noise."
  },
  {
    "id": 2269,
    "topic_id": 200,
    "title": "Understand how to\u00a0control your environment.",
    "description": "In addition to power considerations, maintaining the environment involves control over the HVAC mechanisms. Rooms containing primarily computers should be kept at 59 to 89.6 degrees Fahrenheit (15 to 32 degrees Celsius). Humidity in a computer room should be maintained between 20 and 80 percent. Too much humidity can cause corrosion. Too little humidity causes static electricity."
  },
  {
    "id": 2270,
    "topic_id": 200,
    "title": "Know about static electricity.",
    "description": "Even on nonstatic carpeting, if the environment has low humidity it is still possible to generate 20,000-volt static discharges. Even minimal levels of static discharge can destroy electronic equipment."
  },
  {
    "id": 2271,
    "topic_id": 200,
    "title": "Understand the\u00a0need to\u00a0manage water leakage and\u00a0flooding.",
    "description": "Water leakage and flooding should be addressed in your environmental safety policy and procedures. Plumbing leaks are not an everyday occurrence, but when they occur, they often cause significant damage. Water and electricity don't mix. If your computer systems come in contact with water, especially while they are operating, damage is sure to occur. Whenever possible, locate server rooms and critical computer equipment away from any water source or transport pipes."
  },
  {
    "id": 2272,
    "topic_id": 200,
    "title": "Understand the\u00a0importance of\u00a0fire detection and\u00a0suppression.",
    "description": "Fire detection and suppression must not be overlooked. Protecting personnel from harm should always be the most important goal of any security or protection system. In addition to protecting people, fire detection and suppression are designed to keep damage caused by fire, smoke, heat, and suppression materials to a minimum, especially in regard to the IT infrastructure."
  },
  {
    "id": 2273,
    "topic_id": 200,
    "title": "Understand the\u00a0possible contamination and\u00a0damage caused by a\u00a0fire and\u00a0suppression.",
    "description": "The destructive elements of a fire include smoke and heat but also the suppression medium, such as water or soda acid. Smoke is damaging to most storage devices. Heat can damage any electronic or computer component. Suppression mediums can cause short circuits, initiate corrosion, or otherwise render equipment useless. All of these issues must be addressed when designing a fire response system."
  },
  {
    "id": 2275,
    "topic_id": 200,
    "title": "Understand lighting.",
    "description": "Lighting is the most commonly used form of perimeter security control, providing the security benefit of deterrence."
  },
  {
    "id": 2276,
    "topic_id": 200,
    "title": "Know about security guards and\u00a0guard dogs.",
    "description": "Guards can be posted around a perimeter or inside to monitor access points or watch detection and surveillance monitors. The real benefit of guards is that they are able to adapt and react to various conditions or situations. Guards can learn and recognize attack and intrusion activities and patterns, can adjust to a changing environment, and can make decisions and judgment calls. Guard dogs can be an alternative to security guards. They can often be deployed as a perimeter security control. As a detection and deterrent, dogs are extremely effective."
  },
  {
    "id": 2277,
    "topic_id": 200,
    "title": "Understand how to\u00a0handle visitors in\u00a0a secure facility.",
    "description": "If a facility employs restricted areas to control physical security, then a mechanism to handle visitors is required. Often an escort is assigned to visitors, and their access and activities are monitored closely. Failing to track the actions of outsiders when they are granted access to a protected area can result in malicious activity against the most protected assets."
  },
  {
    "id": 2278,
    "topic_id": 200,
    "title": "Understand internal security controls.",
    "description": "There are many physical security mechanisms for internal control, including locks, badges, protective distribution systems (PDSs), motion detectors, intrusion alarms, and secondary verification mechanisms."
  },
  {
    "id": 2280,
    "topic_id": 200,
    "title": "Know about KPIs of\u00a0physical security.",
    "description": "Key performance indicators (KPIs) of physical security should be determined, monitored, recorded, and evaluated. KPIs are metrics or measurements of the operation of or the failure of various aspects of physical security."
  },
  {
    "id": 2281,
    "topic_id": 200,
    "title": "Know the\u00a0OSI model.",
    "description": "The OSI layers are as follows: Application, Presentation, Session, Transport, Network, Data Link, and Physical."
  },
  {
    "id": 2282,
    "topic_id": 200,
    "title": "Understand encapsulation.",
    "description": "Encapsulation is the addition of a header, and possibly a footer, to the data received by each layer from the layer above before it's handed off to the layer below. The inverse action is deencapsulation."
  },
  {
    "id": 2283,
    "topic_id": 200,
    "title": "Know the\u00a0network container names.",
    "description": "The network containers are: OSI layers 7\u20135 protocol data unit (PDU), layer 4 segment (TCP) or a datagram (UDP), layer 3 packet, layer 2 frame, and layer 1 bits."
  },
  {
    "id": 2285,
    "topic_id": 200,
    "title": "Understand the\u00a0MAC address.",
    "description": "Media Access Control (MAC) address is a 6-byte (48-bit) binary address written in hexadecimal notation, aka hardware address, physical address, the NIC address, and the Ethernet address. The first 3 bytes (24 bits) of the address is the organizationally unique identifier (OUI), which denotes the vendor or manufacturer."
  },
  {
    "id": 2286,
    "topic_id": 200,
    "title": "Know routing protocols.",
    "description": "Interior routing protocols are distance vector (Routing Information Protocol ([RIP] and Interior Gateway Routing Protocol [IGRP]) and link state (Open Shortest Path First [OSPF] and Intermediate System to Intermediate System [IS-IS]); exterior routing protocols are path vector (Border Gateway Protocol [BGP])."
  },
  {
    "id": 2287,
    "topic_id": 200,
    "title": "Understand the\u00a0TCP/IP model.",
    "description": "Also known as DARPA or the DOD model, the model has four layers: Application (also known as Process), Transport (also known as Host-to-Host), Internet (sometimes known as Internetworking), and Link (although Network Interface and sometimes Network Access are used)."
  },
  {
    "id": 2288,
    "topic_id": 200,
    "title": "Be aware of\u00a0the common application layer protocols.",
    "description": "These include Telnet, FTP, TFTP, SMTP, POP3, IMAP, DHCP, HTTP, HTTPS (TLS), LPD, X Window, NFS, and SNMP."
  },
  {
    "id": 2289,
    "topic_id": 200,
    "title": "Understand transport layer protocols.",
    "description": "Be aware of the features and differences between TCP and UDP; also be familiar with ports, session management, and TCP header flags."
  },
  {
    "id": 2291,
    "topic_id": 200,
    "title": "Understand DNS poisoning.",
    "description": "DNS poisoning is the act of falsifying the DNS information used by a client to reach a desired system. It can be accomplished through a rogue DNS server, pharming, altering a hosts file, corrupting IP configuration, DNS query spoofing, and proxy falsification."
  },
  {
    "id": 2292,
    "topic_id": 200,
    "title": "Understand domain hijacking.",
    "description": "Domain hijacking, or domain theft, is the malicious action of changing the registration of a domain name without the authorization of the valid owner."
  },
  {
    "id": 2294,
    "topic_id": 200,
    "title": "Know about IP.",
    "description": "Be familiar with the features and differences between IPv4 and IPv6. Understand IPv4 classes, subnetting, and CIDR notation."
  },
  {
    "id": 2295,
    "topic_id": 200,
    "title": "Understand network layer protocols.",
    "description": "Be familiar with ICMP and IGMP."
  },
  {
    "id": 2296,
    "topic_id": 200,
    "title": "Know about ARP.",
    "description": "Address Resolution Protocol (ARP) is essential to the interoperability of logical and physical addressing schemes. ARP is used to resolve IP addresses into MAC addresses. Also know about ARP poisoning."
  },
  {
    "id": 2297,
    "topic_id": 200,
    "title": "Be able to\u00a0give examples of\u00a0security communication protocols.",
    "description": "Examples include IPsec, Kerberos, SSH, Signal protocol, S-RPC, and TLS."
  },
  {
    "id": 2299,
    "topic_id": 200,
    "title": "Know about converged protocols.",
    "description": "Examples include FCoE, MPLS, iSCSI, VPN, SDN, cloud, virtualization, SOA, microservices, infrastructure as code (IaC), and serverless architecture."
  },
  {
    "id": 2300,
    "topic_id": 200,
    "title": "Define VoIP.",
    "description": "Voice over IP (VoIP) is a tunneling mechanism that encapsulates audio, video, and other data into IP packets to support voice calls and multimedia collaboration over TCP/IP network connections."
  },
  {
    "id": 2302,
    "topic_id": 200,
    "title": "Know about microsegmentation.",
    "description": "Microsegmentation is dividing up an internal network in numerous subzones, potentially as small as a single device, such as a high-value server or even a client or endpoint device. Each zone is separated from the others by internal segmentation firewalls (ISFWs), subnets, or VLANs."
  },
  {
    "id": 2303,
    "topic_id": 200,
    "title": "Define SDN.",
    "description": "Software-defined networking (SDN) is a unique approach to network operation, design, and management. SDN aims at separating the infrastructure layer (hardware and hardware-based settings) from the control layer (network services of data transmission management)."
  },
  {
    "id": 2304,
    "topic_id": 200,
    "title": "Understand the\u00a0various wireless technologies.",
    "description": "Cell phones, Bluetooth (802.15), and wireless networking (802.11) are all called wireless technologies, even though they are all different. Be aware of their differences, strengths, and weaknesses. Understand the basics of securing 802.11\u00a0networking. Know RFID, NFC, LiFi, satellite, narrow-band, and Zigbee."
  },
  {
    "id": 2305,
    "topic_id": 200,
    "title": "Know about service set identifier (SSID).",
    "description": "Examples include ESSID, BSSID, and ISSID."
  },
  {
    "id": 2308,
    "topic_id": 200,
    "title": "Define SAE.",
    "description": "Simultaneous Authentication of Equals (SAE) performs a zero-knowledge proof process known as Dragonfly Key Exchange, which is itself a derivative of Diffie\u2013 Hellman. The process uses a preset password and the MAC addresses of the client and AP to perform authentication and session key exchange."
  },
  {
    "id": 2309,
    "topic_id": 200,
    "title": "Understand site surveys.",
    "description": "A site survey is a formal assessment of wireless signal strength, quality, and interference using an RF signal detector. A site survey is performed by placing a wireless base station in a desired location and then collecting signal measurements from throughout the area."
  },
  {
    "id": 2310,
    "topic_id": 200,
    "title": "Understand WPS attacks.",
    "description": "Wi-Fi Protected Setup (WPS) intended to simplify the effort involved in adding new clients to a secured wireless network. It operates by automatically connecting the first new wireless client to seek the network once WPS is triggered."
  },
  {
    "id": 2311,
    "topic_id": 200,
    "title": "Understand MAC filtering.",
    "description": "A MAC filter is a list of authorized wireless client interface MAC addresses that is used by a WAP to block access to all nonauthorized devices."
  },
  {
    "id": 2312,
    "topic_id": 200,
    "title": "Understand antenna types.",
    "description": "A wide variety of antenna types can be used for wireless clients and base stations. These include omnidirectional pole antennas as well as many directional antennas, such as Yagi, cantenna, panel, and parabolic."
  },
  {
    "id": 2313,
    "topic_id": 200,
    "title": "Understand captive portals.",
    "description": "A captive portal is an authentication technique that redirects a newly connected client to a web-based portal access control page."
  },
  {
    "id": 2315,
    "topic_id": 200,
    "title": "Understand Bluetooth attacks.",
    "description": "Attacks include bluesniffing, bluesmacking, bluejacking, bluesnarfing, and bluebugging."
  },
  {
    "id": 2316,
    "topic_id": 200,
    "title": "Know wireless attacks.",
    "description": "Attacks include war driving, wireless scanners/crackers, rogue access points, evil twin, disassociation, jamming, IV abuse, and replay."
  },
  {
    "id": 2317,
    "topic_id": 200,
    "title": "Be familiar with\u00a0CDNs.",
    "description": "A content distribution network (CDN), or content delivery network, is a collection of resource services deployed in numerous data centers across the internet in order to provide low latency, high performance, and high availability of the hosted content."
  },
  {
    "id": 2318,
    "topic_id": 200,
    "title": "Know the\u00a0common network devices.",
    "description": "Common network devices are repeater, hub, modem, bridge, switch, router, LAN extender, jumpbox, sensor, collector, and aggregator."
  },
  {
    "id": 2319,
    "topic_id": 200,
    "title": "Define NAC.",
    "description": "Network access control (NAC) is the concept of controlling access to an environment through strict adherence to and enforcement of security policy. Know about 802.1X, preadmission, postadmission, agent-based, and agentless."
  },
  {
    "id": 2320,
    "topic_id": 200,
    "title": "Understand the\u00a0various types of\u00a0firewalls.",
    "description": "There are several types of firewalls: static packet filtering, application-level, circuit-level, stateful inspection, NGFW, and ISFW. Also know about virtual firewall, filters/rules/ACLs/tuples, bastion host, ingress, egress, RTBH, stateless vs. stateful, WAF, SWG, TCP wrapper, DPI, and content and URL filtering."
  },
  {
    "id": 2321,
    "topic_id": 200,
    "title": "Know about proxies.",
    "description": "A proxy server is used to mediate between clients and servers. Proxies are most often used in the context of providing clients on a private network with internet access while protecting the identity of the clients. Know about forward, reverse, transparent, and nontransparent."
  },
  {
    "id": 2322,
    "topic_id": 200,
    "title": "Understand endpoint security.",
    "description": "Endpoint security is the concept that each individual device must maintain local security whether or not its network or telecommunications channels also provide security."
  },
  {
    "id": 2324,
    "topic_id": 200,
    "title": "Understand MDR.",
    "description": "managed detection and response (MDR) focuses on threat detection and mediation but is not limited to the scope of endpoints. MDR is a service that attempts to monitor an IT environment in real-time to quickly detect and resolve threats. Often an MDR solution is a combination and integration of numerous technologies, including SIEM, network traffic analysis (NTA), EDR, and IDS."
  },
  {
    "id": 2325,
    "topic_id": 200,
    "title": "Know EPP.",
    "description": "Endpoint protection platform (EPP) is a variation of EDR much like IPS is a variation of IDS. The focus on EPP is on four main security functions: predict, prevent, detect, and respond. Thus, EPP is the more active prevent and predict variation of the more passive EDR concept."
  },
  {
    "id": 2326,
    "topic_id": 200,
    "title": "Understand XDR.",
    "description": "Extended detection and response (XDR) components often include EDR, MDR, and EPP elements. Also, XDR is not solely focused on endpoints, but often includes NTA, NIDS, and NIPS functions as well."
  },
  {
    "id": 2327,
    "topic_id": 200,
    "title": "Be aware of MSSP.",
    "description": "Managed security service provider (MSSP) can provide XDR solutions that are centrally controlled and managed. MSSP solutions can be deployed fully on-premise, fully in the cloud, or as a hybrid structure. MSSP solutions can be overseen through a SOC which is itself local or remote. Typically, working with an MSSP to provide EDR, MDR, EPP, or XDR services can allow an organization to gain the benefits of these advanced security products and leverage the experience and expertise of the MSSP's staff of security management and response professionals."
  },
  {
    "id": 2328,
    "topic_id": 200,
    "title": "Describe the\u00a0different cabling types.",
    "description": "This includes STP, UTP, 10Base2 coax (thinnet), 10Base5 coax (thicknet), 100BaseT, 1000BaseT, and fiber-optic. You should be familiar with UTP categories 1 through 8."
  },
  {
    "id": 2329,
    "topic_id": 200,
    "title": "Be familiar with\u00a0the common LAN technologies.",
    "description": "The most common LAN technology is Ethernet. Also be familiar with analog vs. digital communications; synchronous vs. asynchronous communications; duplexing; baseband vs. broadband communications; broadcast, multicast, and unicast communications; CSMA, CSMA/CD, and CSMA/CA; token passing; and polling."
  },
  {
    "id": 2330,
    "topic_id": 200,
    "title": "Know the\u00a0standard network topologies.",
    "description": "These are ring, bus, star, and mesh."
  },
  {
    "id": 2331,
    "topic_id": 200,
    "title": "Understand PPP.",
    "description": "Point-to-Point Protocol (PPP) is an encapsulation protocol designed to support the transmission of IP traffic over dial-up or point-to-point links. The original PPP options for authentication were PAP, CHAP, and EAP."
  },
  {
    "id": 2332,
    "topic_id": 200,
    "title": "Define PAP, CHAP, and\u00a0EAP.",
    "description": "PAP transmits usernames and passwords in cleartext. CHAP performs authentication using a challenge-response dialogue that cannot be replayed. EAP allows customized authentication security solutions."
  },
  {
    "id": 2334,
    "topic_id": 200,
    "title": "Understand IEEE 802.1X.",
    "description": "IEEE 802.1X defines the use of encapsulated EAP to support a wide range of authentication options for LAN connections. The IEEE 802.1X standard is formally named \"Port-Based Network Access Control.\"."
  },
  {
    "id": 2335,
    "topic_id": 200,
    "title": "Know about port security.",
    "description": "Port security can mean the physical control of all connection points, such as RJ-45\u00a0wall jacks or device ports. Port security is the management of TCP and User Datagram Protocol (UDP) ports. Port security can also refer to the need to authenticate to a port before being allowed to communicate through or across the port (i.e., IEEE 802.1X)."
  },
  {
    "id": 2336,
    "topic_id": 200,
    "title": "Understand voice communications security.",
    "description": "Voice communications are vulnerable to many attacks, especially as voice communications become an important part of network services. You can obtain confidentiality by using encrypted communications. Countermeasures must be deployed to protect against interception, eavesdropping, tapping, and other types of exploitation. Be familiar with voice communication topics, such as POTS, PSTN, PBX, and VoIP."
  },
  {
    "id": 2337,
    "topic_id": 200,
    "title": "Know the\u00a0threats associated with\u00a0PBX systems and\u00a0the countermeasures to\u00a0PBX fraud.",
    "description": "Countermeasures to PBX fraud and abuse include many of the same precautions you would employ to protect a typical computer network: logical or technical controls, administrative controls, and physical controls."
  },
  {
    "id": 2339,
    "topic_id": 200,
    "title": "Recognize what phreaking is.",
    "description": "Phreaking is a specific type of attack in which various types of technology are used to circumvent the telephone system to make free long-distance calls, to alter the function of telephone service, to steal specialized services, or to cause service disruptions. A phreaker is an attacker who performs phreaking."
  },
  {
    "id": 2340,
    "topic_id": 200,
    "title": "Understand the\u00a0issues of\u00a0remote access security management.",
    "description": "Remote access security management requires that security system designers address the hardware and software components of an implementation along with issues related to policy, work tasks, and encryption."
  },
  {
    "id": 2341,
    "topic_id": 200,
    "title": "Know various issues related to\u00a0remote access security.",
    "description": "Be familiar with remote access, dial-up connections, screen scrapers, virtual applications/desktops, and general telecommuting security concerns."
  },
  {
    "id": 2342,
    "topic_id": 200,
    "title": "Understand multimedia collaboration.",
    "description": "Multimedia collaboration is the use of various multimedia-supporting communication solutions to enhance distance collaboration and communications."
  },
  {
    "id": 2343,
    "topic_id": 200,
    "title": "Know the\u00a0purpose of\u00a0load balancers.",
    "description": "The purpose of load balancing is to obtain more optimal infrastructure utilization, minimize response time, maximize throughput, reduce overloading, and eliminate bottlenecks. A load balancer is used to spread or distribute network traffic load across several network links or network devices."
  },
  {
    "id": 2344,
    "topic_id": 200,
    "title": "Understand active/active.",
    "description": "An active-active system is a form of load balancing that uses all  available pathways or systems during normal operations. But has reduced capacity in  adverse conditions."
  },
  {
    "id": 2345,
    "topic_id": 200,
    "title": "Understand active/passive.",
    "description": "An active-passive system is a form of load balancing that keeps some pathways or system in an unused dormant state during normal operations. And is able to maintain consistent capacity during abnormal conditions."
  },
  {
    "id": 2346,
    "topic_id": 200,
    "title": "Understand how email security works.",
    "description": "Internet email is based on SMTP, POP3, and IMAP. It is inherently insecure. It can be secured, but the methods used must be addressed in a security policy. Email security solutions include using S/MIME, PGP, DKIM, SPF, DMARC, STARTTLS, and Implicit SMTPS."
  },
  {
    "id": 2347,
    "topic_id": 200,
    "title": "Know how to\u00a0protect data communications.",
    "description": "Protections should include implementations of secure VoIP, VPNs, VLANs, and NAT."
  },
  {
    "id": 2348,
    "topic_id": 200,
    "title": "Understand virtualized networks.",
    "description": "A virtualized network or network virtualization is the combination of hardware and software networking components into a single integrated entity. Examples include software-defined networks (SDNs), VLANs, VPNs, virtual switches, virtual SANs, guest operating systems, port isolation, and NAT."
  },
  {
    "id": 2349,
    "topic_id": 200,
    "title": "Define tunneling.",
    "description": "Tunneling is the encapsulation of a protocol-deliverable message within a second protocol. The second protocol often performs encryption to protect the message contents."
  },
  {
    "id": 2350,
    "topic_id": 200,
    "title": "Understand VPNs.",
    "description": "VPNs are based on encrypted tunneling. They can offer authentication and data protection as a point-to-point solution. Common VPN protocols are PPTP, L2TP, SSH, TLS, and IPsec."
  },
  {
    "id": 2351,
    "topic_id": 200,
    "title": "Understand split vs. full tunnel.",
    "description": "A split tunnel is a VPN configuration that allows a  VPN-connected client system (i.e., remote node) to access both the organizational network over the VPN and the internet directly at the same time. A full tunnel is a VPN configuration in which all of the client's traffic is sent to the organizational network over the VPN link, and then any internet-destined traffic is routed out of the organizational network's proxy or firewall interface to the internet."
  },
  {
    "id": 2352,
    "topic_id": 200,
    "title": "Be able to\u00a0explain NAT.",
    "description": "NAT protects the addressing scheme of a private network, allows the use of the private IP addresses, and enables multiple internal clients to obtain internet access through a few public IP addresses. NAT is supported by many security border devices, such as firewalls, routers, gateways, WAPs, and proxies."
  },
  {
    "id": 2353,
    "topic_id": 200,
    "title": "Know about third-party connectivity.",
    "description": "Most organizations interact with outside third-party providers. Most of these external entities do not need to interact directly with an organization's IT/IS. However, for those few that do, it is important to consider the risks and ramifications. This includes partnerships, cloud services, and remote workers."
  },
  {
    "id": 2354,
    "topic_id": 200,
    "title": "Understand the\u00a0difference between packet switching and\u00a0circuit switching.",
    "description": "In circuit switching, a dedicated physical pathway is created between the two communicating parties. Packet switching occurs when the message or communication is broken up into small segments and sent across the intermediary networks to the destination. Within packet-switching systems are two types of communication paths, or virtual circuits: permanent virtual circuits (PVCs) and switched virtual circuits (SVCs)."
  },
  {
    "id": 2355,
    "topic_id": 200,
    "title": "Understand the\u00a0various network attacks and\u00a0countermeasures associated with\u00a0communications security.",
    "description": "Communication systems are vulnerable to many attacks, including distributed denial-of-service (DDoS), eavesdropping, impersonation, replay, modification, spoofing, and ARP and DNS attacks. Be able to supply effective countermeasures for each."
  },
  {
    "id": 2358,
    "topic_id": 200,
    "title": "Know the\u00a0difference between subjects and\u00a0objects.",
    "description": "You'll find that CISSP questions and security documentation commonly use the terms subject and object, so it's important to know the difference between them. Subjects are active entities (such as users) that access passive objects (such as files). A user is a subject who accesses objects while performing some action or accomplishing a work task."
  },
  {
    "id": 2359,
    "topic_id": 200,
    "title": "Know the\u00a0difference between identification and\u00a0authentication.",
    "description": "Access controls depend on effective identification and authentication. Subjects claim an identity, and identification can be as simple as a username for a user. Subjects prove their identity by providing authentication credentials such as the matching password for a username. People, devices, and services all verify their identity by giving proper credentials."
  },
  {
    "id": 2360,
    "topic_id": 200,
    "title": "Understand the\u00a0establishment of\u00a0identity, registration, and\u00a0proofing.",
    "description": "New employees establish their identity with official documentation such as a passport, driver's license, or birth certificate. HR personnel then begin the registration process, which includes creating an account for new employees. When biometric authentication is used, the registration process also collects biometric data. Identity proofing includes knowledge-based authentication and cognitive passwords. These ask users a series of questions that only the user would know."
  },
  {
    "id": 2361,
    "topic_id": 200,
    "title": "Understand the\u00a0difference between authorization and\u00a0accountability.",
    "description": "After authenticating subjects, systems authorize access to objects based on their proven identity. Auditing logs and audit trails record events, including the identity of the subject that performed an action. The combination of effective identification, authentication, and auditing provides accountability."
  },
  {
    "id": 2362,
    "topic_id": 200,
    "title": "Understand the\u00a0details of\u00a0the primary authentication factors.",
    "description": "The three primary factors of authentication are something you know (such as a password or PIN), something you have (such as a smartcard or token), and something you are (based on biometrics). Multifactor authentication (MFA) includes two or more authentication factors, and using MFA is more secure than using a single authentication factor. Passwords are the weakest form of authentication, but password policies help increase their security by enforcing complexity and history requirements. Smartcards include microprocessors and cryptographic certificates, and tokens create onetime passwords. Biometric methods identify users based on characteristics such as fingerprints. The crossover error rate (CER) identifies the accuracy of a biometric method and shows where the false rejection rate (FRR) is equal to the false acceptance rate (FAR)."
  },
  {
    "id": 2364,
    "topic_id": 200,
    "title": "Describe how federated identity systems are implemented.",
    "description": "FIM systems are implemented on-premises (providing the most control), via a third-party cloud service, or as a hybrid of both."
  },
  {
    "id": 2365,
    "topic_id": 200,
    "title": "Describe just-in-time (JIT) provisioning.",
    "description": "JIT provisioning creates user accounts on thirdparty sites the first time a user logs onto the site. JIT reduces the administrative workload."
  },
  {
    "id": 2366,
    "topic_id": 200,
    "title": "Know about credential management systems.",
    "description": "Credential management systems help developers easily store usernames and passwords and retrieve them when a user revisits a website. The W3C published the Credential Management API as a working draft in 2019, and developers commonly use it as a credential management system. It allows users to log on automatically to websites without entering their credentials again."
  },
  {
    "id": 2367,
    "topic_id": 200,
    "title": "Explain session management.",
    "description": "Session management processes help prevent unauthorized access by closing unattended sessions. Developers commonly use web frameworks to implement session management. These frameworks allow developers to ensure sessions are closed after a specific amount of inactivity, such as after 2\u00a0minutes."
  },
  {
    "id": 2368,
    "topic_id": 200,
    "title": "Understand the\u00a0identity and\u00a0access provisioning lifecycle.",
    "description": "The identity and access provisioning lifecycle refers to the creation, management, and deletion of accounts. Provisioning ensures that accounts have appropriate privileges based on task requirements and employees receive any needed hardware. Onboarding processes inform employees of organizational processes. Deprovisioning processes disable or delete an account when employees leave, and offboarding processes ensure that employees return all the hardware an organization issued to them."
  },
  {
    "id": 2369,
    "topic_id": 200,
    "title": "Explain the\u00a0importance of\u00a0role definition.",
    "description": "When an organization creates new job roles, it's important to identify privileges needed by anyone in these new roles. Doing so ensures that employees in these new roles do not have excessive privileges."
  },
  {
    "id": 2370,
    "topic_id": 200,
    "title": "Describe the\u00a0purpose of\u00a0account access reviews.",
    "description": "Account access reviews are performed on user accounts, system accounts, and service accounts. These reviews ensure that accounts don't have excessive privileges. They can often detect when accounts have excessive privileges and when unused accounts have not been disabled or deleted."
  },
  {
    "id": 2371,
    "topic_id": 200,
    "title": "Identify common authorization mechanisms.",
    "description": "Authorization ensures that the requested activity or object access is possible, given the authenticated identity's privileges. For example, it ensures that users with appropriate privileges can access files and other resources. Common authorization mechanisms include implicit deny, access control lists, access control matrixes, capability tables, constrained interfaces, content- dependent controls, and context- dependent controls. These mechanisms enforce security principles such as need to know, the principle of least privilege, and separation of duties."
  },
  {
    "id": 2372,
    "topic_id": 200,
    "title": "Describe key concepts of\u00a0the Discretionary Access Control (DAC) model.",
    "description": "With the DAC model, all objects have owners, and the owners can modify permissions. Each object has an access control list defining permissions, such as read and modify for files. All other models are nondiscretionary models, and administrators centrally manage nondiscretionary controls."
  },
  {
    "id": 2373,
    "topic_id": 200,
    "title": "Describe key concepts of\u00a0the Role- Based Access Control (RBAC) model.",
    "description": "RBAC models use task- based roles, and users gain privileges when administrators place their accounts into a role or group. Taking a user out of a role removes the permissions granted through the role membership."
  },
  {
    "id": 2374,
    "topic_id": 200,
    "title": "Describe key concepts of\u00a0the rule- based access control model.",
    "description": "Rule- based access control models use a set of rules, restrictions, or filters to determine access. A firewall's access control list includes a list of rules that define what access is allowed and what access is blocked."
  },
  {
    "id": 2375,
    "topic_id": 200,
    "title": "Describe key concepts of\u00a0the Attribute- Based Access Control (ABAC) model.",
    "description": "An ABAC model is an advanced implementation of a rule- based access control model, applying rules based on attributes. Software- defined networks (SDNs) often use an ABAC model."
  },
  {
    "id": 2376,
    "topic_id": 200,
    "title": "Describe key concepts of\u00a0the Mandatory Access Control (MAC) model.",
    "description": "The MAC model uses labels to identify security domains. Subjects need matching labels to access objects. The MAC model enforces the need to know principle and supports a hierarchical environment, a compartmentalized environment, or a combination of both in a hybrid environment. It is frequently referred to as a lattice- based model."
  },
  {
    "id": 2377,
    "topic_id": 200,
    "title": "Describe key concepts of\u00a0the risk- based access control model.",
    "description": "A risk- based access control model evaluates the environment and the situation, and makes decisions based on software- based security policies. It can control access based on multiple factors such as a user's location, determined by IP addresses, whether the user has logged on with multifactor authentication, and the user's device. Advanced implementations can use machine learning to evaluate risk."
  },
  {
    "id": 2378,
    "topic_id": 200,
    "title": "Understand single sign- on methods used on\u00a0the internet.",
    "description": "Single sign- on (SSO) is a mechanism that allows subjects to authenticate once and access multiple objects without authenticating again. Security Assertion Markup Language (SAML) is an open XML- based standard used to exchange authentication and authorization information. OAuth 2.0 is an authorization framework described in RFC 6749 and supported by many online sites. OASIS maintains OpenID and OpenID Connect (OIDC). OpenID provides authentication. OIDC provides both authentication and authorization by using the OAuth framework and building on the OpenID standard."
  },
  {
    "id": 2379,
    "topic_id": 200,
    "title": "Describe Kerberos.",
    "description": "Kerberos is the most common SSO method used within organizations. The primary purpose of Kerberos is authentication. It uses symmetric cryptography and tickets to prove identification and provide authentication. One server synchronizes its time with a Network Time Protocol (NTP) server, and all clients within a network synchronize with the same time."
  },
  {
    "id": 2380,
    "topic_id": 200,
    "title": "Understand the\u00a0purpose of\u00a0AAA protocols.",
    "description": "Several protocols provide centralized authentication, authorization, and accounting services. Network access (or remote access) systems use AAA protocols. For example, a network access server is a client to a RADIUS server, and the RADIUS server provides AAA services. RADIUS uses UDP and encrypts the password only. TACACS+ uses TCP and encrypts the entire session. Diameter is based on RADIUS and improves many of the weaknesses of RADIUS, but Diameter is not compatible with RADIUS."
  },
  {
    "id": 2381,
    "topic_id": 200,
    "title": "Describe privilege escalation.",
    "description": "Attackers use privilege escalation techniques to gain additional privileges after exploiting a single system. They typically try to gain additional privileges on the exploited systems first. They can also reach other systems in a network and attempt to gain elevated privileges on them. Limiting privileges given to service accounts reduces the success of some privilege escalation attacks. This includes minimizing the use of the sudo account."
  },
  {
    "id": 2382,
    "topic_id": 200,
    "title": "Know about pass- the- hash attacks.",
    "description": "Pass- the- hash attacks allow an attacker to impersonate a user with the captured hash of a user's password instead of the user's password. Pass- the- hash attacks typically exploit NTLM vulnerabilities, but attackers also use similar attacks against other protocols, including Kerberos."
  },
  {
    "id": 2383,
    "topic_id": 200,
    "title": "Know about Kerberos exploitation attacks.",
    "description": "Kerberos attacks attempt to exploit weaknesses in Kerberos tickets. In some attacks, they capture tickets held in the lsass.exe process and use them in pass- the- ticket attacks. A silver ticket grants the attacker all the privileges granted to a service account. Attackers can create golden tickets after obtaining the hash of the Kerberos service account (KRBTGT), giving them the ability to create tickets at will within Active Directory."
  },
  {
    "id": 2384,
    "topic_id": 200,
    "title": "Know how brute- force and\u00a0dictionary attacks work.",
    "description": "Brute- force and dictionary attacks are carried out against a stolen password database file or the system's logon prompt. They are designed to discover passwords. In brute- force attacks, all possible combinations of keyboard characters are used, whereas a predefined list of possible passwords is used in a dictionary attack. Account lockout controls prevent their effectiveness against online attacks."
  },
  {
    "id": 2385,
    "topic_id": 200,
    "title": "Understand how salt and\u00a0pepper thwart password attacks.",
    "description": "Salting adds additional bits to a password before hashing it and helps thwart rainbow table attacks. Some algorithms, such as Argon2, bcrypt, and Password- Based Key Derivation Function 2 (PBKDF2), add the salt and repeat the hashing functions many times. Salts are stored in the same database as the hashed password. A pepper is a large constant number used to increase the security of the hashed password further, and it is stored somewhere outside the database holding the hashed passwords."
  },
  {
    "id": 2386,
    "topic_id": 200,
    "title": "Understand sniffer attacks.",
    "description": "In a sniffer attack (or snooping attack), an attacker uses a packet- capturing tool (such as a sniffer or protocol analyzer) to capture, analyze, and read data sent over a network. Attackers can easily read data sent over a network in cleartext, but encrypting data in transit thwarts this type of attack."
  },
  {
    "id": 2387,
    "topic_id": 200,
    "title": "Understand spoofing attacks.",
    "description": "Spoofing is pretending to be something or someone else, and it is used in many types of attacks, including access control attacks. Attackers often try to obtain the credentials of users so that they can spoof the user's identity. Spoofing attacks include email spoofing, phone number spoofing, and IP spoofing. Many phishing attacks use spoofing methods."
  },
  {
    "id": 2388,
    "topic_id": 200,
    "title": "Understand the\u00a0importance of\u00a0security assessment and\u00a0testing programs.",
    "description": "Security assessment and testing programs provide an important mechanism for validating the ongoing effectiveness of security controls. They include a variety of tools, such as vulnerability assessments, penetration tests, software testing, audits, and security management tasks designed to validate controls. Every organization should have a security assessment and testing program defined and operational."
  },
  {
    "id": 2389,
    "topic_id": 200,
    "title": "Conduct vulnerability assessments and\u00a0penetration tests.",
    "description": "Vulnerability assessments use automated tools to search for known vulnerabilities in systems, applications, and networks. These flaws may include missing patches, misconfigurations, or faulty code that expose the organization to security risks. Penetration tests also use these same tools but supplement them with attack techniques where an assessor attempts to exploit vulnerabilities and gain access to the system. Vulnerability management programs take the results of these tests as inputs and then implement a risk management process for identified vulnerabilities."
  },
  {
    "id": 2390,
    "topic_id": 200,
    "title": "Perform software testing to\u00a0validate code moving into production.",
    "description": "Software testing techniques verify that code functions as designed and does not contain security flaws. Code review uses a peer review process to formally or informally validate code before deploying it in production. Interface testing assesses the interactions between components and users with API testing, user interface testing, and physical interface testing."
  },
  {
    "id": 2391,
    "topic_id": 200,
    "title": "Understand the\u00a0difference between static and\u00a0dynamic software testing.",
    "description": "Static software testing techniques, such as code reviews, evaluate the security of software without running it by analyzing either the source code or the compiled application. Dynamic testing evaluates the security of software in a runtime environment and is often the only option for organizations deploying applications written by someone else."
  },
  {
    "id": 2392,
    "topic_id": 200,
    "title": "Explain the\u00a0concept of\u00a0fuzzing.",
    "description": "Fuzzing uses modified inputs to test software performance under unexpected circumstances. Mutation fuzzing modifies known inputs to generate synthetic inputs that may trigger unexpected behavior. Generational fuzzing develops inputs based on models of expected inputs to perform the same task."
  },
  {
    "id": 2393,
    "topic_id": 200,
    "title": "Perform security management tasks to\u00a0provide oversight to\u00a0the information security program.",
    "description": "Security managers must perform a variety of activities to retain proper oversight of the information security program. Log reviews, particularly for administrator activities, ensure that systems are not misused. Account management reviews ensure that only authorized users retain access to information systems. Backup verification ensures that the organization's data protection process is functioning properly. Key performance and risk indicators provide a high- level view of security program effectiveness."
  },
  {
    "id": 2394,
    "topic_id": 200,
    "title": "Conduct or facilitate internal and\u00a0third- party audits.",
    "description": "Security audits occur when a third party performs an assessment of the security controls protecting an organization's information assets. Internal audits are performed by an organization's internal staff and are intended for management use. External audits are performed by a third- party audit firm and are generally intended for the organization's governing body."
  },
  {
    "id": 2395,
    "topic_id": 200,
    "title": "Collect security process data.",
    "description": "Many components of the information security program generate data that is crucial to security assessment processes. These components include the account management process, management review and approval, key performance and risk indicators, backup verification data, training and awareness metrics, and the data generated by disaster recovery and business continuity programs."
  },
  {
    "id": 2396,
    "topic_id": 200,
    "title": "Know the\u00a0difference between need to\u00a0know and\u00a0the least privilege principle.",
    "description": "Need to know and the least privilege principle are two standard IT security principles implemented in secure networks. They limit access to data and systems so that users and other subjects can access only what they require. This limited access helps prevent security incidents and helps limit the scope of incidents when they occur. When these principles are not followed, security incidents result in far greater damage to an organization."
  },
  {
    "id": 2397,
    "topic_id": 200,
    "title": "Understand separation of\u00a0duties and\u00a0job rotation.",
    "description": "Separation of duties (SoD) is a basic security principle that ensures that no single person can control all critical functions or system elements. With job rotation, employees are rotated into different jobs, or tasks are assigned to different employees. Collusion is an agreement among multiple persons to perform some unauthorized or illegal actions. Implementing these policies helps prevent fraud by limiting actions individuals can do without colluding with others."
  },
  {
    "id": 2398,
    "topic_id": 200,
    "title": "Know about monitoring privileged operations.",
    "description": "Privileged entities are trusted, but they can abuse their privileges. Because of this, it's essential to monitor all assignment of privileges and the use of privileged operations. The goal is to ensure that trusted employees do not abuse the special privileges they are granted. Monitoring these operations can also detect many attacks because attackers commonly use special privileges during an attack. Advanced privileged account management practices can limit the time users have advanced privileges."
  },
  {
    "id": 2399,
    "topic_id": 200,
    "title": "Understand service- level agreements.",
    "description": "Organizations use service- level agreements (SLAs) with outside entities such as vendors. They stipulate performance expectations such as maximum downtimes and often include penalties if the vendor doesn't meet expectations."
  },
  {
    "id": 2400,
    "topic_id": 200,
    "title": "Describe personnel safety and\u00a0security concerns.",
    "description": "Duress systems allow guards to raise alarms in response to emergencies, and emergency management plans help the organization respond to disasters. When employees travel, employees need to be aware of the risks, especially if they travel to different counties. Safety training and awareness programs ensure employees know about these risks and ways to mitigate them."
  },
  {
    "id": 2401,
    "topic_id": 200,
    "title": "Understand secure provisioning concepts.",
    "description": "Secure provisioning of resources includes ensuring that resources are deployed in a secure manner and are maintained in a secure manner throughout their lifecycles. Asset management tracks tangible assets (hardware and software) and intangible assets (such as patents, trademarks, the company's goodwill, and copyrights)."
  },
  {
    "id": 2402,
    "topic_id": 200,
    "title": "Know how to\u00a0manage and\u00a0protect media.",
    "description": "Media management techniques track media used to hold sensitive data. Media is protected throughout its lifetime and destroyed when it's no longer needed."
  },
  {
    "id": 2403,
    "topic_id": 200,
    "title": "Know the\u00a0difference between SaaS, PaaS, and\u00a0IaaS.",
    "description": "Software as a service (SaaS) models provide fully functional applications typically accessible via a web browser. Platform as a service (PaaS) models provide consumers with a computing platform, including hardware, operating systems, and a runtime environment. Infrastructure as a service (IaaS) models provide basic computing resources such as servers, storage, and networking resources."
  },
  {
    "id": 2404,
    "topic_id": 200,
    "title": "Recognize security issues with\u00a0managed services in\u00a0the cloud.",
    "description": "Managed services in the cloud include any resources stored in or accessed via the cloud. Storing data in the cloud increases the risk, so additional steps may be necessary to protect the data, depending on its value. When leasing cloud- based services, you must understand who is responsible for maintenance and security. The cloud service provider provides the least amount of maintenance and security in the IaaS model."
  },
  {
    "id": 2405,
    "topic_id": 200,
    "title": "Explain configuration and\u00a0change control management.",
    "description": "Many outages and incidents can be prevented with effective configuration and change management programs. Configuration management (CM) ensures that systems are configured similarly and the configurations of systems are known and documented. Baselining ensures that systems are deployed with a common baseline or starting point, and imaging is a common baselining method. Change management helps reduce outages or weakened security from unauthorized changes. A change management process requires changes to be requested, approved, tested, and documented. Versioning uses a labeling or numbering system to track changes in updated versions of software."
  },
  {
    "id": 2406,
    "topic_id": 200,
    "title": "Understand patch management.",
    "description": "Patch management ensures that systems are kept up to date with current patches. You should know that an effective patch management program will evaluate, test, approve, and deploy patches. Additionally, be aware that system audits verify the deployment of approved patches to systems. Patch management is often intertwined with change and configuration management to ensure that documentation reflects the changes. When an organization does not have an effective patch management program, it will often experience outages and incidents from known issues that could have been prevented."
  },
  {
    "id": 2407,
    "topic_id": 200,
    "title": "Explain vulnerability management.",
    "description": "Vulnerability management includes routine vulnerability scans and periodic vulnerability assessments. Vulnerability scanners can detect known security vulnerabilities and weaknesses such as the absence of patches or weak passwords. They generate reports that indicate the technical vulnerabilities of a system and are an effective check for a patch management program. Vulnerability assessments extend beyond just technical scans and can include reviews and audits to detect vulnerabilities."
  },
  {
    "id": 2408,
    "topic_id": 200,
    "title": "List and\u00a0describe incident management steps.",
    "description": "The CISSP Security Operations domain lists incident management steps as detection, response, mitigation, reporting, recovery, remediation, and lessons learned. After detecting and verifying an incident, the first response is to limit or contain the scope of the incident while protecting evidence. Based on governing laws, an organization may need to report an incident to official authorities, and if PII is affected, individuals need to be informed. The remediation and lessons learned stages include root cause analysis to determine the cause and recommend solutions to prevent a reoccurrence."
  },
  {
    "id": 2409,
    "topic_id": 200,
    "title": "Understand basic preventive measures.",
    "description": "Basic preventive measures can prevent many incidents from occurring. These include keeping systems up to date, removing or disabling unneeded protocols and services, using intrusion detection and prevention systems, using antimalware software with up- to- date signatures, and enabling both host- based and network- based firewalls."
  },
  {
    "id": 2410,
    "topic_id": 200,
    "title": "Know the\u00a0difference between whitelisting and\u00a0blacklisting.",
    "description": "Software whitelists provide a list of approved software and prevent the installation of any other software not on the list. Blacklists provide a list of unapproved software and prevent the installation of any software on the list."
  },
  {
    "id": 2411,
    "topic_id": 200,
    "title": "Understand sandboxing.",
    "description": "Sandboxing provides an isolated environment and prevents code running in a sandbox from interacting with elements outside of a sandbox."
  },
  {
    "id": 2412,
    "topic_id": 200,
    "title": "Know about third- party provided security services.",
    "description": "Third- party security services help an organization augment security services provided by internal employees. Many organizations use cloud- based solutions to augment their internal security."
  },
  {
    "id": 2413,
    "topic_id": 200,
    "title": "Understand botnets, botnet controllers, and\u00a0bot herders.",
    "description": "Botnets represent significant threats due to the massive number of computers that can launch attacks, so it's important to know what they are. A botnet is a collection of compromised computing devices (often called bots or zombies) organized in a network controlled by a criminal known as a bot herder. Bot herders use a command- and- control server to remotely control the zombies and often use the botnet to launch attacks on other systems or send spam or phishing emails. Bot herders also rent botnet access out to other criminals."
  },
  {
    "id": 2414,
    "topic_id": 200,
    "title": "Know about denial- of- service (DoS) attacks.",
    "description": "DoS attacks prevent a system from responding to legitimate requests for service. A common DoS attack is the SYN flood attack, which disrupts the TCP three- way handshake. Even though older attacks are not as common today because basic precautions block them, you may still be tested on them because many newer attacks are often variations on older methods. Smurf attacks employ an amplification network to send numerous response packets to a victim. Ping- of- death attacks send numerous oversized ping packets to the victim, causing the victim to freeze, crash, or reboot."
  },
  {
    "id": 2415,
    "topic_id": 200,
    "title": "Understand zero- day exploits.",
    "description": "A zero- day exploit is an attack that uses a vulnerability that is either unknown to anyone but the attacker or known only to a limited group of people. On the surface, it sounds like you can't protect against an unknown vulnerability, but basic security practices go a long way toward preventing zero- day exploits. Removing or disabling unneeded protocols and services reduces the attack surface, enabling firewalls blocks many access points, and using intrusion detection and prevention systems helps detect and block potential attacks. Additionally, using tools such as honeypots helps protect live networks."
  },
  {
    "id": 2416,
    "topic_id": 200,
    "title": "Understand man- in- the- middle attacks.",
    "description": "A man- in- the- middle attack (sometimes called an on- path attack) occurs when a malicious user is able to gain a logical position between the two endpoints of a communications link. Although it takes a significant amount of sophistication on the part of an attacker to complete a man- in- the middle attack, the amount of data obtained from the attack can be significant."
  },
  {
    "id": 2417,
    "topic_id": 200,
    "title": "Understand intrusion detection and\u00a0intrusion prevention.",
    "description": "IDSs and IPSs are important detective and preventive measures against attacks. Know the difference between knowledge- based detection (using a database similar to antimalware signatures) and behavior- based detection. Behavior- based detection starts with a baseline to recognize normal behavior and compares activity with the baseline to detect abnormal activity. The baseline can be outdated if the network is modified, so it must be updated when the environment changes."
  },
  {
    "id": 2418,
    "topic_id": 200,
    "title": "Recognize IDS/IPS responses.",
    "description": "An IDS can respond passively by logging and sending notifications or actively by changing the environment. Some people refer to an active IDS as an IPS. However, it's important to recognize that an IPS is placed inline with the traffic and includes the ability to block malicious traffic before it reaches the target."
  },
  {
    "id": 2419,
    "topic_id": 200,
    "title": "Understand the\u00a0differences between HIDSs and\u00a0NIDSs.",
    "description": "Host- based IDSs (HIDSs) can monitor activity on a single system only. A drawback is that attackers can discover and disable them. A network- based IDS (NIDS) can monitor activity on a network, and an NIDS isn't as visible to attackers."
  },
  {
    "id": 2420,
    "topic_id": 200,
    "title": "Describe honeypots and\u00a0honeynets.",
    "description": "A honeypot is a system that typically has pseudo flaws and fake data to lure intruders. A honeynet is two or more honeypots in a network. Administrators can observe attackers' activity while they are in the honeypot, and as long as attackers are in the honeypot, they are not in the live network."
  },
  {
    "id": 2421,
    "topic_id": 200,
    "title": "Understand the\u00a0methods used to\u00a0block malicious code.",
    "description": "Malicious code is thwarted with a combination of tools. The obvious tool is antimalware software with up- to- date definitions installed on each system, at the boundary of the network, and on email servers. However, policies that enforce basic security principles, such as the least privilege principle, prevent regular users from installing potentially malicious software. Additionally, educating users about the risks and the methods attackers commonly use to spread viruses helps users understand and avoid dangerous behaviors."
  },
  {
    "id": 2422,
    "topic_id": 200,
    "title": "Know the\u00a0types of\u00a0log files.",
    "description": "Log data is recorded in databases and different types of log files. Common log files include security logs, system logs, application logs, firewall logs, proxy logs, and change management logs. Log files should be protected by centrally storing them and using permissions to restrict access, and archived logs should be set to read- only to prevent modifications."
  },
  {
    "id": 2423,
    "topic_id": 200,
    "title": "Understand monitoring and\u00a0uses of\u00a0monitoring tools.",
    "description": "Monitoring is a form of auditing that focuses on active review of the log file data. Monitoring is used to hold subjects accountable for their actions and to detect abnormal or malicious activities. It is also used to monitor system performance. Monitoring tools such as IDSs or SIEMs automate continuous monitoring and provide real- time analysis of events, including monitoring what happens inside a network, traffic entering a network, and traffic leaving a network (also known as egress monitoring). Log management includes analyzing logs and archiving logs."
  },
  {
    "id": 2424,
    "topic_id": 200,
    "title": "Be able to\u00a0explain audit trails.",
    "description": "Audit trails are the records created by recording information about events and occurrences into one or more databases or log files. They are used to reconstruct an event, extract information about an incident, and prove or disprove culpability. Using audit trails is a passive form of detective security control, and audit trails are essential evidence in criminals' prosecution."
  },
  {
    "id": 2425,
    "topic_id": 200,
    "title": "Understand how to\u00a0maintain accountability.",
    "description": "Accountability is maintained for individual subjects through the use of auditing. Logs record user activities and users can be held accountable for their logged actions. This directly promotes good user behavior and compliance with the organization's security policy."
  },
  {
    "id": 2426,
    "topic_id": 200,
    "title": "Understand sampling and\u00a0clipping.",
    "description": "Sampling, or data extraction, is the process of extracting elements from a large body of data to construct a meaningful representation or summary of the whole. Statistical sampling uses precise mathematical functions to extract meaningful information from a large volume of data. Clipping is a form of nonstatistical sampling that records only events that exceed a threshold."
  },
  {
    "id": 2427,
    "topic_id": 200,
    "title": "Describe threat feeds and\u00a0threat hunting.",
    "description": "Threat feeds provide organizations with a steady stream of raw data. By analyzing threat feeds, security administrators can learn of current threats. They can then use this knowledge to search through the network, looking for signs of these threats."
  },
  {
    "id": 2428,
    "topic_id": 200,
    "title": "Know the\u00a0relationship between machine learning (ML) and\u00a0artificial intelligence (AI).",
    "description": "ML is a part of AI and refers to a system's ability to learn. AI is a broad topic that includes ML."
  },
  {
    "id": 2429,
    "topic_id": 200,
    "title": "Know the\u00a0benefits of\u00a0SOAR.",
    "description": "SOAR technologies automate responses to incidents. One of the primary benefits is that this reduces the workload of administrators. It also removes the possibility of human error by having computer systems respond."
  },
  {
    "id": 2430,
    "topic_id": 200,
    "title": "Know the\u00a0common types of\u00a0natural disasters that may threaten an\u00a0organization.",
    "description": "Natural disasters that commonly threaten organizations include earthquakes, floods, storms, fires, tsunamis, and volcanic eruptions."
  },
  {
    "id": 2431,
    "topic_id": 200,
    "title": "Know the\u00a0common types of\u00a0human- made disasters that may threaten an\u00a0organization.",
    "description": "Explosions, electrical fires, terrorist acts, power outages, other utility failures, infrastructure failures, hardware/software failures, labor difficulties, theft, and vandalism are all common human- made disasters."
  },
  {
    "id": 2432,
    "topic_id": 200,
    "title": "Be familiar with\u00a0the common types of\u00a0recovery facilities.",
    "description": "The common types of recovery facilities are cold sites, warm sites, hot sites, mobile sites, and multiple sites. Be sure you understand the benefits and drawbacks of each such facility."
  },
  {
    "id": 2433,
    "topic_id": 200,
    "title": "Explain the\u00a0potential benefits behind mutual assistance agreements as\u00a0well as\u00a0the reasons they are not commonly implemented in\u00a0businesses today.",
    "description": "Mutual assistance agreements (MAAs) provide an inexpensive alternative to disaster recovery sites, but they are not commonly used because they are difficult to enforce. Organizations participating in an MAA may also be shut down by the same disaster, and MAAs raise confidentiality concerns."
  },
  {
    "id": 2434,
    "topic_id": 200,
    "title": "Understand the\u00a0technologies that may assist with\u00a0database backup.",
    "description": "Databases benefit from three backup technologies. Electronic vaulting is used to transfer database backups to a remote site as part of a bulk transfer. In remote journaling, data transfers occur on a more frequent basis. With remote mirroring technology, database transactions are mirrored at the backup site in real time."
  },
  {
    "id": 2435,
    "topic_id": 200,
    "title": "Explain the\u00a0common processes used in\u00a0disaster recovery programs.",
    "description": "These programs should take a comprehensive approach to planning and include considerations related to the initial response effort, personnel involved, communication among the team members and with internal and external entities, assessment of response efforts, and restoration of services. DR programs should also include training and awareness efforts to ensure personnel understand their responsibilities and lessons learned sessions to continuously improve the program."
  },
  {
    "id": 2436,
    "topic_id": 200,
    "title": "Know the\u00a0five types of\u00a0disaster recovery plan tests and\u00a0the impact each has on\u00a0normal business operations.",
    "description": "The five types of disaster recovery plan tests are read- through tests, structured walk- throughs, simulation tests, parallel tests, and full- interruption tests. Checklist tests are purely paperwork exercises, whereas structured walk- throughs involve a project team meeting. Neither has an impact on business operations. Simulation tests may shut down noncritical business units. Parallel tests involve relocating personnel but do not affect day- to- day operations. Full- interruption tests involve shutting down primary systems and shifting responsibility to the recovery facility."
  },
  {
    "id": 2437,
    "topic_id": 200,
    "title": "Know the\u00a0definition of\u00a0computer crime.",
    "description": "Computer crime is a crime (or violation of a law or regulation) that is directed against, or directly involves, a computer."
  },
  {
    "id": 2438,
    "topic_id": 200,
    "title": "Be able to\u00a0list and\u00a0explain the\u00a0six categories of\u00a0computer crimes.",
    "description": "Computer crimes are grouped into six categories: military and intelligence attack, business attack, financial attack, terrorist attack, grudge attack, and thrill attack. Be able to explain the motive of each type of attack."
  },
  {
    "id": 2439,
    "topic_id": 200,
    "title": "Know the\u00a0importance of\u00a0collecting evidence.",
    "description": "As soon you discover an incident, you must begin to collect evidence and as much information about the incident as possible. The evidence can be used in a subsequent legal action or in finding the identity of the attacker. Evidence can also assist you in determining the extent of damage."
  },
  {
    "id": 2440,
    "topic_id": 200,
    "title": "Understand the\u00a0eDiscovery process.",
    "description": "Organizations that believe they will be the target of a lawsuit have a duty to preserve digital evidence in a process known as electronic discovery, or eDiscovery. The eDiscovery process includes information governance, identification, preservation, collection, processing, review, analysis, production, and presentation activities."
  },
  {
    "id": 2441,
    "topic_id": 200,
    "title": "Know how to\u00a0investigate intrusions and\u00a0how to\u00a0gather sufficient artifacts from\u00a0the equipment, software, and\u00a0data.",
    "description": "You must have possession of equipment, software, or data to analyze it and use it as evidence. You must acquire the evidence without modifying it or allowing anyone else to modify it."
  },
  {
    "id": 2442,
    "topic_id": 200,
    "title": "Know the\u00a0basic alternatives for\u00a0confiscating evidence and\u00a0when each one is appropriate.",
    "description": "First, the person who owns the evidence could voluntarily surrender it. <br>Second, a subpoena could be used to compel the subject to surrender the evidence. <br>Third, a law enforcement officer performing a legally permissible duty may seize visible evidence that the officer has probable cause to believe is associated with criminal activity. <br>Fourth, a search warrant is most useful when you need to confiscate evidence without giving the subject an opportunity to alter it. <br>Fifth, a law enforcement officer may collect evidence when exigent circumstances exist."
  },
  {
    "id": 2443,
    "topic_id": 200,
    "title": "Know the\u00a0importance of\u00a0retaining investigatory data.",
    "description": "Because you will discover some incidents after they have occurred, you will lose valuable evidence unless you ensure that critical log files are retained for a reasonable period of time. You can retain log files and system status information either in place or in archives."
  },
  {
    "id": 2444,
    "topic_id": 200,
    "title": "Know the\u00a0basic requirements for\u00a0evidence to\u00a0be admissible in\u00a0a court of\u00a0law.",
    "description": "To be admissible, evidence must be relevant to a fact at issue in the case, the fact must be material to the case, and the evidence must be competent or legally collected."
  },
  {
    "id": 2446,
    "topic_id": 200,
    "title": "Understand the\u00a0importance of\u00a0ethics to\u00a0security personnel.",
    "description": "Security practitioners are granted a very high level of authority and responsibility to execute their job functions. The potential for abuse exists, and without a strict code of personal behavior, security practitioners could be regarded as having unchecked power. Adherence to a code of ethics helps ensure that such power is not abused. Security professionals must subscribe to both their own organization's code of ethics as well as the ISC2 Code of Ethics."
  },
  {
    "id": 2447,
    "topic_id": 200,
    "title": "Know the ISC2 Code of Ethics and RFC 1087, Ethics and the Internet.",
    "description": "All CISSP candidates should be familiar with the entire ISC2 Code of Ethics because they have to sign an agreement that they will adhere to it. In addition, be familiar with the basic statements of RFC 1087."
  },
  {
    "id": 2448,
    "topic_id": 200,
    "title": "Explain the\u00a0basic architecture of\u00a0a relational database management system (RDBMS).",
    "description": "Know the structure of relational databases. Be able to explain the function of tables (relations), rows (records/tuples), and columns (fields/attributes). Know how relationships are defined between tables and the roles of various types of keys. Describe the database security threats posed by aggregation and inference."
  },
  {
    "id": 2449,
    "topic_id": 200,
    "title": "Explain how expert systems, machine learning, and\u00a0neural networks function.",
    "description": "Expert systems consist of two main components: a knowledge base that contains a series of \"if/then\" rules and an inference engine that uses that information to draw conclusions about other data. Machine learning techniques attempt to algorithmically discover knowledge from datasets. Neural networks simulate the functioning of the human mind to a limited extent by arranging a series of layered calculations to solve problems. Neural networks require extensive training on a particular problem before they are able to offer solutions."
  },
  {
    "id": 2450,
    "topic_id": 200,
    "title": "Understand the\u00a0models of\u00a0systems development.",
    "description": "Know that the waterfall model describes a sequential development process that results in the development of a finished product. Developers may step back only one phase in the process if errors are discovered. The spiral model uses several iterations of the waterfall model to produce a number of fully specified and tested prototypes. Agile development models place an emphasis on the needs of the customer and quickly developing new functionality that meets those needs in an iterative fashion."
  },
  {
    "id": 2451,
    "topic_id": 200,
    "title": "Explain the\u00a0Scrum approach to\u00a0Agile software development.",
    "description": "Scrum is an organized approach to implementing the Agile philosophy. It relies on daily scrum meetings to organize and review work. Development focuses on short sprints of activity that deliver finished products. Integrated Product Teams (IPTs) are an early effort at this approach that was used by the U.S. Department of Defense."
  },
  {
    "id": 2452,
    "topic_id": 200,
    "title": "Describe software development maturity models.",
    "description": "Know that maturity models help software organizations improve the maturity and quality of their software processes by implementing an evolutionary path from ad hoc, chaotic processes to mature, disciplined software processes. Be able to describe the SW- CMM, IDEAL, and SAMM models."
  },
  {
    "id": 2453,
    "topic_id": 200,
    "title": "Understand the\u00a0importance of\u00a0change and\u00a0configuration management.",
    "description": "Know the three basic components of change control\u2014 request control, change control, and release control\u2014 and how they contribute to security. Explain how configuration management controls the versions of software used in an organization. Understand how the auditing and logging of changes mitigates risk to the organization."
  },
  {
    "id": 2454,
    "topic_id": 200,
    "title": "Understand the\u00a0importance of\u00a0testing.",
    "description": "Software testing should be designed as part of the development process. Testing should be used as a management tool to improve the design, development, and production processes."
  },
  {
    "id": 2455,
    "topic_id": 200,
    "title": "Explain the\u00a0role of\u00a0DevOps and\u00a0DevSecOps in\u00a0the modern enterprise.",
    "description": "DevOps approaches seek to integrate software development and operations activities by embracing automation and collaboration between teams. DevSecOps approaches expand on the DevOps model by introducing security operations activities into the integrated model. Continuous integration and delivery (CI/CD) techniques automate the DevOps and DevSecOps pipelines."
  },
  {
    "id": 2456,
    "topic_id": 200,
    "title": "Know the\u00a0role of\u00a0different coding tools in\u00a0software development ecosystems.",
    "description": "Developers write code in different programming languages, which is then either compiled into machine language or executed through an interpreter. Developers may make use of software development tool sets and integrated development environments to facilitate the code writing process. Software libraries create shared and reusable code, whereas code repositories provide a management platform for the software development process."
  },
  {
    "id": 2457,
    "topic_id": 200,
    "title": "Explain the\u00a0impact of\u00a0acquired software on\u00a0the organization.",
    "description": "Organizations may purchase commercial off- the- shelf (COTS) software to meet their requirements, and they may also rely on free open source software (OSS). All of this software expands the potential attack surface and requires security review and testing."
  },
  {
    "id": 2458,
    "topic_id": 200,
    "title": "Understand the\u00a0propagation techniques used by viruses.",
    "description": "Viruses use four main propagation techniques\u2014 file infection, service injection, boot sector infection, and macro infection\u2014 to penetrate systems and spread their malicious payloads. You need to understand these techniques to effectively protect systems on your network from malicious code."
  },
  {
    "id": 2460,
    "topic_id": 200,
    "title": "Know how antivirus software packages detect known viruses.",
    "description": "Most antivirus programs use signature- based detection algorithms to look for telltale patterns of known viruses. This makes it essential to periodically update virus definition files in order to maintain protection against newly authored viruses as they emerge. Behavior- based detection monitors target users and systems for unusual activity and either blocks it or flags it for investigation."
  },
  {
    "id": 2461,
    "topic_id": 200,
    "title": "Explain how user and\u00a0entity behavior analytics (UEBA) functions.",
    "description": "UEBA tools develop profiles of individual behavior and then monitor users for deviations from those profiles that may indicate malicious activity and/or compromised accounts."
  },
  {
    "id": 2462,
    "topic_id": 200,
    "title": "Be familiar with\u00a0the various types of\u00a0application attacks attackers use to\u00a0exploit poorly written software.",
    "description": "Application attacks are one of the greatest threats to modern computing. Attackers exploit buffer overflows, backdoors, time- of- check- to- time- of- use vulnerabilities, and rootkits to gain illegitimate access to a system. Security professionals must have a clear understanding of each of these attacks and associated countermeasures."
  },
  {
    "id": 2463,
    "topic_id": 200,
    "title": "Understand common web application vulnerabilities and\u00a0countermeasures.",
    "description": "As many applications move to the web, developers and security professionals must understand the new types of attacks that exist in this environment and how to protect against them. The two most common examples are cross- site scripting (XSS) and SQL injection attacks."
  },
  {
    "id": 3000,
    "topic_id": 1,
    "title": "What are the characteristics of qualitative risk analysis?",
    "description": "Qualitative risk analysis assigns subjective and intangible values to the loss of an asset. Qualitative risk analysis is based more on scenarios than calculations. Exact dollar figures are not assigned to possible losses; instead, threats are ranked on a scale to evaluate their risks, costs, and effects. Such an analysis assists those responsible for creating proper risk management policies."
  },
  {
    "id": 3001,
    "topic_id": 1,
    "title": "What are the characteristics of quantitative risk analysis?",
    "description": "Quantitative risk analysis assigns real dollar figures to the loss of an asset. Quantitative risk analysis focuses on hard values and percentages. A complete quantitative analysis is not possible because of intangible aspects of risk. The process involves valuing assets and identifying threats and then determining a threat's potential frequency and the resulting damage, which leads to the risk response tasks of the cost/benefit analysis of safeguards."
  },
  {
    "id": 3002,
    "topic_id": 4,
    "title": "Name six wireless frequency access technologies.",
    "description": "FHSS, DSSS, OFDM, MIMO, TDMA, and CDMA."
  },
  {
    "id": 3003,
    "topic_id": 4,
    "title": "What was the original IEEE standard for Bluetooth? And what is the current standard?",
    "description": "IEEE 802.15.1 originally, now Bluetooth SIG."
  },
  {
    "id": 3004,
    "topic_id": 3,
    "title": "Define reactive threat modeling.",
    "description": "A reactive approach to threat modeling takes place after a product has been created and deployed. This deployment could be in a test or laboratory environment or to the general marketplace. This type of threat modeling is also known as the adversarial approach. This technique of threat modeling is the core concept behind ethical hacking, penetration testing, source code review, and fuzz testing."
  },
  {
    "id": 3005,
    "topic_id": 3,
    "title": "What is IoT?",
    "description": "The Internet of Things (IoT) is a class of devices that are internet-connected in order to provide automation, remote control, or AI processing to appliances or devices. The security issues related to IoT often relate to access and encryption."
  },
  {
    "id": 3006,
    "topic_id": 2,
    "title": "What are the responsibilities of the roles of data custodian, data processor, data administrator, and user?",
    "description": "Data controllers decide what data to process and how to process it. Data processors are often the third-party entities that process data for an organization at the direction of the data processor. Data administrators grant access to data based on guidelines provided by the data owners. A user, or subject, accesses data while performing work tasks. A custodian has day-to-day responsibilities for protecting and storing data."
  },
  {
    "id": 3007,
    "topic_id": 2,
    "title": "What are the responsibilities of the roles of data owner, system owner, and business/mission owner?",
    "description": "The data owner is the person responsible for classifying, labeling, and protecting data. System owners are responsible for the systems that process the data. Business and mission owners own the processes and ensure that the systems provide value to the organization."
  },
  {
    "id": 3008,
    "topic_id": 3,
    "title": "Explain the cryptographic attacks: adversary-in-the-middle (AitM), birthday attack, and replay attack.",
    "description": "The adversary-in-the-middle (AitM), man-in-the-middle (MitM), or on-path, attack fools both parties into communicating with the attacker instead of directly with each other. The birthday attack is an attempt to find collisions in hash functions. The replay attack is an attempt to reuse authentication requests."
  },
  {
    "id": 3009,
    "topic_id": 1,
    "title": "What is silicon root of trust (RoT)?",
    "description": "A silicon root of trust (RoT), also known as a Hardware Root of Trust, is a foundational and tamper-resistant component within a computer's hardware that provides a secure starting point for establishing trust and security in a system. The primary purpose of a silicon RoT is to ensure the integrity, authenticity, and confidentiality of the system's boot process and software."
  },
  {
    "id": 3010,
    "topic_id": 1,
    "title": "What is a physically unclonable function (PUF)?",
    "description": "A physically unclonable function (PUF) is a specialized physical electronic component or function that generates a unique, unpredictable digital identifier based on the inherent physical properties of the component. PUFs are used to provide a hardware-based security feature by creating a unique fingerprint for electronic devices or integrated circuits."
  },
  {
    "id": 3011,
    "topic_id": 1,
    "title": "What is a software bill of materials (SBOM)?",
    "description": "A software bill of materials (SBOM) is a structured and comprehensive inventory or list of all the software components and dependencies that make up a software application or system. An SBOM provides detailed information about the various software components used in a system, including their versions, sources, and relationships. The primary purpose of an SBOM is to enhance software transparency, security, compliance, and management."
  },
  {
    "id": 3012,
    "topic_id": 1,
    "title": "What are the 5 Pillars of Information Security?",
    "description": "The 5 Pillars of Information Security are confidentiality, integrity, availability, authenticity, and nonrepudiation."
  },
  {
    "id": 3013,
    "topic_id": 3,
    "title": "What is defense in breadth or diversity of defense?",
    "description": "Defense in breadth or diversity of defense is also an important related concept to defense in depth. It can be problematic if elements of several security layers are from the same vendor or share common code, since a vulnerability could affect numerous layers simultaneously. By using a range of security products from varied vendors, the risk of a single exploit compromising several layers at once is significantly reduced or avoided."
  },
  {
    "id": 3014,
    "topic_id": 7,
    "title": "What is threat hunting?",
    "description": "Threat hunting is the activity of looking for existing evidence of a compromise once symptoms or an IoC (indicator of compromise) of an exploit become known."
  },
  {
    "id": 3015,
    "topic_id": 3,
    "title": "What is threat modeling?",
    "description": "Threat modeling is the security process where potential threats are identified, categorized, and analyzed. Threat modeling can be performed as a proactive measure during design and development or as a reactive measure once a product has been deployed."
  },
  {
    "id": 3016,
    "topic_id": 1,
    "title": "What are the types and purposes of NDAs?",
    "description": "A unilateral NDA (aka one-way NDA) is used when one party needs to share sensitive data with another party while retaining control and protection over that data. A bilateral NDA (aka mutual NDA or two-way NDA) is a legally binding contract between two parties where both parties agree to protect each other's confidential information. A multilateral NDA is a legal contract involving three or more parties, each of whom agrees to protect and keep confidential the sensitive information shared by the other parties."
  },
  {
    "id": 3017,
    "topic_id": 1,
    "title": "In relation to risk, what is a hazard?",
    "description": "Refers to a potential source or situation that has the capability to cause harm, loss, damage, injury, or adverse consequences to an organization, its assets, individuals, or the environment."
  },
  {
    "id": 3018,
    "topic_id": 1,
    "title": "What are risk perspectives?",
    "description": "Risk perspectives (aka risk management perspectives or approaches) are different lenses through which organizations and individuals can view and address risks. Each perspective emphasizes certain aspects of risk and can guide decision-making, risk assessment, and mitigation strategies. There are innumerable options of risk perspective, including asset, outcome, vulnerability, threat, financial, strategic, operational, compliance, legal, reputational, supply chain, third-party, and workforce."
  },
  {
    "id": 3019,
    "topic_id": 1,
    "title": "In legal and ethical contexts to describe different standards of behavior or decision-making, especially related to risk management, what are prudent actions?",
    "description": "Prudent actions refer to actions or decisions that are marked by a high degree of caution, care, and foresight. They are characterized by careful consideration of potential risks, a focus on preventing harm, and a commitment to acting in a manner that is consistent with established best practices or industry standards."
  },
  {
    "id": 3020,
    "topic_id": 1,
    "title": "In legal and ethical contexts to describe different standards of behavior or decision-making, especially related to risk management, what are reasonable actions?",
    "description": "Reasonable actions refer to actions or decisions that are in line with what a person of ordinary prudence and judgment would do in similar circumstances. These actions are based on the idea of acting in a manner that is sensible, rational, and consistent with societal norms and expectations. Reasonable actions are a standard often used in legal and ethical contexts to assess whether an individual's behavior or decisions meet a minimum threshold of acceptability."
  },
  {
    "id": 3021,
    "topic_id": 1,
    "title": "In the context of a risk management process, what is scope?",
    "description": "Scope refers to the extent or boundaries of a risk management process, project, or assessment. It defines what is included and what is excluded in the risk management efforts. Determining the scope is a critical step in effectively managing and addressing risks, as it helps organizations focus their resources and efforts on the most relevant areas."
  },
  {
    "id": 3022,
    "topic_id": 1,
    "title": "What is cybersecurity insurance (aka cyber insurance or cyber-risk insurance)?",
    "description": "Cybersecurity insurance is a type of insurance policy that provides coverage and financial protection to organizations or individuals in the event of cyber-related incidents, data breaches, or cyberattacks. This form of insurance is designed to help mitigate the financial and legal consequences of cybersecurity breaches, which can result in data loss, financial loss, legal liabilities, and reputational damage."
  },
  {
    "id": 3023,
    "topic_id": 1,
    "title": "Influence campaigns are linked to the distribution of false or misleading content. What types of misleading content are there?",
    "description": "Disinformation, misinformation, propaganda, false information, fake news, and doxing."
  },
  {
    "id": 3024,
    "topic_id": 1,
    "title": "What is disinformation?",
    "description": "Intentionally false or misleading information spread with the purpose of deceiving or manipulating people; often used as a tool for political, ideological, or malicious agendas."
  },
  {
    "id": 3025,
    "topic_id": 1,
    "title": "What is misinformation?",
    "description": "Inaccurate or misleading information that is spread without malicious intent; can be the result of errors, misunderstandings, or the unintentional sharing of false information."
  },
  {
    "id": 3026,
    "topic_id": 1,
    "title": "What is propaganda?",
    "description": "A systematic effort to spread ideas, information, or opinions, often of a biased or misleading nature, to promote a particular cause, political viewpoint, or ideology; aims to shape public perception and behavior."
  },
  {
    "id": 3027,
    "topic_id": 1,
    "title": "What is false information?",
    "description": "Any information that is factually incorrect or inaccurate; can be created or spread unintentionally or intentionally and may or may not have a specific agenda."
  },
  {
    "id": 3028,
    "topic_id": 1,
    "title": "What is fake news?",
    "description": "A term used to describe deliberately fabricated news stories or hoaxes presented as genuine journalism. It can also be used to label genuine, factual, and accurate journalism as false. It often serves to misinform or deceive readers/viewers, and it may be politically motivated or created for profit."
  },
  {
    "id": 3029,
    "topic_id": 1,
    "title": "What is doxing?",
    "description": "Doxing, short for document tracing or dropping documents, involves researching and publishing private or personally identifiable information about an individual, such as their real name, address, contact details, or other sensitive data, often with malicious intent, such as harassment or public shaming. Doxing can also refer to the release of false and fabricated information. Doxing can also be used against organizations."
  },
  {
    "id": 3030,
    "topic_id": 1,
    "title": "What is micro training?",
    "description": "Micro training involves delivering short, focused, and bite-sized learning modules or content to learners. These brief learning units are typically designed to be highly specific, addressing a single learning objective or a small set of related objectives in a concise and easily digestible format. Micro training is characterized by its brevity and effectiveness in conveying information, making it well suited for the fast-paced and attention-challenged digital age. Often, micro training is delivered via mobile apps."
  },
  {
    "id": 3031,
    "topic_id": 3,
    "title": "What is Secure Access Service Edge (SASE)?",
    "description": "Secure Access Service Edge (SASE) is a framework that converges network security functions with wide area networking (WAN) capabilities, catering to the dynamic, secure access needs of modern organizations. SASE is designed to respond to the evolving IT landscape marked by trends such as cloud adoption, a mobile workforce, and an increased emphasis on network security."
  },
  {
    "id": 3032,
    "topic_id": 3,
    "title": "What are the typical stages of the information system life cycle?",
    "description": "Stakeholders' Needs and Requirements, Requirements Analysis, Architectural Design, Development/Implementation, Integration, Verification and Validation, Transition/Deployment, Operations and Maintenance/Sustainment, and Retirement/Disposal."
  },
  {
    "id": 3033,
    "topic_id": 7,
    "title": "What is Structured Threat Information eXpression (STIX)?",
    "description": "A standardized language expressing structured information about cyberthreats and a common framework for organizations to share and analyze threat intelligence."
  },
  {
    "id": 3034,
    "topic_id": 7,
    "title": "What is Trusted Automated eXchange of Intelligence Information (TAXII)?",
    "description": "Defines protocols and services for automated sharing of structured threat information."
  },
  {
    "id": 3035,
    "topic_id": 1,
    "title": "What is data localization?",
    "description": "Data localization refers to storing and processing data within a specific country's or region's physical borders or geographical boundaries. This concept is often driven by regulatory requirements or government policies that mandate certain data, especially sensitive or personal information, to be kept within the jurisdiction's borders where it was generated or where the data subject resides."
  },
  {
    "id": 3036,
    "topic_id": 2,
    "title": "What is data portability?",
    "description": "Data portability refers to the ability of individuals to easily and securely move their personal data from one system, service, or application to another. It allows users to transfer their data between different platforms, promoting user control and facilitating competition among service providers."
  },
  {
    "id": 3037,
    "topic_id": 3,
    "title": "What is emission security (EMSEC)?",
    "description": "Emission security (EMSEC) involves implementing various measures to prevent unauthorized individuals from obtaining valuable information that could be derived through intercepting and analyzing compromising emanations from cryptographic equipment, automated information systems (AISs), and telecommunications systems. EMSEC has mostly replaced TEMPEST."
  },
  {
    "id": 3038,
    "topic_id": 3,
    "title": "What is Modbus?",
    "description": "Modbus is a widely used communication protocol in industrial automation and control systems. Developed by Modicon (now part of Schneider Electric) in 1979, Modbus has become a de facto standard for connecting and managing devices within industrial environments. It provides a common language for different devices to exchange data and commands, facilitating communication in supervisory control and data acquisition (SCADA) systems, programmable logic controllers (PLCs), and other industrial applications."
  },
  {
    "id": 3039,
    "topic_id": 3,
    "title": "What is bricking?",
    "description": "Refers to rendering a device completely nonfunctional or as useless as a brick, typically through a malfunction or intentional action. When a device is \"bricked,\" it loses its normal functionality and becomes inoperable, often requiring significant efforts to restore its original state."
  },
  {
    "id": 3040,
    "topic_id": 3,
    "title": "What is a trust anchor?",
    "description": "A specific entity or component within a system that is inherently trusted. It serves as a reference point for establishing trust in other entities or components within the system. The trust anchor is typically a well-protected and tamper-resistant element, and trust in the overall system is derived from the trustworthiness of the trust anchor."
  },
  {
    "id": 3041,
    "topic_id": 3,
    "title": "What is a hardware-based RoT?",
    "description": "A hardware-based RoT refers to the implementation of the root of trust using dedicated hardware components. This often involves the integration of secure hardware modules, such as trusted platform modules (TPMs) or hardware security modules (HSMs), which are designed to provide a secure and isolated environment for cryptographic operations and key management."
  },
  {
    "id": 3042,
    "topic_id": 7,
    "title": "What is Automatic REquest to eXit (AREX)?",
    "description": "A security system feature commonly employed in access control systems to automatically signal to unlock a secured door or gate when someone wishes to exit a protected area. This feature enhances security and convenience by automating the exit process."
  },
  {
    "id": 3043,
    "topic_id": 3,
    "title": "What is condition monitoring?",
    "description": "Condition monitoring is monitoring and assessing the operational parameters, performance, and health of machinery, equipment, or systems in real time or periodically. The primary goal of condition monitoring is to identify any deviations from normal operating conditions that could indicate potential faults, defects, or deterioration. This proactive approach helps predict and prevent equipment failures, minimize downtime, and optimize maintenance strategies."
  },
  {
    "id": 3044,
    "topic_id": 7,
    "title": "What is aqueous film forming foam (AFFF)?",
    "description": "A type of firefighting foam used to suppress flammable liquid fires. It is a water-based solution containing foaming agents, surfactants, and typically some fluorochemicals. AFFF is designed to quickly spread across the surface of flammable liquids, forming a thin film or barrier that suppresses the release of flammable vapors and prevents the fire from spreading."
  },
  {
    "id": 3045,
    "topic_id": 1,
    "title": "What is the Clarifying Lawful Overseas Use of Data (CLOUD) Act?",
    "description": "This act established procedures that govern access to data held by technology companies across national borders. This piece of legislation was introduced as a way to improve law enforcement's ability to gather digital evidence stored on servers regardless of where the servers are located, provided that the company is based within the United States or subject to U.S. jurisdiction."
  },
  {
    "id": 3046,
    "topic_id": 1,
    "title": "What is the name of the data protection and privacy law of China?",
    "description": "Personal Information Protection Law (PIPL), which came into effect in 2021, is China's first comprehensive national standard in data privacy law, somewhat analogous to the GDPR in the EU, and it imposes stringent regulations on personal data processing activities."
  },
  {
    "id": 3047,
    "topic_id": 1,
    "title": "What is South Africa's primary legislation governing data protection?",
    "description": "The Protection of Personal Information Act (POPIA), which went into effect in 2020, promotes the protection of personal information processed by public and private bodies and introduces specific conditions for the lawful processing of personal information, closely mirroring principles seen in the GDPR."
  },
  {
    "id": 3048,
    "topic_id": 5,
    "title": "What are the components of the AAA model of access control?",
    "description": "The AAA model includes three major components. Authentication confirms that a user, device, or service is who it claims to be. Authorization ensures that users, devices, and services may only perform actions that they are entitled to perform. Accounting creates an audit trail of activity that may be later verified."
  },
  {
    "id": 3049,
    "topic_id": 6,
    "title": "When conducting an exercise, participants are often divided into three teams. What are the names of those teams and their purpose?",
    "description": "Red team members are the attackers who attempt to gain access to systems. Blue team members are the defenders who must secure systems and networks from attack. White team members are the observers and judges. They serve as referees to settle disputes over the rules and watch the exercise to document lessons learned from the test."
  },
  {
    "id": 3050,
    "topic_id": 6,
    "title": "Describe capture-the-flag (CTF) exercises.",
    "description": "In a capture-the-flag (CTF) exercise, the red team begins with set objectives, such as disrupting a website, stealing a file from a secured system, or causing other security failures. The exercise is scored based on how many objectives the red team was able to achieve compared to how many the blue team prevented them from executing."
  },
  {
    "id": 3051,
    "topic_id": 3,
    "title": "What is services integration?",
    "description": "Services integration, cloud integration, systems integration, and integration platform as a service (iPaaS) is the design and architecture of an IT/IS solution that stitches together elements from on-premises and cloud sources into a seamless productive environment. The goals of service integration are to eliminate data silos, expand access, clarify processing visibility, and improve functional connectivity of on-site and off-site resources."
  },
  {
    "id": 3052,
    "topic_id": 7,
    "title": "In the context of security controls, what is tuning?",
    "description": "Tuning is the process of adjusting security controls to better match the needs of the organization and their operational environment. For example, intrusion detection and prevention systems require tuning to reduce the number of false positive alerts that they generate. If a system is too sensitive, it will generate many alerts that will cause administrators to begin to mistrust, and possibly ignore, the system alerts. If a system is not sensitive enough, it may miss a potential intrusion."
  },
  {
    "id": 3053,
    "topic_id": 7,
    "title": "What is a resource capacity agreement?",
    "description": "Organizations relying on cloud computing for their disaster recovery plan should consider entering into a resource capacity agreement with their cloud provider(s). This agreement ensures that the cloud provider will provide the resources needed to support disaster recovery operations."
  },
  {
    "id": 3054,
    "topic_id": 7,
    "title": "Describe the three aspects of test communications.",
    "description": "Before embarking on any test, it's essential to inform all stakeholders about what to expect. This includes giving them an idea of the scheduled timing. During the test, especially ones that might disrupt normal operations, regular updates are crucial. Post-test, a debriefing session provides an opportunity for discussing the outcomes of the test, highlighting both the successes and pinpointing areas that need improvement."
  },
  {
    "id": 3055,
    "topic_id": 7,
    "title": "What is the Locard's exchange principle?",
    "description": "Locard's exchange principle is the core principle that underlies the field of forensic science. Clearly stated, it is that \"every contact leaves a trace.\" That means that when two objects touch each other, there will be some evidence left behind."
  },
  {
    "id": 3056,
    "topic_id": 8,
    "title": "What is Scaled Agile Framework (SAFe)?",
    "description": "SAFe is a comprehensive approach to applying agile principles and practices at the enterprise scale. Recognizing the complexities that larger organizations face, SAFe offers a structured framework to facilitate the use of Agile across multiple teams, often coordinating the efforts of hundreds or even thousands of practitioners."
  },
  {
    "id": 3057,
    "topic_id": 4,
    "title": "What are the two DHCPv6 modes of operation?",
    "description": "In stateful mode, DHCPv6 assigns specific IPv6 addresses to devices and manages the allocation of network configuration parameters. In stateless mode, DHCPv6 provides network configuration parameters without assigning specific IPv6 addresses. Devices may use Stateless Address Autoconfiguration (SLAAC) to generate their own addresses."
  },
  {
    "id": 3058,
    "topic_id": 4,
    "title": "What is Stateless Address Autoconfiguration (SLAAC)?",
    "description": "SLAAC is based on routers periodically sending Router Advertisement (RA) messages to the local network segment in order to facilitate stateless DHCPv6. The RA messages include information about the network prefix that devices should use when forming their IPv6 addresses. The second element used to craft an IPv6 address is the interface identifier, which is typically derived from the Media Access Control (MAC) address of the network interface on the device."
  },
  {
    "id": 3059,
    "topic_id": 4,
    "title": "What is InfiniBand over Ethernet (IBOE)?",
    "description": "InfiniBand over Ethernet (IBOE) refers to the encapsulation of InfiniBand traffic within Ethernet frames, allowing InfiniBand protocols to run over Ethernet networks. InfiniBand is a high-performance and low-latency interconnect technology commonly used in high-performance computing (HPC) environments. IBOE provides a way to integrate InfiniBand technology into existing Ethernet infrastructures."
  },
  {
    "id": 3060,
    "topic_id": 4,
    "title": "What is Compute Express Link (CXL)?",
    "description": "An advanced high-speed interconnect technology developed to address the increasing demands of data-intensive workloads in modern computing systems. It is designed to enhance the performance, efficiency, and scalability of data-centric applications in various domains such as AI, ML, and HPC. As a converged protocol, CXL supports the communication and collaboration of various system components, such as CPUs and GPUs over a single high-speed interconnect."
  },
  {
    "id": 3061,
    "topic_id": 4,
    "title": "What is VRF (virtual routing and forwarding)?",
    "description": "VRF is a technology that allows multiple instances of a routing table to coexist within a router. Each VRF instance operates as a separate and independent routing domain, enabling the isolation of routing information. It allows the same physical router to maintain separate routing tables for different VRF instances, preventing the leakage of routing information between them."
  },
  {
    "id": 3062,
    "topic_id": 4,
    "title": "What is a virtual private cloud (VPC)?",
    "description": "A VPC is a virtualized network infrastructure provided by a cloud computing service provider. It allows users to create and manage isolated, logically segmented networks within the public cloud environment. A VPC enables organizations to host their applications and resources in a secure and dedicated space in the cloud while maintaining control over network configuration."
  },
  {
    "id": 3063,
    "topic_id": 4,
    "title": "What is an edge network?",
    "description": "An edge network is a carefully designed data architecture that strategically allocates computing resources to edge devices within a network. This design helps distribute processing power demands away from central servers, empowering the devices to handle a significant portion of the processing workload. Edge networks are designed to bring content, services, and applications closer to the users to reduce latency and improve performance."
  },
  {
    "id": 3064,
    "topic_id": 4,
    "title": "What are elements that make up quality of service (QoS)?",
    "description": "Attenuation, interference, noise, jitter, bandwidth, and propagation delay or latency."
  },
  {
    "id": 3065,
    "topic_id": 4,
    "title": "What is dense wavelength division multiplexing (DWDM)?",
    "description": "An optical communication technology used in fiber-optic communication systems to increase the capacity and efficiency of the network. DWDM enables multiple data streams or channels to be simultaneously transmitted over a single optical fiber, each using a different wavelength of light."
  },
  {
    "id": 3066,
    "topic_id": 4,
    "title": "Define anycast and geocast.",
    "description": "Anycast technology supports communications where a single sender transmits data to the nearest or best-suited node among a group of potential receivers. The goal is to deliver data to the \"nearest\" or \"best\" node in terms of network topology or routing metrics. Geocast technology supports communications where data is sent to all devices within a specific geographical area. It is a one-to-all communication paradigm limited to a particular geographic region, and devices outside that area do not receive the broadcast."
  },
  {
    "id": 3067,
    "topic_id": 4,
    "title": "What are three methods used to manage and control access to the communication medium in LANs?",
    "description": "Arbitration, deconfliction, and contention-based."
  },
  {
    "id": 3068,
    "topic_id": 4,
    "title": "What are common network administrative functions?",
    "description": "Configuration management, monitoring and analysis, troubleshooting and diagnostics, security management, user account management, software updates and patch management, backup and recovery tasks, and policy enforcement."
  },
  {
    "id": 3069,
    "topic_id": 4,
    "title": "What is a Zoom room?",
    "description": "Refers to a dedicated physical space equipped with audio-visual and communication technology designed for hosting video meetings, conferences, and collaborations. A Zoom room is set up to enhance the quality and experience of online video collaboration meetings. They often include larger displays, high-quality camera and microphone equipment, a high-quality sound system, touchscreen system/room controls, lighting controls, and other smart technologies."
  },
  {
    "id": 3070,
    "topic_id": 4,
    "title": "What is NAT66?",
    "description": "NAT66 allows multiple devices within a private IPv6 network to share the same public IPv6 address when communicating with external networks, such as the Internet. NAT66 provides a level of privacy and security by hiding internal network details from external entities. It assigns global IPv6 addresses to devices within the private network, and external entities see only the public IPv6 address."
  },
  {
    "id": 3071,
    "topic_id": 4,
    "title": "What is broadband over power lines (BPL)?",
    "description": "A technology that enables high-speed data transmission over existing electrical power lines. In a BPL system, data signals are transmitted along the same infrastructure that is used to deliver electric power. This technology leverages the extensive network of power lines to provide broadband Internet access to homes, businesses, and other locations."
  },
  {
    "id": 3072,
    "topic_id": 3,
    "title": "What is FIPS-186-5?",
    "description": "FIPS-186-5 is the Digital Signature Standard (DSS). It specifies algorithms for use as digital signatures: Rivest\u2013Shamir\u2013Adleman (RSA), Elliptic Curve Digital Signature Algorithm (ECDSA), and Edwards Curve Digital Signature Algorithm (EdDSA)."
  }
];
